import React, { useState, useEffect } from 'react';

const EMDNNomenclature = ({
    UDI,
    setUDI,
    initialData = '[]',
    hiddenFieldName = "Form.EUProductUDI.NomenclatureCode",
    fieldTitle = "Nomenclature Code",
    forceIsEditing = null
}) => {
    // Static Dictionary Data
    const nomenclatureLookup = [
        { key: "A", value: "DEVICES FOR ADMINISTRATION, WITHDRAWAL AND COLLECTION" },
        { key: "A01", value: "NEEDLES" },
        { key: "A0101", value: "NEEDLES FOR INFUSION AND SAMPLING" },
        { key: "A010101", value: "HYPODERMIC NEEDLES" },
        { key: "A01010101", value: "HYPODERMIC SYRINGE NEEDLES" },
        { key: "A0101010101", value: "HYPODERMIC SYRINGE NEEDLES, WITH SAFETY SYSTEMS" },
        { key: "A0101010102", value: "HYPODERMIC SYRINGE NEEDLES, W/O SAFETY SYSTEMS" },
        { key: "A01010102", value: "HYPODERMIC PEN NEEDLES" },
        { key: "A0101010201", value: "HYPODERMIC PEN NEEDLES, WITH SAFETY SYSTEMS" },
        { key: "A0101010202", value: "HYPODERMIC PEN NEEDLES, W/O SAFETY SYSTEMS" },
        { key: "A01010199", value: "HYPODERMIC NEEDLES - OTHER" },
        { key: "A010102", value: "BUTTERFLY NEEDLES" },
        { key: "A01010201", value: "BUTTERFLY NEEDLES, WITH SAFETY SYSTEMS" },
        { key: "A01010202", value: "BUTTERFLY NEEDLES, W/O SAFETY SYSTEMS" },
        { key: "A010103", value: "NEEDLES AND KITS FOR IMPLANTABLE SYSTEMS (PORT)" },
        { key: "A01010301", value: "NEEDLES AND KITS FOR IMPLANTABLE SYSTEMS (PORT), WITH SAFETY SYSTEMS" },
        { key: "A01010302", value: "NEEDLES AND KITS FOR IMPLANTABLE SYSTEMS (PORT), W/O SAFETY SYSTEMS" },
        { key: "A010104", value: "NEEDLES FOR VIAL COLLECTION " },
        { key: "A010105", value: "NEEDLES FOR COLLECTION UNDER VACUUM" },
        { key: "A01010501", value: "NEEDLES FOR COLLECTION UNDER VACUUM, WITH SAFETY SYSTEMS" },
        { key: "A01010502", value: "NEEDLES FOR COLLECTION UNDER VACCUM, W/O SAFETY SYSTEMS" },
        { key: "A010106", value: "NEEDLES AND KITS FOR RECONSTRUCTIVE FILLING" },
        { key: "A010180", value: "NEEDLES FOR INFUSION AND COLLECTION - ACCESSORIES" },
        { key: "A01018001", value: "HOLDERS FOR COLLECTION NEEDLES" },
        { key: "A01018099", value: "NEEDLES FOR INFUSION AND COLLECTION - OTHER ACCESSORIES" },
        { key: "A010199", value: "NEEDLES FOR INFUSION AND COLLECTION - OTHER" },
        { key: "A0102", value: "BIOPSY NEEDLES AND KITS" },
        { key: "A010201", value: "NEEDLES AND KITS - HISTOLOGICAL AND CYTOLOGICAL BIOPSY OF SOFT TISSUES" },
        { key: "A01020101", value: "SHEARING BIOPSY NEEDLES AND KITS" },
        { key: "A0102010101", value: "SHEARING BIOPSY NEEDLES" },
        { key: "A0102010102", value: "SHEARING BIOPSY GUNS" },
        { key: "A01020102", value: "ASPIRATION FINE NEEDLES AND KITS" },
        { key: "A01020199", value: "NEEDLES AND KITS FOR HISTOLOGICAL AND CYTOLOGICAL BIOPSY OF SOFT TISSUES - OTHER" },
        { key: "A010202", value: "BONE MARROW BIOPSY NEEDLES AND KITS" },
        { key: "A01020201", value: "ILIAC-STERNAL BIOPSY NEEDLES AND KITS" },
        { key: "A01020202", value: "BONE MARROW EXPLANT NEEDLES AND KITS" },
        { key: "A01020203", value: "VERTEBRAL AND PARAVERTEBRAL BIOPSY NEEDLES AND KITS" },
        { key: "A01020204", value: "MOTORISED BONE BIOPSY KITS" },
        { key: "A01020299", value: "NEEDLES AND KITS - BONE MARROW BIOPSY - OTHER" },
        { key: "A010203", value: "CUTANEOUS BIOPSY NEEDLES AND KITS" },
        { key: "A01020301", value: "CUTANEOUS BIOPSY NEEDLES" },
        { key: "A01020302", value: "CUTANEOUS BIOPSY PUNCHES, SINGLE-USE" },
        { key: "A01020303", value: "CUTANEOUS BIOPSY CURETTES, SINGLE-USE" },
        { key: "A01020399", value: "CUTANEOUS BIOPSY NEEDLES AND KITS - OTHER" },
        { key: "A010204", value: "AMNIOCENTESIS AND VILLOCENTESIS NEEDLES AND KITS" },
        { key: "A01020401", value: "AMNIOCENTESIS NEEDLES AND KITS" },
        { key: "A01020402", value: "VILLOCENTESIS NEEDLES AND KITS" },
        { key: "A010205", value: "PERENDOSCOPIC BIOPSY NEEDLES AND KITS (NON-GASTROINTESTINAL APPARATUS)" },
        { key: "A01020501", value: "PERENDOSCOPIC BRONCHIAL BIOPSY NEEDLES AND KITS" },
        { key: "A01020502", value: "LAPAROSCOPIC AND THORACOSCOPIC BIOPSY NEEDLES AND KITS" },
        { key: "A01020599", value: "PERENDOSCOPIC BIOPSY NEEDLES AND KITS (NON-GASTROINTESTINAL APPARATUS) - OTHER" },
        { key: "A010206", value: "CEREBRAL BIOPSY NEEDLES AND KITS" },
        { key: "A010207", value: "PULMONARY BIOPSY NEEDLES AND KITS" },
        { key: "A010299", value: "BIOPSY NEEDLES AND KITS - OTHER" },
        { key: "A0103", value: "ANAESTHESIA NEEDLES AND KITS" },
        { key: "A010301", value: "SPINAL AND EPIDURAL ANAESTHESIA NEEDLES AND KITS" },
        { key: "A01030101", value: "SPINAL ANAESTHESIA NEEDLES AND KITS" },
        { key: "A01030102", value: "EPIDURAL ANAESTHESIA NEEDLES AND KITS" },
        { key: "A01030103", value: "COMBINED EPIDURAL AND SPINAL ANAESTHESIA NEEDLES AND KITS" },
        { key: "A010302", value: "PLEXUS BLOCK NEEDLES AND KITS" },
        { key: "A010399", value: "ANAESTHESIA NEEDLES AND KIT - OTHER" },
        { key: "A0104", value: "DIALYSIS NEEDLES" },
        { key: "A010401", value: "ARTERIOVENOUS FISTULA NEEDLES" },
        { key: "A010480", value: "DIALYSIS NEEDLES - ACCESSORIES" },
        { key: "A010499", value: "DIALYSIS NEEDLES - OTHER" },
        { key: "A0105", value: "OPHTHALMOLOGY INJECTION NEEDLES AND KITS" },
        { key: "A010501", value: "ANTERIOR EYE CHAMBER NEEDLES" },
        { key: "A010502", value: "EYE IRRIGATION NEEDLES" },
        { key: "A010503", value: "PERIBULBAR NEEDLES" },
        { key: "A010504", value: "RETROBULBAR NEEDLES" },
        { key: "A010505", value: "ENDOCULAR INJECTION NEEDLES" },
        { key: "A010506", value: "ENDOCULAR ASPIRATION CANNULA NEEDLES" },
        { key: "A010599", value: "OPHTHALMOLOGY INJECTION NEEDLES AND KITS - OTHER" },
        { key: "A0106", value: "DENTISTRY NEEDLES AND KITS" },
        { key: "A010601", value: "CARPULE NEEDLES" },
        { key: "A010602", value: "DENTAL IRRIGATION NEEDLES" },
        { key: "A010699", value: "DENTISTRY NEEDLES AND KITS - OTHER" },
        { key: "A0180", value: "NEEDLES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "A018001", value: "NEEDLE CAPS" },
        { key: "A018002", value: "NEEDLE GUIDES" },
        { key: "A018003", value: "NEEDLE INTRODUCERS" },
        { key: "A018004", value: "NEEDLE CONNECTORS AND ADAPTERS" },
        { key: "A018005", value: "NEEDLE COUNTING CONTAINERS" },
        { key: "A018006", value: "HYPODERMIC NEEDLES PEN INJECTORS" },
        { key: "A018099", value: "NEEDLES - OTHER ACCESSORIES" },
        { key: "A0190", value: "NEEDLES FOR OTHER PROCEDURES" },
        { key: "A019001", value: "BLUNT NEEDLES" },
        { key: "A019002", value: "ACUPUNCTURE NEEDLES" },
        { key: "A019003", value: "ALCOHOLISATION NEEDLES" },
        { key: "A019004", value: "OPEN SURGERY CHOLANGIOGRAPHY NEEDLES AND KITS" },
        { key: "A019005", value: "GALACTOGRAPHY NEEDLES AND KITS" },
        { key: "A019006", value: "MESOTHERAPY NEEDLES" },
        { key: "A019007", value: "SCLEROTHERAPY NEEDLES AND KITS" },
        { key: "A019008", value: "MEDICAL PROCEDURES TATTOOING NEEDLES (NOT ENDOSCOPIC)" },
        { key: "A019009", value: "DRAINAGE NEEDLES" },
        { key: "A019010", value: "ANGIOGRAPHY NEEDLES" },
        { key: "A019011", value: "INTRAOSSEOUS INFUSION AND VERTEBROPLASTY INFUSION NEEDLES AND KITS" },
        { key: "A019012", value: "BREAST NODULES AND OTHER STRUCTURES LOCALISATION NEEDLES AND SYSTEMS" },
        { key: "A019013", value: "PERCUTANEOUS NEEDLES" },
        { key: "A019014", value: "LUMBAR PUNCTURE NEEDLES AND KITS" },
        { key: "A019015", value: "PERI- AND NEO-NATAL EPICRANIAL NEEDLES" },
        { key: "A019016", value: "BRACHYTHERAPY NEEDLES" },
        { key: "A019099", value: "NEEDLES FOR OTHER PROCEDURES - OTHER" },
        { key: "A0199", value: "NEEDLES - OTHER" },
        { key: "A02", value: "SYRINGES" },
        { key: "A0201", value: "SINGLE-USE SYRINGES" },
        { key: "A020101", value: "LOSS-OF-RESISTANCE SYRINGES" },
        { key: "A020102", value: "INFUSION AND IRRIGATION SYRINGES, SINGLE-USE" },
        { key: "A02010201", value: "INFUSION AND IRRIGATION SYRINGES, LUER CONE, SINGLE-USE" },
        { key: "A0201020101", value: "INFUSION AND IRRIGATION SYRINGES, 2-PIECE LUER CONE, SINGLE-USE" },
        { key: "A020102010101", value: "INFUSION AND IRRIGATION SYRINGES, 2-PIECE LUER CONE, 2-PIECE WITH NEEDLE, SINGLE-USE" },
        { key: "A020102010102", value: "INFUSION AND IRRIGATION SYRINGES, 2-PIECE LUER CONE, 2-PIECE WITHOUT NEEDLE, SINGLE-USE" },
        { key: "A0201020102", value: "INFUSION AND IRRIGATION SYRINGES, LUER CONE, 3-PIECE" },
        { key: "A020102010201", value: "INFUSION AND IRRIGATION SYRINGES, LUER CONE, 3-PIECE WITH NEEDLE, SINGLE-USE" },
        { key: "A020102010202", value: "INFUSION AND IRRIGATION SYRINGES, LUER CONE, 3-PIECE WITHOUT NEEDLE, SINGLE-USE" },
        { key: "A02010202", value: "INFUSION AND IRRIGATION SYRINGES, LUER LOCK CONE, SINGLE-USE" },
        { key: "A0201020201", value: "INFUSION AND IRRIGATION SYRINGES, LUER LOCK CONE, 3-PIECE, SINGLE-USE" },
        { key: "A020102020101", value: "INFUSION AND IRRIGATION SYRINGES, LUER LOCK CONE, 3-PIECE WITH NEEDLE, SINGLE-USE" },
        { key: "A020102020102", value: "INFUSION AND IRRIGATION SYRINGES, LUER LOCK CONE, 3-PIECE WITHOUT NEEDLE, SINGLE-USE" },
        { key: "A02010203", value: "INFUSION AND IRRIGATION SYRINGES, CATHETER CONE, SINGLE-USE" },
        { key: "A02010204", value: "INFUSION AND IRRIGATION SYRINGES, WITHOUT CONE, WITH FIXED NEEDLE, SINGLE-USE" },
        { key: "A02010205", value: "INFUSION AND IRRIGATION SYRINGES WITH SAFETY SYSTEM, SINGLE-USE" },
        { key: "A02010299", value: "INFUSION AND IRRIGATION SYRINGES - OTHER" },
        { key: "A020104", value: "SYRINGES FOR INJECTORS, SINGLE-USE" },
        { key: "A02010401", value: "SYRINGES FOR CONTRAST MEDIA INJECTOR, SINGLE-USE" },
        { key: "A02010499", value: "SYRINGES FOR INJECTOR, SINGLE-USE - OTHER" },
        { key: "A020105", value: "BLOOD GAS ANALYSIS, SYRINGES WITH NEEDLES AND KITS" },
        { key: "A02010501", value: "BLOOD GAS ANALYSIS, SYRINGES WITH NEEDLE W/O SAFETY SYSTEM AND KITS" },
        { key: "A02010502", value: "BLOOD GAS ANALYSIS, SYRINGES WITH SAFETY NEEDLE AND KITS" },
        { key: "A020106", value: "INSULIN SYRINGES, SINGLE-USE" },
        { key: "A02010601", value: "INSULIN SYRINGES WITH FIXED NEEDLE, SINGLE-USE" },
        { key: "A02010602", value: "INSULIN SYRINGES W/O FIXED NEEDLES, SINGLE-USE" },
        { key: "A02010603", value: "INSULIN SYRINGES WITH SAFETY SYSTEM, SINGLE-USE" },
        { key: "A0201060301", value: "INSULIN SYRINGES WITH SAFETY SYSTEMS AND FIXED NEEDLES, SINGLE-USE" },
        { key: "A0201060302", value: "INSULIN SYRINGES WITH SAFETY SYSTEMS W/O FIXED NEEDLE, SINGLE-USE" },
        { key: "A02010699", value: "INSULIN SYRINGES, SINGLE-USE - OTHER" },
        { key: "A020107", value: "PREFILLED SYRINGES" },
        { key: "A02010701", value: "PREFILLED SYRINGES WITH STERILE PHYSIOLOGICAL SOLUTION" },
        { key: "A02010702", value: "PREFILLED SYRINGES WITH STERILE WATER" },
        { key: "A02010799", value: "PREFILLED SYRINGES - OTHER" },
        { key: "A020108", value: "ENTERAL FEEDING SYRINGES" },
        { key: "A020109", value: "TUBERCULIN SYRINGES, SINGLE-USE" },
        { key: "A020199", value: "SYRINGES, SINGLE-USE - OTHER" },
        { key: "A0202", value: "REUSABLE SYRINGES" },
        { key: "A020201", value: "REUSABLE INFUSION SYRINGES" },
        { key: "A020202", value: "REUSABLE IRRIGATION SYRINGES" },
        { key: "A020203", value: "CARTRIDGE SYRINGES" },
        { key: "A020299", value: "REUSABLE SYRINGES - OTHER" },
        { key: "A0280", value: "SYRINGES - ACCESSORIES" },
        { key: "A0299", value: "SYRINGES - OTHER" },
        { key: "A03", value: "TUBULAR DEVICES" },
        { key: "A0301", value: "FLOW CONTROLLERS" },
        { key: "A030101", value: "INFUSION CONTROLLERS" },
        { key: "A03010101", value: "INFUSION CONTROLLERS WITH OR W/O AIR INLET" },
        { key: "A03010102", value: "INFUSION CONTROLLERS WITH FILTER (ALSO TRANSFUSION CONTROLLERS)" },
        { key: "A03010103", value: "INFUSION CONTROLLERS WITH FLOW REGULATOR" },
        { key: "A03010104", value: "INFUSION MICRO-CONTROLLERS" },
        { key: "A03010105", value: "INFUSION PUMP CONTROLLERS" },
        { key: "A03010199", value: "INFUSION CONTROLLERS - OTHER" },
        { key: "A030102", value: "IRRIGATION CONTROLLERS" },
        { key: "A03010201", value: "ARTHROSCOPIC IRRIGATION CONTROLLERS" },
        { key: "A03010202", value: "UROLOGICAL IRRIGATION CONTROLLERS" },
        { key: "A03010299", value: "IRRIGATION CONTROLLERS - OTHER" },
        { key: "A030103", value: "ENTERAL FEEDING CONTROLLERS" },
        { key: "A03010301", value: "ENTERAL FEEDING GRAVITY CONTROLLERS" },
        { key: "A03010302", value: "ENTERAL FEEDING PUMP CONTROLLERS" },
        { key: "A03010399", value: "ENTERAL FEEDING CONTROLLERS - OTHER" },
        { key: "A030104", value: "FLOW REGULATORS" },
        { key: "A030105", value: "FLUIDS HEATING SYSTEMS" },
        { key: "A030199", value: "CONTROLLERS - OTHER" },
        { key: "A0302", value: "EXTENSION LINES" },
        { key: "A030201", value: "EXTENSIONS" },
        { key: "A03020101", value: "LOW PRESSURE EXTENSION LINES" },
        { key: "A03020102", value: "HIGH PRESSURE EXTENSION LINES" },
        { key: "A03020199", value: "EXTENSIONS - OTHER" },
        { key: "A0303", value: "RAPID INFUSION SYSTEMS (HIGH FLOW)" },
        { key: "A0304", value: "ADMINISTRATION KITS" },
        { key: "A030401", value: "INFUSION KITS (INCLUDING THOSE VIA PUMP), SINGLE-USE" },
        { key: "A03040101", value: "KITS FOR CONTINUOUS SUBCUTANEOUS INSULIN INFUSION" },
        { key: "A03040102", value: "INTRAOSSEOUS INFUSION KITS, SINGLE-USE" },
        { key: "A03040199", value: "INFUSION KITS (WITH OR W/O PUMP), SINGLE-USE - OTHER" },
        { key: "A030402", value: "IRRIGATION KITS, SINGLE-USE" },
        { key: "A03040201", value: "BLADDER IRRIGATION KITS, SINGLE-USE" },
        { key: "A03040202", value: "OCULAR IRRIGATION KITS, SINGLE-USE" },
        { key: "A03040203", value: "PERINEAL IRRIGATION KITS, SINGLE-USE" },
        { key: "A03040204", value: "EAR IRRIGATION KITS, SINGLE-USE" },
        { key: "A03040299", value: "IRRIGATION KITS, SINGLE-USE - OTHER" },
        { key: "A030403", value: "ENTERAL NUTRITION KITS (INCLUDING THOSE VIA PUMP), SINGLE-USE" },
        { key: "A030499", value: "ADMINISTRATION KITS - OTHER" },
        { key: "A0380", value: "TUBULAR DEVICES - ACCESSORIES" },
        { key: "A0399", value: "TUBULAR DEVICES - OTHER" },
        { key: "A04", value: "SOLUTION FILTERS" },
        { key: "A0401", value: "INFUSION AND WITHDRAWL FILTERS" },
        { key: "A040101", value: "ADMINISTRATION AND ASPIRATION FILTERS" },
        { key: "A04010101", value: "WITHDRAWL AND ADMINISTRATION FILTERS (0.2-1.2 MICRONS)" },
        { key: "A04010102", value: "ASPIRATION AND TRANSFER FILTERS (>= 5 MICRONS)" },
        { key: "A04010199", value: "ADMINISTRATION AND ASPIRATION FILTERS - OTHER" },
        { key: "A040180", value: "INFUSION AND WITHDRAWL FILTERS - ACCESSORIES" },
        { key: "A040199", value: "INFUSION AND WITHDRAWL FILTERS - OTHER" },
        { key: "A0499", value: "SOLUTION FILTERS - OTHER" },
        { key: "A05", value: "MECHANICAL INFUSION SYSTEMS, SINGLE-USE" },
        { key: "A0501", value: "ELASTOMERIC SYSTEMS" },
        { key: "A050101", value: "ELASTOMERIC SYSTEMS - FIXED FLOW" },
        { key: "A05010101", value: "ELASTOMERIC SYSTEMS - FIXED FLOW W/O ADDITIONAL BOLUS" },
        { key: "A05010102", value: "ELASTOMERIC SYSTEMS - FIXED FLOW WITH ADDITIONAL BOLUS" },
        { key: "A050102", value: "ELASTOMERIC SYSTEMS - VARIABLE FLOW" },
        { key: "A05010201", value: "ELASTOMERIC SYSTEMS - VARIABLE FLOW W/O ADDITIONAL BOLUS" },
        { key: "A05010202", value: "ELASTOMERIC SYSTEMS - VARIABLE FLOW WITH ADDITIONAL BOLUS" },
        { key: "A0502", value: "NON-ELASTOMERIC SYSTEMS" },
        { key: "A0580", value: "MECHANICAL INFUSION SYSTEMS, SINGLE-USE - ACCESSORIES" },
        { key: "A0599", value: "MECHANICAL INFUSION SYSTEMS, SINGLE-USE - OTHER" },
        { key: "A06", value: "DRAINAGE AND FLUIDS COLLECTION DEVICES" },
        { key: "A0601", value: "SURGICAL DRAINAGE SYSTEMS" },
        { key: "A060101", value: "VACUUM AND GRAVITY DRAINAGE SYSTEMS" },
        { key: "A06010101", value: "DRAINAGE SYSTEMS WITH PREDEFINED SUCTION" },
        { key: "A0601010101", value: "DRAINAGE SYSTEMS WITH REDON TYPE RIGID CONTAINER" },
        { key: "A0601010102", value: "DRAINAGE SYSTEMS WITH RESERVOIR" },
        { key: "A0601010103", value: "BELLOWS DRAINAGE SYSTEMS" },
        { key: "A0601010199", value: "DRAINAGE SYSTEMS WITH PREDEFINED SUCTION - OTHER" },
        { key: "A06010102", value: "DRAINAGE SYSTEMS WITH ADJUSTABLE SUCTION" },
        { key: "A0601010201", value: "DRAINAGE SYSTEMS WITH ADJUSTABLE SUCTION AND COLLECTION CHAMBER" },
        { key: "A0601010299", value: "DRAINAGE SYSTEMS WITH ADJUSTABLE SUCTION - OTHER" },
        { key: "A06010103", value: "CANNULAS AND TIPS FOR ASPIRATION AND IRRIGATION, SINGLE-USE" },
        { key: "A06010104", value: "DRAINAGE PROBES" },
        { key: "A0601010401", value: "THORACIC DRAINAGES (STRAIGHT AND ANGLED)" },
        { key: "A0601010402", value: "CYLINDRICAL OR CIRCULAR DRAINAGES (STRAIGHT AND T-SHAPED)" },
        { key: "A0601010403", value: "FLAT AND LAMELLAR DRAINAGES" },
        { key: "A0601010499", value: "DRAINAGE PROBES - OTHER" },
        { key: "A06010199", value: "VACUUM AND GRAVITY DRAINAGE SYSTEMS - OTHER" },
        { key: "A060102", value: "SURGICAL DRAINAGE CONNECTION MEDICAL TUBES" },
        { key: "A060199", value: "SURGICAL DRAINAGE SYSTEMS - OTHER" },
        { key: "A0602", value: "PERCUTANEOUS DRAINAGE SYSTEMS" },
        { key: "A060201", value: "EXTERNAL DRAINAGE CATHETERS AND KITS (ABSCESSES, GALLSTONES, CYSTS)" },
        { key: "A060202", value: "TROCAR DRAINAGES 3/4" },
        { key: "A060203", value: "PLEURAL DRAINAGES WITH VALVE AND KITS" },
        { key: "A060204", value: "THORACENTESIS AND PARACENTESIS DRAINAGES AND KITS" },
        { key: "A060205", value: "PERICARDIUM DRAINAGES AND KITS" },
        { key: "A060206", value: "PERITONAEAL DRAINAGES AND KITS" },
        { key: "A060299", value: "PERCUTANEOUS DRAINAGE SYSTEMS - OTHER" },
        { key: "A0603", value: "FLUIDS COLLECTION BAGS AND SYSTEMS" },
        { key: "A060301", value: "COLLECTION BAGS AND OTHER CONTAINERS FOR DRAINAGES AND FISTULAS, SINGLE USE" },
        { key: "A060302", value: "COLLECTION BAGS FOR UROLOGICAL AND ARTHROSCOPIC WASHINGS, SINGLE-USE" },
        { key: "A060303", value: "URINE COLLECTION SYSTEMS AND BAGS, SINGLE-USE" },
        { key: "A06030301", value: "URINE COLLECTION BAGS" },
        { key: "A06030302", value: "HOURLY DIURESIS MEASUREMENT SETS" },
        { key: "A06030399", value: "URINE COLLECTION SYSTEMS - OTHER" },
        { key: "A060304", value: "INTRA-OPERATION FLUID COLLECTION DEVICES" },
        { key: "A06030401", value: "INTRAOPERATIVE SUCTION CONTAINERS" },
        { key: "A06030499", value: "INTRA-OPERATION FLUID COLLECTION DEVICES - OTHER" },
        { key: "A060399", value: "FLUID COLLECTION BAGS AND SYSTEMS - OTHER" },
        { key: "A0680", value: "DRAINAGE AND FLUID COLLECTION DEVICES - ACCESSORIES" },
        { key: "A0699", value: "DRAINAGE AND FLUID COLLECTION DEVICES - OTHER" },
        { key: "A07", value: "ADAPTERS, CONNECTORS, RAMPS, STOPCOCKS, CAPS" },
        { key: "A0701", value: "ADAPTERS AND CONNECTORS" },
        { key: "A070101", value: "ASPIRATION LINES ADAPTERS AND CONNECTORS" },
        { key: "A070102", value: "IRRIGATION LINES ADAPTERS AND CONNECTORS" },
        { key: "A070103", value: "INFUSION LINES ADAPTERS AND CONNECTORS" },
        { key: "A070199", value: "ADAPTERS AND CONNECTORS - OTHER" },
        { key: "A0702", value: "RAMPS" },
        { key: "A0703", value: "STOPCOCKS" },
        { key: "A0704", value: "SYSTEMS FOR RECONSTITUTION AND ADMINISTRATION OF PHARMACEUTICALS" },
        { key: "A0705", value: "CAPS OR OBTURATORS" },
        { key: "A070501", value: "CAPS OR OBTURATORS, NON-PERFORABLE" },
        { key: "A070502", value: "CAPS OR OBTURATORS, PERFORABLE" },
        { key: "A07050201", value: "CAPS OR OBTURATORS, PERFORABLE WITH NEEDLE" },
        { key: "A07050202", value: "CAPS OR OBTURATORS, PERFORABLE WITHOUT NEEDLE" },
        { key: "A070599", value: "CAPS OR OBTURATORS - OTHER" },
        { key: "A0706", value: "ANTISEPTIC CONNECTOR PROTECTORS" },
        { key: "A0799", value: "ADAPTERS, CONNECTORS, RAMPS, STOPCOCKS, CAPS - OTHER" },
        { key: "A08", value: "NUTRITION AND INFUSION BAGS AND CONTAINERS, SINGLE-USE" },
        { key: "A0801", value: "NUTRITION BAGS AND CONTAINERS, SINGLE-USE" },
        { key: "A080101", value: "ENTERAL FEEDING BAGS AND CONTAINERS (INCLUDING THOSE VIA PUMP), SINGLE-USE" },
        { key: "A080102", value: "PARENTERAL FEEDING BAGS AND CONTAINERS (INCLUDING THOSE VIA PUMP), SINGLE-USE" },
        { key: "A080199", value: "NUTRITION BAGS AND CONTAINERS, SINGLE-USE - OTHER" },
        { key: "A0802", value: "INFUSION BAGS AND CONTAINERS, SINGLE-USE" },
        { key: "A080201", value: "INFUSION PUMP BAGS AND CONTAINERS, SINGLE-USE" },
        { key: "A080299", value: "INFUSION BAGS AND CONTAINERS, SINGLE-USE - OTHER" },
        { key: "A0880", value: "NUTRITION AND INFUSION BAGS AND CONTAINERS, SINGLE-USE - ACCESSORIES" },
        { key: "A088001", value: "PRESSURE INFUSION CUFFS, SINGLE-USE" },
        { key: "A088099", value: "NUTRITION AND INFUSION BAGS AND CONTAINERS, SINGLE-USE - OTHER ACCESSORIES" },
        { key: "A0899", value: "NUTRITION AND INFUSION BAGS AND CONTAINERS, SINGLE-USE - OTHER" },
        { key: "A09", value: "ORGAN CONTAINERS" },
        { key: "A0901", value: "ORGAN COLLECTION CONTAINERS" },
        { key: "A090101", value: "ORGAN COLLECTION BAGS" },
        { key: "A090199", value: "ORGAN COLLECTION CONTAINERS - OTHER" },
        { key: "A0980", value: "ORGAN CONTAINERS - ACCESSORIES" },
        { key: "A0999", value: "ORGAN CONTAINERS - OTHER" },
        { key: "A10", value: "ABDOMINAL OSTOMY DEVICES" },
        { key: "A1001", value: "ONE PIECE ABDOMINAL OSTOMY DEVICES" },
        { key: "A100101", value: "ONE PIECE COLOSTOMY BAGS" },
        { key: "A10010101", value: "ONE-PIECE COLOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT" },
        { key: "A1001010101", value: "ONE-PIECE COLOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, W/O TISSUE COVER" },
        { key: "A1001010102", value: "ONE-PIECE COLOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, WITH TISSUE COVER" },
        { key: "A10010102", value: "ONE-PIECE COLOSTOMY BAGS FOR RETRACTED STOMA, CONVEX" },
        { key: "A1001010201", value: "ONE-PIECE COLOSTOMY BAGS FOR RETRACTED STOMA, CONVEX, W/O TISSUE COVER" },
        { key: "A1001010202", value: "ONE-PIECE COLOSTOMY BAGS FOR RETRACTED STOMA, CONVEX, WITH TISSUE COVER" },
        { key: "A100102", value: "ONE PIECE ILEOSTOMY BAGS" },
        { key: "A10010201", value: "ONE-PIECE ILEOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT" },
        { key: "A1001020101", value: "ONE-PIECE ILEOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, W/O TISSUE COVER" },
        { key: "A1001020102", value: "ONE-PIECE ILEOSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, WITH TISSUE COVER" },
        { key: "A10010202", value: "ONE-PIECE ILEOSTOMY BAGS FOR RETRACTED STOMA, CONVEX" },
        { key: "A1001020201", value: "ONE-PIECE ILEOSTOMY BAGS FOR RETRACTED STOMA, CONVEX, W/O TISSUE COVER" },
        { key: "A1001020202", value: "ONE-PIECE ILEOSTOMY BAGS FOR RETRACTED STOMA, CONVEX, WITH TISSUE COVER" },
        { key: "A100103", value: "ONE PIECE UROSTOMY BAGS" },
        { key: "A10010301", value: "ONE-PIECE UROSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT" },
        { key: "A1001030101", value: "ONE-PIECE UROSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, W/O TISSUE COVER" },
        { key: "A1001030102", value: "ONE-PIECE UROSTOMY BAGS FOR NON-RETRACTED STOMA, FLAT, WITH TISSUE COVER" },
        { key: "A10010302", value: "ONE-PIECE UROSTOMY BAGS FOR RETRACTED STOMA, CONVEX" },
        { key: "A1001030201", value: "ONE-PIECE UROSTOMY BAGS FOR RETRACTED STOMA, CONVEX, W/O TISSUE COVER" },
        { key: "A1001030202", value: "ONE-PIECE UROSTOMY BAGS FOR RETRACTED STOMA, CONVEX, WITH TISSUE COVER" },
        { key: "A100104", value: "EXPANSION CAPS FOR ABDOMINAL OSTOMY SYSTEMS - ONE PIECE" },
        { key: "A100199", value: "DEVICES FOR ABDOMINAL OSTOMY - ONE PIECE - OTHER" },
        { key: "A1002", value: "ABDOMINAL OOSTOMY DEVICES, TWO PIECE" },
        { key: "A100201", value: "ABDOMINAL OSTOMY PLATES" },
        { key: "A10020101", value: "COLOSTOMY PLATES" },
        { key: "A1002010101", value: "COLOSTOMY PLATES, WITH NON-RETRACTED STOMA" },
        { key: "A1002010102", value: "COLOSTOMY PLATES, WITH RETRACTED STOMA" },
        { key: "A10020102", value: "ILEOSTOMY PLATES" },
        { key: "A1002010201", value: "ILEOSTOMY PLATES, WITH NON-RETRACTED STOMA" },
        { key: "A1002010202", value: "ILEOSTOMY PLATES, WITH RETRACTED STOMA" },
        { key: "A10020103", value: "UROSTOMY PLATES" },
        { key: "A1002010301", value: "UROSTOMY PLATES, WITH NON-RETRACTED STOMA" },
        { key: "A1002010302", value: "UROSTOMY PLATES WITH RETRACTED STOMA" },
        { key: "A10020104", value: "UNIVERSAL PLATES FOR ABDOMINAL STOMA (COLO-, ILEO-, UROSTOMY)" },
        { key: "A1002010401", value: "UNIVERSAL PLATES FOR ABDOMINAL STOMA (COLO-, ILEO-, UROSTOMY) WITH NON-INTROFLEX STOMA" },
        { key: "A1002010402", value: "UNIVERSAL PLATES FOR ABDOMINAL STOMA (COLO-, ILEO-, UROSTOMY) WITH INTROFLEX STOMA" },
        { key: "A100202", value: "COLOSTOMY BAGS FOR TWO-PART SYSTEMS" },
        { key: "A10020201", value: "OLOSTOMY BAGS FOR TWO-PART SYSTEMS, W/O TISSUE COVER" },
        { key: "A10020202", value: "COLOSTOMY BAGS FOR TWO-PART SYSTEMS, WITH TISSUE COVER" },
        { key: "A100203", value: "ILEOSTOMY BAGS FOR TWO-PART SYSTEMS" },
        { key: "A10020301", value: "ILEOSTOMY BAGS FOR TWO-PART SYSTEMS, W/O TISSUE COVER" },
        { key: "A10020302", value: "ILEOSTOMY BAGS FOR TWO-PART SYSTEMS, WITH TISSUE COVER" },
        { key: "A100204", value: "UROSTOMY BAGS FOR TWO-PART SYSTEMS" },
        { key: "A10020401", value: "UROSTOMY BAGS FOR TWO-PART SYSTEMS, W/O TISSUE COVER" },
        { key: "A10020402", value: "UROSTOMY BAGS FOR TWO-PART SYSTEMS, WITH TISSUE COVER" },
        { key: "A100205", value: "EXPANSION CAPS FOR TWO-PIECE ABDOMINAL OSTOMY SYSTEMS" },
        { key: "A100299", value: "TWO-PIECE ABDOMINAL OSTOMY DEVICES - OTHER" },
        { key: "A1003", value: "ABDOMINAL OSTOMY IRRIGATION DEVICES" },
        { key: "A100301", value: "ABDOMINAL OSTOMY IRRIGATION KITS" },
        { key: "A100302", value: "ABDOMINAL OSTOMY DRAINAGE / IRRIGATION BAGS" },
        { key: "A100399", value: "ABDOMINAL OSTOMY IRRIGATION DEVICES - OTHER" },
        { key: "A1080", value: "ABDOMINAL OSTOMY DEVICES - ACCESSORIES" },
        { key: "A108001", value: "RINGS / BEZELS / PLATES FOR PERISTOMAL SKIN" },
        { key: "A108002", value: "PROTECTIVE CREAMS / GELS FOR PERISTOMAL SKIN" },
        { key: "A108003", value: "PROTECTIVE POWDERS FOR PERISTOMAL SKIN" },
        { key: "A108004", value: "PROTECTIVE FILMS / SPRAYS FOR PERISTOMAL SKIN" },
        { key: "A108005", value: "DEVICES FOR THE REMOVAL OF ADHESIVES FROM THE PERISTOMAL SKIN" },
        { key: "A108006", value: "ABDOMINAL OSTOMY SUPPORT BELTS" },
        { key: "A108007", value: "ABDOMINAL OSTOMY IRRIGATION CONES" },
        { key: "A108008", value: "ADHESIVES FOR ABDOMINAL OSTOMY DEVICES" },
        { key: "A108009", value: "ABDOMINAL OSTOMY DILATORS" },
        { key: "A108099", value: "ACCESSORY DEVICES FOR ABDOMINAL OSTOMY - OTHER" },
        { key: "A1099", value: "ABDOMINAL OSTOMY DEVICES - OTHER" },
        { key: "A11", value: "SAMPLE COLLECTION SWABS" },
        { key: "A1101", value: "SAMPLE COLLECTION NEUTRAL SWABS" },
        { key: "A1102", value: "SAMPLE COLLECTION SWABS WITH TRANSPORT MEDIUM" },
        { key: "A12", value: "SAMPLE COLLECTION SPATULAS" },
        { key: "A13", value: "APPLICATORS FOR DRUGS AND MEDICAL DEVICES NOT PRESENT IN OTHER CLASSES" },
        { key: "A99", value: "DEVICES FOR ADMINISTRATION, WITHDRAWAL AND COLLECTION - OTHER" },
        { key: "B", value: "HAEMATOLOGY AND HAEMOTRANSFUSION DEVICES" },
        { key: "B01", value: "BLOOD BAGS AND KITS" },
        { key: "B0101", value: "BLOOD COLLECTION BAGS AND KITS" },
        { key: "B010101", value: "AUTOLOGOUS BLOOD COLLECTION BAGS" },
        { key: "B01010101", value: "AUTOTRANSFUSION BAGS, WITH FILTERS AND KITS" },
        { key: "B0101010101", value: "AUTOTRANSFUSION DOUBLE BAGS, WITH FILTERS AND KITS" },
        { key: "B0101010199", value: "AUTOTRANSFUSION BAGS, WITH FILTERS AND KITS - OTHER" },
        { key: "B01010102", value: "AUTOTRANSFUSION BAGS, W/O FILTERS AND KITS" },
        { key: "B0101010201", value: "AUTOTRANSFUSION SINGULAR BAGS, W/O FILTERS AND KITS" },
        { key: "B0101010202", value: "AUTOTRANSFUSION DOUBLE BAGS, W/O FILTERS AND KITS" },
        { key: "B0101010203", value: "AUTOTRANSFUSION TRIPLE BAGS, W/O FILTERS AND KITS" },
        { key: "B0101010299", value: "AUTOTRANSFUSION BAGS, W/O FILTERS AND KITS - OTHER" },
        { key: "B010102", value: "HOMOLOGOUS DONOR BLOOD COLLECTION BAGS AND KITS" },
        { key: "B01010201", value: "DONOR BLOOD COLLECTION BAGS, WITH FILTERS AND KITS" },
        { key: "B0101020101", value: "DONOR BLOOD COLLECTION QUADRUPLE BAGS, WITH FILTERS AND KITS" },
        { key: "B0101020102", value: "DONOR BLOOD COLLECTION QUINTUPLE BAGS, WITH FILTERS AND KITS" },
        { key: "B0101020199", value: "DONOR BLOOD COLLECTION BAGS AND KITS, WITH FILTERS - OTHER" },
        { key: "B01010202", value: "DONOR BLOOD COLLECTION BAGS, W/O FILTERS AND KITS - OTHER" },
        { key: "B0101020201", value: "DONOR BLOOD COLLECTION TRIPLE BAGS, W/O FILTERS AND KIT" },
        { key: "B0101020202", value: "DONOR BLOOD COLLECTION QUADRUPLE BAGS, W/O FILTERS AND KITS" },
        { key: "B0101020299", value: "DONOR BLOOD COLLECTION BAGS W/O FILTERS AND KITS - OTHER" },
        { key: "B010199", value: "BLOOD COLLECTION BAGS AND KITS - OTHER" },
        { key: "B0102", value: "BLOOD TRANSFER BAGS AND KITS" },
        { key: "B010201", value: "WHOLE BLOOD, RED BLOOD CELLS OR PLASMA TRANSFER BAGS AND KITS" },
        { key: "B010202", value: "PLATELETS CONCENTRATE TRANSFER BAGS AND KITS" },
        { key: "B010299", value: "BLOOD TRANSFER BAGS AND KITS - OTHER" },
        { key: "B0103", value: "MEDULLARY BLOOD COLLECTION, PURIFICATION, CRYOPRESERVATION BAGS AND KITS" },
        { key: "B0104", value: "PLACENTAL BLOOD BAGS AND KITS" },
        { key: "B010401", value: "PLACENTAL BLOOD COLLECTION BAGS AND KITS" },
        { key: "B010402", value: "PLACENTAL BLOOD PURIFICATION BAGS AND KITS" },
        { key: "B010403", value: "PLACENTAL BLOOD CROYPRESERVATION BAGS AND KITS" },
        { key: "B010499", value: "PLACENTAL BLOOD BAGS AND KITS - OTHER" },
        { key: "B0105", value: "UMBILICAL CORD BLOOD COLLECTION, PURIFICATION, CRYOPRESERVATION BAGS AND KITS" },
        { key: "B0180", value: "BLOOD BAGS AND KITS - ACCESSORIES" },
        { key: "B0190", value: "BLOOD BAGS AND KITS - VARIOUS" },
        { key: "B019001", value: "PLATELET GEL AND FIBRIN GLUE PRODUCTION BAGS AND KITS" },
        { key: "B019002", value: "COLLECTION AND FILTRATION OF WHOLE BLOOD WITH ALIQUOTATION OF CONCENTRATED RED BLOOD CELLS BAGS AND KITS" },
        { key: "B019003", value: "BLOOD COMPONENTS ALIQUOTATION KITS" },
        { key: "B019004", value: "BLOOD COMPONENTS SAMPLING BAGS AND KITS" },
        { key: "B0199", value: "BLOOD BAGS AND KITS - OTHER" },
        { key: "B02", value: "BLOOD FILTERS" },
        { key: "B0201", value: "LEUKOREDUCTION FILTERS" },
        { key: "B020101", value: "BED-SIDE LEUKOREDUCTION FILTERS" },
        { key: "B02010101", value: "BED-SIDE ERYTHROCYTES (RBC) LEUKOREDUCTION FILTERS (WITH OR WITHOUT INFUSION CONTROLLER)" },
        { key: "B02010102", value: "BED-SIDE PLATELETS LEUKOREDUCTION FILTERS (WITH OR WITHOUT INFUSION CONTROLLER)" },
        { key: "B02010199", value: "BED-SIDE LEUKOREDUCTION FILTERS - OTHER" },
        { key: "B020102", value: "LABORATORY LEUKOREDUCTION FILTERS" },
        { key: "B02010201", value: "LABORATORY ERYTHROCYTES (RBC) LEUKOREDUCTION FILTERS" },
        { key: "B02010202", value: "LABORATORY PLATELETS LEUKOREDUCTION FILTERS" },
        { key: "B02010299", value: "LABORATORY LEUKOREDUCTION FILTERS - OTHER" },
        { key: "B0202", value: "MASSIVE TRANSFUSION THERAPY FILTERS (FOR 40 MICRON MICROAGGREGATES)" },
        { key: "B020201", value: "MASSIVE TRANSFUSION THERAPY FILTERS, WITH TRANSFUSION CONTROLLER" },
        { key: "B020202", value: "MASSIVE TRANSFUSION THERAPY FILTERS, W/O TRANSFUSION CONTROLLER" },
        { key: "B0280", value: "BLOOD FILTERS - ACCESSORIES" },
        { key: "B0299", value: "BLOOD FILTERS - OTHER" },
        { key: "B03", value: "APHERESIS DEVICES" },
        { key: "B0301", value: "APHERESIS COLLECTION DEVICES" },
        { key: "B030101", value: "APHERESIS PLASMA COLLECTION DEVICES" },
        { key: "B030102", value: "APHERESIS PLATELET COLLECTION DEVICES" },
        { key: "B030103", value: "APHERESIS LEUKOCYTE COLLECTION DEVICES" },
        { key: "B030104", value: "APHERESIS MULTIPLE BLOOD COMPONENT COLLECTION DEVICES" },
        { key: "B030199", value: "APHERESIS COLLECTION DEVICES - OTHER" },
        { key: "B0302", value: "APHERESIS THERAPY DEVICES" },
        { key: "B030201", value: "PLASMAPHERESIS DEVICES AND KITS," },
        { key: "B030202", value: "CYTAPHERESIS DEVICES AND KITS" },
        { key: "B030203", value: "SINGLE PLASMA COMPONENTS REMOVAL DEVICES AND KITS" },
        { key: "B030204", value: "EXTRACORPOREAL PHOTOCHAEMOTHERAPY OR PHOTOPHERESIS DEVICES AND KITS" },
        { key: "B030299", value: "APHERESIS THERAPY DEVICES - OTHER" },
        { key: "B0380", value: "APHERESIS DEVICES - ACCESSORIES" },
        { key: "B0399", value: "APHERESIS DEVICES - OTHER" },
        { key: "B04", value: "AUTOTRANSFUSION DEVICES" },
        { key: "B0401", value: "INTRA- AND POSTOPERATIVE BLOOD COLLECTION, WASHING AND REINFUSION DEVICES AND KITS" },
        { key: "B0402", value: "INTRA- AND POSTOPERATIVE BLOOD COLLECTION AND REINFUSION ONLY DEVICES AND KITS" },
        { key: "B0480", value: "AUTOTRANSFUSION DEVICES - ACCESSORIES" },
        { key: "B0499", value: "AUTOTRANSFUSION DEVICES - OTHER" },
        { key: "B05", value: "TOPICAL USE BLOOD COMPONENTS PREPARATION DEVICES" },
        { key: "B0501", value: "PLATELET GEL AUTOMATIC PREPARATION DEVICES (EXCLUDING BAGS)" },
        { key: "B0502", value: "FIBRIN GLUE AUTOMATIC PREPARATION DEVICES (EXCLUDING BAGS)" },
        { key: "B0599", value: "TOPICAL USE BLOOD COMPONENTS PREPARATION DEVICES - OTHER" },
        { key: "B06", value: "CELLULAR OR BIOLOGICAL MANIPULATION DEVICES" },
        { key: "B07", value: "BLOOD AND BLOOD COMPONENTS PRESERVATION SOLUTIONS" },
        { key: "B99", value: "HAEMATOLOGY AND HAEMOTRANSFUSION DEVICES - OTHER" },
        { key: "C", value: "CARDIOCIRCULATORY SYSTEM DEVICES" },
        { key: "C01", value: "ARTERIO-VENOUS SYSTEM DEVICES" },
        { key: "C0101", value: "PERIPHERAL  I.V. CATHETERS AND CANNULAS" },
        { key: "C010101", value: "PERIPHERAL I.V. CATHETERS" },
        { key: "C01010101", value: "PERIPHERAL I.V. CATHETERS, W/O SAFETY SYSTEMS" },
        { key: "C0101010101", value: "PERIPHERAL I.V. CATHETERS, W/O SAFETY SYSTEMS, WITH INJECTION VALVES" },
        { key: "C0101010102", value: "PERIPHERAL I.V. CATHETERS, W/O SAFETY SYSTEMS, W/O INJECTION VALVES" },
        { key: "C01010102", value: "PERIPHERAL I.V. CATHETERS, WITH SAFETY SYSTEMS" },
        { key: "C0101010201", value: "PERIPHERAL I.V. CATHETERS, WITH SAFETY SYSTEMS, WITH INJECTION VALVES" },
        { key: "C0101010202", value: "PERIPHERAL I.V. CATHETERS, WITH SAFETY SYSTEMS, W/O INJECTION VALVES" },
        { key: "C01010103", value: "PERIPHERAL I.V. CATHETERS, WITH INTEGRATED EXTENSIONS" },
        { key: "C01010180", value: "PERIPHERAL I.V. CATHETERS - ACCESSORIES" },
        { key: "C01010199", value: "PERIPHERAL I.V. CATHETERS - OTHER" },
        { key: "C010102", value: "PERIPHERAL I.V. CATHETER SYSTEMS" },
        { key: "C010103", value: "INTEGRATED PERIPHERAL I.V. DEVICES" },
        { key: "C010104", value: "UMBILICAL I.V. CANNULAS" },
        { key: "C010180", value: "PERIPHERAL I.V. CATHETERS AND CANNULAS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C010199", value: "PERIPHERAL I.V. CATHETERS AND CANNULAS - OTHER" },
        { key: "C0102", value: "CENTRAL I.V. CATHETERS" },
        { key: "C010201", value: "CENTRAL I.V. CATHETERS, PERIPHERAL ACCESS" },
        { key: "C01020101", value: "CENTRAL I.V. SINGLE-LUMEN CATHETERS, PERIPHERAL ACCESS" },
        { key: "C01020102", value: "CENTRAL I.V. MULTI-LUMEN CATHETERS, PERIPHERAL ACCESS" },
        { key: "C010202", value: "CENTRAL I.V. CATHETERS, NON-TUNNELED" },
        { key: "C01020201", value: "CENTRAL I.V. SINGLE-LUMEN CATHETERS, NON-TUNNELED" },
        { key: "C01020202", value: "CENTRAL VENOUS DOUBLE-LUMEN CATHETERS, NON-TUNNELED" },
        { key: "C01020203", value: "CENTRAL VENOUS MULTI-LUMEN (>2) CATHETERS, NON-TUNNELED" },
        { key: "C010203", value: "CENTRAL VENOUS CATHETERS, PARTIALLY TUNNELED" },
        { key: "C01020301", value: "CENTRAL VENOUS SINGLE-LUMEN CATHETERS, PARTIALLY TUNNELED" },
        { key: "C01020302", value: "CENTRAL VENOUS DOUBLE-LUMEN CATHETERS, PARTIALLY TUNNELED" },
        { key: "C01020303", value: "CENTRAL VENOUS MULTI-LUMEN (>2) CATHETERS, PARTIALLY TUNNELED" },
        { key: "C010204", value: "SUBCUTANEOUS IMPLANTABLE VENOUS ACCESS PORT SYSTEMS" },
        { key: "C01020401", value: "SUBCUTANEOUS IMPLANTABLE VENOUS ACCESS PORT SYSTEMS, SINGLE-CHAMBER" },
        { key: "C01020402", value: "SUBCUTANEOUS IMPLANTABLE VENOUS ACCESS PORT SYSTEMS, DUAL-CHAMBER OR DOUBLE-LUMEN" },
        { key: "C01020499", value: "SUBCUTANEOUS IMPLANTABLE VENOUS ACCESS PORT SYSTEMS - OTHER" },
        { key: "C010280", value: "CENTRAL VENOUS CATHETERS - ACCESSORIES" },
        { key: "C010299", value: "CENTRAL VENOUS CATHETERS - OTHER" },
        { key: "C0103", value: "ARTERIAL CANNULAS" },
        { key: "C010301", value: "RADIAL CANNULAS" },
        { key: "C010302", value: "UMBILICAL CANNULAS" },
        { key: "C010303", value: "FEMORAL CANNULAS" },
        { key: "C010380", value: "ARTERIAL CANNULAS - ACCESSORIES" },
        { key: "C010399", value: "ARTERIAL CANNULAS - OTHER" },
        { key: "C0104", value: "ANGIOGRAPHY AND HAEMODYNAMIC DEVICES" },
        { key: "C010401", value: "CARDIAC ANGIOGRAPHY DEVICES" },
        { key: "C01040101", value: "CARDIAC ANGIOGRAPHY DIAGNOSTIC DEVICES," },
        { key: "C0104010101", value: "CARDIAC ANGIOGRAPHY DIAGNOSTIC CATHETERS" },
        { key: "C0104010102", value: "CARDIAC AND INTRACORONARY ULTRASOUND CATHETERS" },
        { key: "C0104010199", value: "CARDIAC ANGIOGRAPHY DIAGNOSTIC DEVICES - OTHER" },
        { key: "C01040102", value: "CORONARY ANGIOGRAPHY THERAPEUTIC DEVICES" },
        { key: "C0104010201", value: "PERCUTANEOUS TRANSLUMINAL CORONARY ANGIOPLASTY (PTCA) DILATATION CATHETERS" },
        { key: "C010401020101", value: "PTCA BALLOON DILATION CATHETERS" },
        { key: "C010401020102", value: "CORONARY STENT IMPLANTATION DILATION CATHETERS" },
        { key: "C010401020180", value: "PTCA BALLOON DILATATION CATHETERS - ACCESSORIES" },
        { key: "C010401020199", value: "PTCA DIALATION CATHETERS - OTHER" },
        { key: "C0104010202", value: "CARDIAC ANGIOGRAPHY GUIDE CATHETERS" },
        { key: "C0104010203", value: "PHARMACEUTICAL INFUSION AND ADMINISTRATION INTRACORONARY AND INTRACARDIAC CATHETERS" },
        { key: "C0104010204", value: "CORONARY ARTERY ATHERECTOMY SYSTEMS" },
        { key: "C010401020401", value: "CORONARY ARTERY ATHERECTOMY SYSTEMS, DIRECTIONAL" },
        { key: "C010401020402", value: "CORONARY ARTERY ATHERECTOMY SYSTEMS, ROTATIONAL" },
        { key: "C010401020480", value: "CORONARY ATHERECTOMY SYSTEMS - ACCESSORIES" },
        { key: "C010401020499", value: "CORONARY ARTERY ATHERECTOMY SYSTEMS - OTHER" },
        { key: "C0104010205", value: "CARDIAC THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010401020501", value: "MANUAL CARDIAC THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010401020502", value: "MOTERED CARDIAC THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010401020580", value: "THROMBECTOMY AND CARDIAC THROMBOASPIRATION SYSTEMS - ACCESSORIES" },
        { key: "C0104010280", value: "INTERVENTIONAL CORONARY ANGIOGRAPHY DEVICES - ACCESSORIES" },
        { key: "C0104010299", value: "CARDIAC THROMBECTOMY AND THROMBOASPIRATION SYSTEMS - OTHER" },
        { key: "C01040180", value: "CORONARY ANGIOGRAPHY DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C01040199", value: "CARDIAC ANGIOGRAPHY DEVICES - OTHER" },
        { key: "C010402", value: "PERIPHERAL ANGIOGRAPHY DEVICES" },
        { key: "C01040201", value: "PERIPHERAL ANGIOGRAPHY DIAGNOSTIC DEVICES" },
        { key: "C0104020101", value: "PANORAMIC AND SELECTIVE PERIPHERAL DIAGNOSTIC ANGIOGRAPHY CATHETERS AND MICROCATHETERS" },
        { key: "C0104020102", value: "INTRAVASCULAR ULTRASOUND CATHETERS" },
        { key: "C0104020103", value: "VASCULAR OCCLUSION CATHETERS" },
        { key: "C0104020180", value: "DIAGNOSTIC PERIPHERAL ANGIOGRAPHY DEVICES - ACCESSORIES" },
        { key: "C0104020199", value: "PERIPHERAL ANGIOGRAPHY DIAGNOSTIC DEVICES - OTHER" },
        { key: "C01040202", value: "PERIPHERAL ANGIOGRAPHY THERAPEUTIC DEVICES" },
        { key: "C0104020201", value: "PERCUTANEOUS TRANSLUMINAL ANGIOPLASTY (PTA) DILATATION CATHETERS" },
        { key: "C010402020101", value: "PTA BALLOON DILATATION CATHETERS" },
        { key: "C010402020102", value: "STENT POSITIONING VASCULAR BALLOON DILATATION CATHETERS" },
        { key: "C010402020180", value: "PTA BALLOON DILATATION CATHETERS - ACCESSORIES" },
        { key: "C010402020199", value: "PTA DILATATION CATHETERS - OTHER" },
        { key: "C0104020202", value: "PERIPHERAL EMBOLISATION CATHETERS AND MICROCATHETERS" },
        { key: "C0104020203", value: "EMBOLISATION DEVICES" },
        { key: "C010402020301", value: "EMBOLISATION COILS" },
        { key: "C010402020302", value: "EMBOLISATION FLUIDS" },
        { key: "C010402020303", value: "EMBOLISATION PARTICLES AND MICROSPHERES" },
        { key: "C010402020380", value: "EMBOLISATION DEVICES - ACCESSORIES" },
        { key: "C010402020399", value: "EMBOLISATION DEVICES - OTHER" },
        { key: "C0104020204", value: "PERIPHERAL ANGIOGRAPHY GUIDE CATHETERS" },
        { key: "C0104020205", value: "PHARMACEUTICAL INFUSION AND ADMINISTRATION INTRAVASCULAR CATHETERS AND MICROCATHETERS" },
        { key: "C0104020206", value: "PERIPHERAL ATHERECTOMY SYSTEMS" },
        { key: "C010402020601", value: "PERIPHERAL ATHERECTOMY SYSTEMS, DIRECTIONAL" },
        { key: "C010402020602", value: "PERIPHERAL ATHERECTOMY SYSTEMS, ROTATIONAL" },
        { key: "C010402020680", value: "PERIPHERAL ATHERECTOMY DEVICES - ACCESSORIES" },
        { key: "C010402020699", value: "PERIPHERAL ATHERECTOMY SYSTEMS - OTHER" },
        { key: "C0104020207", value: "PERIPHERAL THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010402020701", value: "MANUAL PERIPHERAL THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010402020702", value: "MECHANICAL PERIPHERAL THROMBECTOMY AND THROMBOASPIRATION SYSTEMS" },
        { key: "C010402020780", value: "THROMBECTOMY AND PERIPHERAL THROMBOASPIRATION SYSTEMS - ACCESSORIES" },
        { key: "C0104020208", value: "TRANSJUGULAR INTRAHEPATIC PORTOSYSTEMIC SHUNT (TIPS) PERCUTANEOUS SYSTEMS" },
        { key: "C0104020209", value: "PERIPHERAL VASCULAR SYSTEM TOTAL CHRONIC OCCLUSION DEVICES" },
        { key: "C0104020280", value: "INTERVENTIONAL PERIPHERAL ANGIOGRAPHY DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C0104020299", value: "PERIPHERAL ANGIOGRAPHY THERAPEUTIC DEVICES - OTHER" },
        { key: "C01040280", value: "PERIPHERAL ANGIOGRAPHY DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C01040299", value: "PERIPHERAL ANGIOGRAPHY DEVICES - OTHER" },
        { key: "C010403", value: "FRACTIONAL FLOW RESERVE (FFR) MEASUREMENT DEVICES" },
        { key: "C010480", value: "ANGIOGRAPHY AND HEMODYNAMICS DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C010499", value: "ANGIOGRAPHY AND HEMODYNAMICS DEVICES - OTHER" },
        { key: "C0105", value: "INTRAVASCULAR PROTECTION DEVICES" },
        { key: "C010501", value: "VENA CAVA FILTERS" },
        { key: "C01050101", value: "VENA CAVA FILTERS, RETRIEVABLE" },
        { key: "C01050102", value: "VENA CAVA FILTERS, PERMANENT" },
        { key: "C010502", value: "INTRAVASCULAR EMOBILIC PROTECTION CATHETERS AND SYSTEMS" },
        { key: "C01050201", value: "PTCA EMBOLIC PROTECTION CATHETERS AND SYSTEMS" },
        { key: "C01050202", value: "PTA EMBOLIC PROTECTION CATHETERS AND SYSTEMS" },
        { key: "C01050203", value: "ARTERIO-SURGERY EMBOLIC PROTECTION CATHETERS AND SYSTEMS" },
        { key: "C01050299", value: "INTRAVASCULAR EMBOLIC PROTECTION CATHETERS AND SYSTEMS - OTHER" },
        { key: "C010580", value: "INTRAVASCULAR PROTECTION DEVICES - ACCESSORIES" },
        { key: "C010599", value: "INTRAVASCULAR PROTECTION DEVICES - OTHER" },
        { key: "C0180", value: "ARTERO-VENOUS SYSTEM DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C0190", value: "DEVICES FOR VASCULAR PROCEDURES - VARIOUS" },
        { key: "C019001", value: "AORTIC COUNTERPULSATION CATHETERS" },
        { key: "C019002", value: "EMBOLECTOMY CATHETERS" },
        { key: "C019003", value: "THERMODILUTION CATHETERS" },
        { key: "C019004", value: "CARDIOVASCULAR MONITORING SYSTEMS" },
        { key: "C019005", value: "RETRIEVING SYSTEMS FOR VASCULAR FOREIGN BODIES" },
        { key: "C019006", value: "CAROTID ARTERY SHUNTS" },
        { key: "C019007", value: "CARDIOVASCULAR SYSTEM BRACHYTHERAPY RADIOFREQUENCY SYSTEMS" },
        { key: "C019008", value: "IMPLANTABLE SUBCUTANEOUS ARTERIAL ACCESS SYSTEMS" },
        { key: "C019009", value: "AORTIC OCCLUSION SYSTEMS" },
        { key: "C019010", value: "INTRAVASCULAR RECANALISATION SYSTEMS" },
        { key: "C019011", value: "INTRAVASCULAR AND CARDIAC BIOPSY SYSTEMS" },
        { key: "C01901101", value: "INTRAVASCULAR BIOPSY SYSTEMS" },
        { key: "C01901102", value: "MYOCARDIAL BIOPSY KITS" },
        { key: "C019012", value: "AORTIC PUNCHES AND AORTOTOMY SYSTEMS" },
        { key: "C01901201", value: "AORTIC PUNCHES" },
        { key: "C01901202", value: "AORTOTOMY SYSTEMS" },
        { key: "C019013", value: "ISOLATED TISSUE PERFUSION SYSTEMS (LOCOREGIONAL TUMOR THERAPY)" },
        { key: "C019014", value: "CARDIAC VALVULOPLASTY CATHETERS" },
        { key: "C019015", value: "CARDIAC TRANSSEPTAL PUNCTURE KITS" },
        { key: "C019016", value: "PERITONEOVENOUS SHUNTS" },
        { key: "C019017", value: "VALVULOTOMES, SINGLE-USE" },
        { key: "C019018", value: "SURGICAL VENTRICULAR REMODELLING SYSTEMS" },
        { key: "C019019", value: "VESSEL STRIPPER SYSTEMS" },
        { key: "C01901901", value: "VEIN STRIPPER DEVICES" },
        { key: "C01901902", value: "RADIOFREQUENCY VENOUS ABLATION CATHETERS" },
        { key: "C01901903", value: "VASCULAR EXTRACTION SYSTEMS" },
        { key: "C01901999", value: "VEIN STRIPPER SYSTEMS - OTHER" },
        { key: "C019020", value: "SELECTIVE LOCAL HYPERTHERMIA KITS" },
        { key: "C0199", value: "ARTERIO-VENOUS DEVICES - OTHER" },
        { key: "C02", value: "ARRHYTHMOLOGY DEVICES" },
        { key: "C0201", value: "CARDIAC ELECTROPHYSIOLOGY AND MAPPING DEVICES" },
        { key: "C020101", value: "ARRHYTHMOLOGY BIPOLAR DIAGNOSTIC CATHETERS" },
        { key: "C020102", value: "ARRHYTHMOLOGY TRIPOLAR DIAGNOSTIC CATHETERS" },
        { key: "C020103", value: "ARRHYTHMOLOGY TETRAPOLAR DIAGNOSTIC CATHETERS" },
        { key: "C020104", value: "ARRHYTHMOLOGY MULTIPOLAR DIAGNOSTIC CATHETERS" },
        { key: "C02010401", value: "ARRHYTHMOLOGY MULTIPOLAR DIAGNOSTIC CATHETERS, CONVENTIONAL" },
        { key: "C02010402", value: "ARRHYTHMOLOGY MULTIPOLAR DIAGNOSTIC CATHETERS, BASKET TYPE" },
        { key: "C02010403", value: "ARRHYTHMOLOGY MULTIPOLAR DIAGNOSTIC CATHETERS, ADJUSTABLE" },
        { key: "C02010499", value: "ARRHYTHMOLOGY MULTIPOLAR DIAGNOSTIC CATHETERS – OTHER" },
        { key: "C020105", value: "NON-CONVENTIONAL MAPPING (CONTACT AND NON-CONTACT) THREE-DIMENSIONAL DIAGNOSTIC CATHETERS" },
        { key: "C020180", value: "CARDIAC ELECTROPHYSIOLOGY AND MAPPING DEVICES - ACCESSORIES" },
        { key: "C020199", value: "CARDIAC ELECTROPHYSIOLOGY AND MAPPING DEVICES - OTHER" },
        { key: "C0202", value: "CARDIAC TEMPORARY STIMULATION DEVICES (WITH OR WITHOUT ACTIVE SUBSTANCES)" },
        { key: "C020201", value: "TEMPORARY ENDOCARDIAL LEADS" },
        { key: "C020202", value: "EPICARDIAL LEADS (MONOPOLAR AND BIPOLAR)" },
        { key: "C020203", value: "TRANSOESOPHAGEAL RECORDING AND STIMULATION LEADS" },
        { key: "C020280", value: "TEMPORARY CARDIAC ELECTRICAL STIMULATION DEVICES - ACCESSORIES" },
        { key: "C020299", value: "CARDIAC TEMPORARY STIMULATION DEVICES (WITH OR WITHOUT ACTIVE SUBSTANCES) - OTHER" },
        { key: "C0203", value: "CARDIAC TISSUE ABLATION DEVICES" },
        { key: "C020301", value: "ARRHYTHMOGENIC FOCI RADIOFREQUENCY ABLATION CATHETERS" },
        { key: "C020302", value: "ARRHYTHMOGENIC FOCI CRYOENERGY ABLATION CATHETERS" },
        { key: "C020304", value: "ARRHYTHMOGENIC FOCI PULSED FIELD ABLATION CATHETERS" },
        { key: "C020305", value: "ARRHYTHMOGENIC FOCI LASER ABLATION CATHETERS" },
        { key: "C020380", value: "ABLATION OF ARRHYTHMOGENIC FOCUS DEVICES - ACCESSORIES" },
        { key: "C020399", value: "CARDIAC TISSUE ABLATION DEVICES - OTHER" },
        { key: "C0204", value: "EXTERNAL CARDIOVERSION AND DEFIBRILLATION DEVICES" },
        { key: "C020401", value: "EXTERNAL CARDIOVERSION DEFIBRILLATOR ELECTRODE PADS" },
        { key: "C020402", value: "TEMPORARY CARDIOVERSION LEADS" },
        { key: "C02040201", value: "TEMPORARY ENDOCAVITARY CARDIOVERSION LEADS" },
        { key: "C02040202", value: "TEMPORARY TRANSOESOPHAGEAL CARDIOVERSION LEADS" },
        { key: "C02040299", value: "TEMPORARY CARDIOVERSION LEADS - OTHER" },
        { key: "C020480", value: "CARDIOVERSION AND EXTERNAL DEFIBRILLATION DEVICES - ACCESSORIES" },
        { key: "C020499", value: "EXTERNAL CARDIOVERSION AND DEFIBRILLATION DEVICES - OTHER" },
        { key: "C0205", value: "CARDIAC DIAGNOSTIC DEVICES" },
        { key: "C020501", value: "ECG ELECTRODES" },
        { key: "C020599", value: "CARDIAC DIAGNOSTIC DEVICES - OTHER" },
        { key: "C0280", value: "ARRYTHMOLOGY DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C0299", value: "ARRHYTHMOLOGY DEVICES - OTHER" },
        { key: "C03", value: "CARDIAC SURGERY AND HEART TRANSPLANT DEVICES" },
        { key: "C0301", value: "EXTRACORPOREAL ASSISTED CIRCULATION DEVICES" },
        { key: "C030101", value: "EXTRACORPOREAL CIRCULATION KITS" },
        { key: "C03010101", value: "EXTRACORPOREAL CIRCULATION CIRCUITS" },
        { key: "C03010102", value: "OXYGENATOR KITS" },
        { key: "C03010104", value: "EXTRACORPOREAL CIRCULATION FILTERS" },
        { key: "C03010199", value: "EXTRACORPOREAL CIRCULATION KITS - OTHER" },
        { key: "C030102", value: "CARDIOPLEGIA SOLUTION ADMINISTRATION KITS" },
        { key: "C030103", value: "CIRCULATORY SUPPORT KITS" },
        { key: "C03010301", value: "CARDIOPULMONARY SUPPORT KITS (C.P.S. AND ECMO)" },
        { key: "C03010399", value: "CIRCULATORY SUPPORT KITS - OTHER" },
        { key: "C030104", value: "EXTRACORPOREAL CIRCULATION CANNULAS" },
        { key: "C03010401", value: "EXTRACORPOREAL CIRCULATION ARTERIAL CANNULAS" },
        { key: "C0301040101", value: "EXTRACORPOREAL CIRCULATION ARTERIAL CANNULAS, W/O FILTER" },
        { key: "C0301040102", value: "EXTRACORPOREAL CIRCULATION ARTERIAL CANNULAS, WITH FILTER" },
        { key: "C03010402", value: "EXTRACORPOREAL CIRCULATION VENOUS CANNULAS" },
        { key: "C0301040201", value: "ATRIOCAVAL CANNULAS" },
        { key: "C0301040202", value: "BICAVAL CANNULAS" },
        { key: "C03010403", value: "INTRACAVITARY SUCTION CANNULAS" },
        { key: "C03010404", value: "CARDIOPLEGIA CANNULAS" },
        { key: "C0301040401", value: "EXTRACORPOREAL CIRCULATION NON-SELECTIVE PERFUSION CANNULAS (WITH AORTIC VENTING LUMEN)" },
        { key: "C0301040402", value: "SELECTIVE CORONARY ARTERIES PERFUSION CANNULAS" },
        { key: "C0301040499", value: "CARDIOPLEGIA CANNULAS - OTHER" },
        { key: "C03010405", value: "SELECTIVE CAROTID ARTERY AND CORONARY SINUS PERFUSION CANNULAS" },
        { key: "C03010406", value: "PERCUTANEOUS ARTERIOVENOUS CANNULAS (WITH ENDOCLAMP AND CARDIPLEGIA VENTING LUMEN)" },
        { key: "C03010499", value: "EXTRACORPOREAL CIRCULATION CANNULAS - OTHER" },
        { key: "C030180", value: "EXTRACORPOREAL AND ASSISTED CIRCULATION DEVICES - ACCESSORIES" },
        { key: "C030199", value: "EXTRACORPOREAL AND ASSISTED CIRCULATION DEVICES - OTHER" },
        { key: "C0380", value: "HEART SURGERY AND ORGAN TRANSPLANTATION DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C0390", value: "CARDIAC SURGERY AND HEART TRANSPLANT DEVICES - VARIOUS" },
        { key: "C039001", value: "MINIMALLY INVASIVE ACCESS CARDIAC SURGERY SYSTEMS" },
        { key: "C03900101", value: "DIRECT VISION MINIMALLY INVASIVE CARDIAC ACCESS KITS" },
        { key: "C03900102", value: "MINI-INVASIVE VIDEO-ASSISTED CARDIO-SURGICAL ACCESS KITS (WITH EXTERNAL MONITOR)" },
        { key: "C039002", value: "BEATING HEART CARDIOSURGERY DEVICES" },
        { key: "C03900201", value: "EPI-MYOCARDIAL STABILISATION KITS" },
        { key: "C03900202", value: "INTRACORONARY SHUNTS" },
        { key: "C03900203", value: "GAS-JET CARDIAC SURGERY FIELD CLEANSING KITS (BLOWER)" },
        { key: "C03900299", value: "BEATING HEART CARDIOSURGERY DEVICES - OTHER" },
        { key: "C0399", value: "CARDIOSURGERY AND ORGAN TRANSPLANTATION DEVICES - OTHER" },
        { key: "C04", value: "CARDIOVASCULAR GUIDEWIRES" },
        { key: "C0401", value: "CORONARY ARTERY GUIDEWIRES" },
        { key: "C040101", value: "CORONARY ARTERY DIAGNOSTIC GUIDEWIRES" },
        { key: "C04010101", value: "CORONARY ARTERY DIAGNOSTIC GUIDEWIRES, HYDROPHILIC" },
        { key: "C04010102", value: "CORONARY ARTERY DIAGNOSTIC GUIDEWIRES, NON-HYDROPHILIC" },
        { key: "C04010199", value: "CORONARY ARTERY DIAGNOSTIC GUIDEWIRES - OTHER" },
        { key: "C040102", value: "CORONARY ARTERY THERAPEUTIC GUIDEWIRES" },
        { key: "C04010201", value: "CORONARY ARTERY THERAPEUTIC GUIDEWIRES, HYDROPHILIC" },
        { key: "C04010202", value: "CORONARY ARTERY THERAPEUTIC GUIDEWIRES, NON-HYDROPHILIC" },
        { key: "C04010299", value: "CORONARY ARTERY THERAPEUTIC GUIDEWIRES - OTHER" },
        { key: "C0402", value: "PERIPHERAL VASCULAR GUIDEWIRES" },
        { key: "C040201", value: "PERIPHERAL VASCULAR DIAGNOSTIC GUIDEWIRES" },
        { key: "C04020101", value: "PERIPHERAL VASCULAR DIAGNOSTIC GUIDEWIRES, HYDROPHILIC" },
        { key: "C04020102", value: "PERIPHERAL VASCULAR DIAGNOSTIC GUIDEWIRES, NON-HYDROPHILIC" },
        { key: "C04020199", value: "PERIPHERAL VASCULAR DIAGNOSTIC GUIDEWIRES- OTHER" },
        { key: "C040202", value: "PERIPHERAL VASCULAR THERAPEUTIC GUIDEWIRES" },
        { key: "C04020201", value: "PERIPHERAL VASCULAR THERAPEUTIC GUIDEWIRES, HYDROPHILIC" },
        { key: "C04020202", value: "PERIPHERAL VASCULAR THERAPEUTIC GUIDEWIRES, NON-HYDROPHILIC" },
        { key: "C04020299", value: "PERIPHERAL VASCULAR GUIDEWIRES, THERAPEUTICAL - OTHER" },
        { key: "C0403", value: "CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES" },
        { key: "C040301", value: "DIAGNOSTIC CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES" },
        { key: "C04030101", value: "DIAGNOSTIC CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES, HYDROPHILIC" },
        { key: "C04030102", value: "DIAGNOSTIC CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES, NON-HYDROPHILIC" },
        { key: "C04030199", value: "DIAGNOSTIC CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES - OTHER" },
        { key: "C040302", value: "INTERVENTIONAL CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES" },
        { key: "C04030201", value: "INTERVENTIONAL CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES, HYDROPHILIC" },
        { key: "C04030202", value: "INTERVENTIONAL CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES, NON-HYDROPHILIC" },
        { key: "C04030299", value: "INTERVENTIONAL CORONARY AND PERIPHERAL VASCULAR GUIDE WIRES - OTHER" },
        { key: "C0480", value: "CARDIOVASCULAR GUIDEWIRES - ACCESSORIES" },
        { key: "C0499", value: "CARDIOVASCULAR GUIDEWIRES - OTHER" },
        { key: "C05", value: "CARDIOVASCULAR INTRODUCER SHEATHS" },
        { key: "C0501", value: "CARDIOVASCULAR INTRODUCER SHEATHS, NON-VALVED" },
        { key: "C0502", value: "CARDIOVASCULAR INTRODUCER SHEATHS, VALVED" },
        { key: "C0503", value: "CARDIOVASCULAR INTRODUCER SHEATHS, PEEL-AWAY" },
        { key: "C0504", value: "ARTERIAL INTRODUCTION SETS" },
        { key: "C0580", value: "CARDIOVASCULAR INTRODUCER SHEATHS - ACCESSORIES" },
        { key: "C058001", value: "ADAPTERS AND CONNECTORS FOR CARDIOVASCULAR INTRODUCERS" },
        { key: "C058099", value: "CARDIOCIRCULATORY SYSTEM INTRODUCERS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C0599", value: "CARDIOVASCULAR INTRODUCER SHEATHS - OTHER" },
        { key: "C06", value: "CARDIOVASCULAR SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "C0601", value: "CARDIOVASCULAR SURGERY INSTRUMENT KITS NOT INCLUDED IN OTHER CLASSES, SINGLE-USE" },
        { key: "C0602", value: "CARDIOVASCULAR SURGERY DILATORS, SINGLE-USE" },
        { key: "C0603", value: "CARDIOVASCULAR SURGERY FORCEPS, SINGLE-USE" },
        { key: "C0699", value: "CARDIOVASCULAR SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "C90", value: "CARDIOCIRCULATORY DEVICES - VARIOUS" },
        { key: "C9001", value: "HAEMOSTASIS VALVES AND SYSTEMS" },
        { key: "C900101", value: "HAEMOSTASIS VALVES" },
        { key: "C900102", value: "HAEMOSTASIS ADAPTORS" },
        { key: "C900103", value: "PERCUTANEOUS ARTERIAL ACCESS HAEMOSTASIS SYSTEMS" },
        { key: "C90010301", value: "HAEMOSTASIS MECHANICAL SYSTEMS (INCLUDING SINGLE-USE TOURNIQUETS)" },
        { key: "C90010302", value: "COLLAGEN-BASED HAEMOSTASIS SYSTEMS" },
        { key: "C90010303", value: "HAEMOSTASIS SYSTEMS WITH SUTURE OR CLIP SYSTEMS" },
        { key: "C90010399", value: "PERCUTANEOUS ARTERIAL ACCESS HAEMOSTASIS SYSTEMS - OTHER" },
        { key: "C900180", value: "HAEMOSTASIS SYSTEMS - ACCESSORIES" },
        { key: "C900199", value: "HAEMOSTASIS SYSTEMS - OTHER" },
        { key: "C9002", value: "VASCULAR AND FASCIAL DILATORS" },
        { key: "C9003", value: "CARDIOVASCULAR SENSORS" },
        { key: "C900301", value: "PULSE OXIMETER SENSORS" },
        { key: "C900399", value: "CARDIOVASCULAR SENSORS - OTHER" },
        { key: "C9005", value: "PHONENDOSCOPES AND STETHOSCOPES" },
        { key: "C9006", value: "ANEROID SPHYGMOMANOMETERS" },
        { key: "C9080", value: "CARDIOCIRCULATORY SYSTEM DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "C99", value: "CARDIOCIRCULATORY DEVICES - OTHER" },
        { key: "D", value: "DISINFECTANTS, ANTISEPTICS, STERILISING AGENTS AND DETERGENTS FOR MEDICAL DEVICES" },
        { key: "D01", value: "ALDEHYDES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0101", value: "GLUTARALDEHYDE AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D010101", value: "GLUTARALDEHYDE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D01010101", value: "GLUTARALDEHYDE, BASIC SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D01010102", value: "GLUTARALDEHYDE, ACIDIC SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D01010103", value: "GLUTARALDEHYDE, NEUTRAL SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D010102", value: "GLUTARALDEHYDE AND POLYPHENOLS FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D01010201", value: "GLUTARALDEHYDE AND POLYPHENOLS, SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D010103", value: "ORTHOPHTALALDEHYDE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D010199", value: "ASSOCIATED GLUTARALDEHYDE FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0199", value: "ALDEHYDES FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D02", value: "BIGUANIDES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0201", value: "CHLORHEXIDINE AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D020101", value: "CHLORHEXIDINE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D02010101", value: "CHLORHEXIDINE, AQUEOUS SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D02010102", value: "CHLORHEXIDINE, HYDROALCOHOLIC SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D02010199", value: "CHLORHEXIDINE FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D020102", value: "CHLORHEXIDINE WITH DETERGENT FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D020199", value: "CHLORHEXIDINE IN ASSCOCIATION FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0299", value: "BIGUANIDES FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D03", value: "CHLORINE DERIVATIVES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0301", value: "HYPOCHLORITES AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030101", value: "HYPOCHLORITE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D03010101", value: "HYPOCHLORITE, AQUEOUS SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D03010102", value: "HYPOCHLORITE, HYDROALCOHOLIC SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D03010199", value: "HYPOCHLORITE FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D030102", value: "HYPOCHLORITE WITH DETERGENT FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030103", value: "HYPOCHLORITE WITH DISINCRUSTANTS FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030199", value: "ASSOCIATED HYPOCHLORITES FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0302", value: "DICHLOROISOCYANURATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0303", value: "SODIUM CHLORITES AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030301", value: "SODIUM CHLORITE AND LACTIC ACID FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030302", value: "SODIUM CHLORITE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D030399", value: "ASSOCIATED SODIUM CHLORITES FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0399", value: "CHLORINE DERIVATIVES FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D05", value: "OXYGEN PRODUCERS FOR DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0501", value: "PERACETIC ACID AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D050101", value: "PERACETIC AND ACETIC ACID WITH HYDROGEN PEROXIDE FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D050102", value: "PERACETIC ACID AND ADAMANTAN DERIVATIVES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D050103", value: "PERACETIC ACID FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D050199", value: "ASSOCIATED PERACETIC ACID FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0502", value: "HYDROGEN PEROXIDE FOR DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0599", value: "OXYGEN PRODUCERS FOR DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D06", value: "PHENOLS FOR DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0601", value: "POLYPHENOLS AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D060101", value: "POLYPHENOLS " },
        { key: "D06010101", value: "POLYPHENOLS, AQUEOUS SOLUTION FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D06010199", value: "POLYPHENOLS FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D060102", value: "POLYPHENOLS WITH DETERGENTSFOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D060199", value: "ASSOCIATED POLYPHENOLS FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D0699", value: "PHENOLS FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D07", value: "ALCOHOLS FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0701", value: "ETHANOL FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0702", value: "ISOPROPYL ALCOHOL FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0799", value: "ALCOHOLS FOR THE DISINFECTION OF MEDICAL DEVICES - OTHER" },
        { key: "D08", value: "DETERGENTS FOR MEDICAL DEVICES" },
        { key: "D0801", value: "ENZYMATIC DETERGENTS FOR MEDICAL DEVICES" },
        { key: "D0899", value: "DETERGENTS FOR MEDICAL DEVICES - OTHER" },
        { key: "D09", value: "AMMONIUM SALTS AND ASSOCIATES FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0901", value: "AMMONIUM SALTS FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D0902", value: "ASSOCIATED AMMONIUM SALTS FOR THE DISINFECTION OF MEDICAL DEVICES" },
        { key: "D99", value: "DISINFECTANTS, ANTISEPTICS, STERILISING AGENTS AND DETERGENTS FOR MEDICAL DEVICES - OTHER" },
        { key: "F", value: "DIALYSIS DEVICES" },
        { key: "F01", value: "DIALYSIS FILTERS" },
        { key: "F0106", value: "HAEMODIALYSIS, HAEMOFILTRATION, HAEMODIAFILTRATION FILTERS" },
        { key: "F010601", value: "DIALYSERS - UFC < 18 ml/h/mmHg" },
        { key: "F01060101", value: "DIALYSERS - UFC < 18 ml/h/mmHg, CELLULOSE MEMBRANES" },
        { key: "F01060102", value: "DIALYSERS - UFC < 18 ml/h/mmHg, SUBSTITUTED CELLULOSE MEMBRANES" },
        { key: "F01060103", value: "DIALYSERS - UFC < 18 ml/h/mmHg, SYNTHETIC MEMBRANES" },
        { key: "F01060199", value: "DIALYSERS - UFC < 18 ml/h/mmHg - OTHER" },
        { key: "F010602", value: "DIALYSERS - UFC = 18 - 35 ml/h/mmHg" },
        { key: "F01060201", value: "DIALYSERS - UFC = 18 - 35 ml/h/mmHg, CELLULOSE MEMBRANES" },
        { key: "F01060202", value: "DIALYSERS - UFC = 18 - 35 ml/h/mmHg, SUBSTITUTED CELLULOSE MEMBRANES" },
        { key: "F01060203", value: "DIALYSERS - UFC = 18 - 35 ml/h/mmHg, SYNTHETIC MEMBRANES" },
        { key: "F01060299", value: "DIALYSERS - UFC = 18 - 35 ml/h/mmHg - OTHER" },
        { key: "F010603", value: "DIALYSERS - UFC > 35 ml/h/mmHg" },
        { key: "F01060301", value: "DIALYSERS - UFC > 35 ml/h/mmHg, CELLULOSE MEMBRANES" },
        { key: "F01060302", value: "DIALYSERS - UFC > 35 ml/h/mmHg, SUBSTITUTED CELLULOSE MEMBRANES" },
        { key: "F01060303", value: "DIALYSERS - UFC > 35 ml/h/mmHg, SYNTHETIC MEMBRANES" },
        { key: "F01060399", value: "DIALYSERS - UFC > 35 ml/h/mmHg - OTHER" },
        { key: "F010604", value: "DIALYSERS FOR SPECIAL HAEMODIAFILTRATION AND OTHER THERAPIES" },
        { key: "F0107", value: "HAEMOPERFUSION FILTERS" },
        { key: "F010701", value: "HAEMOPERFUSION CARBON FILTERS" },
        { key: "F010702", value: "HAEMOPERFUSION RESIN FILTERS" },
        { key: "F010799", value: "HAEMOPERFUSION FILTERS - OTHER" },
        { key: "F0108", value: "ADSORPTION FILTERS AND COLUMNS" },
        { key: "F010801", value: "IMMUNOADSORPTION FILTERS AND COLUMNS" },
        { key: "F01080101", value: "IMMUNOADSORPTION FILTERS" },
        { key: "F01080102", value: "IMMUNOADSORPTION COLUMNS" },
        { key: "F010802", value: "ENDOTOXIN REMOVAL FILTERS AND COLUMNS" },
        { key: "F01080201", value: "ENDOTOXIN REMOVAL FILTERS" },
        { key: "F01080202", value: "ENDOTOXIN REMOVAL COLUMNS" },
        { key: "F0109", value: "PERITONEAL DIALYSIS FILTERS" },
        { key: "F0199", value: "HAEMODIALYSIS FILTERS - OTHER" },
        { key: "F02", value: "DIALYSIS LINES" },
        { key: "F0201", value: "ARTERIOVENOUS DIALYSIS LINES FOR HAEMODIALYSIS - HAEMOFILTRATION -HAEMODIAFILTRATION" },
        { key: "F020101", value: "ARTERIOVENOUS DIALYSIS LINES, ONE NEEDLE" },
        { key: "F020102", value: "ARTERIOVENOUS DIALYSIS LINES, TWO NEEDLES" },
        { key: "F020104", value: "REINFUSION DIALYSIS LINES" },
        { key: "F020180", value: "ARTERIOVENOUS DIALYSIS LINES FOR HAEMODIALYSIS - HAEMOFILTRATION -HAEMODIAFILTRATION - ACCESSORIES" },
        { key: "F020199", value: "ARTERIOVENOUS DIALYSIS LINES FOR HAEMODIALYSIS - HAEMOFILTRATION -HAEMODIAFILTRATION - OTHER" },
        { key: "F0202", value: "PERITONAEAL DIALYSIS LINES" },
        { key: "F020201", value: "PERMANENT PERITONAEAL DIALYSIS LINES" },
        { key: "F02020101", value: "PERMANENT PERITONAEAL DIALYSIS LINES, ONE BAG (CAPD)" },
        { key: "F02020102", value: "PERMANENT PERITONAEAL DIALYSIS LINES, TWO BAGS (CAPD)" },
        { key: "F02020199", value: "PERMANENT PERITONAEAL DIALYSIS LINES - OTHER" },
        { key: "F020202", value: "TEMPORARY PERITONAEAL DIALYSIS LINES" },
        { key: "F02020201", value: "TEMPORARY PERITONAEAL DIALYSIS LINES, GRAVITY (APD)" },
        { key: "F02020202", value: "TEMPORARY PERITONAEAL DIALYSIS LINES, WITH PUMP (APD)" },
        { key: "F02020299", value: "TEMPORARY PERITONAEAL DIALYSIS LINES - OTHER" },
        { key: "F020280", value: "PERITONAEAL DIALYSIS LINES - ACCESSORIES" },
        { key: "F020299", value: "PERITONAEAL DIALYSIS LINES - OTHER" },
        { key: "F0299", value: "DIALYSIS LINES - OTHER" },
        { key: "F03", value: "DIALYSIS KITS" },
        { key: "F0301", value: "HAEMOFILTRATION-HAEMODIAFILTRATION KITS" },
        { key: "F0302", value: "BIOFILTRATION KITS" },
        { key: "F0303", value: "HAEMODIALYSIS KITS" },
        { key: "F0304", value: "DIALYSIS WASHING/FILLING KITS" },
        { key: "F0305", value: "HAEMOPERFUSION KITS" },
        { key: "F0306", value: "CONTINUOUS DIALYSIS KITS" },
        { key: "F0307", value: "ULTRAFILTRATION KITS" },
        { key: "F0399", value: "DIALYSIS KITS - OTHER" },
        { key: "F04", value: "DIALYSIS CONCENTRATES" },
        { key: "F0401", value: "DIALYSIS CONCENTRATES, ACID SOLUTIONS" },
        { key: "F040101", value: "DIALYSIS CONCENTRATES, ACID SOLUTIONS, NON-STERILE" },
        { key: "F040102", value: "DIALYSIS CONCENTRATES, ACID SOLUTIONS, STERILE" },
        { key: "F0402", value: "DIALYSIS CONCENTRATES, BASIC SOLUTIONS" },
        { key: "F040201", value: "DIALYSIS CONCENTRATES, BASIC SOLUTIONS, POWDER" },
        { key: "F040202", value: "DIALYSIS CONCENTRATES, BASIC SOLUTIONS, LIQUID" },
        { key: "F0403", value: "DIALYSIS CONCENTRATES, WITHOUT ACETATE BUFFER" },
        { key: "F040302", value: "DIALYSIS CONCENTRATES, WITHOUT ACETATE BUFFER - AFB" },
        { key: "F040399", value: "DIALYSIS CONCENTRATES, WITHOUT ACETATE BUFFER FOR OTHER TREATMENTS" },
        { key: "F0404", value: "DIALYSIS PROCEDURES, SALTS" },
        { key: "F0499", value: "DIALYSIS CONCENTRATES - OTHER" },
        { key: "F05", value: "DEVICES FOR MICRODIALYSIS OF SPECIFIC ORGANS" },
        { key: "F90", value: "DIALYSIS DEVICES - VARIOUS" },
        { key: "F9001", value: "PERITONAEAL DIALYSIS DEVICES (NOT INCLUDED IN OTHER GROUPS)" },
        { key: "F900101", value: "PERITONEAL DIALYSIS CATHETERS AND KITS" },
        { key: "F900199", value: "PERITONAEAL DIALYSIS - OTHER" },
        { key: "F9002", value: "VASCULAR ACCESS DEVICES (ONLY FOR HAEMODIALYSIS)" },
        { key: "F900201", value: "TEMPORARY HEMODIALYSIS CATHETERS AND KITS" },
        { key: "F900202", value: "PERMANENT HEMODIALYSIS CATHETERS AND KITS" },
        { key: "F900299", value: "VASCULAR ACCESS DEVICES (ONLY FOR HAEMODIALYSIS) - OTHER" },
        { key: "F9003", value: "DIALYSIS ADAPTORS" },
        { key: "F900301", value: "HAEMODIALYSIS ADAPTORS" },
        { key: "F900302", value: "PERITONAEAL DIALYSIS ADAPTORS" },
        { key: "F9004", value: "DIALYSATE COLLECTION AND REINFUSION BAGS" },
        { key: "F900401", value: "DIALYSATE COLLECTION BAGS" },
        { key: "F90040101", value: "HAEMODIALYSATE COLLECTION BAGS" },
        { key: "F90040102", value: "PERITONAEAL DIALYSATE COLLECTION BAGS" },
        { key: "F900402", value: "DIALYSATE REINFUSION BAGS" },
        { key: "F9006", value: "DIALYTIC TREATMENT INSTRUMENTS, SINGLE-USE" },
        { key: "F9080", value: "DIALYSIS DEVICES - OTHER ACCESSORIES" },
        { key: "F9099", value: "DIALYSIS DEVICES - OTHER" },
        { key: "G", value: "GASTROINTESTINAL DEVICES" },
        { key: "G01", value: "ORO-OESOPHAGEAL TUBES" },
        { key: "G0101", value: "OESOPHAGEAL DILATION TUBES" },
        { key: "G010101", value: "OESOPHAGEAL BOUGIES" },
        { key: "G010102", value: "CARDIAS DILATATION TUBES" },
        { key: "G010199", value: "OESOPHAGEAL DILATION TUBES - OTHER" },
        { key: "G0102", value: "OESOPHAGEAL HAEMOSTASIS TUBES " },
        { key: "G010201", value: "SENGSTAKEN TUBES" },
        { key: "G010202", value: "LINTON-NACHLAS TUBES" },
        { key: "G010299", value: "OESOPHAGEAL HAEMOSTASIS TUBES - OTHER" },
        { key: "G0103", value: "ORO-ESOPAGHEAL DIAGNOSTIC TUBES" },
        { key: "G010301", value: "OESOPHAGEAL PH-METRY, TUBES" },
        { key: "G010302", value: "OESOPHAGEAL MANOMETRY, CATHETERS" },
        { key: "G010303", value: "SIALOGRAPHY, CATHETERS" },
        { key: "G010304", value: "TUBES FOR pH METRY AND OESOPHAGEAL IMPEDANCE ANALYSIS" },
        { key: "G010305", value: "TUBES FOR OESOPHAGEA pH METRY AND BILIARY REFLUX ASSESSMENT" },
        { key: "G010399", value: "ORO-OESOPAGHEAL DIAGNOSTIC TUBES - OTHER" },
        { key: "G0180", value: "ORO-OESOPHAGEAL TUBES - ACCESSORIES" },
        { key: "G0199", value: "ORO-OESOPHAGEAL TUBES - OTHER" },
        { key: "G02", value: "GASTROINTESTINAL TUBES AND SETS" },
        { key: "G0201", value: "GASTRO-INTESTINAL LAVAGE TUBES AND SETS" },
        { key: "G020101", value: "GASTRIC LAVAGE TUBES AND SETS" },
        { key: "G020102", value: "INTESTINAL LAVAGE TUBES AND SETS" },
        { key: "G020199", value: "GASTROINTESTINAL LAVAGE, TUBES AND SETS - OTHER" },
        { key: "G0202", value: "GASTROINTESTINAL FEEDING/ASPIRATION TUBES" },
        { key: "G020201", value: "NASOGASTRIC INTESTINAL TUBES" },
        { key: "G02020101", value: "NASOGASTRIC TUBES" },
        { key: "G02020102", value: "NASOJEJUNAL/NASODUODENAL TUBES" },
        { key: "G02020199", value: "NASOGASTRIC INTESTINAL TUBES - OTHER" },
        { key: "G020202", value: "GASTRO-JEJUNOSTOMY, TUBES AND SETS" },
        { key: "G02020201", value: "GASTROSTOMY, TUBES AND SETS" },
        { key: "G02020202", value: "JEJUNOSTOMY, TUBES AND SETS" },
        { key: "G02020203", value: "ILEOSTOMY, TUBES AND SETS" },
        { key: "G020299", value: "GASTROINTESTINAL FEEDING/ASPIRATION TUBES - OTHER" },
        { key: "G0203", value: "EVACUATION TUBES" },
        { key: "G020301", value: "RECTAL TUBES" },
        { key: "G020399", value: "EVACUATION TUBES - OTHER" },
        { key: "G0204", value: "GASTROINTESTINAL HAEMOSTASIS DEVICES" },
        { key: "G020401", value: "HAEMORRHOID LIGATURE SETS" },
        { key: "G020402", value: "HAEMORRHOID SCLEROTHERAPY DEVICES" },
        { key: "G020499", value: "GASTROINTESTINAL HAEMOSTASIS DEVICES - OTHER" },
        { key: "G0205", value: "DEVICES FOR THE SURGICAL OBESITY THERAPY" },
        { key: "G020501", value: "GASTRIC BANDS" },
        { key: "G020502", value: "GASTRIC CALIBRATION TUBES" },
        { key: "G020503", value: "GASTRIC BAND SYSTEM ADJUSTMENT SETS" },
        { key: "G020599", value: "DEVICES FOR THE SURGICAL THERAPY OF OBESITY - OTHER" },
        { key: "G0206", value: "DEVICES FOR GASTROINTESTINAL DIAGNOSTIC PROCEDURES" },
        { key: "G020601", value: "GASTROINTESTINAL DIAGNOSTIC PROCEDURE CATHETERS" },
        { key: "G02060101", value: "DUODENOGRAPHY CATHETERS" },
        { key: "G02060102", value: "CATHETERS FOR GASTRO-JEJUNAL MANOMETRY" },
        { key: "G02060199", value: "CATHETERS FOR GASTRO-DUODENAL-DIGIUNAL DIAGNOSTICS - OTHER" },
        { key: "G020602", value: "CATHETERS FOR BILIARY AND PANCREATIC DIAGNOSTIC PROCEDURES" },
        { key: "G02060201", value: "OPEN SURGERY CHOLANGIOGRAPHY CATHETERS" },
        { key: "G02060202", value: "BILIARY MANOMETRY CATHETERS" },
        { key: "G02060299", value: "BILIARY AND PANCREATIC DIAGNOSTIC PROCEDURE CATHETERS - OTHER" },
        { key: "G020603", value: "DEVICES FOR COLORECTAL DIAGNOSTIC PROCEDURES" },
        { key: "G02060301", value: "ANOSCOPES" },
        { key: "G02060302", value: "RIGID PROCTOSCOPES" },
        { key: "G02060303", value: "BALLOON CATHETERS, BARIUM ENEMA" },
        { key: "G02060304", value: "COLORECTAL INSUFFLATION TUBES" },
        { key: "G02060305", value: "COLORECTAL MANOMETRY CATHETERS" },
        { key: "G02060399", value: "DEVICES FOR COLORECTAL DIAGNOSTIC PROCEDURES - OTHER" },
        { key: "G0280", value: "GASTROINTESTINAL TUBES - ACCESSORIES" },
        { key: "G0299", value: "GASTROINTESTINAL TUBES - OTHER" },
        { key: "G03", value: "GASTROINTESTINAL ENDOSCOPY DEVICES" },
        { key: "G0301", value: "DEVICES FOR DILATION IN DIGESTIVE ENDOSCOPY" },
        { key: "G030101", value: "GASTROINTESTINAL ENDOSCOPY, BALLOON CATHETERS" },
        { key: "G03010101", value: "OESOPHAGEAL BALLOON CATHETERS" },
        { key: "G0301010101", value: "OESOPHAGEAL BALLOON CATHETERS, LOW PRESSURE" },
        { key: "G0301010102", value: "OESOPHAGEAL BALLOON CATHETERS, HIGH PRESSURE" },
        { key: "G03010102", value: "ACHALASIA BALLOON CATHETERS" },
        { key: "G0301010201", value: "ACHALASIA BALLOON CATHETERS, LOW PRESSURE" },
        { key: "G0301010202", value: "ACHALASIA BALLOON CATHETERS, HIGH PRESSURE" },
        { key: "G03010103", value: "PYLORIC BALLOON CATHETERS" },
        { key: "G0301010301", value: "PYLORIC BALLOON CATHETERS, LOW PRESSURE" },
        { key: "G0301010302", value: "PYLORIC BALLOON CATHETERS, HIGH PRESSURE" },
        { key: "G03010104", value: "BILIARY BALLOON CATHETERS" },
        { key: "G0301010401", value: "BILIARY BALLOON CATHETERS, LOW PRESSURE" },
        { key: "G0301010402", value: "BILIARY BALLOON CATHETERS, HIGH PRESSURE" },
        { key: "G03010105", value: "COLONIC BALLOON CATHETERS" },
        { key: "G0301010501", value: "COLONIC BALLOON CATHETERS, LOW PRESSURE" },
        { key: "G0301010502", value: "COLONIC BALLOON CATHETERS, HIGH PRESSURE" },
        { key: "G03010199", value: "GASTROINTESTINAL ENDOSCOPY, BALLOON CATHETERS - OTHER" },
        { key: "G030102", value: "DIGESTIVE ENDOSCOPY, PROGRESSIVE DILATORS" },
        { key: "G03010201", value: "DIGESTIVE ENDOSCOPY, PROGRESSIVE RIGID DILATORS" },
        { key: "G03010202", value: "DIGESTIVE ENDOSCOPY, PROGRESSIVE FLEXIBLE DILATORS" },
        { key: "G0302", value: "DIGESTIVE ENDOSCOPY, HAEMOSTASIS DEVICES" },
        { key: "G030201", value: "DIGESTIVE ENDOSCOPY, NEEDLES" },
        { key: "G03020101", value: "DIGESTIVE ENDOSCOPY, SINGLE-LUMEN NEEDLES" },
        { key: "G03020102", value: "DIGESTIVE ENDOSCOPY, MULTI-LUMEN NEEDLES" },
        { key: "G030202", value: "DIGESTIVE ENDOSCOPY, HAEMOSTASIS CLIPS" },
        { key: "G030203", value: "DIGESTIVE ENDOSCOPY, LIGATURE SYSTEMS" },
        { key: "G03020301", value: "LIGATURE SYSTEMS, OESOPHAGEAL VARICES" },
        { key: "G03020302", value: "DIGESTIVE LIGATURE DEVICES, POLYPS" },
        { key: "G03020399", value: "DIGESTIVE ENDOSCOPY, LIGATURE SYSTEMS - OTHER" },
        { key: "G030204", value: "DIGESTIVE ENDOSCOPY, THERMOCOAGULATION PROBES" },
        { key: "G030299", value: "DIGESTIVE ENDOSCOPY, HAEMOSTASIS DEVICES - OTHER" },
        { key: "G0303", value: "POLYPECTOMY DEVICES" },
        { key: "G030301", value: "POLYPECTOMY SNARES" },
        { key: "G03030101", value: "POLYPECTOMY SNARES, REVOLVING" },
        { key: "G03030102", value: "POLYPECTOMY SNARES, NON-REVOLVING" },
        { key: "G03030199", value: "POLYPECTOMY SNARES - OTHER" },
        { key: "G030399", value: "POLYPECTOMY DEVICES - OTHER" },
        { key: "G0304", value: "ENDOSCOPIC RETROGRADE CHOLANGIOPANCREATOGRAPHY (ERCP) AND SPHINCTEROTOMY DEVICES" },
        { key: "G030401", value: "ERCP CANNULAS" },
        { key: "G03040101", value: "ERCP CANNULAS, SINGLE-LUMEN" },
        { key: "G0304010101", value: "ERCP CANNULAS, SINGLE-LUMEN, STANDARD TIP" },
        { key: "G0304010102", value: "ERCP CANNULAS, SINGLE-LUMEN, CONICAL TIP" },
        { key: "G0304010103", value: "ERCP CANNULAS, SINGLE-LUMEN, TAPERED TIP" },
        { key: "G0304010104", value: "ERCP CANNULAS, SINGLE-LUMEN, CIRCULAR TIP" },
        { key: "G0304010199", value: "ERCP CANNULAS, SINGLE-LUMEN - OTHER" },
        { key: "G03040102", value: "ERCP CANNULAS, MULTI-LUMEN" },
        { key: "G0304010201", value: "ERCP CANNULAS, MULTI-LUMEN, STANDARD TIP" },
        { key: "G0304010202", value: "ERCP CANNULAS, MULTI-LUMEN, CONICAL TIP" },
        { key: "G0304010203", value: "ERCP CANNULAS, MULTI-LUMEN, TAPERED TIP" },
        { key: "G0304010204", value: "ERCP CANNULAS, MULTI-LUMEN, CIRCULAR TIP" },
        { key: "G0304010299", value: "ERCP CANNULAS, MULTI-LUMEN - OTHER" },
        { key: "G030402", value: "PAPILLOTOMES / SPHINCTEROTOMES" },
        { key: "G03040201", value: "PAPILLOTOMES / SPHINCTEROTOMES, DOUBLE-LUMEN" },
        { key: "G03040202", value: "PAPILLOTOMES / SPHINCTEROTOMES, TRIPLE (OR MORE) LUMEN" },
        { key: "G03040299", value: "PAPILLOTOMES / SPHINCTEROTOMES - OTHER" },
        { key: "G030403", value: "NASO-BILIARY-PANCREATIC TUBES" },
        { key: "G03040301", value: "BILIARY TUBES" },
        { key: "G03040302", value: "HEPATIC DUCT TUBES" },
        { key: "G03040303", value: "PANCREATIC TUBES" },
        { key: "G030499", value: "ERCP AND SPHINCTEROTOMY DEVICES - OTHER" },
        { key: "G0305", value: "RETRIEVAL AND LITHOTRIPSY DEVICES (stones, polyps and foreign bodies)" },
        { key: "G030501", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL DEVICES" },
        { key: "G03050101", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL BALLOON DEVICES" },
        { key: "G03050102", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL BASKET DEVICES" },
        { key: "G0305010201", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL BASKET DEVICES, REVOLVING" },
        { key: "G0305010202", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL BASKET DEVICES, NON-REVOLVING" },
        { key: "G03050103", value: "DIGESTIVE ENDOSCOPY, DEVICES FOR RECOVERY BY ASPIRATION" },
        { key: "G03050199", value: "DIGESTIVE ENDOSCOPY, RETRIEVAL DEVICES - OTHER" },
        { key: "G030502", value: "LITHOTRIPSY DEVICES" },
        { key: "G0306", value: "DEVICES FOR THE NON-SURGICAL THERAPY OF OBESITY" },
        { key: "G030601", value: "INTRAGASTRIC BALLOON SYSTEMS" },
        { key: "G030602", value: "DEVICES FOR REMOVAL OF INTRAGASTRIC BALLOONS" },
        { key: "G030603", value: "INTESTINAL COATING YSTEMS FOR ABSORPTION REDUCTION" },
        { key: "G030604", value: "DEVICES FOR REMOVAL OF INTESTINAL COATING SYSTEMS" },
        { key: "G030699", value: "DEVICES FOR THE NON-SURGICAL TREATMENT OF OBESITY - OTHER" },
        { key: "G0307", value: "GASTROINTESTINAL ENDOSCOPY, DIAGNOSTIC DEVICES" },
        { key: "G030701", value: "GASTROINTESTINAL IMAGING DIAGNOSTIC DEVICES" },
        { key: "G030702", value: "PH MONITORING DEVICES" },
        { key: "G030703", value: "MARKERS FOR EVALUATION OF GASTROINTESTINAL PASSAGE" },
        { key: "G030704", value: "COLON DYE SPRAYING CATHETERS" },
        { key: "G030799", value: "GASTROINTESTINAL ENDOSCOPY, DIAGNOSTIC DEVICES - OTHER" },
        { key: "G0308", value: "GASTROINTESTINAL ENDOSCOPY AND ECHOENDOSCOPY, SINGLE-USE INSTRUMENTS" },
        { key: "G030801", value: "GASTROINTESTINAL ENDOSCOPY, FORCEPS, SINGLE-USE" },
        { key: "G03080101", value: "GASTROINTESTINAL ENDOSCOPY, BIOPSY FORCEPS, SINGLE-USE" },
        { key: "G0308010101", value: "GASTROINTESTINAL ENDOSCOPY, COLD BIOPSY FORCEPS, SINGLE-USE" },
        { key: "G0308010102", value: "GASTROINTESTINAL ENDOSCOPY, HOT BIOPSY FORCEPS, SINGLE-USE" },
        { key: "G03080102", value: "GASTROINTESTINAL ENDOSCOPY, EXTRACTION FORCEPS, SINGLE-USE" },
        { key: "G03080199", value: "GASTROINTESTINAL ENDOSCOPY, FORCEPS, SINGLE-USE - OTHER" },
        { key: "G030803", value: "GASTROINTESTINAL ENDOSCOPY AND ECHOENDOSCOPY, BRUSHES" },
        { key: "G03080301", value: "GASTROINTESTINAL CYTOLOGY, BRUSHES" },
        { key: "G03080399", value: "GASTROINTESTINAL ENDOSCOPY AND ECHOENDOSCOPY, BRUSHES - OTHER" },
        { key: "G030804", value: "GASTROINTESTINAL ENDOSCOPY AND ECHOENDOSCOPY, BITE BLOCKS" },
        { key: "G030805", value: "GASTROINTESTINAL ENDOSCOPIC TATTOOING SYSTEMS" },
        { key: "G030899", value: "INSTRUMENTS FOR GASTRO-INTESTINAL ENDOSCOPY AND ECO-ENDOSCOPY, SINGLE-USE - OTHER" },
        { key: "G0380", value: "DIGESTIVE ENDOSCOPY DEVICES - ACCESSORIES" },
        { key: "G0399", value: "DIGESTIVE ENDOSCOPY DEVICES - OTHER" },
        { key: "G04", value: "ORALLY ADMINISTERED GASTROINTESTINAL DEVICES" },
        { key: "G0401", value: "ORALLY ADMINISTERED DEVICES FOR THE THERAPY OF GASTRO-INTESTINAL DISORDERS" },
        { key: "G0402", value: "ORALLY ADMINISTERED DEVICES FOR APPETITE CONTROL AND REDUCTION OF INTESTINAL ABSORPTION" },
        { key: "G0499", value: "ORALLY ADMINISTERED GASTROINTESTINAL DEVICES - OTHER" },
        { key: "G05", value: "TOPICAL ANORECTAL ADMINISTERED GASTRO-INTESTINAL SYSTEM DEVICES" },
        { key: "G06", value: "ANAL DILATORS" },
        { key: "G99", value: "GASTROINTESTINAL DEVICES - OTHER" },
        { key: "H", value: "SUTURE DEVICES" },
        { key: "H01", value: "SURGICAL SUTURES" },
        { key: "H0101", value: "ABSORBABLE SUTURES" },
        { key: "H010101", value: "ABSORBABLE SYNTHETIC SUTURES" },
        { key: "H01010101", value: "MONOFILAMENT ABSORBABLE SYNTHETIC SUTURES" },
        { key: "H0101010101", value: "POLYDIOXANONE MONOFILAMENT" },
        { key: "H010101010101", value: "POLYDIOXANONE MONOFILAMENT WITH NEEDLE FOR OPEN SURGERY" },
        { key: "H010101010102", value: "MOUNTED POLYDIOXANONE MONOFILAMENT WITH NEEDLE FOR VIDEO SURGERY" },
        { key: "H010101010103", value: "POLYDIOXANONE MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101010104", value: "MOUNTED POLYDIOXANONE MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (‘BARBED’)" },
        { key: "H0101010102", value: "POLYGLYCONATE AND MONOFILAMENT DERIVATIVES" },
        { key: "H010101010201", value: "POLYGLYCONATE AND DERIVATIVES MONOFILAMENT WITH NEEDLE" },
        { key: "H010101010202", value: "POLYGLYCONATE AND DERIVATIVES MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101010203", value: "POLYGLYCONATE AND DERIVATIVES MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (‘BARBED’)" },
        { key: "H0101010103", value: "POLIGLECAPRONE AND DERIVATIVES MONOFILAMENT" },
        { key: "H010101010301", value: "POLIGLECAPRONE AND DERIVATIVES MONOFILAMENT WITH NEEDLE" },
        { key: "H010101010302", value: "POLIGLECAPRONE AND DERIVATIVES MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101010303", value: "POLIGLECAPRONE AND DERIVATIVES MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (‘BARBED’)" },
        { key: "H0101010199", value: "MONOFILAMENT ABSORBABLE SYNTHETIC SUTURES - OTHER" },
        { key: "H01010102", value: "MULTIFILAMENT SYNTHETIC ABSORBABLE SUTURES" },
        { key: "H0101010201", value: "POLYGLYCOLIC ACID MULTIFILAMENT" },
        { key: "H010101020101", value: "POLYGLYCOLIC ACID MULTIFILAMENT WITH NEEDLE FOR OPEN SURGERY" },
        { key: "H010101020102", value: "POLYGLYCOLIC ACID MULTIFILAMENT WITH NEEDLE FOR VIDEO SURGERY" },
        { key: "H010101020103", value: "POLYGLYCOLIC ACID MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0101010202", value: "POLYGLYCOLIC WITH LACTIC ACID MULTIFILAMENT" },
        { key: "H010101020201", value: "POLYGLYCOLIC WITH LACTIC ACID MULTIFILAMENT WITH NEEDLE FOR OPEN SURGERY" },
        { key: "H010101020202", value: "POLYGLYCOLIC WITH LACTIC ACID MULTIFILAMENT WITH NEEDLE FOR VIDEO SURGERY" },
        { key: "H010101020203", value: "POLYGLYCOLIC WITH LACTIC ACID MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0101010299", value: "SYNTHETIC ABSORBABLE MULTIFILAMENT SUTURES - OTHER" },
        { key: "H01010103", value: "SYNTHETIC ABSORBABLE MONOFILAMENT SUTURES WITH ANTIBACTERIAL" },
        { key: "H0101010301", value: "POLYDIOXANONE WITH ANTIBACTERIAL MONOFILAMENT" },
        { key: "H010101030101", value: "POLYDIOXANONE WITH ANTIBACTERIAL MONOFILAMENT WITH NEEDLE" },
        { key: "H010101030102", value: "POLYDIOXANONE WITH ANTIBACTERIAL MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101030103", value: "POLYDIOXANONE MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (‘BARBED’) WITH ANTIBACTERIAL" },
        { key: "H0101010302", value: "POLYGLYCOLIC AND LACTIC ACID WITH ANTIBACTERIAL MONOFILAMENT" },
        { key: "H010101030201", value: "POLYGLYCOLIC AND LACTIC ACID WITH ANTIBACTERIAL MONOFILAMENT WITH NEEDLE" },
        { key: "H010101030202", value: "POLYGLYCOLIC AND LACTIC ACID WITH ANTIBACTERIAL MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101030203", value: "POLYGLYCOLIC AND LACTIC ACID WITH ANTIBACTERIAL MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (‘BARBED’) WITH ANTIBACTERIAL" },
        { key: "H0101010303", value: "POLYGECAPRONE AND DERIVATIVES WITH ANTIBACTERIAL MONOFILAMENT" },
        { key: "H010101030301", value: "POLYGLECAPRONE AND DERIVATIVES WITH ANTIBACTERIAL MONOFILAMENT WITH NEEDLE" },
        { key: "H010101030302", value: "POLIGLECAPRONE AND DERIVATIVES WITH ANTIBACTERIAL MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010101030303", value: "POLYGLYCAPRONE AND DERIVATIVES WITH ANTIBACTERIAL MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (\"BARBED\")" },
        { key: "H0101010399", value: "SYNTHETIC RESORBABLE SUTURES WITH ANTIBACTERIAL MONOFILAMENT - OTHER" },
        { key: "H01010104", value: "SYNTHETIC RESORBABLE SUTURES WITH ANTIBACTERIAL MULTIFILAMENT" },
        { key: "H0101010401", value: "POLYGLYCOLIC ACID WITH ANTIBACTERIAL MULTIFILAMENT" },
        { key: "H010101040101", value: "POLYGLYCOLIC ACID WITH ANTIBACTERIAL MULTIFILAMENT WITH NEEDLE" },
        { key: "H010101040102", value: "POLYGLYCOLIC ACID WITH ANTIBACTERIAL MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0101010402", value: "POLYGLYCOLIC ACID WITH ANTIBACTERIAL MULTIFILAMENT WITH NEEDLE" },
        { key: "H010101040201", value: "POLYGLYCOLIC ACID WITH LACTIC ACID WITH ANTIBACTERIAL MULTIFILAMENT WITH NEEDLE" },
        { key: "H010101040202", value: "POLYGLYCOLIC AND LACTIC ACID WITH ANTIBACTERIAL MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0101010499", value: "SYNTHETIC RESORBABLE SUTURES WITH ANTIBACTERIAL MULTIFILAMENT - OTHER" },
        { key: "H0102", value: "NON-ABSORBABLE SUTURES" },
        { key: "H010201", value: "NON-ABSORBABLE SYNTHETIC SUTURES" },
        { key: "H01020101", value: "MONOFILAMENT NON-ABSORBABLE SYNTHETIC SUTURES" },
        { key: "H0102010101", value: "POLYAMIDE MONOFILAMENT" },
        { key: "H010201010101", value: "POLYAMIDE MONOFILAMENT WITH NEEDLE" },
        { key: "H010201010102", value: "POLYAMIDE MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010201010103", value: "POLYAMIDE MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (\"BARBED\")" },
        { key: "H0102010102", value: "POLYESTER AND DERIVATIVES MONOFILAMENT" },
        { key: "H010201010201", value: "POLYESTER AND DERIVATIVES MONOFILAMENT WITH NEEDLE" },
        { key: "H010201010202", value: "POLYESTER AND DERIVATIVES MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010201010203", value: "POLYESTER AND DERIVATIVES MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (\"BARBED\")" },
        { key: "H0102010103", value: "POLYETHERPOLYURETHANE MONOFILAMENT" },
        { key: "H010201010301", value: "POLYETHERPOLYURETHANE MONOFILAMENT WITH NEEDLE" },
        { key: "H010201010302", value: "POLYETHERPOLYURETHANE MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102010104", value: "POLYPROPYLENE MONOFILAMENT" },
        { key: "H010201010401", value: "POLYPROPYLENE MONOFILAMENT WITH NEEDLE FOR OPEN SURGERY" },
        { key: "H010201010402", value: "POLYPROPYLENE MONOFILAMENT WITH NEEDLE FOR VIDEO SURGERY" },
        { key: "H010201010403", value: "POLYPROPYLENE MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H010201010404", value: "POLYPROPYLENE MONOFILAMENT WITH NEEDLE FOR TISSUE TRACTION (\"BARBED\")" },
        { key: "H0102010105", value: "POLYTETRAFLUOROETHYLENE (PTFE) MONOFILAMENT" },
        { key: "H010201010501", value: "POLYTETRAFLUOROETHYLENE (PTFE) MONOFILAMENT WITH NEEDLE" },
        { key: "H010201010502", value: "POLYTETRAFLUOROETHYLENE (PTFE)  MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102010106", value: "POLYVINYLIDENE FLUORIDE AND DERIVATIVES MONOFILAMENT" },
        { key: "H010201010601", value: "POLYVINYLIDENE FLUORIDE AND DERIVATIVES MONOFILAMENT WITH NEEDLE" },
        { key: "H010201010602", value: "POLYVINYLIDENE FLUORIDE AND DERIVATIVES MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102010199", value: "NON-ABSORBABLE SYNTHETIC MONOFILAMENT SUTURES - OTHER" },
        { key: "H01020102", value: "SYNTHETIC NONABSORBABLE MULTIFILAMENT SUTURES" },
        { key: "H0102010201", value: "POLYAMIDE MULTIFILAMENT" },
        { key: "H010201020101", value: "POLYAMIDE MULTIFILAMENT WITH NEEDLE" },
        { key: "H010201020102", value: "POLYAMIDE MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0102010202", value: "POLYESTER MULTIFILAMENT" },
        { key: "H010201020201", value: "POLYSTER MULTIFILAMENT WITH NEEDLE FOR OPEN SURGERY" },
        { key: "H010201020202", value: "POLYSTER MULTIFILAMENT WITH NEEDLE FOR VIDEO SURGERY" },
        { key: "H010201020203", value: "POLYSTER MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0102010299", value: "SYNTHETIC NONABSORBABLE MULTIFILAMENT SUTURES - OTHER" },
        { key: "H010202", value: "NON-ABSORBABLE NON-SYNTHETIC SUTURES" },
        { key: "H01020201", value: "NON-ABSORBABLE NON-SYNTHETIC MONOFILAMENT SUTURES" },
        { key: "H0102020101", value: "STAINLESS STEEL MONOFILAMENT" },
        { key: "H010202010101", value: "STAINLESS STEEL MONOFILAMENT WITH NEEDLE" },
        { key: "H010202010102", value: "STAINLESS STEEL MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102020102", value: "SILVER MONOFILAMENT" },
        { key: "H010202010201", value: "SILVER MONOFILAMENT WITH NEEDLE" },
        { key: "H010202010202", value: "SILVER MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102020103", value: "TITANIUM MONOFILAMENT" },
        { key: "H010202010301", value: "TITANIUM MONOFILAMENT WITH NEEDLE" },
        { key: "H010202010302", value: "TITANIUM MONOFILAMENT WITHOUT NEEDLE" },
        { key: "H0102020199", value: "NON-ABSORBABLE NON-SYNTHETIC MONOFILAMENT SUTURES - OTHER" },
        { key: "H01020202", value: "NON-ABSORBABLE NON-SYNTHETIC MULTIFILAMENT SUTURES" },
        { key: "H0102020201", value: "STAINLESS STEEL MULTIFILAMENT" },
        { key: "H010202020101", value: "STAINLESS STEEL MULTIFILAMENT WITH NEEDLE" },
        { key: "H010202020102", value: "STAINLESS STEEL MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0102020202", value: "LINEN" },
        { key: "H010202020201", value: "LINEN WITH NEEDLE" },
        { key: "H010202020202", value: "LINEN WITHOUT NEEDLE" },
        { key: "H0102020203", value: "SILK" },
        { key: "H010202020301", value: "SILK WITH NEEDLE" },
        { key: "H010202020302", value: "SILK WITHOUT NEEDLE" },
        { key: "H0102020204", value: "TITANIUM MULTIFILAMENT" },
        { key: "H010202020401", value: "TITANIUM MULTIFILAMENT WITH NEEDLE" },
        { key: "H010202020402", value: "TITANIUM MULTIFILAMENT WITHOUT NEEDLE" },
        { key: "H0102020299", value: "NON-ABSORBABLE NON-SYNTHETIC MULTIFILAMENT SUTURES - OTHER" },
        { key: "H0199", value: "SURGICAL SUTURES - OTHER" },
        { key: "H02", value: "MECHANICAL SURGICAL STAPLERS" },
        { key: "H0201", value: "SKIN STAPLERS" },
        { key: "H020101", value: "MECHANICAL SKIN STAPLERS" },
        { key: "H02010101", value: "SKIN STAPLERS, SINGLE-USE" },
        { key: "H02010102", value: "SKIN STAPLERS, SINGLE PATIENT" },
        { key: "H02010103", value: "SKIN STAPLERS, REUSABLE (STAINLESS STEEL)" },
        { key: "H02010104", value: "SINGLE-USE STAPLER CARTRIDGES FOR SINGLE PATIENT" },
        { key: "H02010105", value: "SINGLE-USE CARTRIDGES FOR REUSABLE STAPLERS" },
        { key: "H02010106", value: "METAL SURGICAL STAPLE REMOVERS, SINGLE-USE" },
        { key: "H02010199", value: "MECHANICAL SKIN STAPLERS - OTHER" },
        { key: "H020102", value: "CLIPS" },
        { key: "H02010201", value: "SKIN CLIPS" },
        { key: "H02010202", value: "STERNAL CLIPS" },
        { key: "H02010299", value: "CLIPS - OTHER" },
        { key: "H020180", value: "SKIN STAPLERS - ACCESSORIES" },
        { key: "H020199", value: "SKIN STAPLERS - OTHER" },
        { key: "H0202", value: "STAPLERS, OPEN SURGERY" },
        { key: "H020201", value: "LINEAR STAPLERS, OPEN SURGERY" },
        { key: "H02020101", value: "STRAIGHT LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202010101", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H020201010101", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITH BLADE FOR OPEN SURGERY" },
        { key: "H020201010102", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H0202010102", value: "REUSABLE (STAINLESS STEEL) STRAIGHT LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H020201010201", value: "REUSABLE (STAINLESS STEEL) STRAIGHT LINEAR STAPLERS WITH BLADE FOR OPEN SURGERY" },
        { key: "H020201010202", value: "REUSABLE (STAINLESS STEEL) STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H0202010199", value: "STRAIGHT LINEAR STAPLERS FOR OPEN SURGERY - OTHER" },
        { key: "H02020102", value: "ARTICULATED LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202010201", value: "SINGLE-USE ARTICULATED LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H020201020101", value: "SINGLE-USE ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H020201020102", value: "SINGLE-USE ARTICULATED LINEAR STAPLERS WITH BLADE FOR OPEN SURGERY" },
        { key: "H0202010202", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS FOR OPEN SURGERY" },
        { key: "H020201020201", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITH BLADE FOR OPEN SURGERY" },
        { key: "H020201020202", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H0202010299", value: "ARTICULATED LINEAR STAPLERS FOR OPEN SURGERY- OTHER" },
        { key: "H02020103", value: "SINGLE-PATIENT LINEAR SUTURE CARTDRIGES FOR OPEN SURGERY" },
        { key: "H0202010301", value: "SINGLE-PATIENT LINEAR SUTURE CARTDRIGES WITH BLADE FOR OPEN SURGERY" },
        { key: "H0202010302", value: "SINGLE-PATIENT LINEAR SUTURE CARTDRIGES WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H0202010399", value: "SINGLE-PATIENT LINEAR SUTURE CARTDRIGES FOR OPEN SURGERY - OTHER" },
        { key: "H02020104", value: "REUSABLE LINEAR SUTURE CARTDRIGES FOR OPEN SURGERY" },
        { key: "H0202010401", value: "REUSABLE LINEAR SUTURE CARTDRIGES WITH BLADE FOR OPEN SURGERY" },
        { key: "H0202010402", value: "REUSABLE LINEAR SUTURE CARTDRIGES WITHOUT BLADE FOR OPEN SURGERY" },
        { key: "H0202010499", value: "REUSABLE LINEAR SUTURE CARTDRIGES FOR OPEN SURGERY - OTHER" },
        { key: "H02020199", value: "LINEAR STAPLERS FOR OPEN SURGERY - OTHER" },
        { key: "H020202", value: "CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H02020201", value: "STRAIGHT CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202020101", value: "SINGLE-USE STRAIGHT CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202020102", value: "REUSABLE STRAIGHT CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H02020202", value: "CURVED CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202020201", value: "SINGLE-USE CURVED CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H0202020202", value: "REUSABL CURVED CIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H02020203", value: "PURSE STRING STAPLERS" },
        { key: "H02020204", value: "REUSABLE CIRCULAR STAPLER CARTDRIGES FOR OPEN SURGERY" },
        { key: "H02020299", value: "CIRCULAR STAPLERS FOR OPEN SURGERY - OTHER" },
        { key: "H020203", value: "SEMICIRCULAR STAPLERS FOR OPEN SURGERY" },
        { key: "H02020301", value: "SINGLE PATIENT STRAIGHT SEMICIRCULAR STAPLERS WITH BLADE FOR OPEN SURGERY" },
        { key: "H02020302", value: "SINGLE PATIENT STRAIGHT SEMICIRCULAR STAPLER CARTRIDGES WITH BLADE FOR OPEN SURGERY" },
        { key: "H02020399", value: "SEMICIRCULAR STAPLERS FOR OPEN SURGERY - OTHER" },
        { key: "H020280", value: "STAPLERS FOR OPEN SURGERY - ACCESSORIES" },
        { key: "H020299", value: "STAPLERS FOR OPEN SURGERY - OTHER" },
        { key: "H0203", value: "STAPLERS FOR VIDEOSURGERY" },
        { key: "H020301", value: "LINEAR STAPLERS FOR VIDEOSURGERY" },
        { key: "H02030104", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS FOR VIDEOSURGERY" },
        { key: "H0203010401", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITH BLADE FOR VIDEOSURGERY" },
        { key: "H020301040101", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITH BLADE FOR THORACOSCOPY" },
        { key: "H020301040102", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITH BLADE FOR LAPAROSCOPY" },
        { key: "H020301040199", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITH BLADE FOR VIDEOSURGERY - OTHER" },
        { key: "H0203010402", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR VIDEOSURGERY" },
        { key: "H020301040201", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR THORACOSCOPY" },
        { key: "H020301040202", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR LAPAROSCOPY" },
        { key: "H020301040299", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS WITHOUT BLADE FOR VIDEOSURGERY – OTHER" },
        { key: "H0203010499", value: "SINGLE PATIENT STRAIGHT LINEAR STAPLERS FOR VIDEOSURGERY – OTHER" },
        { key: "H02030105", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS FOR VIDEO SURGERY" },
        { key: "H0203010501", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITH BLADE FOR VIDEO SURGERY" },
        { key: "H020301050101", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITH BLADE FOR THORACOSCOPY" },
        { key: "H020301050102", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITH BLADE FOR LAPAROSCOPY" },
        { key: "H020301050199", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITH BLADE FOR VIDEOSURGERY – OTHER" },
        { key: "H0203010502", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR VIDEO SURGERY" },
        { key: "H020301050201", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR THORACOSCOPY" },
        { key: "H020301050202", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR LAPAROSCOPY" },
        { key: "H020301050299", value: "SINGLE PATIENT ARTICULATED LINEAR STAPLERS WITHOUT BLADE FOR VIDEOSURGERY – OTHER" },
        { key: "H02030106", value: "LINEAR STAPLER CARTRIDGES FOR VIDEOSURGERY" },
        { key: "H02030199", value: "LINEAR STAPLERS FOR VIDEOSURGERY - OTHER" },
        { key: "H020302", value: "CIRCULAR STAPLERS FOR VIDEOSURGERY" },
        { key: "H02030201", value: "CURVED CIRCULAR STAPLERS FOR VIDEOSURGERY" },
        { key: "H0203020101", value: "SINGLE-USE CURVED CIRCULAR STAPLERS FOR VIDEOSURGERY" },
        { key: "H0203020199", value: "CIRCULAR STAPLERS FOR VIDEOSURGERY - OTHER" },
        { key: "H02030299", value: "CIRCULAR STAPLERS FOR VIDEOSURGERY – OTHER" },
        { key: "H020303", value: "CLIP APPLIERS" },
        { key: "H020380", value: "STAPLERS, VIDEOSURGERY - ACCESSORIES" },
        { key: "H020399", value: "STAPLERS, VIDEOSURGERY - OTHER" },
        { key: "H0204", value: "TRANSANAL RECTAL STAPLERS" },
        { key: "H020401", value: "SINGLE PATIENT TRANSANAL RECTAL STAPLERS" },
        { key: "H020402", value: "MULTI-USE TRANSANAL RECTAL STAPLERS" },
        { key: "H020403", value: "TRANSANAL RECTAL STAPLER CARTRIDGES" },
        { key: "H0299", value: "MECHANICAL SURGICAL STAPLERS - OTHER" },
        { key: "H03", value: "HAEMOSTASIS CLIPS" },
        { key: "H0301", value: "HAEMOSTASIS CLIPS FOR OPEN SURGERY" },
        { key: "H030101", value: "MULTIPLE CLIP APPLIERS FOR OPEN SURGERY" },
        { key: "H03010101", value: "SINGLE-USE MULTIPLE CLIP APPLIERS FOR OPEN SURGERY" },
        { key: "H03010102", value: "SINGLE-PATIENT MULTIPLE CLIP APPLIERS FOR OPEN SURGERY" },
        { key: "H03010104", value: "SINGLE-PATIENT MULTIPLE CLIP APPLIER CARTRIDGES FOR OPEN SURGERY" },
        { key: "H03010105", value: "REUSABLE MULTIPLE CLIP APPLIER CARTRIDGES FOR OPEN SURGERY" },
        { key: "H03010199", value: "MULTIPLE CLIP APPLIERS FOR OPEN SURGERY - OTHER" },
        { key: "H030102", value: "SINGULAR CLIPS FOR OPEN SURGERY" },
        { key: "H03010201", value: "NON-ABSORBABLE SINGULAR CLIPS FOR OPEN SURGERY" },
        { key: "H03010202", value: "ABSORBABLE SINGULAR CLIPS FOR OPEN SURGERY" },
        { key: "H030199", value: "HAEMOSTASIS CLIPS FOR OPEN SURGERY - OTHER" },
        { key: "H0302", value: "HAEMOSTASIS CLIPS FOR VIDEOSURGERY" },
        { key: "H030201", value: "MULTIPLE CLIP APPLIERS FOR VIDEOSURGERY" },
        { key: "H03020101", value: "SINGLE-USE MULTIPLE CLIP APPLIERS FOR VIDEOSURGERY" },
        { key: "H03020103", value: "REUSABLE MULTIPLE CLIP APPLIERS FOR VIDEOSURGERY" },
        { key: "H03020199", value: "MULTIPLE CLIP APPLIERS FOR VIDEOSURGERY - OTHER" },
        { key: "H030299", value: "HAEMOSTASIS CLIPS FOR VIDEOSURGERY - OTHER" },
        { key: "H0303", value: "HAEMOSTASIS CLIPS FOR OPEN SURGERY AND VIDEOSURGERY" },
        { key: "H030301", value: "SINGULAR HAEMOSTASIS CLIPS FOR OPEN SURGERY AND VIDEOSURGERY" },
        { key: "H03030101", value: "SINGULAR NON-ABSORBABLE HAEMOSTASIS CLIPS FOR OPEN SURGERY AND VIDEOSURGERY" },
        { key: "H03030102", value: "SINGLE ABSORBABLE CLIPS FOR HEMOSTASIS IN OPEN AND VIDEO SURGERY" },
        { key: "H0380", value: "HEMOSTASIS CLIPS - ACCESSORIES" },
        { key: "H038001", value: "SINGLE-USE DEVICES FOR REMOVAL OF CLIPS FOR HEMOSTASIS" },
        { key: "H03800101", value: "SINGLE-USE DEVICES FOR CLIP REMOVAL IN OPEN SURGERY" },
        { key: "H03800102", value: "SINGLE-USE DEVICES FOR CLIP REMOVAL IN VIDEO SURGERY" },
        { key: "H038099", value: "CLIPS FOR HEMOSTASIS - ACCESSORIES OTHER" },
        { key: "H0399", value: "HAEMOSTASIS CLIPS - OTHER" },
        { key: "H90", value: "SUTURE DEVICES - VARIOUS" },
        { key: "H9001", value: "TISSUE ADHESIVES" },
        { key: "H900101", value: "GLUES" },
        { key: "H90010101", value: "BIOLOGICAL GLUES" },
        { key: "H90010102", value: "SYNTHETIC GLUES" },
        { key: "H900102", value: "BANDAGES FOR SUTURES" },
        { key: "H900199", value: "TISSUE ADHESIVES - OTHER" },
        { key: "H9002", value: "TAPES, MEDICAL/SURGICAL" },
        { key: "H900201", value: "SUTURE TAPES" },
        { key: "H90020101", value: "UMBILICAL CORD TAPES" },
        { key: "H90020102", value: "CERCLAGE TAPES" },
        { key: "H90020103", value: "PARENCHYMATOUS TISSUE TAPES" },
        { key: "H90020199", value: "SUTURE TAPES - OTHER" },
        { key: "H900202", value: "MARKING TAPES, VASCULAR STRUCTURES" },
        { key: "H900203", value: "OCCLUSION TAPES, VASCULAR STRUCTURES" },
        { key: "H900299", value: "TAPES, MEDICAL/SURGICAL - OTHER" },
        { key: "H9003", value: "SUTURE REINFORCEMENT OR SUPPORT DEVICES" },
        { key: "H900301", value: "SUTURE BUTTONS" },
        { key: "H900302", value: "SUTURE FELTS" },
        { key: "H900303", value: "PLEDGETS" },
        { key: "H900304", value: "PLUGS" },
        { key: "H900305", value: "STAPLER REINFORCEMENTS" },
        { key: "H900399", value: "SUTURE SUPPORT OR REINFORCEMENT SUPPORT DEVICES - OTHER" },
        { key: "H9005", value: "SUTURE ZIPPERS" },
        { key: "H9006", value: "CRANIAL HOLE COVERS" },
        { key: "H9007", value: "ANCHORS FOR SOFT TISSUE SUTURE (excluding P09120102 ANCHORS FOR TENDON-LIGAMENT SYNTHESIS)" },
        { key: "H9008", value: "SINGLE-USE SUTURE INSTRUMENTS" },
        { key: "H900801", value: "SINGLE-USE NODE PUSHER" },
        { key: "H900802", value: "SINGLE-USE NEEDLE HOLDERS" },
        { key: "H900899", value: "SINGLE-USE INSTRUMENTS FOR SUTURES - OTHER" },
        { key: "H9080", value: "SUTURE ACCESSORIES" },
        { key: "H9099", value: "SUTURE DEVICES - OTHER" },
        { key: "J", value: "ACTIVE-IMPLANTABLE DEVICES" },
        { key: "J01", value: "CARDIAC FUNCTIONALITY IMPLANTABLE DEVICES" },
        { key: "J0101", value: "IMPLANTABLE PACEMAKERS" },
        { key: "J010101", value: "IMPLANTABLE SINGLE CHAMBER PACEMAKERS" },
        { key: "J01010101", value: "IMPLANTABLE SINGLE CHAMBER PACEMAKERS (SC)" },
        { key: "J01010102", value: "IMPLANTABLE SINGLE CHAMBER PACEMAKERS WITH SENSOR (SR)" },
        { key: "J010102", value: "IMPLANTABLE SINGLE LEAD PACEMAKERS" },
        { key: "J01010201", value: "IMPLANTABLE SINGLE LEAD VDD PACEMAKERS" },
        { key: "J01010202", value: "IMPLANTABLE SINGLE LEAD VDDR PACEMAKERS WITH SENSOR" },
        { key: "J010103", value: "IMPLANTABLE DUAL CHAMBER PACEMAKERS" },
        { key: "J01010301", value: "IMPLANTABLE DUAL CHAMBER PACEMAKERS (DC)" },
        { key: "J01010302", value: "IMPLANTABLE DUAL CHAMBER PACEMAKERS WITH SENSOR (DR)" },
        { key: "J010104", value: "IMPLANTABLE TRIPLE CHAMBER PACEMAKERS" },
        { key: "J01010401", value: "IMPLANTABLE TRIPLE CHAMBER PACEMAKERS FOR CARDIAC RESYNCHRONIZATION (TR)" },
        { key: "J010105", value: "IMPLANTABLE PACEMAKERS WITH INCORPORATED ELECTRODES (LEADLESS)" },
        { key: "J010180", value: "IMPLANTABLE PACEMAKERS - ACCESSORIES" },
        { key: "J010199", value: "IMPLANTABLE PACEMAKERS - OTHER" },
        { key: "J0102", value: "IMPLANTABLE CARDIAC DIAGNOSTIC DEVICES" },
        { key: "J010201", value: "IMPLANTABLE DIAGNOSTIC ARRHYTHMIAS RECORDING CARDIAC DEVICES" },
        { key: "J010280", value: "CARDIAC DIAGNOSTIC DEVICES - ACCESSORIES" },
        { key: "J010299", value: "CARDIAC DIAGNOSTIC DEVICES - OTHER" },
        { key: "J0103", value: "IMPLANTABLE VENTRICULAR ASSISTANCE SYSTEMS" },
        { key: "J010301", value: "IMPLANTABLE MONOVENTRICULAR AND BIVENTRICULAR ASSISTANCE SYSTEMS" },
        { key: "J01030101", value: "IMPLANTABLE RIGHT MONOVENTRICULAR ASSISTANCE SYSTEMS (RVAD)" },
        { key: "J01030102", value: "IMPLANTABLE LEFT MONOVENTRICULAR ASSISTANCE SYSTEMS (LVAD)" },
        { key: "J01030103", value: "IMPLANTABLE BIVENTRICULAR ASSISTANCE SYSTEMS (BIVAD)" },
        { key: "J010380", value: "IMPLANTABLE VENTRICULAR ASSISTANCE SYSTEMS - ACCESSORIES" },
        { key: "J010399", value: "IMPLANTABLE VENTRICULAR ASSISTANCE SYSTEMS - OTHER" },
        { key: "J0104", value: "IMPLANTABLE ARTIFICIAL HEART AND IMPLANT KITS" },
        { key: "J010401", value: "IMPLANTABLE ARTIFICIAL HEART AND IMPLANT KITS" },
        { key: "J010480", value: "IMPLANTABLE ARTIFICIAL HEART AND IMPLANT KITS - ACCESSORIES" },
        { key: "J010499", value: "IMPLANTABLE ARTIFICIAL HEART AND IMPLANT KITS - OTHER" },
        { key: "J0105", value: "IMPLANTABLE DEFIBRILLATORS" },
        { key: "J010501", value: "IMPLANTABLE SINGLE CHAMBER DEFIBRILLATORS" },
        { key: "J01050101", value: "IMPLANTABLE SINGLE CHAMBER DEFIBRILLATORS, WITH SENSORS" },
        { key: "J010502", value: "IMPLANTABLE DUAL CHAMBER DEFIBRILLATORS" },
        { key: "J01050201", value: "IMPLANTABLE DUAL CHAMBER DEFIBRILLATORS, WITH SENSORS" },
        { key: "J010503", value: "IMPLANTABLE TRIPLE CHAMBER DEFIBRILLATORS" },
        { key: "J01050301", value: "IMPLANTABLE TRIPLE CHAMBER DEFIBRILLATORS, WITH SENSORS" },
        { key: "J010504", value: "SUBCUTANEOUS IMPLANTABLE DEFIBRILLATORS" },
        { key: "J010580", value: "IMPLANTABLE DEFIBRILLATORS - ACCESSORIES" },
        { key: "J010599", value: "IMPLANTABLE DEFIBRILLATORS - OTHER" },
        { key: "J0106", value: "CARDIAC CONTRACTILITY MODULATION IMPLANTABLE DEVICES" },
        { key: "J0107", value: "ACTIVE IMPLANTABLE CARDIAC DEVICES REMOTE MONITORING SYSTEMS" },
        { key: "J010701", value: "PULMONARY BLOOD PRESSURE REMOTE MONITORING SYSTEMS (INCLUDING SENSORS)" },
        { key: "J010702", value: "PACEMAKER AND IMPLANTABLE DEFIBRILLATOR REMOTE MONITORING SYSTEMS" },
        { key: "J010780", value: "ACTIVE IMPLANTABLE CARDIAC DEVICES REMOTE MONITORING SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "J010782", value: "ACTIVE IMPLANTABLE CARDIAC DEVICES REMOTE MONITORING SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "J010792", value: "ACTIVE IMPLANTABLE CARDIAC DEVICES REMOTE MONITORING SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "J010799", value: "ACTIVE IMPLANTABLE CARDIAC DEVICES REMOTE MONITORING SYSTEMS - OTHER" },
        { key: "J0190", value: "IMPLANTABLE CARDIAC DEVICES - VARIOUS" },
        { key: "J019001", value: "PERMANENT CARDIAC LEADS" },
        { key: "J01900101", value: "PERMANENT PACEMAKER LEADS (WITH OR W/O STEROID-ELUTION)" },
        { key: "J0190010101", value: "ENDOCARDIAL ATRIAL AND VENTRICULAR LEADS, UNIPOLAR" },
        { key: "J019001010101", value: "ATRIAL LEADS, PASSIVE FIXATION" },
        { key: "J019001010102", value: "VENTRICULAR LEADS, PASSIVE FIXATION" },
        { key: "J0190010102", value: "ENDOCARDIAL ATRIAL AND VENTRICULAR LEADS, BIPOLAR (WITH ACTIVE OR PASSIVE FIXATION)" },
        { key: "J0190010103", value: "LEFT VENTRICULAR LEADS WITH CORONARY SINUS CANNULATION SYSTEM (TRIPLE CHAMBER P.M.)" },
        { key: "J0190010104", value: "ENDOCARDIAL PACEMAKER LEADS, SINGLE-LEAD" },
        { key: "J0190010105", value: "EPICARDIAL PERMANENT CARDIAC LEADS" },
        { key: "J01900102", value: "PERMANENT DEFIBRILLATOR LEADS (STEROID RELEASE INCLUDED)" },
        { key: "J0190010201", value: "PERMANENT PACING AND DEFIBRILLATION RIGHT VENTRICULAR LEADS (WITH ACTIVE AND PASSIVE FIXATION)" },
        { key: "J019001020101", value: "PERMANENT CARDIAC DEFIBRILLATOR LEADS, SINGLE COIL" },
        { key: "J019001020102", value: "PERMANENT CARDIAC DEFIBRILLATOR LEADS, DOUBLE COIL" },
        { key: "J019001020199", value: "PERMANENT PACING AND DEFIBRILLATION RIGHT VENTRICULAR LEADS - OTHER" },
        { key: "J0190010202", value: "PERMANENT SUBCUTANEOUS DEFIBRILLATOR LEADS" },
        { key: "J01900180", value: "PERMANENT CARDIAC LEADS - ACCESSORIES" },
        { key: "J01900199", value: "PERMANENT CARDIAC LEADS - OTHER" },
        { key: "J019002", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS AND ACCESSORIES" },
        { key: "J01900203", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS" },
        { key: "J01900280", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS - HARDWARE ACCESSORY" },
        { key: "J01900282", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS - SOFTWARE ACCESSORY" },
        { key: "J01900285", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS - CONSUMABLES" },
        { key: "J01900292", value: "IMPLANTABLE CARDIAC DEVICES PROGRAMMERS - MEDICAL DEVICE SOFTWARE" },
        { key: "J019003", value: "ACTIVE-IMPLANTABLE CARDIAC SYSTEMS MAGNETISED DEVICES" },
        { key: "J019004", value: "ACTIVE-IMPLANTABLE CARDIAC SYSTEMS ADAPTORS" },
        { key: "J019005", value: "CARDIAC LEADS EXTRACTION SYSTEMS" },
        { key: "J019099", value: "IMPLANTABLE CARDIAC DEVICES - OTHER" },
        { key: "J02", value: "IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J0201", value: "CEREBRAL IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020101", value: "DEEP BRAIN STIMULATION (DBS) IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J02010101", value: "DEEP BRAIN STIMULATION (DBS) IMPLANTABLE NEUROSTIMULATORS, RECHARGEABLE" },
        { key: "J02010102", value: "DEEP BRAIN STIMULATION (DBS) IMPLANTABLE NEUROSTIMULATORS, NOT RECHARGEABLE" },
        { key: "J020102", value: "DEEP BRAIN STIMULATION (DBS) LEADS" },
        { key: "J020180", value: "CEREBRAL IMPLANTABLE NEUROSTIMULATORS - ACCESSORIES" },
        { key: "J020199", value: "CEREBRAL IMPLANTABLE NEUROSTIMULATORS - OTHER" },
        { key: "J0202", value: "SPINAL IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020201", value: "RADIOFREQUENCY IMPLANTABLE SPINAL NEUROSTIMULATORS" },
        { key: "J020202", value: "FULLY IMPLANTABLE SPINAL NEUROSTIMULATORS" },
        { key: "J02020201", value: "FULLY IMPLANTABLE SPINAL NEUROSTIMULATORS, RECHARGEABLE" },
        { key: "J02020202", value: "FULLY IMPLANTABLE SPINAL NEUROSTIMULATORSS, NOT RECHARGEABLE" },
        { key: "J020203", value: "SPINAL NEUROSTIMULATION LEADS" },
        { key: "J020280", value: "SPINAL IMPLANTABLE NEUROSTIMULATORS - ACCESSORIES" },
        { key: "J020299", value: "SPINAL IMPLANTABLE NEUROSTIMULATORS - OTHER" },
        { key: "J0203", value: "VAGAL IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020301", value: "DRUG-RESISTANT EPILEPSY NON-SURGICAL THERAPY IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020302", value: "VAGAL NEUROSTIMULATION LEADS" },
        { key: "J020380", value: "VAGAL IMPLANTABLE NEUROSTIMULATORS - ACCESSORIES" },
        { key: "J020399", value: "VAGAL IMPLANTABLE NEUROSTIMULATORS - OTHER" },
        { key: "J0204", value: "SACRAL SPINE IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020401", value: "BLADDER INCONTINENCE NEUROSTIMULATORS" },
        { key: "J020402", value: "INTESTINAL INCONTINENCE NEUROSTIMULATORS" },
        { key: "J020403", value: "SACRAL SPINE NEUROSTIMULATION LEADS" },
        { key: "J020480", value: "SACRAL SPINE IMPLANTABLE NEUROSTIMULATORS - ACCESSORIES" },
        { key: "J020499", value: "SACRAL SPINE IMPLANTABLE NEUROSTIMULATORS - OTHER" },
        { key: "J0206", value: "FRENIC NERVE IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J0207", value: "NEUROSTIMULATORS PROGRAMMERS AND ACCESSORIES" },
        { key: "J020701", value: "NEUROSTIMULATORS PROGRAMMERS " },
        { key: "J020780", value: "NEUROSTIMULATORS PROGRAMMERS - HARDWARE ACCESSORIES" },
        { key: "J020782", value: "NEUROSTIMULATORS PROGRAMMERS - SOFTWARE ACCESSORIES" },
        { key: "J020785", value: "NEUROSTIMULATORS PROGRAMMERS - CONSUMABLES" },
        { key: "J020792", value: "NEUROSTIMULATORS PROGRAMMERS - MEDICAL DEVICE SOFTWARE" },
        { key: "J0208", value: "GASTRIC IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020801", value: "INFERIOR ESOPHAGEAL SPHINCTER IMPLANTABLE NEUROSTIMULATORS" },
        { key: "J020802", value: "GASTRIC IMPLANTABLE OBESITY TREATMENT NEUROSTIMULATORS" },
        { key: "J020803", value: "GASTRIC IMPLANTABLE NAUSEA THERAPY NEUROSTIMULATORS" },
        { key: "J020804", value: "GASTRIC NEUROSTIMULATION LEADS" },
        { key: "J0209", value: "CAROTID SINUS IMPLANTABLE NEUROSTIMULATORS AND LEADS" },
        { key: "J0210", value: "PERIPHERAL NERVE IMPLANTABLE NEUROSTIMULATORS AND PAIN THERAPY LEADS" },
        { key: "J0211", value: "SLEEP APNEA TREATMENT IMPLANTABLE NEUROSTIMULATORS AND LEADS" },
        { key: "J0280", value: "IMPLANTABLE NEUROSTIMULATORS - ACCESSORIES" },
        { key: "J0299", value: "IMPLANTABLE NEUROSTIMULATORS - OTHER" },
        { key: "J03", value: "AUDITORY ACTIVE-IMPLANTABLE DEVICES" },
        { key: "J0301", value: "COCHLEAR IMPLANTABLE DEVICES" },
        { key: "J0302", value: "MIDDLE EAR ACTIVE-IMPLANTABLE DEVICES" },
        { key: "J0303", value: "PROFOUND DEAFNESS BRAINSTEM ACTIVE-IMPLANTABLE DEVICES" },
        { key: "J0380", value: "AUDITORY ACTIVE-IMPLANTABLE DEVICES - ACCESSORIES" },
        { key: "J0399", value: "AUDITORY ACTIVE-IMPLANTABLE DEVICES - OTHER" },
        { key: "J04", value: "IMPLANTABLE PUMPS" },
        { key: "J0401", value: "IMPLANTABLE PUMPS, ELECTRONIC" },
        { key: "J0402", value: "IMPLANTABLE PUMPS, MECHANICAL" },
        { key: "J0403", value: "IMPLANTABLE PUMPS PROGRAMMERS AND ACCESSORIES" },
        { key: "J040301", value: "IMPLANTABLE PUMPS PROGRAMMERS" },
        { key: "J040380", value: "IMPLANTABLE PUMPS PROGRAMMERS - HARDWARE ACCESSORIES" },
        { key: "J040382", value: "IMPLANTABLE PUMPS PROGRAMMERS - SOFTWARE ACCESSORIES" },
        { key: "J040385", value: "IMPLANTABLE PUMPS PROGRAMMERS - CONSUMABLES" },
        { key: "J040392", value: "IMPLANTABLE PUMPS PROGRAMMERS - MEDICAL DEVICE SOFTWARE" },
        { key: "J0480", value: "IMPLANTABLE PUMPS - ACCESSORIES" },
        { key: "J0499", value: "IMPLANTABLE PUMPS - OTHER" },
        { key: "J05", value: "BRACHYTHERAPY IMPLANTABLE DEVICES" },
        { key: "J0501", value: "BRACHYTHERAPY SOURCES" },
        { key: "J0502", value: "BRACHYTHERAPY ADMINISTRATION KITS" },
        { key: "J0580", value: "IMPLANTABLE BRACHYTHERAPY DEVICES - ACCESSORIES" },
        { key: "J06", value: "ACTIVE IMPLANTABLE GLUCOSE MONITORING SYSTEMS" },
        { key: "J0601", value: "IMPLANTABLE GLUCOSE MONITORING SENSORS" },
        { key: "J0602", value: "ACTIVE IMPLANTABLE GLUCOSE MONITORING SYSTEM TRANSMITTERS" },
        { key: "J0680", value: "ACTIVE IMPLANTABLE GLUCOSE MONITORING SYSTEMS - ACCESSORIES" },
        { key: "J07", value: "OPHTHALMOLOGICAL USE ACTIVE IMPLANTABLE DEVICES" },
        { key: "J0701", value: "ACTIVE RETINAL IMPLANTABLE DEVICES" },
        { key: "J0702", value: "INTRAOCULAR PRESSURE MONITORING IMPLANTABLE DEVICES" },
        { key: "J0780", value: "OPHTHALMOLOGICAL USE ACTIVE IMPLANTABLE DEVICES - ACCESSORIES" },
        { key: "J0799", value: "OPHTHALMOLOGICAL USE ACTIVE IMPLANTABLE DEVICES - OTHER" },
        { key: "J99", value: "ACTIVE-IMPLANTABLE DEVICES - OTHER" },
        { key: "K", value: "ENDOTHERAPY AND ELECTROSURGICAL DEVICES" },
        { key: "K01", value: "ENDOTHERAPY DEVICES" },
        { key: "K0101", value: "TROCAR AND KITS, SINGLE-USE" },
        { key: "K010101", value: "TROCAR, SINGLE-USE" },
        { key: "K01010101", value: "TROCAR STANDARD, SINGLE-USE" },
        { key: "K01010102", value: "HASSON TROCAR, SINGLE-USE" },
        { key: "K01010103", value: "OPTICAL TROCAR, SINGLE-USE" },
        { key: "K01010104", value: "THORACIC TROCAR, SINGLE-USE" },
        { key: "K01010105", value: "SPECIAL TROCAR, SINGLE-USE" },
        { key: "K01010180", value: "TROCAR, SINGLE-USE - ACCESSORIES" },
        { key: "K01010199", value: "TROCAR, SINGLE-USE - OTHER" },
        { key: "K010102", value: "MINIMALLY INVASIVE SURGERY KITS, SINGLE-USE" },
        { key: "K0102", value: "IMINIMALLY INVASIVE AND ROBOTIC SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K010201", value: "MINIMALLY INVASIVE SURGERY SURGICAL INSTRUMENTS, SINGLE-USE" },
        { key: "K01020101", value: "MINIMALLY INVASIVE SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K01020102", value: "MINIMALLY INVASIVE SURGERY SCISSORS, SINGLE-USE" },
        { key: "K01020103", value: "MINIMALLY INVASIVE SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K01020104", value: "MINIMALLY INVASIVE SURGERY FORCEPS, SINGLE-USE" },
        { key: "K01020105", value: "MINIMALLY INVASIVE SURGERY NEEDLE HOLDERS, SINGLE-USE" },
        { key: "K01020106", value: "MINIMALLY INVASIVE SURGERY SPREADERS AND RETRACTORS, SINGLE-USE" },
        { key: "K01020107", value: "MINIMALLY INVASIVE SURGERY RECOVERY BAGS" },
        { key: "K01020109", value: "MINIMALLY INVASIVE SURGERY SWABS" },
        { key: "K01020110", value: "MINIMALLY INVASIVE SURGERY CANNULAS, SINGLE-USE" },
        { key: "K01020111", value: "MINIMALLY INVASIVE SURGERY BLADES, SINGLE-USE" },
        { key: "K01020112", value: "MINIMALLY INVASIVE SURGERY HOOKS, SINGLE-USE" },
        { key: "K01020113", value: "MINIMALLY INVASIVE SURGERY SPATULAS, SINGLE-USE" },
        { key: "K01020114", value: "MINIMALLY INVASIVE SURGERY GUIDES, SINGLE-USE" },
        { key: "K01020115", value: "MINIMALLY INVASIVE SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K01020116", value: "ENDOSCOPIC TISSUE SUTURE APPROXIMATORS, SINGLE - USE" },
        { key: "K01020117", value: "MINIMALLY INVASIVE SURGERY DILATORS, SINGLE-USE" },
        { key: "K01020118", value: "MINIMALLY INVASIVE SURGERY NEEDLES, SINGLE-USE" },
        { key: "K01020119", value: "MINIMALLY INVASIVE SURGERY PALPATORS, SINGLE USE" },
        { key: "K01020120", value: "MINIMALLY INVASIVE SURGERY SURGICAL INSTRUMENT KITS, SINGLE-USE" },
        { key: "K01020199", value: "MINIMALLY INVASIVE SURGERY SURGICAL INSTRUMENT KITS, SINGLE-USE - OTHER" },
        { key: "K010202", value: "ROBOTIC SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K01020201", value: "ROBOTIC SURGERY SCALPELS AND BLADES, SINGLE-USE" },
        { key: "K01020202", value: "ROBOTIC SURGERY CLIPS, SINGLE-USE" },
        { key: "K01020203", value: "ROBOTIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "K01020204", value: "ROBOTIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "K01020205", value: "ROBOTIC SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K01020299", value: "ROBOTIC SURGERY INSTRUMENT, SINGLE-USE - OTHER" },
        { key: "K0103", value: "SPINAL ENDOTHERAPY DEVICES" },
        { key: "K010301", value: "SPINAL PERCUTANEOUS PLASTIC DEVICES WITH BALLOON" },
        { key: "K010302", value: "MINIMALLY INVASIVE SPINAL SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K010399", value: "SPINAL ENDOTHERAPY DEVICES - OTHER" },
        { key: "K0104", value: "VERESS NEEDLES" },
        { key: "K0105", value: "MINIMALLY INVASIVE SURGERY STABILITY SCREW THREADS" },
        { key: "K0106", value: "MINIMALLY INVASIVE SURGERY REDUCERS" },
        { key: "K0107", value: "CHOLANGIOGRAPHY PROBES" },
        { key: "K0108", value: "HAND-ASSISTED SURGERY DEVICES" },
        { key: "K0180", value: "ENDOTHERAPY DEVICES - OTHER ACCESSORIES" },
        { key: "K0199", value: "ENDOTHERAPY DEVICES - OTHER" },
        { key: "K02", value: "ELECTROSURGERY DEVICES, SINGLE-USE" },
        { key: "K0201", value: "MONO- AND BIPOLAR DEVICES, SINGLE-USE" },
        { key: "K020101", value: "MONO- AND BIPOLAR SURGICAL INSTRUMENTS, SINGLE-USE" },
        { key: "K02010101", value: "ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, SINGLE-USE" },
        { key: "K0201010101", value: "OPEN ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, SINGLE-USE" },
        { key: "K0201010102", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, SINGLE-USE" },
        { key: "K02010102", value: "ELECTROSURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0201010201", value: "OPEN ELECTROSURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0201010202", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY DISSECTORS, SINGLE-USE" },
        { key: "K02010103", value: "ELECTROSURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0201010301", value: "OPEN ELECTROSURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0201010302", value: "LAPAR AND THORACOSCOPIC ELECTROSURGERY ELECTRODES, SINGLE-USE" },
        { key: "K02010104", value: "ELECTROSURGERY SCISSORS, SINGLE-USE" },
        { key: "K0201010401", value: "OPEN ELECTROSURGERY SCISSORS, SINGLE-USE" },
        { key: "K0201010402", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY SCISSORS, SINGLE-USE" },
        { key: "K02010105", value: "ELECTROSURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0201010501", value: "OPEN ELECTROSURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0201010502", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY HANDPIECES, SINGLE-USE" },
        { key: "K02010106", value: "ELECTROSURGERY FORCEPS, SINGLE-USE" },
        { key: "K0201010601", value: "OPEN ELECTROSURGERY FORCEPS, SINGLE-USE" },
        { key: "K0201010602", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY FORCEPS, SINGLE-USE" },
        { key: "K02010107", value: "SMOKE EVACUATION SYSTEMS" },
        { key: "K02010108", value: "ELECTROSURGERY NEEDLES, SINGLE-USE" },
        { key: "K0201010801", value: "OPEN ELECTROSURGERY NEEDLES, SINGLE-USE" },
        { key: "K0201010802", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY NEEDLES, SINGLE-USE" },
        { key: "K02010109", value: "ELECTROSURGERY BLADES, SINGLE-USE" },
        { key: "K0201010901", value: "OPEN ELECTROSURGERY BLADES, SINGLE-USE" },
        { key: "K0201010902", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY BLADES, SINGLE-USE" },
        { key: "K02010110", value: "ELECTROSURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0201011001", value: "OPEN ELECTROSURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0201011002", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K02010111", value: "ELECTROSURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K0201011101", value: "OPEN ELECTROSURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K0201011102", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K02010112", value: "ELECTROSURGERY PROBES, SINGLE-USE" },
        { key: "K0201011201", value: "OPEN ELECTROSURGERY PROBES, SINGLE-USE" },
        { key: "K0201011202", value: "LAPAROSCOPIC AND THORACOSCOPIC ELECTROSURGERY PROBES, SINGLE-USE" },
        { key: "K02010113", value: "MINIMALLY INVASIVE SURGERY MULTIPURPOSE HANDPIECES, SINGLE-USE" },
        { key: "K02010199", value: "MONO- AND BIPOLAR INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "K020102", value: "ELECTROSURGERY PADS (NEUTRAL ELECTRODES) AND CABLES, SINGLE-USE" },
        { key: "K02010201", value: "ELECTROSURGERY SINGLE PATIENT PADS (NEUTRAL ELECTRODES), SINGLE-USE" },
        { key: "K02010202", value: "ELECTROSURGERY DUAL PATIENT PADS (NEUTRAL ELECTRODES), SINGLE-USE" },
        { key: "K02010203", value: "ELECTROSURGERY CONNECTION CABLES, SINGLE-USE" },
        { key: "K020103", value: "SELF-POWERED BIPOLAR ELECTROCAUTERS SINGLE USE" },
        { key: "K02010301", value: "LOW TEMPERATURE BIPOLAR ELECTROCAUTERS, SINGLE USE" },
        { key: "K02010302", value: "MEDIUM TEMPERATURE BIPOLAR ELECTROCAUTERS, SINGLE USE" },
        { key: "K02010303", value: "HIGH TEMPERATURE BIPOLAR ELECTROCAUTERS, SINGLE USE" },
        { key: "K020180", value: "SINGLE- AND BIPOLAR DEVICES, SINGLE USE - ACCESSORIES" },
        { key: "K020199", value: "MONO- AND BIPOLAR DEVICES, SINGLE USE - OTHER" },
        { key: "K0202", value: "DEVICES FOR SURGERY WITH ULTRASONIC GENERATOR, SINGLE-USE" },
        { key: "K020201", value: "ULTRASONIC SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K02020101", value: "ULTRASONIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "K0202010101", value: "ULTRASONIC OPEN SURGERY SCISSORS, SINGLE-USE" },
        { key: "K0202010102", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "K02020102", value: "ULTRASONIC SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0202010201", value: "ULTRASONIC OPEN SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0202010202", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K02020103", value: "ULTRASONIC SURGERY BLADES, SINGLE-USE" },
        { key: "K0202010301", value: "ULTRASONIC OPEN SURGERY BLADES, SINGLE-USE" },
        { key: "K0202010302", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY BLADES, SINGLE-USE" },
        { key: "K02020104", value: "ULTRASONIC SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K0202010401", value: "ULTRASONIC OPEN SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K0202010402", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K02020105", value: "ULTRASONIC SURGERY CANNULAS, SINGLE-USE" },
        { key: "K0202010501", value: "ULTRASONIC OPEN SURGERY CANNULAS, SINGLE-USE" },
        { key: "K0202010502", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY CANNULAS, SINGLE-USE" },
        { key: "K02020106", value: "ULTRASONIC SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0202010601", value: "ULTRASONIC OPEN SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0202010602", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K02020107", value: "ULTRASONIC SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0202010701", value: "ULTRASONIC OPEN SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0202010702", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K02020108", value: "ULTRASONIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "K0202010801", value: "ULTRASONIC OPEN SURGERY FORCEPS, SINGLE-USE" },
        { key: "K0202010802", value: "LAPAROSCOPIC AND THORACOSCOPIC ULTRASONIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "K02020109", value: "ULTRASONIC SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0202010901", value: "ULTRASONIC OPEN SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0202010902", value: "ULTRASONIC LAPAROSCOPIC AND THORACOSCOPIC SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K02020199", value: "ULTRASONIC SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "K020280", value: "DEVICES FOR SURGERY WITH ULTRASONIC GENERATOR, SINGLE-USE - ACCESSORIES" },
        { key: "K020299", value: "DEVICES FOR SURGERY WITH ULTRASONIC GENERATOR, SINGLE-USE - OTHER" },
        { key: "K0203", value: "DEVICES FOR SURGERY WITH RADIOFREQUENCY GENERATOR, SINGLE-USE" },
        { key: "K020301", value: "RADIOFREQUENCY SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K02030101", value: "RADIOFREQUENCY SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K02030102", value: "RADIOFREQUENCY SURGERY FORCEPS, SINGLE-USE" },
        { key: "K02030103", value: "RADIOFREQUENCY SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K02030104", value: "RADIOFREQUENCY SURGERY NEEDLES, SINGLE-USE" },
        { key: "K02030105", value: "RADIOFREQUENCY SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K02030106", value: "RADIOFREQUENCY SURGERY CANNULAS, SINGLE-USE" },
        { key: "K02030107", value: "RADIOFREQUENCY SURGERY BLADES, SINGLE-USE" },
        { key: "K02030108", value: "RADIOFREQUENCY SURGERY SCISSORS, SINGLE-USE" },
        { key: "K02030109", value: "RADIOFREQUENCY SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K02030110", value: "RADIOFREQUENCY SURGERY MANIPULATORS,  SINGLE-USE" },
        { key: "K02030199", value: "RADIOFREQUENCY SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "K020380", value: "DEVICES FOR SURGERY WITH RADIOFREQUENCY GENERATOR, SINGLE-USE - ACCESSORIES" },
        { key: "K020399", value: "DEVICES FOR SURGERY WITH RADIOFREQUENCY GENERATOR, SINGLE-USE - OTHER" },
        { key: "K0204", value: "DEVICES FOR SURGERY WITH ARGON GAS GENERATOR, SINGLE-USE" },
        { key: "K020401", value: "ARGON GAS SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K02040101", value: "ARGON GAS SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0204010101", value: "ARGON GAS OPEN SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K0204010102", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K02040102", value: "ARGON GAS SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0204010201", value: "ARGON GAS OPEN SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K0204010202", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC GAS SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K02040103", value: "ARGON GAS SURGERY FORCEPS, SINGLE-USE" },
        { key: "K0204010301", value: "ARGON GAS OPEN SURGERY FORCEPS, SINGLE-USE" },
        { key: "K0204010302", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "K02040104", value: "ARGON GAS SURGERY SCISSORS, SINGLE-USE" },
        { key: "K0204010401", value: "ARGON GAS OPEN SURGERY SCISSORS, SINGLE-USE" },
        { key: "K0204010402", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "K02040105", value: "ARGON GAS SURGERY BLADES, SINGLE-USE" },
        { key: "K0204010501", value: "ARGON GAS OPEN SURGERY BLADES, SINGLE-USE" },
        { key: "K0204010502", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY BLADES, SINGLE-USE" },
        { key: "K02040106", value: "ARGON GAS SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0204010601", value: "ARGON GAS OPEN SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K0204010602", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY DISSECTORS, SINGLE-USE" },
        { key: "K02040107", value: "ARGON GAS SURGERY CANNULAS, SINGLE-USE" },
        { key: "K0204010701", value: "ARGON GAS OPEN SURGERY CANNULAS, SINGLE-USE" },
        { key: "K0204010702", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY CANNULAS, SINGLE-USE" },
        { key: "K02040108", value: "ARGON GAS SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0204010801", value: "ARGON GAS OPEN SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0204010802", value: "ARGON GAS LAPAROSCOPIC AND THORACOSCOPIC SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K02040109", value: "ARGON GAS SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K02040199", value: "ARGON GAS SURGERY INSTRUMENTS, SINGLE-USE- OTHER" },
        { key: "K020480", value: "DEVICES FOR SURGERY WITH ARGON GAS GENERATOR, SINGLE-USE- ACCESSORIES" },
        { key: "K020499", value: "DEVICES FOR SURGERY WITH ARGON GAS GENERATOR, SINGLE-USE - OTHER" },
        { key: "K0205", value: "DEVICES FOR SURGERY WITH COMBINED RADIOFREQUENCY / ULTRASOUND GENERATORS, SINGLE-USE" },
        { key: "K020501", value: "COMBINED RADIOFREQUENCY / ULTRASOUND SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "K02050101", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY ELECTRODES, SINGLE-USE" },
        { key: "K02050102", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "K02050103", value: "COMBINED RADIOFREQUENCY / ULTRASOUND SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "K02050104", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY NEEDLES, SINGLE-USE" },
        { key: "K02050105", value: "RADIOFREQUENCY / ULTRASONIC SURGERY COMBINED DISSECTORS, SINGLE-USE" },
        { key: "K02050106", value: "COMBINED RADIOFREQUENCY / ULTRASOUND SURGERY CANNULAS, SINGLE-USE" },
        { key: "K02050107", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY BLADES, SINGLE-USE" },
        { key: "K02050108", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "K02050109", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY HANDPIECES, SINGLE-USE" },
        { key: "K02050110", value: "COMBINED RADIOFREQUENCY / ULTRASONIC SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "K0299", value: "ELECTROSURGERY DEVICES, SINGLE-USE - OTHER" },
        { key: "K03", value: "ARTHROSCOPY DEVICES, SINGLE-USE" },
        { key: "K0301", value: "ARTHROSCOPY TRACTION SYSTEMS, SINGLE-USE" },
        { key: "K0302", value: "ARTHROSCOPY SURGICAL INSTRUMENTS, SINGLE-USE" },
        { key: "K030201", value: "ARTHROSCOPY CANNULAS, SINGLE-USE" },
        { key: "K030202", value: "ARTHROSCOPY GUIDE WIRES, SINGLE-USE" },
        { key: "K030203", value: "ARTHROSCOPY BLADES, SINGLE-USE" },
        { key: "K030204", value: "ARTHROSCOPY BURS, SINGLE-USE" },
        { key: "K030205", value: "ARTHROSCOPY SUTURE DEVICES NOT INCLUDED IN OTHER CLASSES, SINGLE-USE" },
        { key: "K030206", value: "ARTHROSCOPY DISSECTORS, SINGLE-USE" },
        { key: "K030207", value: "ARTHROSCOPY ELECTRODES, SINGLE-USE" },
        { key: "K030208", value: "ARTHROSCOPY FORCEPS, SINGLE-USE" },
        { key: "K030209", value: "ARTHROSCOPY SCISSORS, SINGLE-USE" },
        { key: "K030210", value: "ARTHROSCOPY HANDPIECES, SINGLE USE" },
        { key: "K030211", value: "ARTHROSCOPY MANIPULATORS, SINGLE USE" },
        { key: "K030212", value: "ARTHROSCOPY INSTRUMENT KITS, SINGLE USE" },
        { key: "K030299", value: "ARTHROSCOPY SURGICAL INSTRUMENTS, SINGLE USE - OTHER" },
        { key: "K0380", value: "ARTHROSCOPY DEVICES, SINGLE USE - ACCESSORIES" },
        { key: "K0399", value: "ARTHROSCOPY DEVICES, SINGLE USE - OTHER" },
        { key: "L", value: "REUSABLE SURGICAL INSTRUMENTS" },
        { key: "L01", value: "SHARP INSTRUMENTS, REUSABLE" },
        { key: "L0101", value: "SURGICAL SCALPELS, REUSABLE" },
        { key: "L010101", value: "MONOBLOCK SURGICAL SCALPELS, REUSABLE" },
        { key: "L010102", value: "SCALPEL BLADES, REUSABLE" },
        { key: "L010103", value: "HANDLES FOR SCALPELS, REUSABLE" },
        { key: "L0102", value: "SURGICAL KNIVES, REUSABLE" },
        { key: "L0103", value: "DERMOTOMES AND BLADES, REUSABLE" },
        { key: "L0104", value: "SURGICAL SCISSORS, REUSABLE" },
        { key: "L010401", value: "SCISSORS FOR BANDAGES AND CLOTHING, REUSABLE" },
        { key: "L01040101", value: "SCISSORS FOR PLASTERS, REUSABLE" },
        { key: "L01040102", value: "SCISSORS FOR BANDAGES, REUSABLE" },
        { key: "L01040103", value: "SCISSORS FOR CLOTHING, REUSABLE" },
        { key: "L01040199", value: "SCISSORS FOR BANDAGES AND CLOTHING, REUSABLE - OTHER" },
        { key: "L010402", value: "SURGICAL SUTURES SCISSORS, REUSABLE" },
        { key: "L01040201", value: "STAPLE REMOVER SCISSORS, REUSABLE" },
        { key: "L01040202", value: "LIGATURES SCISSORS, REUSABLE" },
        { key: "L01040299", value: "SURGICAL SUTURES SCISSORS, REUSABLE - OTHER" },
        { key: "L010403", value: "SURGICAL DISSECTION SCISSORS, REUSABLE" },
        { key: "L010404", value: "CARDIOVASCULAR SURGERY SCISSORS, REUSABLE" },
        { key: "L01040401", value: "CARDIAC SCISSORS, REUSABLE" },
        { key: "L01040402", value: "VASCULAR SCISSORS, REUSABLE" },
        { key: "L010405", value: "OPHTHALMOLOGY SCISSORS, REUSABLE" },
        { key: "L01040501", value: "CORNEAL SCISSORS, REUSABLE" },
        { key: "L01040502", value: "OCULAR ENUCLEATION SCISSORS, REUSABLE" },
        { key: "L01040503", value: "IRIS SCISSORS, REUSABLE" },
        { key: "L01040504", value: "VITREO-RETINA SURGERY SCISSORS, REUSABLE" },
        { key: "L01040505", value: "CONJUNCTIVA SCISSORS, REUSABLE" },
        { key: "L01040506", value: "TENOTOMY AND STRABISM CORRECTION SCISSORS, REUSABLE" },
        { key: "L01040507", value: "BLEPHAROPLASTY SCISSORS, REUSABLE" },
        { key: "L01040508", value: "ENDOCULAR IMPLANTS SCISSORS, REUSABLE" },
        { key: "L01040509", value: "OCULAR ADNEXA SCISSORS, REUSABLE" },
        { key: "L0104050901", value: "CILIARY SCISSORS, REUSABLE" },
        { key: "L0104050999", value: "OCULAR ADNEXA SCISSORS, REUSABLE - OTHER" },
        { key: "L01040510", value: "CAPSULOTOMY SCISSORS, REUSABLE" },
        { key: "L01040599", value: "OPHTHALMOLOGY SCISSORS, REUSABLE - OTHER" },
        { key: "L010406", value: "OTOLARYNGOLOGICAL (ENT) SURGERY SCISSORS, REUSABLE" },
        { key: "L01040601", value: "NASAL SCISSORS, REUSABLE" },
        { key: "L01040602", value: "EAR SURGERY SCISSORS, REUSABLE" },
        { key: "L01040603", value: "TONSILLAR SCISSORS, REUSABLE" },
        { key: "L01040604", value: "LARYNGEAL SCISSORS, REUSABLE" },
        { key: "L01040699", value: "OTOLARYNGOLOGICAL (ENT) SURGERY SCISSORS, REUSABLE - OTHER" },
        { key: "L010407", value: "NEUROSURGERY SCISSORS, REUSABLE" },
        { key: "L01040701", value: "DURA MATER SCISSORS, REUSABLE" },
        { key: "L01040702", value: "NERVES SCISSORS, REUSABLE" },
        { key: "L01040799", value: "NEUROSURGERY SCISSORS, REUSABLE - OTHER" },
        { key: "L010408", value: "GASTROENTEROLOGY SCISSORS, REUSABLE" },
        { key: "L01040801", value: "INTESTINAL SCISSORS, REUSABLE" },
        { key: "L0104080101", value: "RECTAL SCISSORS, REUSABLE" },
        { key: "L0104080102", value: "ENTEROTOMY SCISSORS, REUSABLE" },
        { key: "L0104080199", value: "INTESTINAL SCISSORS, REUSABLE - OTHER" },
        { key: "L01040899", value: "GASTROENTEROLOGY SCISSORS, REUSABLE - OTHER" },
        { key: "L010409", value: "THORACIC SURGERY SCISSORS, REUSABLE" },
        { key: "L010410", value: "ODONTOSTOMATOLOGY SCISSORS, REUSABLE" },
        { key: "L01041001", value: "GINGIVAL SCISSORS, REUSABLE" },
        { key: "L01041099", value: "ODONTOSTOMATOLOGY SCISSORS, REUSABLE - OTHER" },
        { key: "L010411", value: "OBSTETRIC-GYNECOLOGICAL SURGERY SCISSORS, REUSABLE" },
        { key: "L01041101", value: "OBSTETRICS SCISSORS, REUSABLE" },
        { key: "L0104110101", value: "UMBILICAL SCISSORS, REUSABLE" },
        { key: "L0104110102", value: "EPISIOTOMY SCISSORS, REUSABLE" },
        { key: "L0104110103", value: "CEPHALOTOMY SCISSORS, REUSABLE" },
        { key: "L0104110199", value: "OBSTETRICS SCISSORS, REUSABLE - OTHER" },
        { key: "L01041102", value: "GYNECOLOGY SCISSORS, REUSABLE" },
        { key: "L0104110201", value: "UTERINE SCISSORS, REUSABLE" },
        { key: "L0104110202", value: "PARAMETRIUM SCISSORS, REUSABLE" },
        { key: "L0104110299", value: "GYNECOLOGY SCISSORS, REUSABLE - OTHER" },
        { key: "L01041199", value: "OBSTETRIC-GYNECOLOGICAL SURGERY SCISSORS, REUSABLE - OTHER" },
        { key: "L010412", value: "ORTHOPAEDIC SURGERY SCISSORS, REUSABLE" },
        { key: "L01041201", value: "BONE SCISSORS, REUSABLE" },
        { key: "L01041202", value: "WIRES AND METAL PLATES SCISSORS, REUSABLE" },
        { key: "L01041299", value: "ORTHOPAEDIC SURGERY SCISSORS, REUSABLE - OTHER" },
        { key: "L010413", value: "MICROSURGERY SCISSORS, REUSABLE" },
        { key: "L010499", value: "SURGICAL SCISSORS, REUSABLE - OTHER" },
        { key: "L0107", value: "SURGICAL SAWS AND BLADES, REUSABLE" },
        { key: "L010701", value: "MANUAL SURGICAL SAWS, REUSABLE" },
        { key: "L010702", value: "BLADES FOR MANUAL SURGICAL SAWS, REUSABLE" },
        { key: "L010703", value: "BLADES FOR MOTORISED SURGICAL SAWS, REUSABLE" },
        { key: "L0180", value: "SHARP INSTRUMENTS, REUSABLE - ACCESSORIES" },
        { key: "L0199", value: "SHARP INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L02", value: "SUTURE INSTRUMENTS, REUSABLE" },
        { key: "L0201", value: "NEEDLES AND APPLICATORS FOR LIGATURES, REUSABLE" },
        { key: "L0202", value: "SUTURE NEEDLES, REUSABLE" },
        { key: "L0203", value: "NEEDLE CONTAINERS, REUSABLE" },
        { key: "L0204", value: "STAPLE REMOVERS, REUSABLE" },
        { key: "L0205", value: "NEEDLE HOLDERS, REUSABLE" },
        { key: "L0206", value: "GROOVED PROBES, REUSABLE" },
        { key: "L0207", value: "KNOT PUSHERS, REUSABLE" },
        { key: "L0208", value: "MULTIPLE CLIPS APPLICATORS, REUSABLE" },
        { key: "L020801", value: "MULTIPLE CLIPS APPLICATORS FOR OPEN SURGERY, REUSABLE" },
        { key: "L020802", value: "MULTIPLE APPLICATORS OF CLIPS FOR VIDEO SURGERY, REUSABLE" },
        { key: "L0299", value: "SUTURE INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L03", value: "GENERAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L0301", value: "GENERAL SURGERY SURGICAL CANNULAS AND HANDPIECES, REUSABLE" },
        { key: "L030101", value: "SUCTION AND IRRIGATION SURGICAL CANNULAS AND HANDPIECES, REUSABLE" },
        { key: "L030199", value: "GENERAL SURGERY SURGICAL CANNULAS AND HANDPIECES, REUSABLE - OTHER" },
        { key: "L0311", value: "PROBES AND EXPLORERS, REUSABLE" },
        { key: "L031101", value: "FISTULA PROBES, REUSABLE" },
        { key: "L031102", value: "EXPLORATION PROBES, REUSABLE" },
        { key: "L031103", value: "BUTTONED PROBES, REUSABLE" },
        { key: "L031104", value: "SURGICAL MIRRORS, REUSABLE" },
        { key: "L031199", value: "PROBES AND MIRRORS, REUSABLE - OTHER" },
        { key: "L0312", value: "SURGICAL TROCAR, REUSABLE" },
        { key: "L031201", value: "THORACIC TROCAR, REUSABLE" },
        { key: "L031202", value: "ABDOMINAL TROCAR, REUSABLE" },
        { key: "L031203", value: "OTOLARYNGOLOGICAL SURGERY TROCAR, REUSABLE" },
        { key: "L031204", value: "ARTHROSCOPIC SURGERY TROCAR, REUSABLE" },
        { key: "L031205", value: "ORTHOPAEDIC SURGERY TROCAR, REUSABLE" },
        { key: "L031280", value: "SURGICAL TROCAR, REUSABLE - ACCESSORIES" },
        { key: "L031299", value: "SURGICAL TROCAR, REUSABLE - OTHER" },
        { key: "L0313", value: "GENERAL SURGERY FORCEPS, REUSABLE" },
        { key: "L031301", value: "GENERAL SURGERY BIOPSY FORCEPS, REUSABLE" },
        { key: "L031302", value: "MEDICATION FORCEPS, REUSABLE" },
        { key: "L031303", value: "SWAB FORCEPS, REUSABLE" },
        { key: "L031304", value: "GRASPING FORCEPS, REUSABLE" },
        { key: "L03130401", value: "TISSUE AND ORGAN GRASPING FORCEPS, REUSABLE" },
        { key: "L03130402", value: "FORCEPS FOR EXTERNAL BODIES, REUSABLE" },
        { key: "L03130403", value: "SPLINTER FORCEPS, REUSABLE" },
        { key: "L03130499", value: "GRASPING FORCEPS, REUSABLE - OTHER" },
        { key: "L031305", value: "FORCEPS FOR FABRICS AND BANDAGES, REUSABLE" },
        { key: "L031306", value: "HEMOSTATIC FORCEPS, REUSABLE" },
        { key: "L031307", value: "TOWEL AND TUBE CLAMPS, REUSABLE" },
        { key: "L031308", value: "SURGICAL AND ANATOMICAL TWEEZERS, REUSABLE" },
        { key: "L031309", value: "SUTURE NEEDLE PASSERS, REUSABLE" },
        { key: "L031310", value: "DISSECTION FORCEPS, REUSABLE" },
        { key: "L031312", value: "INTUBATION FORCEPS, REUSABLE" },
        { key: "L031399", value: "GENERAL SURGERY FORCEPS, REUSABLE - OTHER" },
        { key: "L0314", value: "GENERAL SURGERY SPREADERS AND SPATULAS, REUSABLE" },
        { key: "L031401", value: "GENERAL SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L03140101", value: "SELF-STATIC SPREADERS, REUSABLE" },
        { key: "L03140102", value: "VAGINAL SPREADERS, REUSABLE" },
        { key: "L03140103", value: "VASCULAR SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L03140104", value: "SPREADERS HOOKS, REUSABLE" },
        { key: "L03140105", value: "SKIN RETRACTORS, REUSABLE" },
        { key: "L03140199", value: "SPREADERS AND RETRACTORS FOR GENERAL SURGERY, REUSABLE   - OTHER" },
        { key: "L031402", value: "GENERAL SURGERY SPATULAS, REUSABLE" },
        { key: "L0315", value: "GENERAL SURGERY DISSECTORS, REUSABLE" },
        { key: "L0316", value: "HELMETS AND BINOCULAR GLASSES FOR SURGEONS" },
        { key: "L0317", value: "GENERAL SURGERY ADAPTERS AND CONNECTORS, REUSABLE" },
        { key: "L0318", value: "INSTRUMENTS FOR SUPPORT OF SURGICAL DEVICES, REUSABLE" },
        { key: "L0399", value: "GENERAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L04", value: "ABDOMINAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L0406", value: "RIGID RECTOSCOPES AND ANOSCOPES, REUSABLE" },
        { key: "L0408", value: "ABDOMINAL SURGERY SPECIAL FORCEPS, REUSABLE" },
        { key: "L040801", value: "LIVER AND BILIARY TRACT SPECIAL FORCEPS, REUSABLE" },
        { key: "L04080101", value: "GALLBLADDER FORCEPS, REUSABLE" },
        { key: "L04080102", value: "GALLSTONES FORCEPS, REUSABLE" },
        { key: "L04080103", value: "BILIARY TRACT FORCEPS, REUSABLE" },
        { key: "L04080199", value: "LIVER AND BILIARY TRACT SPECIAL FORCEPS, REUSABLE - OTHER" },
        { key: "L040802", value: "GASTROINTESTINAL SYSTEM SPECIAL FORCEPS, REUSABLE" },
        { key: "L04080201", value: "ESOPHAGEAL FORCEPS, REUSABLE" },
        { key: "L04080202", value: "GASTRIC FORCEPS, REUSABLE" },
        { key: "L04080203", value: "INTESTINAL FORCEPS, REUSABLE" },
        { key: "L0408020301", value: "INTESTINAL TISSUE GRIPPERS, REUSABLE" },
        { key: "L0408020302", value: "ENTEROSTATS, REUSABLE" },
        { key: "L0408020303", value: "RECTAL BIOPTIC FORCEPS, REUSABLE" },
        { key: "L0408020304", value: "INTESTINAL COMPRESSION FORCEPS, REUSABLE" },
        { key: "L0408020305", value: "INTESTINAL ANASTOMOSIS FORCEPS, REUSABLE" },
        { key: "L0408020306", value: "HEMORROIDAL FORCEPS, REUSABLE" },
        { key: "L0408020399", value: "INTESTINAL FORCEPS, REUSABLE - OTHER" },
        { key: "L04080204", value: "PERITONEAL FORCEPS, REUSABLE" },
        { key: "L04080299", value: "GASTROINTESTINAL SYSTEM SPECIAL FORCEPS, REUSABLE - OTHER" },
        { key: "L0409", value: "ABDOMINAL SURGERY DILATORS AND SPREADERS, REUSABLE" },
        { key: "L040901", value: "ABDOMINAL SPREADERS, REUSABLE" },
        { key: "L040902", value: "RECTAL AND ANAL SPREADERS, REUSABLE" },
        { key: "L040903", value: "GASTRIC DILATORS, REUSABLE" },
        { key: "L040999", value: "ABDOMINAL SURGERY DILATORS AND SPREADERS, REUSABLE - OTHER" },
        { key: "L0410", value: "ABDOMINAL SURGERY PROBES, REUSABLE" },
        { key: "L041001", value: "LIVER AND BILIARY ROUTES SURGICAL PROBES, MULTIPURPOSE" },
        { key: "L04100101", value: "BILIARY SURGICAL PROBES, REUSABLE" },
        { key: "L04100102", value: "LIVER SURGICAL PROBES, REUSABLE" },
        { key: "L041002", value: "DIGESTIVE SYSTEM SURGICAL PROBES, REUSABLE" },
        { key: "L04100201", value: "ESOPHAGEAL SURGICAL PROBES, REUSABLE" },
        { key: "L04100202", value: "RECTAL SURGICAL PROBES, REUSABLE" },
        { key: "L04100299", value: "DIGESTIVE SYSTEM SURGICAL PROBES, REUSABLE - OTHER" },
        { key: "L0411", value: "ABDOMINAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L0499", value: "ABDOMINAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L05", value: "OBSTETRICS AND GYNECOLOGY INSTRUMENTS, REUSABLE" },
        { key: "L0508", value: "OBSTETRICS INSTRUMENTS, REUSABLE" },
        { key: "L050801", value: "OBSTETRICS FORCEPS, REUSABLE" },
        { key: "L050802", value: "AMNIOTOMES, REUSABLE" },
        { key: "L050803", value: "OBSTETRIC SURGERY FORCEPS, REUSABLE" },
        { key: "L05080301", value: "OBSTETRIC SURGERY CLAMPS, REUSABLE" },
        { key: "L0508030101", value: "UMBILICAL CLAMPING FORCEPS, REUSABLE" },
        { key: "L0508030199", value: "OBSTETRIC SURGERY CLAMPS, REUSABLE - OTHER" },
        { key: "L05080302", value: "OBSTETRIC GRIPPERS, REUSABLE" },
        { key: "L05080303", value: "PLACENTA AND ABORTIVE TISSUE FORCEPS, REUSABLE" },
        { key: "L05080399", value: "OBSTETRIC SURGERY FORCEPS, REUSABLE - OTHER" },
        { key: "L050804", value: "OBSTETRICS HOOKS, REUSABLE" },
        { key: "L050899", value: "OBSTETRICS INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0509", value: "GYNECOLOGICAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L050901", value: "UTERINE CURETTES, REUSABLE" },
        { key: "L050902", value: "GYNECOLOGICAL USE DILATORS AND SPREADERS, REUSABLE" },
        { key: "L05090201", value: "GYNECOLOGICAL USE DILATORS, REUSABLE" },
        { key: "L0509020101", value: "VAGINAL DILATORS, REUSABLE" },
        { key: "L0509020102", value: "CERVICAL DILATORS, REUSABLE" },
        { key: "L0509020103", value: "TUBES DILATORS, REUSABLE" },
        { key: "L0509020199", value: "GYNECOLOGICAL USE DILATORS, REUSABLE - OTHER" },
        { key: "L05090202", value: "GYNECOLOGICAL USE SPREADERS, REUSABLE" },
        { key: "L0509020201", value: "UTERINE RETRACTORS, REUSABLE" },
        { key: "L0509020299", value: "GYNECOLOGICAL USE SPREADERS, REUSABLE - OTHER" },
        { key: "L050903", value: "GYNECOLOGICAL SURGERY FORCEPS, REUSABLE" },
        { key: "L05090301", value: "GYNECOLOGICAL BIOPSY FORCEPS, REUSABLE" },
        { key: "L05090302", value: "UTERINE FORCEPS, REUSABLE" },
        { key: "L0509030201", value: "HYSTERECTOMY FORCEPS, REUSABLE" },
        { key: "L0509030202", value: "UTERINE GRIPPERS, REUSABLE" },
        { key: "L0509030203", value: "PARAMETRIUM FORCEPS, REUSABLE" },
        { key: "L0509030299", value: "UTERINE FORCEPS, REUSABLE - OTHER" },
        { key: "L05090399", value: "GYNECOLOGICAL SURGERY FORCEPS, REUSABLE - OTHER" },
        { key: "L050905", value: "GYNECOLOGICAL SURGERY PROBES, REUSABLE" },
        { key: "L05090501", value: "UTERINE SURGICAL PROBES, REUSABLE" },
        { key: "L05090599", value: "GYNECOLOGICAL SURGERY PROBES, REUSABLE - OTHER" },
        { key: "L050906", value: "GYNECOLOGICAL PROSTHETIC INSTRUMENTS AND KIT, REUSABLE" },
        { key: "L0590", value: "OBSTETRICS AND GYNECOLOGY INSTRUMENTS, REUSABLE - VARIOUS" },
        { key: "L059001", value: "VAGINAL SPECULUMS, REUSABLE" },
        { key: "L059002", value: "UTERINE LEVERS, REUSABLE" },
        { key: "L059003", value: "GYNECOLOGICAL USE HOOKS, REUSABLE" },
        { key: "L059004", value: "UTERINE MANIPULATORS, REUSABLE" },
        { key: "L059005", value: "CERVICAL CERCLAGE NEEDLES, REUSABLE" },
        { key: "L059006", value: "OBSTETRIC AND GYNECOLOGICAL SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L059007", value: "UTERINE MYOMA EXTRACTORS, REUSABLE" },
        { key: "L059008", value: "OBSTETRIC AND GYNECOLOGICAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L059099", value: "OBSTETRICS AND GYNECOLOGY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L06", value: "UROLOGY INSTRUMENTS, REUSABLE" },
        { key: "L0604", value: "ENDOSCOPIC UROLOGY INSTRUMENTS, REUSABLE" },
        { key: "L060401", value: "ENDOSCOPIC UROLOGY SCISSORS, REUSABLE" },
        { key: "L060402", value: "ENDOSCOPIC UROLOGY MANIPULATORS, REUSABLE" },
        { key: "L060403", value: "ENDOSCOPIC UROLOGY FORCEPS, REUSABLE" },
        { key: "L060404", value: "ENDOSCOPIC UROLOGY DISSECTORS, REUSABLE" },
        { key: "L060405", value: "ENDOSCOPIC UROLOGY SCALPELS, REUSABLE" },
        { key: "L06040501", value: "ENDOSCOPIC SURGERY URETHROTOMES AND URETHEROTOMES, REUSABLE" },
        { key: "L06040599", value: "ENDOSCOPIC UROLOGY SCALPELS, REUSABLE - OTHER" },
        { key: "L060406", value: "ENDOSCOPIC UROLOGY RECOVERY BASKETS, REUSABLE" },
        { key: "L060407", value: "ENDOSCOPIC UROLOGY SHIRTS, REUSABLE" },
        { key: "L060408", value: "ENDOSCOPIC UROLOGY FILLERS, REUSABLE" },
        { key: "L060409", value: "ENDOSCOPIC UROLOGY CANNULAS, REUSABLE" },
        { key: "L060410", value: "ENDOSCOPIC UROLOGY NEEDLES, REUSABLE" },
        { key: "L060411", value: "ENDOSCOPIC UROLOGY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L060412", value: "ENDOSCOPIC UROLOGY DILATORS, REUSABLE" },
        { key: "L060413", value: "ENDOSCOPIC UROLOGY ADAPTERS AND CONNECTORS, REUSABLE" },
        { key: "L060480", value: "ENDOSCOPIC UROLOGY INSTRUMENTS, REUSABLE - ACCESSORIES" },
        { key: "L060499", value: "ENDOSCOPIC UROLOGY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0605", value: "NON-ENDOSCOPIC UROLOGY DILATORS AND SPREADERS, REUSABLE" },
        { key: "L060501", value: "NON-ENDOSCOPIC UROLOGICAL EXPANSION INSTRUMENTS, REUSABLE" },
        { key: "L06050101", value: "NON-ENDOSCOPIC URETHRAL EXPANSION INSTRUMENTS, REUSABLE" },
        { key: "L06050199", value: "NON-ENDOSCOPIC UROLOGICAL DILATION INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L060502", value: "NON-ENDOSCOPIC UROLOGY SPREADERS, REUSABLE" },
        { key: "L06050201", value: "NON-ENDOSCOPIC BLADDER SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L06050202", value: "NON-ENDOSCOPIC PROSTATIC SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L06050299", value: "NON-ENDOSCOPIC UROLOGY RETRACTORS, REUSABLE - OTHER" },
        { key: "L0606", value: "NON-ENDOSCOPIC UROLOGY FORCEPS, REUSABLE" },
        { key: "L060601", value: "NON-ENDOSCOPIC KIDNEY FORCEPS, REUSABLE" },
        { key: "L06060101", value: "KIDNEY STONES NON-ENDOSCOPIC FORCEPS, REUSABLE" },
        { key: "L06060102", value: "NON-ENDOSCOPIC UROLOGICAL SURGERY SPATULAS, REUSABLE" },
        { key: "L06060103", value: "NON-ENDOSCOPIC KIDNEY GRIPPERS, REUSABLE" },
        { key: "L06060199", value: "NON-ENDOSCOPIC KIDNEY FORCEPS, REUSABLE - OTHER" },
        { key: "L060602", value: "NON-ENDOSCOPIC URINARY TRACT FORCEPS, REUSABLE" },
        { key: "L060603", value: "EXTERNAL MALE GENITALS FORCEPS, REUSABLE" },
        { key: "L06060301", value: "EXTERNAL MALE GENITALS CLAMPS, REUSABLE" },
        { key: "L0606030101", value: "PENILE CLAMPS, REUSABLE" },
        { key: "L0606030199", value: "EXTERNAL MALE GENITALS CLAMPS, REUSABLE - OTHER" },
        { key: "L06060399", value: "EXTERNAL MALE GENITALS FORCEPS, REUSABLE - OTHER" },
        { key: "L060604", value: "NON-ENDOSCOPIC PROSTATIC FORCEPS, REUSABLE" },
        { key: "L060699", value: "NON-ENDOSCOPIC UROLOGY FORCEPS, REUSABLE - OTHER" },
        { key: "L0607", value: "SUPRAPUBIC ACCESS HANDPIECES, REUSABLE" },
        { key: "L0608", value: "NON-ENDOSCOPIC URINARY TRACT SURGICAL MANIPULATORS, REUSABLE" },
        { key: "L0609", value: "UROLOGICAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L0610", value: "NON-ENDOSCOPIC UROLOGICAL SURGERY SPATULAS, REUSABLE" },
        { key: "L0611", value: "NON-ENDOSCOPIC UROLOGY NEEDLES, REUSABLE" },
        { key: "L0612", value: "UROLOGY PROSTHETIC INSTRUMENTS AND KIT, REUSABLE" },
        { key: "L0699", value: "UROLOGY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L07", value: "CARDIOVASCULAR SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L0707", value: "CARDIAC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L070701", value: "CARDIAC SURGERY FORCEPS, REUSABLE" },
        { key: "L070702", value: "CARDIAC DILATORS AND RETRACTORS, REUSABLE" },
        { key: "L07070201", value: "CARDIAC DILATORS, REUSABLE" },
        { key: "L0707020101", value: "VALVE DILATORS, REUSABLE" },
        { key: "L0707020199", value: "CARDIAC DILATORS, REUSABLE - OTHER" },
        { key: "L07070202", value: "CARDIAC RETRACTORS, REUSABLE" },
        { key: "L070703", value: "CARDIAC VALVULOTOMES, REUSABLE" },
        { key: "L070704", value: "CARDIAC SURGERY MEASUREMENT INSTRUMENTS, REUSABLE" },
        { key: "L070705", value: "CARDIAC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L070799", value: "CARDIAC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0708", value: "VASCULAR SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L070801", value: "VASCULAR SURGERY FORCEPS, REUSABLE" },
        { key: "L07080101", value: "VASCULAR CLIPS, REUSABLE" },
        { key: "L0708010101", value: "BULLDOG VASCULAR CLIPS, REUSABLE" },
        { key: "L0708010180", value: "VASCULAR CLIPS, REUSABLE- ACCESSORIES" },
        { key: "L070801018001", value: "FORCEPS FOR THE APPLICATION AND REMOVAL OF VASCULAR CLIPS, REUSABLE" },
        { key: "L070801018099", value: "VASCULAR CLIPS, REUSABLE - OTHER - ACCESSORIES" },
        { key: "L0708010199", value: "VASCULAR CLIPS, REUSABLE - OTHER" },
        { key: "L07080102", value: "GENERIC VASCULAR CLAMPING ANGIOSTATS AND FORCEPS, REUSABLE" },
        { key: "L07080103", value: "VASCULAR ANASTOMOSIS FORCEPS, REUSABLE" },
        { key: "L07080104", value: "VASCULAR APPROXIMATORS, REUSABLE" },
        { key: "L07080105", value: "SPECIFIC VESSELS CLAMPS, REUSABLE" },
        { key: "L0708010501", value: "AORTIC CLAMPS, REUSABLE" },
        { key: "L0708010502", value: "CAROTID CLAMPS, REUSABLE" },
        { key: "L0708010503", value: "VENA CAVA CLAMPS, REUSABLE" },
        { key: "L0708010599", value: "SPECIFIC VESSELS CLAMPS, REUSABLE - OTHER" },
        { key: "L07080199", value: "VASCULAR SURGERY CLAMPS, REUSABLE - OTHER" },
        { key: "L070802", value: "VASCULAR DILATORS, REUSABLE" },
        { key: "L070803", value: "VASCULAR SPATULAS, REUSABLE" },
        { key: "L070804", value: "VENOUS STRIPPERS, REUSABLE" },
        { key: "L070805", value: "VASCULAR TUNNELLERS, REUSABLE" },
        { key: "L070806", value: "CARDIOVASCULAR PROSTHETICS INSTRUMENTS, REUSABLE" },
        { key: "L07080601", value: "VASCULAR PROSTHETICS FORCEPS, REUSABLE" },
        { key: "L0708060101", value: "FORCEPS FOR THE APPLICATION OF VASCULAR PROSTHESES, REUSABLE" },
        { key: "L0708060199", value: "VASCULAR PROSTHETICS FORCEPS, REUSABLE - OTHER" },
        { key: "L07080699", value: "CARDIOVASCULAR PROSTHETICS INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L070807", value: "VASCULAR PERFORATORS, REUSABLE" },
        { key: "L070808", value: "VASCULAR SURGERY MANIPULATORS, REUSABLE" },
        { key: "L07080801", value: "VASCULAR DEPRESSORS, REUSABLE" },
        { key: "L07080899", value: "VASCULAR SURGERY MANIPULATORS, REUSABLE - OTHER" },
        { key: "L070809", value: "ENDOARTERIECTOMY INSTRUMENTS, REUSABLE" },
        { key: "L070810", value: "VASCULAR SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L070899", value: "VASCULAR SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L08", value: "THORACIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L0801", value: "COSTOTOMES, REUSABLE" },
        { key: "L0804", value: "STERNOTOMY SURGICAL INSTRUMENTS, REUSABLE" },
        { key: "L0805", value: "THORACIC SURGERY FORCEPS, REUSABLE" },
        { key: "L080501", value: "BRONCHUS CLAMPS, REUSABLE" },
        { key: "L080502", value: "PULMONARY CLAMPS, REUSABLE" },
        { key: "L08050201", value: "PULMONARY TISSUE GRIPPERS, REUSABLE" },
        { key: "L08050299", value: "PULMONARY CLAMPS, REUSABLE - OTHER" },
        { key: "L080599", value: "THORACIC SURGERY CLAMPS, REUSABLE - OTHER" },
        { key: "L0806", value: "THORACIC SURGERY DILATORS AND SPREADERS, REUSABLE" },
        { key: "L080601", value: "THORACIC SURGERY DILATORS, REUSABLE" },
        { key: "L08060101", value: "PULMONARY DILATORS, REUSABLE" },
        { key: "L08060199", value: "THORACIC SURGERY DILATORS, REUSABLE - OTHER" },
        { key: "L080602", value: "THORACIC SURGERY SPREADERS, REUSABLE" },
        { key: "L08060201", value: "COSTAL AND STERNAL RETRACTORS, REUSABLE" },
        { key: "L08060299", value: "THORACIC SURGERY SPREADERS, REUSABLE - OTHER" },
        { key: "L0807", value: "THORACIC SURGERY SPATULAS, REUSABLE" },
        { key: "L0808", value: "BRONCHOSCOPIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L080801", value: "BRONCHOSCOPIC SURGERY DISSECTORS, REUSABLE" },
        { key: "L080802", value: "BRONCHOSCOPIC SURGERY SCISSORS, REUSABLE" },
        { key: "L080803", value: "BRONCHOSCOPIC SURGERY CLAMPS, REUSABLE" },
        { key: "L080804", value: "BRONCHOSCOPIC SURGERY CURETTES, REUSABLE" },
        { key: "L080805", value: "BRONCHOSCOPIC SURGERY CANNULAS, REUSABLE" },
        { key: "L080806", value: "BRONCHOSCOPY ADAPTERS AND CONNECTORS, REUSABLE" },
        { key: "L080899", value: "BRONCHOSCOPIC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0809", value: "THORACIC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L0899", value: "THORACIC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L09", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L0901", value: "ORTHOPAEDIC SURGERY SPOONS AND CURETTES, REUSABLE" },
        { key: "L0902", value: "ORTHOPAEDIC SURGERY LEVERS, REUSABLE" },
        { key: "L0903", value: "ORTHOPAEDIC SURGERY HAMMERS, REUSABLE" },
        { key: "L0904", value: "OSTEOTOMES AND SCALPELS, REUSABLE" },
        { key: "L090401", value: "ORTHOPAEDIC SURGERY OSTEOTOMES, REUSABLE" },
        { key: "L090402", value: "ORTHOPAEDIC SURGERY SCALPELS, REUSABLE" },
        { key: "L090403", value: "ORTHOPAEDIC SURGERY GOUGES, REUSABLE" },
        { key: "L090404", value: "OSTEOTOMES AND SCALPELS BLADES, REUSABLE" },
        { key: "L0908", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL TRACTION INSTRUMENTS, REUSABLE" },
        { key: "L0909", value: "ORTHOPAEDIC SURGERY CUTTING INSTRUMENTS, REUSABLE" },
        { key: "L090901", value: "BONE CUTTERS, REUSABLE" },
        { key: "L090902", value: "ORTHOPAEDIC SURGERY TREPHINES, REUSABLE" },
        { key: "L090903", value: "ORTHOPAEDIC SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L090999", value: "ORTHOPAEDIC SURGERY CUTTING INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0910", value: "OSTEOSYNTHESIS INSTRUMENTS, REUSABLE " },
        { key: "L091001", value: "INSTRUMENTS FOR INSERTION AND EXTRACTION OF MATERIALS FOR OSTEOSYNTHESIS, REUSABLE " },
        { key: "L091002", value: "INSTRUMENTS FOR PROCESSING MATERIALS FOR OSTEOSYNTHESIS, REUSABLE " },
        { key: "L091099", value: "OSTEOSYNTHESIS INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0911", value: "ORTHOPAEDIC PROSTHETICS INSTRUMENTS, REUSABLE " },
        { key: "L091101", value: "ORTHOPAEDIC PROSTHESES AND TRAUMATOLOGICAL IMPLANTS EXTRACTORS, REUSABLE " },
        { key: "L091102", value: "ORTHOPAEDIC PROSTHESES REAMERS AND BURS, REUSABLE" },
        { key: "L091103", value: "ORTHOPAEDIC PROSTHESES FORCEPS, REUSABLE" },
        { key: "L091104", value: "ORTHOPAEDIC PROSTHESES POSITIONERS, REUSABLE" },
        { key: "L091105", value: "CEMENTATION INSTRUMENTS, REUSABLE" },
        { key: "L091106", value: "INSTRUMENTS FOR THE PREPARATION OF TISSUE IMPLANTS IN ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY, REUSABLE" },
        { key: "L091199", value: "ORTHOPAEDIC PROSTHETICS INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L0912", value: "ORTHOPAEDIC RASPS AND FILES, REUSABLE" },
        { key: "L091201", value: "ORTHOPAEDIC SURGERY RASPS, REUSABLE" },
        { key: "L091202", value: "ORTHOPAEDIC SURGERY FILES, REUSABLE" },
        { key: "L0913", value: "ORTHOPAEDIC SURGERY FORCEPS, REUSABLE" },
        { key: "L091301", value: "BONE GRASPS, REUSABLE" },
        { key: "L091302", value: "BONE RONGEURS, REUSABLE" },
        { key: "L091303", value: "BONE REDUCTION FORCEPS, REUSABLE" },
        { key: "L091304", value: "SEQUESTRIAL PLIERS, REUSABLE" },
        { key: "L091305", value: "FORCEPS FOR TENDONS AND LIGAMENTS, REUSABLE" },
        { key: "L091306", value: "CARTILAGE FORCEPS, REUSABLE" },
        { key: "L091307", value: "ORTHOPAEDIC SURGERY RONGEURS, REUSABLE" },
        { key: "L091399", value: "ORTHOPAEDIC SURGERY FORCEPS, REUSABLE - OTHER" },
        { key: "L0914", value: "SCOLLAPERIOSTIUM AND PERIOSTEOTOMES, REUSABLE" },
        { key: "L0915", value: "SPREADERS AND RETRACTORS FOR ORTHOPAEDIC SURGERY, REUSABLE" },
        { key: "L0916", value: "ORTHOPAEDIC SURGERY BURS AND TIPS, REUSABLE" },
        { key: "L0917", value: "ORTHOPAEDIC SPATULAS, REUSABLE" },
        { key: "L0918", value: "ORTHOPAEDIC TUNNELISERS, REUSABLE" },
        { key: "L0919", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L0920", value: "ORTHOPAEDIC SURGERY DISTRACTORS, REUSABLE" },
        { key: "L0921", value: "NON-IMPLANTABLE ORTHOPAEDIC DEVICES EXTRACTORS, REUSABLE" },
        { key: "L0922", value: "ORTHOPAEDIC SURGERY GUIDES, REUSABLE" },
        { key: "L0923", value: "ORTHOPAEDICS SURGICAL MEASURERS, REUSABLE" },
        { key: "L0924", value: "TENOTOMES, REUSABLE" },
        { key: "L0925", value: "ORTHOPAEDIC SURGERY DILATORS, REUSABLE" },
        { key: "L0926", value: "ORTHOPAEDIC SURGERY DISSECTORS, REUSABLE" },
        { key: "L0927", value: "ORTHOPAEDIC SURGERY MANUAL PERFORATORS, REUSABLE" },
        { key: "L0980", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE - ACCESSORIES" },
        { key: "L098001", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY MANDRELS, REUSABLE" },
        { key: "L098002", value: "ORTHOPAEDIC INSTRUMENTS KEYS, REUSABLE" },
        { key: "L098003", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY TAPS, REUSABLE" },
        { key: "L098099", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE - OTHER ACCESSORIES" },
        { key: "L0999", value: "ORTHOPAEDIC AND TRAUMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L10", value: "MICROSURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1001", value: "MICROSURGERY APPROXIMATORS, REUSABLE" },
        { key: "L1003", value: "MICROSURGERY FORCEPS, REUSABLE" },
        { key: "L1004", value: "MICROSURGERY NEEDLE HOLDERS, REUSABLE" },
        { key: "L1005", value: "MICROSURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1099", value: "MICROSURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L11", value: "NEUROSURGERY AND SPINAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1102", value: "NEUROSURGERY SPATULAS AND DISSECTORS, REUSABLE" },
        { key: "L1103", value: "CERVICAL TRACTION BRACKETS, REUSABLE" },
        { key: "L1104", value: "BITS FOR NEUROSURGERY DRILLS, REUSABLE" },
        { key: "L1105", value: "NEUROSURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L110501", value: "VERTEBRAL SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L11050101", value: "LAMINECTOMY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L11050199", value: "VERTEBRAL SURGERY SPREADERS AND RETRACTORS, REUSABLE - OTHER" },
        { key: "L110502", value: "NERVES AND VESSELS HOOK RETRACTORS, REUSABLE" },
        { key: "L110503", value: "CRANIAL SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L11050301", value: "CEREBRAL SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L11050399", value: "CRANIAL SURGERY SPREADERS AND RETRACTORS, REUSABLE- OTHER" },
        { key: "L110599", value: "NEUROSURGERY SPREADERS AND RETRACTORS, REUSABLE - OTHER" },
        { key: "L1106", value: "NEUROSURGERY FORCEPS, REUSABLE" },
        { key: "L110601", value: "DISC HERNIA FORCEPS, REUSABLE" },
        { key: "L110602", value: "NEUROSURGERY GRIPPERS, REUSABLE" },
        { key: "L110603", value: "CRANIAL CLIPS, REUSABLE" },
        { key: "L11060301", value: "SCALP CLIPS, REUSABLE" },
        { key: "L11060399", value: "CRANIAL CLIPS, REUSABLE - OTHER" },
        { key: "L110604", value: "NEUROSURGERY RONGEURS, REUSABLE" },
        { key: "L110699", value: "NEUROSURGERY FORCEPS, REUSABLE - OTHER" },
        { key: "L1107", value: "NEUROSURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L110701", value: "CEREBRAL AND MENINGEAL SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L11070101", value: "LEUCOTOMES, REUSABLE" },
        { key: "L11070199", value: "CEREBRAL AND MENINGEAL SURGERY SCALPELS AND KNIVES, REUSABLE - OTHER" },
        { key: "L110702", value: "CRANIAL TREPHINES, REUSABLE" },
        { key: "L110799", value: "NEUROSURGERY SCALPELS AND KNIVES, REUSABLE - OTHER" },
        { key: "L1108", value: "NEUROSURGERY LEVERS, REUSABLE" },
        { key: "L1109", value: "NEUROSURGERY AND SPINAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1110", value: "NEUROSURGERY OBTURATORS, REUSABLE" },
        { key: "L1111", value: "NEUROSURGERY MANIPULATORS, REUSABLE" },
        { key: "L1112", value: "NEUROSURGERY SUCTION CANNULES, REUSABLE" },
        { key: "L1113", value: "NEUROSURGERY BURS AND TIPS, REUSABLE" },
        { key: "L1199", value: "NEUROSURGERY INSTRUMENTS, REUSABLE- OTHER" },
        { key: "L12", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1201", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY DISSECTORS, REUSABLE" },
        { key: "L1202", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY SCISSORS, REUSABLE" },
        { key: "L1203", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY MANIPULATORS, REUSABLE" },
        { key: "L1204", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY FORCEPS REUSABLE" },
        { key: "L1205", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY NEEDLE HOLDERS, REUSABLE" },
        { key: "L1206", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L1207", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY CANNULAS, REUSABLE" },
        { key: "L1208", value: "SUTURING ENDOSCOPIC TISSUE APPROXIMATORS, REUSABLE" },
        { key: "L1209", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY SCALPELS, REUSABLE" },
        { key: "L1210", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY HOOKS, REUSABLE" },
        { key: "L1211", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY SPATULAS, REUSABLE" },
        { key: "L1212", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY GUIDES, REUSABLE" },
        { key: "L1213", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY HANDPIECES, REUSABLE" },
        { key: "L1214", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY DILATORS, REUSABLE" },
        { key: "L1215", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY NEEDLES, REUSABLE" },
        { key: "L1216", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY PALPATORS, REUSABLE" },
        { key: "L1217", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1218", value: "LAPAROSCOPIC AND THORACOSCOPY ADAPTERS AND CONNECTORS, REUSABLE" },
        { key: "L1280", value: "LAPAROSCOPIC AND THORACOSCOPIC SURGERY INSTRUMENTS, REUSABLE - ACCESSORIES" },
        { key: "L1299", value: "LAPAROSCOPIC AND THORACOSCOPIC INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L13", value: "ROBOTIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1301", value: "ROBOTIC SURGERY SCALPELS, REUSABLE" },
        { key: "L1302", value: "ROBOTIC SURGERY CLIPS, REUSABLE" },
        { key: "L1303", value: "ROBOTIC SURGERY SCISSORS, REUSABLE" },
        { key: "L1304", value: "ROBOTIC SURGERY FORCEPS, REUSABLE" },
        { key: "L1305", value: "ROBOTIC SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L1306", value: "ULTRASONIC GENERATOR ROBOTIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1307", value: "ROBOTIC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1399", value: "ROBOTIC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L14", value: "ENT INSTRUMENTS, REUSABLE" },
        { key: "L1401", value: "PHARYNX SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L140101", value: "RHINOPHARYNGAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L14010101", value: "ADENOTOMES, REUSABLE" },
        { key: "L14010102", value: "RHINOPHARYNGAL SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L14010103", value: "RHINOPHARYNGAL SURGERY CURETTES, REUSABLE" },
        { key: "L14010199", value: "RHINOPHARYNGAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L140102", value: "OROPHARYNX SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L14010201", value: "TONSILLARY PLIERS, REUSABLE" },
        { key: "L14010202", value: "TONSILLARY HOOKS, REUSABLE" },
        { key: "L14010203", value: "OROPHARYNGAL SURGERY TONSILOTOMES AND SCALPELS, REUSABLE" },
        { key: "L14010204", value: "OROPHARYNX SURGERY PLIERS NOT INCLUDED IN OTHER CLASSES, REUSABLE" },
        { key: "L14010205", value: "OROPHARYNGAL SURGERY DEPRESSORS, REUSABLE" },
        { key: "L14010206", value: "OROPHARYNGAL SURGERY CANNULAS, REUSABLE" },
        { key: "L14010299", value: "OROPHARYNGAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1402", value: "NASAL AND PARANASAL CAVITY SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L140201", value: "NASAL DILATORS, REUSABLE" },
        { key: "L140202", value: "NASAL AND PARANASAL CAVITY SURGERY PLIERS, REUSABLE" },
        { key: "L140203", value: "NASAL HOOKS, REUSABLE" },
        { key: "L140204", value: "NASAL SURGERY RASPS AND FILES, REUSABLE" },
        { key: "L140205", value: "NASAL AND PARANASAL CAVITY SURGERY RASPS AND KNIVES, REUSABLE" },
        { key: "L140206", value: "NASAL AND PARANASAL CAVITY SURGERY CANNULAS, REUSABLE" },
        { key: "L140299", value: "NASAL AND PARANASAL CAVITY SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1403", value: "LARYNX SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L140301", value: "LARYNX SURGERY SCALPELS, REUSABLE" },
        { key: "L140399", value: "LARYNX SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1404", value: "TRACHEA SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L140401", value: "TRACHEAL DILATORS, REUSABLE" },
        { key: "L140402", value: "TRACHEOTOMY INSTRUMENTS, REUSABLE" },
        { key: "L14040201", value: "TRACHEOTOMY INSTRUMENT KITS, REUSABLE" },
        { key: "L14040202", value: "CRICOTHYROTOMY INSTRUMENT KITS, REUSABLE" },
        { key: "L14040203", value: "TRACHEOTOMES, REUSABLE" },
        { key: "L14040204", value: "CRICOTHYROTOMES, REUSABLE" },
        { key: "L14040299", value: "TRACHEOTOMY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L140499", value: "TRACHEA SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1405", value: "EAR SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L140501", value: "MIDDLE EAR SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L14050101", value: "BONE SURGERY HOOKS, REUSABLE" },
        { key: "L14050102", value: "OSSICULAR SURGERY RASPS AND FILES, REUSABLE" },
        { key: "L14050103", value: "BONE SURGERY SPATULAS, REUSABLE" },
        { key: "L14050199", value: "MIDDLE EAR SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L140502", value: "EAR SURGERY PLIERS, REUSABLE" },
        { key: "L140503", value: "EAR SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L140599", value: "EAR SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1406", value: "ENT OSTEOTOMES AND SCALPELS, REUSABLE" },
        { key: "L140601", value: "ENT OSTEOTOMES, REUSABLE" },
        { key: "L140602", value: "ENT CHISELS, REUSABLE" },
        { key: "L1490", value: "ENT INSTRUMENTS, REUSABLE - VARIOUS" },
        { key: "L149001", value: "ENT CURETTES, REUSABLE" },
        { key: "L149002", value: "ENT LEVERS, REUSABLE" },
        { key: "L149003", value: "ENT RETRACTORS, REUSABLE" },
        { key: "L149004", value: "ENT SPECULUMS, REUSABLE" },
        { key: "L149005", value: "ENT PROBES, REUSABLE" },
        { key: "L149006", value: "ENT PERFORATORS, REUSABLE" },
        { key: "L149007", value: "ENT SPOONS, REUSABLE" },
        { key: "L149008", value: "ENT ENUCLEATION INSTRUMENTS, REUSABLE" },
        { key: "L149009", value: "ENT SURGERY BURS, REUSABLE" },
        { key: "L149010", value: "ENT SURGERY MANIPULATORS, REUSABLE" },
        { key: "L149011", value: "ENT SURGERY DISSECTORS, REUSABLE" },
        { key: "L149012", value: "ENT SURGERY PUNCHES, REUSABLE" },
        { key: "L149013", value: "ENT SURGERY INSTRUMENT KITS NOT INCLUDED IN OTHER CLASSES, REUSABLE" },
        { key: "L149099", value: "ENT INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L15", value: "ODONTOSTOMATOLOGY INSTRUMENTS, REUSABLE" },
        { key: "L1501", value: "ODONTOSTOMATOLOGY OSTEOTOMES AND SCALPELS, REUSABLE" },
        { key: "L150101", value: "ODONTOSTOMATOLOGY OSTEOTOMES, REUSABLE" },
        { key: "L150102", value: "ODONTOSTOMATOLOGY CHISELS, REUSABLE" },
        { key: "L150103", value: "DENTAL OSTEOTOME BLADES, REUSABLE" },
        { key: "L1502", value: "ODONTOSTOMATOLOGY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L150201", value: "DENTAL RETRACTORS, REUSABLE" },
        { key: "L150202", value: "BUCCAL SPREADERS, REUSABLE" },
        { key: "L150299", value: "ODONTOSTOMATOLOGY SPREADERS AND RETRACTORS, REUSABLE - OTHER" },
        { key: "L1503", value: "ODONTOSTOMATOLOGY FORCEPS, REUSABLE" },
        { key: "L150301", value: "DENTAL EXTRACTION TOOTH FORCEPS, REUSABLE" },
        { key: "L150302", value: "DENTAL RONGEURS, REUSABLE" },
        { key: "L150399", value: "ODONTOSTOMATOLOGY FORCEPS, REUSABLE - OTHER" },
        { key: "L1504", value: "ODONTOSTOMATOLOGY MODELERS, REUSABLE" },
        { key: "L1505", value: "ODONTOSTOMATOLOGY LEVERS, REUSABLE" },
        { key: "L1506", value: "ODONTOSTOMATOLOGY OBTURATORS, REUSABLE" },
        { key: "L1507", value: "ORTHODONTIC INSTRUMENTS, REUSABLE" },
        { key: "L150701", value: "ORTHODONTIC LIGATURE TOOLS, REUSABLE" },
        { key: "L150702", value: "ORTHODONTIC PLIERS, REUSABLE" },
        { key: "L150703", value: "ORTHODONTIC CUTTERS, REUSABLE" },
        { key: "L150704", value: "ORTHODONTIC BAND PUSHERS, REUSABLE" },
        { key: "L150705", value: "ORTHODONTIC MEASUREMENT INSTRUMENTS, REUSABLE" },
        { key: "L150799", value: "ORTHODONTIC INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L1508", value: "REAMERS, REUSABLE" },
        { key: "L1590", value: "ODONTOSTOMATOLOGY INSTRUMENTS, REUSABLE - VARIOUS" },
        { key: "L159001", value: "DENTAL AND PERIODONTAL CURETTES, REUSABLE" },
        { key: "L159002", value: "DENTAL EXCAVATORS, REUSABLE" },
        { key: "L159003", value: "DENTAL AND PERIODONTAL PROBES AND EXPLORERS, REUSABLE" },
        { key: "L159004", value: "ENDODONTIC RASPS AND FILES, REUSABLE" },
        { key: "L159005", value: "SYNDESMOTOMES, REUSABLE" },
        { key: "L159006", value: "DENTAL MATERIAL PROCESSING TOOLS, REUSABLE" },
        { key: "L15900601", value: "DENTAL MATERIAL PROCESSING MILLS, REUSABLE" },
        { key: "L15900602", value: "DENTAL MATERIAL PROCESSING SHARP INSTRUMENTS, REUSABLE" },
        { key: "L15900699", value: "DENTAL MATERIAL PROCESSING INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L159007", value: "ODONTOSTOMATOLOGY BURS, REUSABLE" },
        { key: "L159008", value: "DENTAL EQUIPMENT TIPS NOT INCLUDED IN OTHER CLASSES, REUSABLE" },
        { key: "L15900801", value: "PNEUMATIC SYSTEM TIPS FOR DENTAL USE, REUSABLE" },
        { key: "L15900899", value: "DENTAL EQUIPMENT TIPS NOT INCLUDED IN OTHER CLASSES, REUSABLE - OTHER" },
        { key: "L159009", value: "ODONTOSTOMATOLOGY SCALERS, REUSABLE" },
        { key: "L159010", value: "STOMATOLOGICAL SURGERY DILATORS, REUSABLE" },
        { key: "L159011", value: "POSITIONING INSTRUMENTS FOR DENTAL DEVICES, REUSABLE" },
        { key: "L15901101", value: "POSITIONING INSTRUMENTS FOR DENTAL MATRICES, REUSABLE" },
        { key: "L15901102", value: "DAM POSITIONING INSTRUMENTS, REUSABLE" },
        { key: "L15901199", value: "POSITIONING INSTRUMENTS FOR DENTAL DEVICES, REUSABLE - OTHER" },
        { key: "L159012", value: "ENDODONTIC SPREADERS AND PLUGGERS, REUSABLE" },
        { key: "L159013", value: "DENTAL SPATULAS, REUSABLE" },
        { key: "L159014", value: "ODONTOSTOMATOLOGY BURNISHERS, REUSABLE" },
        { key: "L159015", value: "HONEYCOMB SPOONS, REUSABLE" },
        { key: "L159016", value: "DENTAL SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L159017", value: "DENTAL RESTORATION CARVERS, REUSABLE" },
        { key: "L159018", value: "ODONTOSTOMATOLOGICAL SURGERY SCALPELS, REUSABLE" },
        { key: "L159019", value: "DENTAL FINISHING RASPS AND FILES, REUSABLE" },
        { key: "L159099", value: "ODONTOSTOMATOLOGY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L16", value: "DIAGNOSTIC INSTRUMENTS, REUSABLE" },
        { key: "L1601", value: "DIAGNOSTIC HAMMERS, REUSABLE" },
        { key: "L160101", value: "NEUROLOGICAL HAMMERS, REUSABLE" },
        { key: "L160199", value: "DIAGNOSTIC HAMMERS, REUSABLE - OTHER" },
        { key: "L1602", value: "DIAGNOSTIC USE MIRRORS, REUSABLE" },
        { key: "L160201", value: "DENTAL MIRRORS AND HANDLES, REUSABLE" },
        { key: "L160202", value: "LARYNGEAL MIRRORS AND HANDLES, REUSABLE" },
        { key: "L160299", value: "DIAGNOSTIC USE MIRRORS, REUSABLE - OTHER" },
        { key: "L1699", value: "DIAGNOSTIC INSTRUMENTS, REUSABLE- OTHER" },
        { key: "L17", value: "OPHTHALMOLOGY INSTRUMENTS, REUSABLE" },
        { key: "L1701", value: "OPHTHALMOLOGY DILATORS AND RETRACTORS, REUSABLE" },
        { key: "L170101", value: "OCULAR DILATORS, REUSABLE" },
        { key: "L17010101", value: "LACRIMAL DUCTS DILATORS, REUSABLE" },
        { key: "L17010199", value: "OCULAR DILATORS, REUSABLE - OTHER" },
        { key: "L170102", value: "OCULAR AND ENDOCULAR RETRACTORS, REUSABLE" },
        { key: "L1702", value: "OPHTHALMOLOGY FORCEPS, REUSABLE" },
        { key: "L170201", value: "OPHTHALMIC GRASPING FORCEPS, REUSABLE" },
        { key: "L170202", value: "ENDOCULAR IMPLANTS FORCEPS, REUSABLE" },
        { key: "L170203", value: "FORCEPS FOR HANDLING DEVICES FOR OPHTHALMIC USE, REUSABLE" },
        { key: "L170299", value: "OPHTHALMOLOGY FORCEPS, REUSABLE - OTHER" },
        { key: "L1703", value: "OPHTHALMOLOGY CURETTES, REUSABLE" },
        { key: "L1704", value: "OPHTHALMOLOGY SHARP INSTRUMENTS (EXCLUDING SCISSORS), REUSABLE" },
        { key: "L170401", value: "CORNEAL TREPHINES, REUSABLE" },
        { key: "L170402", value: "KERATOMES AND BLADES, REUSABLE" },
        { key: "L170499", value: "OPHTHALMOLOGY SHARP INSTRUMENTS (EXCLUDING SCISSORS), REUSABLE - OTHER" },
        { key: "L1705", value: "OPHTHALMOLOGY PROBES, REUSABLE" },
        { key: "L1706", value: "OPHTHALMOLOGY SPATULAS, REUSABLE" },
        { key: "L1707", value: "OPHTHALMOLOGY SPOONS, REUSABLE" },
        { key: "L1708", value: "OPHTHALMOLOGY ENUCLEATION INSTRUMENTS (EXCLUDING SCISSORS), REUSABLE" },
        { key: "L1709", value: "OCULAR IMPLANT INSTRUMENTS NOT INCLUDED IN OTHER CLASSES, REUSABLE" },
        { key: "L1710", value: "EYE SURGERY HANDPIECES, REUSABLE" },
        { key: "L1711", value: "OPHTHALMOLOGY HOOKS, REUSABLE" },
        { key: "L1712", value: "SCLEROTOMES, REUSABLE" },
        { key: "L1713", value: "OCULAR IRRIGATION OR SUCTION CANNULAS, REUSABLE" },
        { key: "L1714", value: "TRABECULOTOMES, REUSABLE" },
        { key: "L1715", value: "SCLERAL MARKERS, REUSABLE" },
        { key: "L1790", value: "OPHTHALMOLOGY INSTRUMENTS, REUSABLE - VARIOUS" },
        { key: "L179001", value: "OPHTHALMOLOGY SURGICAL GAUGES, REUSABLE" },
        { key: "L179002", value: "INTRAOPERATIVE KERATOMETERS, REUSABLE" },
        { key: "L179003", value: "OCULAR ADNEXA INSTRUMENTS NOT INCLUDED IN OTHER CLASSES, REUSABLE" },
        { key: "L17900301", value: "POSITIONERS AND MODELERS OF LACRIMAL TUBES, REUSABLE" },
        { key: "L17900399", value: "OCULAR ADNEXA INSTRUMENTS NOT INCLUDED IN OTHER CLASSES, REUSABLE - OTHER" },
        { key: "L179004", value: "OCULAR IRRIGATION OR SUCTION HANDPIECES, REUSABLE" },
        { key: "L179005", value: "OPHTHALMIC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1799", value: "OPHTHALMOLOGY INSTRUMENTS, REUSABLE- OTHER" },
        { key: "L18", value: "ELECTROSURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1801", value: "ELECTROSURGERY DISSECTORS, REUSABLE" },
        { key: "L180101", value: "OPEN ELECTROSURGERY DISSECTORS, REUSABLE" },
        { key: "L180102", value: "ENDOSCOPIC ELECTROSURGERY DISSECTORS, REUSABLE" },
        { key: "L1802", value: "ELECTROSURGERY SCISSORS, REUSABLE" },
        { key: "L180201", value: "OPEN ELECTROSURGERY SCISSORS, REUSABLE" },
        { key: "L180202", value: "ENDOSCOPIC ELECTROSURGERY SCISSORS, REUSABLE" },
        { key: "L1803", value: "ELECTROSURGERY HANDPIECES, REUSABLE" },
        { key: "L180301", value: "OPEN ELECTROSURGERY HANDPIECES, REUSABLE" },
        { key: "L180302", value: "ENDOSCOPIC ELECTROSURGERY HANDPIECES, REUSABLE" },
        { key: "L1804", value: "ELECTROSURGERY FORCEPS, REUSABLE" },
        { key: "L180401", value: "OPEN ELECTROSURGERY FORCEPS, REUSABLE" },
        { key: "L180402", value: "ENDOSCOPIC ELECTROSURGERY FORCEPS, REUSABLE" },
        { key: "L1805", value: "ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, REUSABLE" },
        { key: "L180501", value: "OPEN ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, REUSABLE" },
        { key: "L180502", value: "ENDOSCOPIC ELECTROSURGERY MULTIFUNCTIONAL CANNULAS, REUSABLE" },
        { key: "L1806", value: "ELECTROSURGERY ELECTRODES, REUSABLE" },
        { key: "L180601", value: "OPEN ELECTROSURGERY ELECTRODES, REUSABLE" },
        { key: "L180602", value: "ENDOSCOPIC ELECTROSURGERY ELECTRODES, REUSABLE" },
        { key: "L1807", value: "ELECTROSURGERY PROBES, REUSABLE" },
        { key: "L180701", value: "OPEN ELECTROSURGERY PROBES, REUSABLE" },
        { key: "L180702", value: "ENDOSCOPIC ELECTROSURGERY PROBES, REUSABLE" },
        { key: "L1808", value: "ELECTROSURGERY MANIPULATORS, REUSABLE" },
        { key: "L180801", value: "OPEN ELECTROSURGERY MANIPULATORS, REUSABLE" },
        { key: "L180802", value: "ENDOSCOPIC ELECTROSURGERY MANIPULATORS, REUSABLE" },
        { key: "L1809", value: "ELECTROSURGERY NEEDLES, REUSABLE" },
        { key: "L180901", value: "OPEN ELECTROSURGERY NEEDLES, REUSABLE" },
        { key: "L180902", value: "ENDOSCOPIC ELECTROSURGERY NEEDLES, REUSABLE" },
        { key: "L1810", value: "ELECTROSURGERY PADS (NEUTRAL ELECTRODES) AND CABLES, REUSABLE" },
        { key: "L181001", value: "ELECTROSURGERY SINGLE PATIENT PADS (NEUTRAL ELECTRODES), REUSABLE" },
        { key: "L181002", value: "ELECTROSURGERY DUAL PATIENT PADS (NEUTRAL ELECTRODES), REUSABLE" },
        { key: "L181003", value: "ELECTROSURGERY CONNECTION CABLES, REUSABLE" },
        { key: "L1890", value: "ELECTROSURGERY INSTRUMENTS, REUSABLE - VARIOUS" },
        { key: "L189001", value: "ELECTROSURGICAL DENERVATION PROBES, REUSABLE" },
        { key: "L189002", value: "ELECTROSURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1899", value: "ELECTROSURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L19", value: "ARTHROSCOPIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L1901", value: "ARTHROSCOPIC SURGERY DISSECTORS, REUSABLE" },
        { key: "L1902", value: "ARTHROSCOPIC SURGERY SCISSORS, REUSABLE" },
        { key: "L1903", value: "ARTHROSCOPIC SURGERY MANIPULATORS, REUSABLE" },
        { key: "L1904", value: "ARTHROSCOPIC SURGERY FORCEPS AND PUNCHES, REUSABLE" },
        { key: "L1905", value: "ARTHROSCOPIC SURGERY NEEDLE HOLDERS, REUSABLE" },
        { key: "L1906", value: "ARTHROSCOPIC SURGERY SPREADERS AND RETRACTORS, REUSABLE" },
        { key: "L1907", value: "ARTHROSCOPIC SURGERY CANNULAS, REUSABLE" },
        { key: "L1908", value: "ARTHROSCOPIC SURGERY INSTRUMENT KITS, REUSABLE" },
        { key: "L1909", value: "ARTHROSCOPIC SURGERY SCALPELS, MENISCOTOMES AND KNIVES REUSABLE" },
        { key: "L1910", value: "ARTHROSCOPIC SURGERY HOOKS, REUSABLE" },
        { key: "L1911", value: "ARTHROSCOPIC SURGERY SPATULAS, REUSABLE" },
        { key: "L1912", value: "ARTHROSCOPIC SURGERY GUIDES, REUSABLE" },
        { key: "L1913", value: "ARTHROSCOPIC SURGERY HANDPIECES, REUSABLE" },
        { key: "L1914", value: "ARTHROSCOPIC SURGERY DILATORS, REUSABLE" },
        { key: "L1915", value: "ARTHROSCOPIC SURGERY NEEDLES, REUSABLE" },
        { key: "L1916", value: "ARTHROSCOPIC SURGERY PALPATORS, REUSABLE" },
        { key: "L1917", value: "ARTHROSCOPY ADAPTERS AND CONNECTORS, REUSABLE" },
        { key: "L1918", value: "MICROFRACTORS FOR BONE STIMULATION, REUSABLE" },
        { key: "L1919", value: "ARTHROSCOPIC SURGERY SPOONS AND CURETTES, REUSABLE" },
        { key: "L1920", value: "ARTHROSCOPIC SURGERY FILES AND RASPS, REUSABLE" },
        { key: "L1921", value: "ARTHROSCOPIC SURGERY PROBES, REUSABLE" },
        { key: "L1980", value: "ARTHROSCOPIC SURGERY INSTRUMENTS, REUSABLE - ACCESSORIES" },
        { key: "L1999", value: "ARTHROSCOPIC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L20", value: "THYROID SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L2001", value: "THYROID RETRACTORS, REUSABLE" },
        { key: "L2099", value: "THYROID SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L21", value: "CLIP REMOVAL SURGICAL FORCEPS, REUSABLE" },
        { key: "L22", value: "IMPLANTABLE TISSUES HANDLING GRASPING FORCEPS, REUSABLE" },
        { key: "L23", value: "SURGICAL TUNNELIZATION FORCEPS, REUSABLE" },
        { key: "L24", value: "DERMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L2401", value: "DERMATOLOGICAL SURGERY CURETTES, REUSABLE" },
        { key: "L2402", value: "DERMATOLOGICAL SURGERY TREPHINES AND PUNCHES, REUSABLE" },
        { key: "L2403", value: "DERMATOLOGICAL SURGERY SCALPELS AND KNIVES, REUSABLE" },
        { key: "L2499", value: "DERMATOLOGICAL SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L25", value: "PLASTIC SURGERY INSTRUMENTS, REUSABLE" },
        { key: "L2501", value: "PLASTIC SURGERY OSTEOTOMES, REUSABLE" },
        { key: "L2502", value: "PLASTIC SURGERY RASPS AND FILES, REUSABLE" },
        { key: "L2503", value: "LIPOSUCTION INSTRUMENTS, REUSABLE" },
        { key: "L250301", value: "LIPOSUCTION CANNULAS, REUSABLE" },
        { key: "L250399", value: "LIPOSUCTION INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L2599", value: "PLASTIC SURGERY INSTRUMENTS, REUSABLE - OTHER" },
        { key: "L26", value: "SURGICAL SCREWDRIVERS, REUSABLE" },
        { key: "L80", value: "SURGICAL INSTRUMENTS, REUSABLE - VARIOUS ACCESSORIES" },
        { key: "L99", value: "SURGICAL INSTRUMENTS, REUSABLE - OTHER" },
        { key: "M", value: "DEVICES FOR GENERAL AND SPECIALIST DRESSINGS" },
        { key: "M01", value: "COTTON AND SYNTHETIC WADDING" },
        { key: "M0101", value: "COTTON WADDING " },
        { key: "M010101", value: "HYDROPHILIC COTTON" },
        { key: "M010102", value: "PURE COTTON" },
        { key: "M010103", value: "COTTON PAD" },
        { key: "M010199", value: "COTTON WADDING - OTHER" },
        { key: "M0102", value: "ORTHOPAEDIC WADDING" },
        { key: "M010201", value: "ORTHOPAEDICS COTTON WADDING" },
        { key: "M010202", value: "SYNTHETIC WOOL WADDING" },
        { key: "M01020201", value: "SYNTHETIC WOOL WADDING RUBBERISED" },
        { key: "M01020202", value: "SYNTHETIC WOOL WADDING NON-RUBBERISED" },
        { key: "M010203", value: "PADDING FELT" },
        { key: "M010299", value: "ORTHOPAEDIC WADDING - OTHER" },
        { key: "M0199", value: "WOOL AND SYNTHETIC COTTON - OTHER" },
        { key: "M02", value: "GAUZES" },
        { key: "M0201", value: "COTTON GAUZES" },
        { key: "M020101", value: "COTTON GAUZES, CUT" },
        { key: "M02010101", value: "COTTON GAUZES, CUT, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0201010101", value: "COTTON GAUZE, CUT, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201010102", value: "COTTON GAUZES, CUT, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02010102", value: "COTTON GAUZES, CUT, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0201010201", value: "COTTON GAUZES, CUT, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201010202", value: "COTTON GAUZES, CUT, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020102", value: "COTTON GAUZES, FOLDED" },
        { key: "M02010201", value: "COTTON GAUZES, FOLDED, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0201020101", value: "COTTON GAUZES, FOLDED, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201020102", value: "COTTON GAUZES, FOLDED, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02010202", value: "COTTON GAUZES, FOLDED, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0201020201", value: "COTTON GAUZES, FOLDED, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201020202", value: "COTTON GAUZES, FOLDED, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020103", value: "LAPAROTOMY COTTON GAUZES" },
        { key: "M02010301", value: "LAPAROTOMY COTTON GAUZES, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0201030101", value: "LAPAROTOMY COTTON GAUZES, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201030102", value: "LAPAROTOMY COTTON GAUZES, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02010302", value: "LAPAROTOMY COTTON GAUZES, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0201030201", value: "LAPAROTOMY COTTON GAUZES, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201030202", value: "LAPAROTOMY COTTON GAUZES, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020104", value: "STARCHED COTTON GAUZES" },
        { key: "M020105", value: "COTTON GAUZE PADS" },
        { key: "M02010501", value: "COTTON GAUZE PADS, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0201050101", value: "COTTON GAUZE PADS, WITHOUT X-RAY DETECTABLE THREAD, STERILE " },
        { key: "M0201050102", value: "COTTON GAUZE PADS, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02010502", value: "COTTON GAUZE PADS, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0201050201", value: "COTTON GAUZE PADS, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0201050202", value: "COTTON GAUZE PADS, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020106", value: "COTTON GAUZES IN PIECES" },
        { key: "M020107", value: "COTTON GAUZES IN ROLLS" },
        { key: "M020199", value: "COTTON GAUZES - OTHER" },
        { key: "M0202", value: "NON-WOVEN GAUZES" },
        { key: "M020201", value: "NON-WOVEN FOLDED GAUZES" },
        { key: "M02020101", value: "NON-WOVEN FOLDED GAUZES, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0202010101", value: "NON-WOVEN FOLDED GAUZES, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202010102", value: "NON-WOVEN FOLDED GAUZES, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02020102", value: "NON-WOVEN FOLDED GAUZES, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0202010201", value: "NON-WOVEN FOLDED GAUZES, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202010202", value: "NON-WOVEN FOLDED GAUZES, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020202", value: "NON-WOVEN LAPAROTOMY GAUZES" },
        { key: "M02020201", value: "NON-WOVEN LAPAROTOMY GAUZES, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0202020101", value: "NON-WOVEN LAPAROTOMY GAUZES, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202020102", value: "NON-WOVEN LAPAROTOMY GAUZES, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02020202", value: "NON-WOVEN LAPAROTOMY GAUZES, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0202020201", value: "NON-WOVEN LAPAROTOMY GAUZES, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202020202", value: "NON-WOVEN LAPAROTOMY GAUZES, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020203", value: "NON-WOVEN GAUZE PADS" },
        { key: "M02020301", value: "NON-WOVEN GAUZE PADS, WITHOUT X-RAY DETECTABLE THREAD" },
        { key: "M0202030101", value: "NON-WOVEN GAUZE PADS, WITHOUT X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202030102", value: "NON-WOVEN GAUZE PADS, WITHOUT X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M02020302", value: "NON-WOVEN GAUZE PADS, WITH X-RAY DETECTABLE THREAD" },
        { key: "M0202030201", value: "NON-WOVEN GAUZE PADS, WITH X-RAY DETECTABLE THREAD, STERILE" },
        { key: "M0202030202", value: "NON-WOVEN GAUZE PADS, WITH X-RAY DETECTABLE THREAD, NON-STERILE" },
        { key: "M020204", value: "NON-WOVEN GAUZES IN PIECES" },
        { key: "M020205", value: "NON-WOVEN GAUZES IN ROLLS" },
        { key: "M020299", value: "NON-WOVEN GAUZES - OTHER" },
        { key: "M0203", value: "MEDICATED GAUZES" },
        { key: "M020301", value: "IODOFORM GAUZES" },
        { key: "M020302", value: "IMPREGNATED GAUZES" },
        { key: "M02030201", value: "GAUZE IMPREGNATED WITHOUT ANTISEPTIC" },
        { key: "M02030202", value: "GAUZE IMPREGNATED WITH ANTISEPTIC" },
        { key: "M020399", value: "MEDICATED GAUZES - OTHER" },
        { key: "M0299", value: "GAUZES - OTHER" },
        { key: "M03", value: "BANDAGES" },
        { key: "M0301", value: "HYDROPHILIC AND NON-WOVEN GAUZE BANDAGES" },
        { key: "M030101", value: "HYDROPHILIC GAUZE BANDAGES" },
        { key: "M030102", value: "NON-WOVEN BANDAGES" },
        { key: "M0302", value: "MEDICATED BANDAGES" },
        { key: "M030201", value: "IODOFORM MEDICATED BANDAGES" },
        { key: "M030202", value: "MEDICATED BANDAGES, WITH ZINC OXIDE AND OTHER COMPONENTS" },
        { key: "M03020201", value: "MEDICATED BANDAGES, WITH ZINC OXIDE" },
        { key: "M03020202", value: "MEDICATED BANDAGES, WITH ZINC OXIDE AND AMMONIUM BITUMINOSULFONATE" },
        { key: "M03020299", value: "MEDICATED BANDAGES, WITH ZINC OXIDE AND OTHER COMPONENTS - OTHER" },
        { key: "M030299", value: "MEDICATED BANDAGES - OTHER" },
        { key: "M0303", value: "ELASTIC FIXING OR PROTECTION BANDAGES" },
        { key: "M030301", value: "ELASTIC FIXING BANDAGES" },
        { key: "M03030101", value: "ELASTIC FIXING BANDAGES, NON-ADHESIVE" },
        { key: "M0303010101", value: "ELASTIC FIXING BANDAGES, NON-ADHESIVE, EXTENSIBLE IN ONE DIRECTION" },
        { key: "M0303010103", value: "ELASTIC FIXING BANDAGES, NON-ADHESIVE, EXTENSIBLE IN TWO DIRECTIONS" },
        { key: "M03030102", value: "ELASTIC FIXING BANDAGES, SELF-ADHESIVE" },
        { key: "M0303010201", value: "ELASTIC FIXING BANDAGES, SELF-ADHESIVE, EXTENSIBLE IN ONE DIRECTION" },
        { key: "M0303010203", value: "ELASTIC FIXING BANDAGES, SELF-ADHESIVE, EXTENSIBLE IN TWO DIRECTIONS" },
        { key: "M03030103", value: "TUBULAR NET BANDAGES" },
        { key: "M03030199", value: "ELASTIC FIXING BANDAGES - OTHER" },
        { key: "M030302", value: "PROTECTION SYSTEMS" },
        { key: "M03030201", value: "TUBULAR MESH" },
        { key: "M03030202", value: "SKIN PROTECTIVE BANDAGES" },
        { key: "M03030203", value: "FOAM PADS" },
        { key: "M03030299", value: "PROTECTION SYSTEMS - OTHER" },
        { key: "M0304", value: "ELASTIC BANDAGES, SUPPORT AND COMPRESSION" },
        { key: "M030401", value: "ELASTIC COMPRESSION BANDAGES" },
        { key: "M03040101", value: "ELASTIC COMPRESSION BANDAGES, NON-ADHESIVE" },
        { key: "M0304010101", value: "ELASTIC COMPRESSION BANDAGES, NON-ADHESIVE, LOW EXTENSIBILITY (<70%)" },
        { key: "M0304010102", value: "ELASTIC COMPRESSION BANDAGES, NON-ADHESIVE, MEDIUM EXTENSIBILITY (70-140%)" },
        { key: "M0304010103", value: "ELASTIC COMPRESSION BANDAGES, NON-ADHESIVE, HIGH EXTENSIBILITY (>140%)" },
        { key: "M03040102", value: "ELASTIC COMPRESSION BANDAGES, COHESIVE" },
        { key: "M0304010201", value: "ELASTIC COMPRESSION BANDAGES, COHESIVE, LOW EXTENSIBILITY (<70%)" },
        { key: "M0304010202", value: "ELASTIC COMPRESSION BANDAGES, COHESIVE, MEDIUM EXTENSIBILITY (70-140%)" },
        { key: "M0304010203", value: "ELASTIC COMPRESSION BANDAGES, COHESIVE, HIGH EXTENSIBILITY (>140%)" },
        { key: "M03040103", value: "ELASTIC COMPRESSION BANDAGES, ADHESIVE" },
        { key: "M0304010301", value: "ELASTIC COMPRESSION BANDAGES, ADHESIVE, LOW EXTENSIBILITY (<70%)" },
        { key: "M0304010302", value: "ELASTIC COMPRESSION BANDAGES, ADHESIVE, MEDIUM EXTENSIBILITY (70-140%)" },
        { key: "M0304010303", value: "ELASTIC COMPRESSION BANDAGES, ADHESIVE, HIGH EXTENSIBILITY (> 140%)" },
        { key: "M03040199", value: "ELASTIC COMPRESSION BANDAGES - OTHER" },
        { key: "M030402", value: "ELASTIC SUPPORT BANDAGES" },
        { key: "M03040201", value: "ELASTIC SUPPORT BANDAGES, NON-ADHESIVE" },
        { key: "M0304020101", value: "ELASTIC SUPPORT BANDAGES, NON-ADHESIVE, HIGH EXTENSIBILITY (>140%)" },
        { key: "M030402010101", value: "ELASTIC SUPPORT BANDAGES, NON-ADHESIVE, EXTENSIBLE IN ONE DIRECTION, HIGH EXTENSIBILITY" },
        { key: "M030402010103", value: "ELASTIC SUPPORT BANDAGES, NON-ADHESIVE, EXTENSIBLE IN TWO DIRECTIONS, HIGH EXTENSIBILITY" },
        { key: "M03040202", value: "ELASTIC SUPPORT BANDAGES, COHESIVE (SELF-ADHESIVE)" },
        { key: "M0304020201", value: "ELASTIC SUPPORT BANDAGES, COHESIVE, HIGH EXTENSIBILITY (>140%)" },
        { key: "M030402020101", value: "ELASTIC SUPPORT BANDAGES, COHESIVE, EXTENSIBLE IN ONE DIRECTION, HIGH EXTENSIBILITY" },
        { key: "M030402020103", value: "ELASTIC SUPPORT BANDAGES, COHESIVE, EXTENSIBLE IN TWO DIRECTIONS, HIGH EXTENSIBILITY" },
        { key: "M03040203", value: "ELASTIC SUPPORT BANDAGES, ADHESIVE" },
        { key: "M0304020301", value: "ELASTIC SUPPORT BANDAGES, ADHESIVE, HIGH EXTENSIBILITY (>140%)" },
        { key: "M030402030102", value: "ELASTIC SUPPORT BANDAGES, ADHESIVE EXTENSIBLE IN ONE DIRECTION, HIGH EXTENSIBILITY" },
        { key: "M030402030103", value: "ELASTIC SUPPORT BANDAGES, ADHESIVE, EXTENSIBLE IN TWO DIRECTIONS, HIGH EXTENSIBILITY" },
        { key: "M03040299", value: "ELASTIC SUPPORT BANDAGES - OTHER" },
        { key: "M030403", value: "FUNCTIONAL BANDAGES WITH ANELASTIC TAPES" },
        { key: "M030404", value: "DIALYSIS FISTULA, BANDAGES" },
        { key: "M030405", value: "COMPRESSION STOCKINGS" },
        { key: "M030499", value: "ELASTIC BANDAGES, SUPPORT AND COMPRESSION - OTHER" },
        { key: "M0305", value: "IMMOBILISATION SYSTEMS AND DEVICES" },
        { key: "M030501", value: "IMMOBILISATION BANDAGES FOR SHOULDER, ARM AND COLLARBONE" },
        { key: "M030502", value: "BANDAGES AND SPLINTS" },
        { key: "M03050201", value: "NATURAL CAST BANDAGES AND SPLINTS" },
        { key: "M03050202", value: "SYNTHETIC CAST BANDAGES AND SPLINTS" },
        { key: "M03050299", value: "BANDAGES AND SPLINTS - OTHER" },
        { key: "M030503", value: "SKIN TRACTION SYSTEMS" },
        { key: "M030504", value: "IMMOBILISATION SYSTEMS, MOULDABLE UNDER COLD AND HOT TEMPRATURES" },
        { key: "M030505", value: "ZIMMER SPLINTS" },
        { key: "M030506", value: "FERULES" },
        { key: "M030599", value: "IMMOBILISATION SYSTEMS AND DEVICES - OTHER" },
        { key: "M0399", value: "BANDAGES - OTHER (see Y06 for collars, tutors, etc.)" },
        { key: "M04", value: "SPECIAL DRESSINGS" },
        { key: "M0401", value: "PREPARED DRESSINGS" },
        { key: "M040101", value: "ADHESIVE DRESSINGS, WITH ABSORBENT PAD" },
        { key: "M04010101", value: "NON-WOVEN ADHESIVE DRESSINGS, WITH ABSORBENT PAD" },
        { key: "M04010102", value: "POLYURETHANE (OR OTHER MATERIAL) ADHESIVE DRESSINGS, WITH ABSORBENT PAD" },
        { key: "M04010199", value: "ADHESIVE DRESSINGS, WITH ABSORBENT PAD - OTHER" },
        { key: "M040102", value: "FIXING DRESSINGS" },
        { key: "M04010201", value: "NON-WOVEN FIXING DRESSINGS" },
        { key: "M04010202", value: "POLYURETHANE FIXING DRESSINGS" },
        { key: "M04010203", value: "SILICONE DRESSINGS" },
        { key: "M04010299", value: "FIXING DRESSINGS - OTHER" },
        { key: "M040199", value: "PREPARED DRESSINGS - OTHER" },
        { key: "M0402", value: "NON-ADHESIVE ABSORBENT DRESSINGS" },
        { key: "M040201", value: "ABSORBENT DRESSINGS WITH CELLULOSE PAD AND NON-WOVEN WRAPS" },
        { key: "M040202", value: "ALUMINIUM NON-WOVEN ABSORBENT DRESSINGS" },
        { key: "M040203", value: "TRACHEOSTOMY DRESSINGS" },
        { key: "M040204", value: "NON-ADHERENT ABSORBENT DRESSINGS" },
        { key: "M040299", value: "NON-ADHESIVE ABSORBENT DRESSINGS - OTHER" },
        { key: "M0403", value: "OPHTHALMIC DRESSINGS" },
        { key: "M040301", value: "EYE PADS, COTTON OR NON-WOVEN MATERIALS" },
        { key: "M040302", value: "STICKS/LANCETS/STRIPS FOR OPHTHALMIC USE" },
        { key: "M040303", value: "ORTHOPTIC EYE PATCHES" },
        { key: "M040304", value: "OPHTHALMIC DRESSINGS CONTAINING COMPONENTS OF HUMAN ORIGIN" },
        { key: "M040305", value: "OPHTHALMIC DRESSINGS IN THE FORM OF EYE DROPS/GEL/CREAMS" },
        { key: "M040306", value: "OPHTHALMIC PROTECTORS" },
        { key: "M040399", value: "OPHTHALMIC DRESSINGS - OTHER" },
        { key: "M0404", value: "DRESSINGS FOR WOUNDS, SORES AND ULCERATIONS" },
        { key: "M040401", value: "SALINE DRESSINGS" },
        { key: "M04040101", value: "SALINE DRESSINGS, NON-COMBINED" },
        { key: "M04040102", value: "SALINE DRESSINGS IN COMBINATION WITH OTHER SUBSTANCES" },
        { key: "M040402", value: "ALGINATE DRESSINGS" },
        { key: "M04040201", value: "ALGINATE DRESSINGS, NON-COMBINED" },
        { key: "M04040202", value: "ALGINATE DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040403", value: "HYDROCOLLOID DRESSINGS" },
        { key: "M04040301", value: "HYDROCOLLOID DRESSINGS, NON-COMBINED" },
        { key: "M04040302", value: "HYDROCOLLOID DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040404", value: "CELLULOSE AND/OR MODIFIED CELLULOSE DRESSINGS, NON-COMBINED OR COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040405", value: "HYDROGEL DRESSINGS" },
        { key: "M04040501", value: "HYDROGEL DRESSINGS, NON-COMBINED" },
        { key: "M04040502", value: "HYDROGEL DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040406", value: "POLYURETHANE DRESSINGS" },
        { key: "M04040601", value: "POLYURETHANE DRESSINGS, NON-COMBINED" },
        { key: "M04040602", value: "POLYURETHANE DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040407", value: "SILICONE DRESSINGS" },
        { key: "M04040701", value: "SILICONE DRESSINGS, NON-COMBINED" },
        { key: "M04040702", value: "SILICONE DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040408", value: "SILVER DRESSINGS" },
        { key: "M04040801", value: "SILVER DRESSINGS, NON-COMBINED" },
        { key: "M04040802", value: "SILVER DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040409", value: "ACTIVATED CHARCOAL DRESSINGS" },
        { key: "M04040901", value: "ACTIVATED CHARCOAL DRESSINGS, NON-COMBINED" },
        { key: "M04040902", value: "ACTIVATED CHARCOAL DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040410", value: "ANIMAL-DERIVED COLLAGEN DRESSINGS" },
        { key: "M04041001", value: "ANIMAL-DERIVED COLLAGEN DRESSINGS, NON-COMBINED" },
        { key: "M04041002", value: "ANIMAL-DERIVED COLLAGEN DRESSINGS, COMBINED WITH OTHER SUBSTANCES" },
        { key: "M040411", value: "INSTRUMENT DRESSINGS" },
        { key: "M040412", value: "ANTISEPTICS-BASED DRESSINGS" },
        { key: "M040413", value: "INTERACTIVE DRESSINGS" },
        { key: "M040414", value: "MULTI-LAYER ABSORBENT DRESSINGS" },
        { key: "M040415", value: "DRESSINGS IN SOLUTIONS, EMULSIONS, GELS, POWDERS" },
        { key: "M04041501", value: "DRESSINGS IN SOLUTIONS, EMULSIONS, GELS, POWDERS WITH HERBAL COMPONENTS" },
        { key: "M04041502", value: "DRESSINGS IN SOLUTIONS, EMULSIONS, GELS, POWDERS WITH ANIMAL COMPONENTS" },
        { key: "M04041503", value: "DRESSINGS IN SOLUTIONS, EMULSIONS, GELS, POWDERS WITH SYNTHETIC COMPONENTS" },
        { key: "M040416", value: "HYDROPHOBIC DRESSINGS" },
        { key: "M040499", value: "DRESSINGS FOR WOUNDS, SORES AND ULCERATIONS - OTHER" },
        { key: "M0405", value: "HAEMOSTATIC DRESSINGS" },
        { key: "M040501", value: "POLYSACCHARIDE HAEMOSTATIC DRESSINGS" },
        { key: "M040502", value: "ANIMAL COLLAGEN HAEMOSTATIC DRESSINGS" },
        { key: "M040503", value: "GELATINE SPONGE HAEMOSTATIC DRESSINGS" },
        { key: "M040504", value: "INORGANIC HAEMOSTATIC DEVICES" },
        { key: "M040505", value: "HAEMOSTATIC DEVICES BASED ON CLOTTING FACTORS" },
        { key: "M04050501", value: "HEMOSTATIC DRESSINGS BASED ON COAGULATION FACTORS OF ANIMAL ORIGIN" },
        { key: "M04050502", value: "HEMOSTATIC DRESSINGS BASED ON COAGULATION FACTORS OF HUMAN ORIGIN" },
        { key: "M040506", value: "HEMOSTATIC WAXES" },
        { key: "M040599", value: "HAEMOSTATIC DRESSINGS - OTHER" },
        { key: "M0406", value: "DRESSINGS FOR THE PREVENTION OF POST-OPERATIVE ADHESIONS" },
        { key: "M0407", value: "SPECIAL PADS" },
        { key: "M040701", value: "NASAL PADS" },
        { key: "M040702", value: "SURGICAL PADS" },
        { key: "M040703", value: "WOUND DEBRIDEMENT PADS" },
        { key: "M040799", value: "SPECIAL PADS - OTHER" },
        { key: "M0408", value: "DRESSINGS FOR BURNS ONLY" },
        { key: "M0409", value: "DRESSINGS FOR PHOTO- AND THERMOTHERAPY IN THE FORM OF GELS AND SOLUTIONS" },
        { key: "M0410", value: "DRESSINGS FOR NAILS IN THE FORM OF LIQUIDS, GELS AND CREAMS" },
        { key: "M0411", value: "OSMOTIC DRESSINGS" },
        { key: "M0412", value: "DRESSINGS FOR THE TREATMENT OF WARTS, CORNS AND CALLUSES" },
        { key: "M0499", value: "SPECIAL DRESSINGS - OTHER" },
        { key: "M05", value: "PLASTERS" },
        { key: "M0501", value: "SURGICAL PLASTERS" },
        { key: "M050101", value: "PLASTERS ON SPOOLS (ROLLS)" },
        { key: "M050102", value: "MEDICATED PLASTERS" },
        { key: "M050199", value: "SURGICAL PLASTERS - OTHER" },
        { key: "M0502", value: "PLASTERS FOR EXTENSIVE AREAS" },
        { key: "M050201", value: "EXTENSIBLE NON-WOVEN PLASTERS" },
        { key: "M050202", value: "NON-EXTENSIBLE WOVEN PLASTERS" },
        { key: "M050299", value: "PLASTERS FOR EXTENSIVE AREAS - OTHER" },
        { key: "M0599", value: "MEDICAL PLASTERS - OTHER" },
        { key: "M90", value: "DEVICES FOR GENERAL AND SPECIALIST DRESSINGS - VARIOUS" },
        { key: "M9001", value: "CRYOTHERAPY AND THERMOTHERAPY DEVICES" },
        { key: "M9002", value: "PROTECTIVE DEVICES, LUBRICANTS AND SOOTHING DEVICES (SPRAYS, GELS, FLUIDS AND CREAMS)" },
        { key: "M9003", value: "SOLUTIONS FOR ADHESIVE TAPE REMOVAL" },
        { key: "M9099", value: "GENERAL AND SPECIALIST MEDICAL DEVICES – OTHER (SUTURE PATCHES SEE H900102)" },
        { key: "N", value: "NERVOUS AND MEDULLARY SYSTEMS DEVICES" },
        { key: "N01", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM DEVICES" },
        { key: "N0101", value: "NEUROPHYSIOLOGY DEVICES" },
        { key: "N010101", value: "ELECTROMYOGRAPHIC ELECTRODES" },
        { key: "N010102", value: "ELECTROENCEPHALOGRAPHIC ELECTRODES" },
        { key: "N01010201", value: "EEG INTRACRANIC ELECTRODES" },
        { key: "N0101020101", value: "EEG CORTICAL ELECTRODES" },
        { key: "N0101020102", value: "EEG DEPTH ELECTRODES" },
        { key: "N0101020199", value: "EEG INTRACRANIC ELECTRODES - OTHER" },
        { key: "N01010202", value: "EEG EXTRACRANIC ELECTRODES" },
        { key: "N01010203", value: "EEG HEADSETS" },
        { key: "N01010299", value: "EEG ELECTRODES - OTHER" },
        { key: "N010103", value: "BIPOLAR NERVOUS ELECTROSTIMULATORS, BATTERY-POWERED" },
        { key: "N010180", value: "NEUROPHYSIOLOGY DEVICES - ACCESSORIES" },
        { key: "N010199", value: "NEUROPHYSIOLOGY DEVICES - OTHER" },
        { key: "N0102", value: "NEUROLOGIC PHYSIOTHERAPHY DEVICES" },
        { key: "N010201", value: "TENS SYSTEM ELECTRODES" },
        { key: "N010202", value: "STIMULATION POINT LOCATORS" },
        { key: "N010280", value: "NEUROLOGICAL PHYSIOTHERAPY DEVICES - ACCESSORIES" },
        { key: "N01028001", value: "SPONGES FOR THE APPLICATION OF CUTANEOUS NEUROLOGICAL ELECTRODES" },
        { key: "N01028002", value: "NEUROLOGICAL PHYSIOTHERAPY CONNECTORS" },
        { key: "N01028003", value: "NEUROLOGICAL ELECTRODES BANDS" },
        { key: "N01028099", value: "NEUROLOGICAL PHYSIOTHERAPY DEVICES - ACCESSORIES - OTHER" },
        { key: "N010299", value: "NEUROLOGIC PHYSIOTHERAPHY DEVICES - OTHER" },
        { key: "N0103", value: "CRANIAL DRAINAGE DEVICES AND KITS" },
        { key: "N010301", value: "VENTRICULAR-PERITONEAL SHUNTS" },
        { key: "N010302", value: "VENTRICULAR-ATRIAL SHUNTS" },
        { key: "N010303", value: "CEREBRAL FLUID EXTERNAL DRAINS AND KITS" },
        { key: "N010380", value: "INTRACRANIAL DRAINAGE DEVICES AND KITS - ACCESSORIES" },
        { key: "N01038001", value: "INTRACRANIAL DRAINAGE DEVICES ADAPTERS AND CONNECTORS, SINGLE-USE" },
        { key: "N01038002", value: "INTRACRANIAL DRAINAGE DEVICE VALVES" },
        { key: "N01038099", value: "INTRACRANIAL DRAINAGE DEVICES AND KITS - ACCESSORIES - OTHER" },
        { key: "N010399", value: "INTRACRANIAL DRAINAGE DEVICES AND KITS - OTHER" },
        { key: "N0104", value: "PERIPHERAL NERVOUS SYSTEM CATHETERS" },
        { key: "N010401", value: "PERIPHERAL NERVOUS SYSTEM CATHETERS AND KITS" },
        { key: "N010480", value: "PERIPHERAL NERVOUS SYSTEM CATHETERS - ACCESSORIES" },
        { key: "N010499", value: "PERIPHERAL NERVOUS SYSTEM CATHETERS - OTHER" },
        { key: "N0180", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM DEVICES - ACCESSORIES" },
        { key: "N018001", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL INSTRUMENTS, SINGLE-USE" },
        { key: "N01800101", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL FORCEPS, SINGLE-USE" },
        { key: "N01800102", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL SCISSORS, SINGLE-USE" },
        { key: "N01800103", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM NEEDLE HOLDERS, SINGLE-USE" },
        { key: "N01800104", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SPREADERS AND RETRACTORS, SINGLE-USE" },
        { key: "N01800105", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL BLADES, SINGLE-USE" },
        { key: "N01800106", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL INSTRUMENT KITS, SINGLE-USE" },
        { key: "N01800199", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM SURGICAL INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "N018099", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM DEVICES - ACCESSORIES - OTHER" },
        { key: "N0199", value: "ENCEPHALIC AND PERIPHERAL NERVOUS SYSTEM DEVICES - OTHER" },
        { key: "N02", value: "SPINAL MEDULLAR SYSTEM DEVICES" },
        { key: "N0201", value: "SPINAL CATHETERS AND KITS" },
        { key: "N020101", value: "PERIDURAL / EPIDURAL SPINAL CATHETERS AND KITS" },
        { key: "N02010101", value: "EPIDUROSCOPY AND EPIDUROPLASTICS CATHETERS AND KITS" },
        { key: "N02010102", value: "PERIDURAL / EPIDURAL CATHETERS FOR CONTINUOUS ANALGESIA AND KITS" },
        { key: "N02010180", value: "PERIDURAL / EPIDURAL SPINAL CATHETERS AND KITS - ACCESSORIES" },
        { key: "N02010199", value: "PERIDURAL / EPIDURAL SPINAL CATHETERS AND KITS - OTHER" },
        { key: "N020102", value: "SUBARACHNOID SPINAL CATHETERS AND KITS" },
        { key: "N020180", value: "SPINAL CATHETERS AND KITS - ACCESSORIES" },
        { key: "N020199", value: "SPINAL CATHETERS AND KITS - OTHER" },
        { key: "N0202", value: "SPINAL ACCESS SYSTEMS FOR INFUSION THERAPY   " },
        { key: "N020201", value: "PERIDURAL / EPIDURAL ACCESS SYSTEMS FOR INFUSION THERAPY" },
        { key: "N020202", value: "SUBARACHNOID ACCESS SYSTEMS FOR INFUSION THERAPY" },
        { key: "N020280", value: "SPINAL ACCESS SYSTEMS FOR INFUSION THERAPY - ACCESSORIES" },
        { key: "N020299", value: "SPINAL ACCESS SYSTEMS FOR INFUSION THERAPY - OTHER" },
        { key: "N0203", value: "SPINAL LUMBAR DRAINAGE DEVICES AND KITS" },
        { key: "N020301", value: "LUMBO-PERITONEAL SHUNTS" },
        { key: "N020302", value: "EXTERNAL SPINAL FLUID DRAINS AND KITS" },
        { key: "N020380", value: "SPINAL LUMBAR DRAINAGE DEVICES AND KITS - ACCESSORIES" },
        { key: "N020399", value: "SPINAL LUMBAR DRAINAGE DEVICES AND KITS - OTHER" },
        { key: "N0280", value: "SPINAL MEDULLARY SYSTEM DEVICES - ACCESSORIES" },
        { key: "N028001", value: "FILTERS FOR CONTINUOUS SPINAL ANALGESIA" },
        { key: "N028002", value: "SPINAL MEDULLARY SYSTEM SURGICAL INSTRUMENTS, SINGLE-USE" },
        { key: "N02800201", value: "SPINAL MEDULLARY SYSTEM SURGICAL FORCEPS, SINGLE-USE" },
        { key: "N02800202", value: "SPINAL MEDULLARY SYSTEM SURGICAL SCISSORS, SINGLE-USE" },
        { key: "N02800203", value: "SPINAL MEDULLARY SYSTEM NEEDLE HOLDERS, SINGLE-USE" },
        { key: "N02800204", value: "SPINAL MEDULLARY SYSTEM SPREADERS AND RETRACTORS, SINGLE-USE" },
        { key: "N02800205", value: "SPINAL MEDULLAR SYSTEM SURGICAL BLADES, SINGLE-USE" },
        { key: "N02800206", value: "DILATORS FOR POSITIONING OF SPINAL DEVICES, SINGLE-USE" },
        { key: "N02800207", value: "SPINAL DEVICES INTRODUCERS, SINGLE-USE" },
        { key: "N02800208", value: "SPINAL DEVICES TUNNELISERS, SINGLE-USE" },
        { key: "N02800209", value: "SPINAL MEDULLARY SYSTEM SURGICAL INSTRUMENT KITS, SINGLE-USE" },
        { key: "N02800299", value: "SPINAL MEDULLARY SYSTEM SURGICAL INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "N028099", value: "SPINAL MEDULLARY SYSTEM DEVICES - ACCESSORIES - OTHER" },
        { key: "N0299", value: "SPINAL MEDULLARY SYSTEM DEVICES - OTHER" },
        { key: "N99", value: "NERVOUS AND MEDULLARY SYSTEM DEVICES - OTHER" },
        { key: "P", value: "IMPLANTABLE PROSTHETIC AND OSTEOSYNTHESIS DEVICES" },
        { key: "P01", value: "PROSTHESES, FACIAL, ODONTOLOGICAL, AND CRANIAL" },
        { key: "P0101", value: "FACIAL PROSTHESES" },
        { key: "P010101", value: "CHIN PROSTHESES" },
        { key: "P010102", value: "ZYGOMATIC PROSTHESES" },
        { key: "P010103", value: "MANDIBULAR PROSTHESES" },
        { key: "P010104", value: "PROSTHESES, ORBITAL CAVITY" },
        { key: "P01010401", value: "PROSTHESES, ORBITAL CAVITY - PARTIAL" },
        { key: "P01010402", value: "PROSTHESES, ORBITAL CAVITY - TOTAL" },
        { key: "P010199", value: "FACIAL PROSTHESES - OTHER" },
        { key: "P0102", value: "ODONTOLOGICAL PROSTHESES" },
        { key: "P010201", value: "DENTAL IMPLANTS AND ACCESSORIES" },
        { key: "P01020101", value: "DENTAL IMPLANTS" },
        { key: "P01020180", value: "DENTAL IMPLANTS - ACCESSORIES" },
        { key: "P010299", value: "ODONTOLOGICAL PROSTHESES - OTHER" },
        { key: "P0103", value: "PROSTHESES, CRANIAL" },
        { key: "P0180", value: "FACIAL AND ODONTOLOGICAL PROSTHESES - ACCESSORIES" },
        { key: "P0199", value: "PROSTHESES, FACIAL, ODONTOLOGICAL, AND CRANIAL - OTHERS" },
        { key: "P02", value: "ENT PROSTHESES" },
        { key: "P0201", value: "OTOLOGIC PROSTHESES" },
        { key: "P020101", value: "MIDDLE EAR IMPLANTS" },
        { key: "P02010101", value: "OSSICULAR PROSTHESES (PORP AND TORP)" },
        { key: "P02010102", value: "STAPEDIOPLASTIC PROSTHESES" },
        { key: "P02010103", value: "EUSTACHIAN TUBE PROSTHESIS" },
        { key: "P02010199", value: "MIDDLE EAR IMPLANTS - OTHER" },
        { key: "P020102", value: "EXTERNAL-MIDDLE EAR IMPLANTS" },
        { key: "P02010201", value: "TRANSTYMPANIC DRAINAGE PROSTHESES (VENTILATION TUBES)" },
        { key: "P02010202", value: "TYMPANIC PROSTHESES" },
        { key: "P02010299", value: "EXTERNAL-MIDDLE EAR IMPLANTS- OTHER" },
        { key: "P020103", value: "EXTERNAL EAR PROSTHESES" },
        { key: "P020180", value: "OTOLOGIC PROSTHESES - ACCESSORIES" },
        { key: "P020199", value: "OTOLOGIC PROSTHESES - OTHER" },
        { key: "P0202", value: "RHINOLOGY PROSTHESES" },
        { key: "P020201", value: "NASAL SEPTAL PLUGGERS" },
        { key: "P020202", value: "NASAL SINUS STENTS" },
        { key: "P020203", value: "NASAL SPLINTS" },
        { key: "P020299", value: "RHINOLOGY PROSTHESES - OTHER" },
        { key: "P0203", value: "PHARYNGO-OESOPHAGEAL PROSTHESES" },
        { key: "P020301", value: "PHARYNX PROSTHESES" },
        { key: "P020399", value: "PHARYNGO-OOESOPHAGEAL PROSTHESES - OTHER" },
        { key: "P0204", value: "LARYNX PROSTHESES" },
        { key: "P0205", value: "PHONATION PROSTHESES" },
        { key: "P0280", value: "ENT PROSTHESES- ACCESSORIES" },
        { key: "P0299", value: "ENT PROSTHESES - OTHER" },
        { key: "P03", value: "OCULAR PROSTHESES" },
        { key: "P0301", value: "INTRAOCULAR LENSES (IOL)" },
        { key: "P030101", value: "IOLs, PHAKIC" },
        { key: "P03010103", value: "IOLs, PHAKIC, MONOFOCAL" },
        { key: "P0301010301", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL" },
        { key: "P030101030101", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL, HYDROPHOBIC ACRYLIC" },
        { key: "P030101030102", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL, HYDROPHILIC ACRYLIC" },
        { key: "P030101030103", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL, SILICONE" },
        { key: "P030101030104", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL, PMMA" },
        { key: "P030101030199", value: "IOLs, PHAKIC, MONOFOCAL, SPHERICAL - OTHER" },
        { key: "P0301010302", value: "IOLs, PHAKIC, MONOFOCAL, ASPHERIC" },
        { key: "P030101030201", value: "IOLs, PHAKIC, MONOFOCAL, ASPHERIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030101030202", value: "IOLs, PHAKIC, MONOFOCAL, ASPHERIC, HYDROPHILIC ACRYLIC" },
        { key: "P030101030203", value: "IOLs, PHAKIC, MONOFOCAL, ASPHERIC, SILICONE" },
        { key: "P030101030299", value: "IOLs, PHAKIC, MONOFOCAL, ASPHERIC - OTHER" },
        { key: "P0301010303", value: "IOLs, PHAKIC, MONOFOCAL, TORIC" },
        { key: "P030101030301", value: "IOLs, PHAKIC, MONOFOCAL, TORIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030101030302", value: "IOLs, PHAKIC, MONOFOCAL, TORIC, HYDROPHILIC ACRYLIC" },
        { key: "P030101030303", value: "IOLs, PHAKIC, MONOFOCAL, TORIC, SILICONE" },
        { key: "P030101030399", value: "IOLs, PHAKIC, MONOFOCAL, TORIC - OTHER" },
        { key: "P03010104", value: "IOLs, PHAKIC, MULTIFOCAL" },
        { key: "P0301010401", value: "IOLs, PHAKIC, MULTIFOCAL, SPHERICAL" },
        { key: "P030101040101", value: "IOLs, PHAKIC, MULTIFOCAL, SPHERICAL, HYDROPHOBIC ACRYLIC" },
        { key: "P030101040102", value: "IOLs, PHAKIC, MULTIFOCAL, SPHERICAL, HYDROPHILIC ACRYLIC" },
        { key: "P030101040103", value: "IOLs, PHAKIC, MULTIFOCAL, SPHERICAL, SILICONE" },
        { key: "P030101040199", value: "IOLs, PHAKIC, MULTIFOCAL, SPHERICAL - OTHER" },
        { key: "P0301010402", value: "IOLs, PHAKIC, MULTIFOCAL, ASPHERIC" },
        { key: "P030101040201", value: "IOLs, PHAKIC, MULTIFOCAL, ASPHERIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030101040202", value: "IOLs, PHAKIC, MULTIFOCAL, ASPHERIC, HYDROPHILIC ACRYLIC" },
        { key: "P030101040203", value: "IOLs, PHAKIC, MULTIFOCAL, ASPHERIC, SILICONE" },
        { key: "P030101040299", value: "IOLs, PHAKIC, MULTIFOCAL, ASPHERIC - OTHER" },
        { key: "P0301010403", value: "IOLs, PHAKIC, MULTIFOCAL, TORIC" },
        { key: "P030101040301", value: "IOLs, PHAKIC, MULTIFOCAL, TORIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030101040302", value: "IOLs, PHAKIC, MULTIFOCAL, TORIC, HYDROPHILIC ACRYLIC" },
        { key: "P030101040303", value: "IOLs, PHAKIC, MULTIFOCAL, TORIC, SILICONE" },
        { key: "P030101040399", value: "IOLs, PHAKIC, MULTIFOCAL, TORIC - OTHER" },
        { key: "P030102", value: "IOLs, APHAKIC" },
        { key: "P03010209", value: "IOLs, APHAKIC, MONOFOCAL" },
        { key: "P0301020901", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL" },
        { key: "P030102090101", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL, HYDROPHOBIC ACRYLIC" },
        { key: "P030102090102", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL, HYDROPHILIC ACRYLIC" },
        { key: "P030102090103", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL, SILICONE" },
        { key: "P030102090104", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL, PMMA" },
        { key: "P030102090199", value: "IOLs, APHAKIC, MONOFOCAL, SPHERICAL - OTHER" },
        { key: "P0301020902", value: "IOLs, APHAKIC, MONOFOCAL, ASPHERIC" },
        { key: "P030102090201", value: "IOLs, APHAKIC, MONOFOCAL, ASPHERIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102090202", value: "IOLs, APHAKIC, MONOFOCAL, ASPHERIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102090203", value: "IOLs, APHAKIC, MONOFOCAL, ASPHERIC, SILICONE" },
        { key: "P030102090299", value: "IOLs, APHAKIC, MONOFOCAL, ASPHERIC - OTHER" },
        { key: "P0301020903", value: "IOLs, APHAKIC, MONOFOCAL, TORIC" },
        { key: "P030102090301", value: "IOLs, APHAKIC, MONOFOCAL, TORIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102090302", value: "IOLs, APHAKIC, MONOFOCAL, TORIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102090303", value: "IOLs, APHAKIC, MONOFOCAL, TORIC, SILICONE" },
        { key: "P030102090399", value: "IOLs, APHAKIC, MONOFOCAL, TORIC - OTHER" },
        { key: "P03010210", value: "IOLs, APHAKIC, MULTIFOCAL" },
        { key: "P0301021001", value: "IOLs, APHAKIC, MULTIFOCAL, SPHERICAL" },
        { key: "P030102100101", value: "IOLs, APHAKIC, MULTIFOCAL, SPHERICAL, HYDROPHOBIC ACRYLIC" },
        { key: "P030102100102", value: "IOLs, APHAKIC, MULTIFOCAL, SPHERICAL, HYDROPHILIC ACRYLIC" },
        { key: "P030102100103", value: "IOLs, APHAKIC, MULTIFOCAL, SPHERICAL, SILICONE" },
        { key: "P030102100199", value: "IOLs, APHAKIC, MULTIFOCAL, SPHERICAL - OTHER" },
        { key: "P0301021002", value: "IOLs, APHAKIC, MULTIFOCAL, ASPHERIC" },
        { key: "P030102100201", value: "IOLs, APHAKIC, MULTIFOCAL, ASPHERIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102100202", value: "IOLs, APHAKIC, MULTIFOCAL, ASPHERIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102100203", value: "IOLs, APHAKIC, MULTIFOCAL, ASPHERIC, SILICONE" },
        { key: "P030102100299", value: "IOLs, APHAKIC, MULTIFOCAL, ASPHERIC - OTHER" },
        { key: "P0301021003", value: "IOLs, APHAKIC, MULTIFOCAL, TORIC" },
        { key: "P030102100301", value: "IOLs, APHAKIC, MULTIFOCAL, TORIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102100302", value: "IOLs, APHAKIC, MULTIFOCAL, TORIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102100303", value: "IOLs, APHAKIC, MULTIFOCAL, TORIC, SILICONE" },
        { key: "P030102100399", value: "IOLs, APHAKIC, MULTIFOCAL, TORIC - OTHER" },
        { key: "P03010211", value: "IOLs, APHAKIC, ACCOMMODATIVE" },
        { key: "P0301021101", value: "IOLs, APHAKIC, ACCOMMODATIVE, SPHERICAL" },
        { key: "P030102110101", value: "IOLs, APHAKIC, ACCOMMODATIVE, SPHERICAL, HYDROPHOBIC ACRYLIC" },
        { key: "P030102110102", value: "IOLs, APHAKIC, ACCOMMODATIVE, SPHERICAL, HYDROPHILIC ACRYLIC" },
        { key: "P030102110103", value: "IOLs, APHAKIC, ACCOMMODATIVE, SPHERICAL, SILICONE" },
        { key: "P030102110199", value: "IOLs, APHAKIC, ACCOMMODATIVE, SPHERICAL - OTHER" },
        { key: "P0301021102", value: "IOLs, APHAKIC, ACCOMMODATIVE, ASPHERIC" },
        { key: "P030102110201", value: "IOLs, APHAKIC, ACCOMMODATIVE, ASPHERIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102110202", value: "IOLs, APHAKIC, ACCOMMODATIVE, ASPHERIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102110203", value: "IOLs, APHAKIC, ACCOMMODATIVE, ASPHERIC, SILICONE" },
        { key: "P030102110299", value: "IOLs, APHAKIC, ACCOMMODATIVE, ASPHERIC - OTHER" },
        { key: "P0301021103", value: "IOLs, APHAKIC, ACCOMMODATIVE, TORIC" },
        { key: "P030102110301", value: "IOLs, APHAKIC, ACCOMMODATIVE, TORIC, HYDROPHOBIC ACRYLIC" },
        { key: "P030102110302", value: "IOLs, APHAKIC, ACCOMMODATIVE, TORIC, HYDROPHILIC ACRYLIC" },
        { key: "P030102110303", value: "IOLs, APHAKIC, ACCOMMODATIVE, TORIC, SILICONE" },
        { key: "P030102110399", value: "IOLs, APHAKIC, ACCOMMODATIVE, TORIC - OTHER" },
        { key: "P030190", value: "INTRAOCULAR LENSES (IOL) - VARIOUS" },
        { key: "P03019001", value: "MACULOPATHY LOW VISION CORRECTION LENSES " },
        { key: "P030199", value: "INTRAOCULAR LENSES (IOL) - OTHER" },
        { key: "P0380", value: "OCULAR PROSTHESES - ACCESSORIES" },
        { key: "P0399", value: "OCULAR PROSTHESES - OTHER" },
        { key: "P04", value: "RESPIRATORY PROSTHESES" },
        { key: "P0401", value: "TRACHEOBRONCHIAL PROSTHESES" },
        { key: "P0480", value: "RESPIRATORY PROSTHESES - ACCESSORIES" },
        { key: "P0499", value: "RESPIRATORY PROSTHESES - OTHER" },
        { key: "P05", value: "OESOPHAGEAL AND GASTROINTESTINAL PROSTHESES" },
        { key: "P0501", value: "OESOPHAGEAL PROSTHESES" },
        { key: "P050101", value: "GASTRO-ESOPHAGEAL REFLUX CORRECTION PROSTHESES" },
        { key: "P050199", value: "ESOPHAGEAL PROSTHESES - OTHER" },
        { key: "P0502", value: "BILIARY AND PANCREATIC PROSTHESES" },
        { key: "P0503", value: "COLONIC AND DUODENAL PROSTHESES" },
        { key: "P0504", value: "FAECAL INCONTINENCE PROSTHESES" },
        { key: "P050401", value: "ANAL SPHINCTERS" },
        { key: "P050499", value: "FAECAL INCONTINENCE PROSTHESES - OTHER" },
        { key: "P0580", value: "OESOPHAGEAL AND GASTROINTESTINAL PROSTHESES - ACCESSORIES" },
        { key: "P058001", value: "OESOPHAGEAL AND GASTROINTESTINAL PROSTHESES POSITIONING DEVICES" },
        { key: "P058099", value: " OESOPHAGEAL AND GASTROINTESTINAL PROSTHESES - OTHER ACCESSORIES" },
        { key: "P0599", value: "PROSTHESES, OESOPHAGEAL AND GASTROINTESTINAL PROSTHESES - OTHER" },
        { key: "P06", value: "BREAST IMPLANTS" },
        { key: "P0601", value: "PERMANENT, NON-EXPANDABLE BREAST IMPLANTS" },
        { key: "P060101", value: "BREAST PROSTHESES, ROUND" },
        { key: "P06010101", value: "BREAST IMPLANTS, ROUND, SALINE" },
        { key: "P0601010101", value: "BREAST IMPLANTS, ROUND, SALINE, WITH SMOOTH SURFACE" },
        { key: "P0601010102", value: "BREAST IMPLANTS, ROUND, SALINE, WITH TEXTURED SURFACE" },
        { key: "P0601010199", value: "BREAST IMPLANTS, ROUND, SALINE - OTHER" },
        { key: "P06010102", value: "BREAST IMPLANTS, ROUND, MADE OF SILICONE" },
        { key: "P0601010201", value: "BREAST IMPLANTS, ROUND, MADE OF SILICONE, WITH SMOOTH SURFACE" },
        { key: "P0601010202", value: "BREAST IMPLANTS, ROUND, MADE OF SILICONE, WITH TEXTURED SURFACE" },
        { key: "P0601010299", value: "BREAST IMPLANTS, ROUND, MADE OF SILICONE - OTHER" },
        { key: "P060102", value: "BREAST IMPLANTS, ANATOMIC" },
        { key: "P06010201", value: "BREAST IMPLANTS, ANATOMICAL, SALINE" },
        { key: "P0601020101", value: "BREAST IMPLANTS, ANATOMICAL, SALINE, WITH SMOOTH SURFACE" },
        { key: "P0601020102", value: "BREAST IMPLANTS, ANATOMICAL, SALINE, WITH TEXTURED SURFACE" },
        { key: "P0601020199", value: "BREAST IMPLANTS, ANATOMICAL, SALINE - OTHER" },
        { key: "P06010202", value: "BREAST IMPLANTS, ANATOMICAL, MADE OF SILICONE" },
        { key: "P0601020201", value: "BREAST IMPLANTS, ANATOMICAL, MADE OF SILICONE, WITH SMOOTH SURFACE" },
        { key: "P0601020202", value: "BREAST IMPLANTS, ANATOMICAL, MADE OF SILICONE, WITH TEXTURED SURFACE" },
        { key: "P0601020299", value: "BREAST IMPLANTS, ANATOMICAL, MADE OF SILICONE - OTHER" },
        { key: "P060199", value: "BREAST IMPLANTS, STANDARD - OTHER" },
        { key: "P0602", value: "BREAST IMPLANTS, EXPANDER" },
        { key: "P060201", value: "BREAST IMPLANTS, BECKER TYPE" },
        { key: "P060299", value: "BREAST IMPLANTS, EXPANDER - OTHER" },
        { key: "P0680", value: "BREAST IMPLANTS - ACCESSORIES" },
        { key: "P0699", value: "BREAST IMPLANTS - OTHER" },
        { key: "P07", value: "VASCULAR AND CARDIAC PROSTHESES" },
        { key: "P0701", value: "VASCULAR PROSTHESES" },
        { key: "P070101", value: "BIOLOGICAL VASCULAR PROSTHESES" },
        { key: "P07010101", value: "PERICARDIUM VASCULAR PROSTHESES" },
        { key: "P0701010101", value: "PERICARDIUM VASCULAR PROSTHESES, STRAIGHT" },
        { key: "P0701010102", value: "PERICARDIUM VASCULAR PROSTHESES, BIFURCATED" },
        { key: "P07010102", value: "HOMOLOGOUS VASCULAR PROSTHESES," },
        { key: "P0701010201", value: "HOMOLOGOUS VASCULAR PROSTHESES, STRAIGHT" },
        { key: "P0701010202", value: "HOMOLOGOUS VASCULAR PROSTHESES, BIFURCATED" },
        { key: "P07010199", value: "BIOLOGICAL VASCULAR PROSTHESES - OTHER" },
        { key: "P070102", value: "VASCULAR PROSTHESES, SYNTHETIC" },
        { key: "P07010201", value: "DACRON VASCULAR PROSTHESES" },
        { key: "P0701020101", value: "DACRON VASCULAR PROSTHESES, STRAIGHT" },
        { key: "P070102010101", value: "DACRON VASCULAR PROSTHESES, STRAIGHT, KNITTED" },
        { key: "P070102010102", value: "DACRON VASCULAR PROSTHESES, STRAIGHT, WOVEN" },
        { key: "P0701020102", value: "DACRON VASCULAR PROSTHESES, MULTIFURCATED" },
        { key: "P070102010201", value: "DACRON VASCULAR PROSTHESES, MULTIFURCATED (AORTIC ARCH (ALSO COLLATERAL AND MULTIPLE) AND THORACIC-ABDOMINAL)" },
        { key: "P070102010202", value: "DACRON VASCULAR PROSTHESES, WOVEN, MULTIFURCATED" },
        { key: "P07010202", value: "PTFE VASCULAR PROSTHESES" },
        { key: "P0701020201", value: "PTFE VASCULAR PROSTHESES, STRAIGHT" },
        { key: "P070102020101", value: "PTFE VASCULAR PROSTHESES, STRAIGHT, SIMPLE" },
        { key: "P070102020102", value: "PTFE VASCULAR PROSTHESES, STRAIGHT, REINFORCED" },
        { key: "P0701020202", value: "PTFE VASCULAR PROSTHESES, BIFURCATED" },
        { key: "P070102020201", value: "PTFE VASCULAR PROSTHESES, BIFURCATED, SIMPLE" },
        { key: "P070102020202", value: "PTFE VASCULAR PROSTHESES, BIFURCATED, REINFORCED" },
        { key: "P07010299", value: "VASCULAR PROSTHESES, SYNTHETIC - OTHER" },
        { key: "P070180", value: "VASCULAR PROSTHESES - ACCESSORIES" },
        { key: "P0702", value: "VASCULAR PATCHES" },
        { key: "P070201", value: "BIOLOGICAL VASCULAR PATCHES" },
        { key: "P07020101", value: "PERICARDIUM VASCULAR PATCHES" },
        { key: "P07020102", value: "SIS (SMALL INTESTINAL SUBMUCOSA) VASCULAR PATCHES" },
        { key: "P07020199", value: "BIOLOGICAL VASCULAR PATCHES - OTHER" },
        { key: "P070202", value: "SYNTHETIC VASCULAR PATCHES" },
        { key: "P07020201", value: "DACRON VASCULAR PATCHES" },
        { key: "P07020202", value: "PTFE VASCULAR PATCHES" },
        { key: "P07020203", value: "PET VASCULAR PATCHES" },
        { key: "P07020204", value: "PU VASCULAR PATCHES" },
        { key: "P07020299", value: "SYNTHETIC VASCULAR PATCHES - OTHER" },
        { key: "P0703", value: "CARDIAC VALVES" },
        { key: "P070301", value: "BIOLOGICAL CARDIAC VALVES" },
        { key: "P07030101", value: "BIOLOGICAL CARDIAC VALVES FOR SURGICAL IMPLANT WITH SUPPORT" },
        { key: "P0703010101", value: "STENTED BIOLOGICAL HEART VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010101", value: "STENTED AORTIC BIOLOGICAL VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010102", value: "STENTED MITRAL BIOLOGICAL VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010103", value: "STENTED PULMONARY BIOLOGICAL VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010104", value: "STENTED TRICUSPID BIOLOGICAL VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P0703010102", value: "STENTED BIOLOGICAL HEART VALVES FOR SURGICAL IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010201", value: "STENTED AORTIC BIOLOGICAL VALVES FOR SURGICAL IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010202", value: "STENTED MITRAL BIOLOGICAL VALVES FOR SURGICAL IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010203", value: "STENTED PULMONARY BIOLOGICAL VALVES FOR SURGICAL IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301010204", value: "STENTED TRICUSPID BIOLOGICAL VALVES FOR SURGICAL IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P07030102", value: "STENTLESS BIOLOGICAL HEART VALVES FOR SURGICAL IMPLANT" },
        { key: "P0703010201", value: "STENTLESS BIOLOGICAL HEART VALVES FOR SURGICAL IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P0703010202", value: "STENTLESS BIOLOGICAL HEART VALVES FOR SURGICAL IMPLANT - TISSUE OF ANIMAL ORIGIN" },
        { key: "P07030103", value: "BIOLOGICAL HEART VALVES FOR PERCUTANEOUS IMPLANTATION, WITH SUPPORT" },
        { key: "P0703010301", value: "STENTED BIOLOGICAL HEART VALVES FOR PERCUTANEOUS IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030101", value: "STENTED BIOLOGICAL AORTIC VALVES FOR PERCUTANEOUS IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030102", value: "STENTED BIOLOGICAL MITRAL VALVES FOR PERCUTANEOUS IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030103", value: "STENTED BIOLOGICAL PULMONARY VALVES FOR PERCUTANEOUS IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030104", value: "STENTED BIOLOGICAL TRICUSPID VALVES FOR PERCUTANEOUS IMPLANT - VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P0703010302", value: "BIOLOGICAL HEART VALVES WITH SUPPORT FOR PERCUTANEOUS IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030201", value: "STENTED BIOLOGICAL AORTIC VALVES FOR PERCUTANEOUS IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030202", value: "STENTED BIOLOGICAL MITRAL VALVES FOR PERCUTANEOUS IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030203", value: "STENTED BIOLOGICAL PULMONARY VALVES FOR PERCUTANEOUS IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P070301030204", value: "STENTED BIOLOGICAL TRICUSPID VALVES FOR PERCUTANEOUS IMPLANT - NON-VALVE TISSUE OF ANIMAL ORIGIN" },
        { key: "P07030104", value: "BIOLOGICAL VALVES, BICAVAL" },
        { key: "P07030199", value: "BIOLOGICAL HEART VALVES - OTHER" },
        { key: "P070302", value: "MECHANICAL HEART VALVES" },
        { key: "P07030201", value: "MECHANICAL HEART VALVES, BALL-VALVES" },
        { key: "P07030202", value: "MECHANICAL HEART VALVES, SINGLE-DISC" },
        { key: "P07030203", value: "MECHANICAL HEART VALVES DOUBLE-DISC" },
        { key: "P0703020301", value: "BILEAFLET MECHANICAL AORTIC VALVES" },
        { key: "P0703020302", value: "BILEAFLET MECHANICAL MITRAL VALVES" },
        { key: "P0703020399", value: "BILEAFLET MECHANICAL HEART VALVES - OTHER" },
        { key: "P07030299", value: "MECHANICAL HEART VALVES - OTHER" },
        { key: "P070303", value: "HEART VALVE TUBES" },
        { key: "P07030301", value: "BIOLOGICAL HEART VALVE TUBES" },
        { key: "P07030302", value: "MECHANICAL HEART VALVE TUBES" },
        { key: "P07030399", value: "HEART VALVE TUBES - OTHER" },
        { key: "P070304", value: "HEART VALVE RINGS" },
        { key: "P07030401", value: "FLEXIBLE OR UNSUPPORTED HEART VALVE RINGS" },
        { key: "P07030402", value: "RIGID OR SEMI-RIGID HEART VALVE RINGS WITH SUPPORT" },
        { key: "P07030403", value: "INCOMPLETE SEMI-RIGID HEART VALVE RINGS" },
        { key: "P07030499", value: "HEART VALVE RINGS - OTHER" },
        { key: "P070380", value: "HEART VALVES - ACCESSORIES" },
        { key: "P07038001", value: "HEART VALVE IMPLANT SIZERS" },
        { key: "P07038002", value: "CARDIAC VALVE TRANSCATHETER IMPLANT ACCESSORIES" },
        { key: "P07038003", value: "MECHANICAL HEART VALVE IMPLANT ACCESSORIES" },
        { key: "P07038004", value: "HEART VALVE RECONSTRUCTION IMPLANTS" },
        { key: "P07038099", value: "HEART VALVE ACCESSORIES - OTHER" },
        { key: "P070399", value: "CARDIAC VALVES - OTHER" },
        { key: "P0704", value: "VASCULAR AND CARDIAC ENDOPROSTHESES" },
        { key: "P070401", value: "VASCULAR ENDOPROSTHESES" },
        { key: "P07040101", value: "DACRON VASCULAR ENDOPROSTHESES" },
        { key: "P0704010101", value: "DACRON VASCULAR ENDOPROSTHESES, STRAIGHT" },
        { key: "P070401010101", value: "DACRON VASCULAR ENDOPROSTHESES, STRAIGHT - ABDOMINAL" },
        { key: "P070401010102", value: "DACRON VASCULAR ENDOPROSTHESES, STRAIGHT - THORACIC" },
        { key: "P070401010199", value: "DACRON VASCULAR ENDOPROSTHESES, STRAIGHT - OTHER" },
        { key: "P0704010102", value: "DACRON VASCULAR ENDOPROSTHESES, BIFURCATED" },
        { key: "P0704010103", value: "DACRON VASCULAR ENDOPROSTHESES, AUXILIARY" },
        { key: "P07040102", value: "PTFE VASCULAR ENDOPROSTHESES" },
        { key: "P0704010201", value: "PTFE VASCULAR ENDOPROSTHESES, STRAIGHT" },
        { key: "P070401020101", value: "PTFE VASCULAR ENDOPROSTHESES, STRAIGHT - ABDOMINAL" },
        { key: "P070401020102", value: "PTFE VASCULAR ENDOPROSTHESES, STRAIGHT - THORACIC" },
        { key: "P070401020103", value: "PTFE VASCULAR ENDOPROSTHESES, STRAIGHT - PERIPHERAL" },
        { key: "P070401020199", value: "PTFE VASCULAR ENDOPROSTHESES, STRAIGHT - OTHER" },
        { key: "P0704010202", value: "PTFE VASCULAR ENDOPROSTHESES, BIFURCATED" },
        { key: "P0704010203", value: "PTFE VASCULAR ENDOPROSTHESES, AUXILIARY" },
        { key: "P07040199", value: "VASCULAR ENDOPROSTHESES - OTHER" },
        { key: "P070402", value: "VASCULAR STENTS" },
        { key: "P07040201", value: "CORONARY STENTS" },
        { key: "P0704020101", value: "CORONARY BARE METAL STENTS (BMS)" },
        { key: "P070402010101", value: "STAINLESS STEEL CORONARY BARE METAL STENTS (BMS)" },
        { key: "P070402010102", value: "METALLIC NON-STAINLESS STEEL CORONARY STENTS" },
        { key: "P070402010199", value: "CORONARY BARE METAL STENTS (BMS) - OTHER" },
        { key: "P0704020102", value: "COATED CORONARY STENTS" },
        { key: "P0704020103", value: "CORONARY DRUG ELUTING STENTS (DES)" },
        { key: "P070402010301", value: "CORONARY DRUG ELUTING STENTS (DES) WITH POLYMERS" },
        { key: "P070402010302", value: "CORONARY DRUG ELUTING STENTS (DES) WITHOUT POLYMERS" },
        { key: "P0704020104", value: "CORONARY STENTS, ABSORBABLE" },
        { key: "P0704020105", value: "CORONARY STENTS, BIOACTIVE" },
        { key: "P0704020199", value: "CORONARY STENTS - OTHER" },
        { key: "P07040202", value: "PERIPHERAL VASCULAR STENTS" },
        { key: "P0704020201", value: "PERIPHERAL VASCULAR STENTS, BMS" },
        { key: "P070402020101", value: "STAINLESS STEEL PERIPHERAL VASCULAR BARE METAL STENTS" },
        { key: "P070402020102", value: "NON-STAINLESS STEEL PERIPHERAL VASCULAR BARE METAL STENTS" },
        { key: "P070402020199", value: "PERIPHERAL VASCULAR BARE STENTS - OTHER" },
        { key: "P0704020202", value: "PERIPHERAL VASCULAR COATED STENTS" },
        { key: "P0704020203", value: "PERIPHERAL VASCULAR DRUG ELUTING STENTS (DES)" },
        { key: "P0704020204", value: "PERIPHERAL VASCULAR STENTS, BIOACTIVE" },
        { key: "P0704020299", value: "PERIPHERAL VASCULAR STENTS - OTHER" },
        { key: "P070403", value: "CARDIAC AND CORONARY DEFECT OCCLUDERS" },
        { key: "P07040301", value: "CARDIAC OCCLUDERS, VENTRICULAR SEPTAL DEFECTS" },
        { key: "P07040302", value: "CARDIAC OCCLUDERS, ATRIAL SEPTAL DEFECTS" },
        { key: "P07040303", value: "CARDIAC OCCLUDERS, FORAMEN OVALE AND BOTALLO DUCT" },
        { key: "P07040399", value: "HEART AND CORONARY DEFECT OCCLUDERS - OTHER" },
        { key: "P070404", value: "LEFT ATRIAL APPENDAGE OCCLUDERS" },
        { key: "P0780", value: "VASCULAR AND CARDIAC PROSTHESES - ACCESSORIES" },
        { key: "P0799", value: "VASCULAR AND CARDIAC PROSTHESES - OTHER" },
        { key: "P08", value: "UROGENITAL PROSTHESES" },
        { key: "P0801", value: "URINARY INCONTINENCE PROSTHESES" },
        { key: "P080102", value: "ARTIFICIAL URINARY SPHINCTERS" },
        { key: "P080199", value: "URINARY INCONTINENCE PROSTHESES - OTHER" },
        { key: "P0802", value: "MALE GENITAL SYSTEM PROSTHESES" },
        { key: "P080201", value: "TESTICLE PROSTHESES" },
        { key: "P080202", value: "PENILE PROSTHESES" },
        { key: "P080299", value: "MALE GENITAL SYSTEM PROSTHESES - OTHER" },
        { key: "P0803", value: "URINARY OBSTRUCTION PROSTHESES" },
        { key: "P080301", value: "URETHRAL PROSTHESES" },
        { key: "P08030101", value: "TRANS-PROSTATIC URETHRAL PROSTHESES" },
        { key: "P08030102", value: "VAS DEFERENS PROSTHESES" },
        { key: "P08030199", value: "ENDOURETHRAL PROSTHESES - OTHER" },
        { key: "P080302", value: "URETERAL PROSTHESES" },
        { key: "P080399", value: "URINARY OBSTRUCTION PROSTHESES - OTHER" },
        { key: "P0804", value: "FEMALE GENITAL SYSTEM PROSTHESES" },
        { key: "P080401", value: "FALLOPIAN TUBE PROSTHESES" },
        { key: "P080499", value: "FEMALE GENITAL SYSTEM PROSTHESES - OTHER" },
        { key: "P0805", value: "URINARY TRACT IMPLANTABLE VALVES" },
        { key: "P0880", value: "UROGENITAL PROSTHESES - ACCESSORIES" },
        { key: "P0899", value: "UROGENITAL PROSTHESES - OTHER" },
        { key: "P09", value: "ORTHOPAEDIC PROSTHESES, OSTEOSYNTHESIS DEVICES, DEVICES FOR TENDON AND LIGAMENT SYNTHESIS" },
        { key: "P0901", value: "SHOULDER PROSTHESES" },
        { key: "P090103", value: "GLENOID COMPONENTS" },
        { key: "P09010301", value: "METAL BACK AND METAGLENE GLENOID BASEPLATES" },
        { key: "P09010302", value: "ANATOMICAL SHOULDER PROSTHESIS INSERTS" },
        { key: "P09010303", value: "GLENOSPHERES" },
        { key: "P09010304", value: "MONOBLOCK GLENOIDS" },
        { key: "P09010399", value: "GLENOID COMPONENTS - OTHER" },
        { key: "P090104", value: "SHOULDER PROSTHESES HUMERAL COMPONENTS" },
        { key: "P09010401", value: "EPIPHYSARY HUMERAL COMPONENTS" },
        { key: "P0901040101", value: "EPIPHYSARY HUMERAL COMPONENTS FOR ANATOMICAL PROSTHESES" },
        { key: "P090104010101", value: "EPIPHYSARY HUMERAL COMPONENTS FOR ANATOMICAL PROSTHESES - HUMERAL HEADS" },
        { key: "P090104010102", value: "EPIPHYSARY HUMERAL COMPONENTS FOR RESURFACING ANATOMICAL PROSTHESES" },
        { key: "P0901040102", value: "EPIPHYSARY HUMERAL COMPONENTS FOR REVERSE PROSTHESES" },
        { key: "P090104010201", value: "EPIPHYSARY HUMERAL COMPONENTS FOR REVERSE PROSTHESES - INSERTS" },
        { key: "P090104010202", value: "EPIPHYSARY HUMERAL COMPONENTS FOR REVERSE PROSTHESES - HUMERAL CUPS" },
        { key: "P0901040199", value: "EPIPHYSARY HUMERAL COMPONENTS - OTHER" },
        { key: "P09010402", value: "DIAPHYSARY HUMERAL COMPONENTS" },
        { key: "P0901040201", value: "SHOULDER PROSTHESES NON MODULAR STEMS" },
        { key: "P0901040202", value: "SHOULDER PROSTHESES MODULAR STEMS" },
        { key: "P0901040203", value: "MONOBLOCK DIAPHYSARY HUMERAL COMPONENTS (STEM + EPIPHYSARY COMPONENT)" },
        { key: "P090104020301", value: "MONOBLOCK DIAPHYSARY HUMERAL COMPONENTS FOR ANATOMICAL PROSTHESIS (STEM + HEAD)" },
        { key: "P090104020302", value: "MONOBLOCK DIAPHYSARY HUMERAL COMPONENTS FOR REVERSE PROSTHESIS (STEM + CUP)" },
        { key: "P0901040204", value: "SHOULDER PROSTHESES REVISION STEMS" },
        { key: "P0901040205", value: "SHOULDER PROSTHESES LARGE RESECTIONS STEMS" },
        { key: "P0901040299", value: "DIAPHYSARY HUMERAL COMPONENTS - OTHER" },
        { key: "P09010403", value: "SHOULDER PROSTHESES SPACERS" },
        { key: "P09010499", value: "HUMERAL COMPONENTS FOR SHOULDER PROSTHESES - OTHER" },
        { key: "P090180", value: "SHOULDER PROSTHESES - ACCESSORIES" },
        { key: "P09018001", value: "SHOULDER PROSTHESES FIXING SCREWS" },
        { key: "P09018002", value: "SHOULDER PROSTHESES ADAPTERS (INCLUDING CONES AND SLEEVES)" },
        { key: "P0901800201", value: "GLENOID COMPONENTS ADAPTERS" },
        { key: "P0901800202", value: "HUMERAL COMPONENTS ADAPTERS" },
        { key: "P09018003", value: "SHOULDER PROSTHESES ENDOMIDOLLAR CAPS" },
        { key: "P09018099", value: "SHOULDER PROSTHESES - ACCESSORIES - OTHER" },
        { key: "P090199", value: "SHOULDER PROSTHESES - OTHER" },
        { key: "P0902", value: "ELBOW PROSTHESES" },
        { key: "P090203", value: "ELBOW PROSTHESES HUMERAL COMPONENTS" },
        { key: "P090204", value: "ELBOW PROSTHESES RADIAL COMPONENTS" },
        { key: "P090205", value: "ELBOW PROSTHESES ULNAR COMPONENTS" },
        { key: "P090280", value: "ELBOW PROSTHESES - ACCESSORIES" },
        { key: "P090299", value: "ELBOW PROSTHESES - OTHER" },
        { key: "P0903", value: "WRIST PROSTHESES" },
        { key: "P090303", value: "WRIST PROSTHESES CARPAL COMPONENTS" },
        { key: "P090304", value: "WRIST PROSTHESES RADIAL-ULNAR COMPONENTS" },
        { key: "P09030401", value: "WRIST PROSTHESES RADIAL COMPONENTS" },
        { key: "P09030402", value: "WRIST PROSTHESES ULNAR COMPONENTS" },
        { key: "P090305", value: "TOTAL WRIST PROSTHESES" },
        { key: "P090380", value: "WRIST PROSTHESES - ACCESSORIES" },
        { key: "P090399", value: "WRIST PROSTHESES - OTHER" },
        { key: "P0904", value: "HAND PROSTHESES" },
        { key: "P090403", value: "HAND PROSTHESES INTERPHALANGE COMPONENTS" },
        { key: "P090404", value: "HAND PROSTHESES TRAPEZIO-METACARPAL COMPONENTS" },
        { key: "P090480", value: "HAND PROSTHESES - ACCESSORIES" },
        { key: "P090499", value: "HAND PROSTHESES - OTHER" },
        { key: "P0905", value: "ANKLE PROSTHESES" },
        { key: "P090506", value: "ANKLE PROSTHESIS WITH MOBILE INSERT" },
        { key: "P09050601", value: "ANKLE PROSTHESES WITH CEMENTED MOBILE INSERT" },
        { key: "P0905060101", value: "ANKLE PROSTHESES WITH CEMENTED MOBILE INSERT - TIBIAL COMPONENTS" },
        { key: "P0905060102", value: "ANKLE PROSTHESES WITH CEMENTED MOBILE INSERT - TALAR COMPONENTS" },
        { key: "P09050602", value: "ANKLE PROSTHESES WITH UNCEMENTED MOBILE INSERT" },
        { key: "P0905060201", value: "ANKLE PROSTHESES WITH UNCEMENTED MOBILE INSERT - TIBIAL COMPONENTS" },
        { key: "P0905060202", value: "ANKLE PROSTHESES WITH UNCEMENTED MOBILE INSERT - TALAR COMPONENTS" },
        { key: "P09050603", value: "ANKLE PROSTHESES MOBILE INSERTS" },
        { key: "P090507", value: "ANKLE PROSTHESIS WITH FIXED INSERT" },
        { key: "P09050701", value: "ANKLE PROSTHESES WITH CEMENTED FIXED INSERT" },
        { key: "P0905070101", value: "ANKLE PROSTHESES WITH CEMENTED FIXED INSERT - TIBIAL COMPONENTS" },
        { key: "P0905070102", value: "ANKLE PROSTHESES WITH CEMENTED FIXED INSERT - TALAR COMPONENTS" },
        { key: "P09050702", value: "ANKLE PROSTHESES WITH UNCEMENTED FIXED INSERT" },
        { key: "P0905070201", value: "ANKLE PROSTHESES WITH UNCEMENTED FIXED INSERT - TIBIAL COMPONENTS" },
        { key: "P0905070202", value: "ANKLE PROSTHESES WITH UNCEMENTED FIXED INSERT - TALAR COMPONENTS" },
        { key: "P09050703", value: "ANKLE PROSTHESES FIXED INSERTS" },
        { key: "P090508", value: "ANKLE PROSTHESES SPACERS" },
        { key: "P090580", value: "ANKLE PROSTHESES - ACCESSORIES" },
        { key: "P09058001", value: "ANKLE PROSTHESES TIBIAL STEMS" },
        { key: "P09058099", value: "ANKLE PROSTHESES - ACCESSORIES - OTHER" },
        { key: "P090599", value: "ANKLE PROSTHESES - OTHER" },
        { key: "P0906", value: "FOOT PROSTHESES" },
        { key: "P090603", value: "FOOT PROSTHESES INTERPHALANGEAL COMPONENTS" },
        { key: "P090604", value: "FOOT PROSTHESES METATARSALPHALANGEAL COMPONENTS" },
        { key: "P090605", value: "FOOT ENDORTHESIS" },
        { key: "P090680", value: "FOOT PROSTHESES - ACCESSORIES" },
        { key: "P090699", value: "FOOT PROSTHESES - OTHER" },
        { key: "P0907", value: "SPINE STABILISATION PROSTHESES AND SYSTEMS" },
        { key: "P090701", value: "SPINAL FUSION SYSTEMS" },
        { key: "P09070101", value: "SPINAL CAGES" },
        { key: "P09070199", value: "SPINAL FUSION SYSTEMS - OTHER" },
        { key: "P090702", value: "INTERVERTEBRAL DISCS REPLACEMENT SYSTEMS" },
        { key: "P09070201", value: "DISC PROSTHESES" },
        { key: "P090703", value: "IMPLANTABLE VERTEBRAL STABILISATION OR FIXATION SYSTEMS" },
        { key: "P09070301", value: "CERVICAL FIXATION SYSTEMS" },
        { key: "P09070302", value: "THORACOLUMBOSACRAL FIXATION SYSTEMS" },
        { key: "P09070304", value: "SPINE FIXATION SYSTEM CONNECTORS" },
        { key: "P09070305", value: "SPINAL STABILISERS, DYNAMIC TYPE" },
        { key: "P09070399", value: "IMPLANTABLE SPINAL STABILISATION OR FIXATION SYSTEMS - OTHER" },
        { key: "P090780", value: "SPINAL PROSTHESES AND STABILISATION SYSTEMS - ACCESSORIES" },
        { key: "P090799", value: "SPINAL PROSTHESES AND STABILISATION SYSTEMS - OTHER" },
        { key: "P0908", value: "HIP PROSTHESES" },
        { key: "P090803", value: "HIP PROSTHESES ACETABULAR COMPONENTS" },
        { key: "P09080301", value: "PRIMARY IMPLANT ACETABULAR CUPS" },
        { key: "P0908030101", value: "PRIMARY IMPLANT CEMENTED ACETABULAR CUPS" },
        { key: "P090803010101", value: "PRIMARY IMPLANT CEMENTED METAL ACETABULAR CUPS" },
        { key: "P090803010102", value: "PRIMARY IMPLANT CEMENTED POLYETHYLENE ACETABULAR CUPS, ONE-PIECE" },
        { key: "P090803010199", value: "PRIMARY IMPLANT CEMENTED ACETABULAR CUPS - OTHER" },
        { key: "P0908030102", value: "PRIMARY IMPLANT UNCEMENTED ACETABULAR CUPS" },
        { key: "P090803010201", value: "PRIMARY IMPLANT UNCEMENTED METAL ACETABULAR CUPS" },
        { key: "P090803010202", value: "PRIMARY IMPLANT UNCEMENTED ONE-PIECE POLYETHYLENE ACETABULAR CUPS" },
        { key: "P090803010203", value: "PRIMARY IMPLANT UNCEMENTED ONE-PIECE METAL ACETABULAR CUPS" },
        { key: "P090803010299", value: "PRIMARY IMPLANT UNCEMENTED ACETABULAR CUPS - OTHER" },
        { key: "P09080302", value: "HIP RESURFACING ACETABULAR COMPONENTS" },
        { key: "P09080303", value: "REVISION SURGERY ACETABULAR CUPS" },
        { key: "P0908030301", value: "REVISION SURGERY CEMENTED ACETABULAR CUPS" },
        { key: "P0908030302", value: "REVISION SURGERY UNCEMENTED ACETABULAR CUPS" },
        { key: "P09080304", value: "HIP PROSTHESES ACETABULAR INSERTS" },
        { key: "P0908030401", value: "HIP PROSTHESES POLYETHYLENE ACETABULAR INSERTS" },
        { key: "P090803040101", value: "STANDARD POLYETHYLENE HIP PROSTHESES INSERTS" },
        { key: "P090803040102", value: "ECCENTRIC POLYETHYLENE HIP PROSTHESES INSERTS" },
        { key: "P090803040103", value: "RETENTIVE POLYETHYLENE HIP PROSTHESES INSERTS, ANTI-DISLOCATION" },
        { key: "P0908030402", value: "HIP PROSTHESES CERAMIC ACETABULAR INSERTS" },
        { key: "P0908030403", value: "HIP PROSTHESES METAL ACETABULAR INSERTS" },
        { key: "P0908030499", value: "HIP PROSTHESES ACETABULAR INSERTS - OTHER" },
        { key: "P09080305", value: "DUAL-MOBILITY ACETABULAR COMPONENTS" },
        { key: "P0908030501", value: "DOUBLE-MOBILITY ACETABULAR CUPS" },
        { key: "P090803050101", value: "CEMENTED DOUBLE-MOBILITY ACETABULAR CUPS" },
        { key: "P090803050102", value: "UNCEMENTED DOUBLE-MOBILITY ACETABULAR CUPS" },
        { key: "P0908030502", value: "DOUBLE-MOBILITY ACETABULAR COMPONENTS INSERTS" },
        { key: "P09080306", value: "PRE-ASSEMBLED ACETABULAR COMPONENTS (ACETABULAR CUP + INSERT)" },
        { key: "P0908030601", value: "PRE-ASSEMBLED ACETABULAR COMPONENTS WITH CERAMIC INSERT" },
        { key: "P0908030602", value: "PRE-ASSEMBLED ACETABULAR COMPONENTS WITH POLYETHYLENE INSERTS" },
        { key: "P0908030699", value: "PRE-ASSEMBLED ACETABULAR COMPONENTS - OTHER" },
        { key: "P090804", value: "HIP PROSTHESES FEMORAL COMPONENTS" },
        { key: "P09080401", value: "PRIMARY IMPLANT FEMORAL STEMS" },
        { key: "P0908040101", value: "PRIMARY IMPLANT CEMENTED FEMORAL STEMS" },
        { key: "P090804010101", value: "CEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, STRAIGHT" },
        { key: "P090804010102", value: "CEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, ANATOMICAL" },
        { key: "P090804010105", value: "CEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, FOR PRESERVATION" },
        { key: "P090804010106", value: "CEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH MODULAR NECK, STRAIGHT" },
        { key: "P090804010107", value: "CEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH MODULAR NECK, ANATOMICAL" },
        { key: "P0908040102", value: "PRIMARY IMPLANT UNCEMENTED FEMORAL STEMS" },
        { key: "P090804010201", value: "UNCEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, STRAIGHT" },
        { key: "P090804010202", value: "UNCEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, ANATOMICAL" },
        { key: "P090804010205", value: "UNCEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH FIXED NECK, FOR PRESERVATION" },
        { key: "P090804010206", value: "UNCEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH MODULAR NECK, STRAIGHT" },
        { key: "P090804010207", value: "UNCEMENTED FEMORAL STEMS FOR PRIMARY IMPLANT, WITH MODULAR NECK, ANATOMICAL" },
        { key: "P09080402", value: "HIP RESURFACING FEMORAL COMPONENTS" },
        { key: "P09080403", value: "REVISION SURGERY FEMORAL STEMS" },
        { key: "P0908040301", value: "REVISION SURGERY CEMENTED FEMORAL STEMS" },
        { key: "P090804030101", value: "REVISION CEMENTED FEMORAL STEMS, WITH FIXED NECK" },
        { key: "P090804030102", value: "REVISION CEMENTED FEMORAL STEMS, WITH MODULAR NECK" },
        { key: "P0908040302", value: "REVISION UNCEMENTED FEMORAL STEMS" },
        { key: "P090804030201", value: "REVISION UNCEMENTED FEMORAL STEMS, WITH FIXED NECK" },
        { key: "P090804030202", value: "REVISION UNCEMENTED FEMORAL STEMS, WITH MODULAR NECK" },
        { key: "P09080404", value: "LARGE RESECTIONS FEMORAL STEMS" },
        { key: "P09080405", value: "FEMORAL HEADS" },
        { key: "P0908040501", value: "FEMORAL HEADS FOR PRIMARY IMPLANT OF PARTIAL PROSTHESES" },
        { key: "P090804050101", value: "CERAMIC FEMORAL HEADS, PARTIAL HIP REPLACEMENT" },
        { key: "P090804050102", value: "METAL FEMORAL HEADS, PARTIAL HIP REPLACEMENT" },
        { key: "P090804050199", value: "FEMORAL HEADS FOR PRIMARY IMPLANT OF PARTIAL PROSTHESES - OTHER" },
        { key: "P0908040502", value: "FEMORAL HEADS FOR PRIMARY IMPLANT OF TOTAL PROSTHESES" },
        { key: "P090804050201", value: "CERAMIC FEMORAL HEADS, TOTAL HIP REPLACEMENT" },
        { key: "P090804050202", value: "METAL FEMORAL HEADS, TOTAL HIP REPLACEMENT" },
        { key: "P090804050299", value: "FEMORAL HEADS FOR PRIMARY IMPLANT OF TOTAL PROSTHESES - OTHER" },
        { key: "P0908040503", value: "HIP PROSTHESES, BI-ARTICULAR CUPS" },
        { key: "P0908040504", value: "REVISION FEMORAL HEADS" },
        { key: "P09080406", value: "ONE-PIECE FEMORAL PROSTHESES (STEM+HEAD)" },
        { key: "P09080407", value: "MODULAR NECKS" },
        { key: "P090805", value: "HIP PROSTHESES SPACERS" },
        { key: "P090880", value: "HIP PROSTHESES - ACCESSORIES" },
        { key: "P09088001", value: "ACETABULAR RINGS" },
        { key: "P09088002", value: "ACETABULAR MESHES" },
        { key: "P09088003", value: "HIP PROSTHESES AUGMENTS" },
        { key: "P09088004", value: "HIP PROSTHESES ADAPTERS (INCLUDING CONES AND SLEEVES)" },
        { key: "P09088005", value: "HIP PROSTHESES CENTRALIZERS" },
        { key: "P09088006", value: "FEMORAL INTRAMEDULLARY CAPS" },
        { key: "P09088007", value: "HIP PROSTHESES FIXING SCREWS" },
        { key: "P09088099", value: "HIP PROSTHESES - OTHER ACCESSORIES" },
        { key: "P090899", value: "HIP PROSTHESES - OTHER" },
        { key: "P0909", value: "KNEE PROSTHESES" },
        { key: "P090903", value: "BICOMPARTMENTAL PRIMARY IMPLANT KNEE PROSTHESES " },
        { key: "P09090301", value: "BICOMPARTMENTAL PRIMARY IMPLANT FEMORAL COMPONENTS" },
        { key: "P0909030101", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTED FEMORAL COMPONENTS" },
        { key: "P0909030102", value: "BICOMPARTMENTAL PRIMARY IMPLANT UNCEMENTED FEMORAL COMPONENTS" },
        { key: "P0909030103", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTABLE FEMORAL COMPONENTS" },
        { key: "P09090302", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL COMPONENTS" },
        { key: "P0909030201", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL PLATES" },
        { key: "P090903020101", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTED MOBILE BEARING TIBIAL PLATES" },
        { key: "P090903020102", value: "BICOMPARTMENTAL PRIMARY IMPLANT UNCEMENTED MOBILE BEARING TIBIAL PLATES" },
        { key: "P090903020103", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTABLE MOBILE BEARING TIBIAL PLATES" },
        { key: "P090903020104", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTED FIXED BEARING TIBIAL PLATES" },
        { key: "P090903020105", value: "BICOMPARTMENTAL PRIMARY IMPLANT UNCEMENTED FIXED BEARING TIBIAL PLATES" },
        { key: "P090903020106", value: "BICOMPARTMENTAL PRIMARY IMPLANT CEMENTABLE FIXED BEARING TIBIAL PLATES" },
        { key: "P0909030202", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL INSERTS" },
        { key: "P090903020201", value: "BICOMPARTMENTAL PRIMARY IMPLANT MOBILE BEARING TIBIAL INSERTS" },
        { key: "P090903020202", value: "BICOMPARTMENTAL PRIMARY IMPLANT FIXED BEARING TIBIAL INSERTS" },
        { key: "P0909030203", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL COMPONENTS, MONOBLOCK" },
        { key: "P090903020301", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL COMPONENTS, MONOBLOCK MADE OF POLYETHYLENE" },
        { key: "P090903020399", value: "BICOMPARTMENTAL PRIMARY IMPLANT TIBIAL COMPONENTS, MONOBLOCK - OTHER" },
        { key: "P090904", value: "UNICOMPARTMENTAL KNEE PROSTHESES (UNICONDYLAR)" },
        { key: "P09090401", value: "UNICOMPARTMENTAL KNEE PROSTHESES FEMORAL COMPONENTS (UNICONDYLAR)" },
        { key: "P0909040101", value: "UNICOMPARTMENTAL KNEE PROSTHESES FEMORAL COMPONENTS (UNICONDYLAR), CEMENTED" },
        { key: "P0909040102", value: "UNICOMPARTMENTAL KNEE PROSTHESES FEMORAL COMPONENTS (UNICONDYLAR), UNCEMENTED" },
        { key: "P09090402", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS" },
        { key: "P0909040201", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL PLATES" },
        { key: "P090904020101", value: "MOBILE CEMENTED UNICOMPARTMENTAL PRIMARY IMPLANT TIBIAL PLATES" },
        { key: "P090904020102", value: "MOBILE UNCEMENTED UNICOMPARTMENTAL PRIMARY IMPLANT TIBIAL PLATES" },
        { key: "P090904020103", value: "FIXED CEMENTED UNICOMPARTMENTAL PRIMARY IMPLANT TIBIAL PLATES" },
        { key: "P090904020104", value: "FIXED UNCEMENTED UNICOMPARTMENTAL PRIMARY IMPLANT TIBIAL PLATES" },
        { key: "P0909040202", value: "UNICOMPARTMENTAL KNEE REPLACEMENT TIBIAL INSERTS" },
        { key: "P090904020201", value: "MOBILE UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL INSERTS" },
        { key: "P090904020202", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL INSERTS, FIXED" },
        { key: "P0909040203", value: "PRE-ASSEMBLED UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS (INSERT + TIBIAL PLATE)" },
        { key: "P090904020301", value: "KNEE PROSTHESES TIBIAL COMPONENTS, PREASSEMBLED, CEMENTED" },
        { key: "P090904020302", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS, PREASSEMBLED, UNCEMENTED" },
        { key: "P0909040204", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS, MONOBLOCK" },
        { key: "P090904020401", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS, MONOBLOCK, MADE OF POLYETHYLENE" },
        { key: "P090904020499", value: "UNICOMPARTMENTAL KNEE PROSTHESES TIBIAL COMPONENTS, MONOBLOCK - OTHER" },
        { key: "P090905", value: "REVISION KNEE PROSTHESES" },
        { key: "P09090501", value: "REVISION KNEE PROSTHESES FEMORAL COMPONENTS" },
        { key: "P09090502", value: "REVISION KNEE PROSTHESES TIBIAL COMPONENTS" },
        { key: "P0909050201", value: "REVISION KNEE PROSTHESES TIBIAL PLATES" },
        { key: "P090905020101", value: "REVISION KNEE PROSTHESES MOBILE BEARING TIBIAL PLATES" },
        { key: "P090905020102", value: "REVISION KNEE PROSTHESES FIXED BEARING TIBIAL PLATES" },
        { key: "P0909050202", value: "REVISION KNEE PROSTHESES TIBIAL INSERTS" },
        { key: "P090905020201", value: "REVISION KNEE PROSTHESES MOBILE BEARING TIBIAL INSERTS" },
        { key: "P090905020202", value: "REVISION KNEE PROSTHESES FIXED BEARING TIBIAL INSERTS" },
        { key: "P090906", value: "KNEE PROSTHESES FOR LARGE RESECTIONS" },
        { key: "P090907", value: "PATELLO-FEMORAL KNEE PROSTHESES" },
        { key: "P09090701", value: "FEMORAL TROCHLEA RESURFACING COMPONENTS" },
        { key: "P09090702", value: "PATELLAR COMPONENTS" },
        { key: "P0909070201", value: "PATELLAR COMPONENTS, MONOBLOCK" },
        { key: "P0909070202", value: "PATELLAR COMPONENTS, MODULAR" },
        { key: "P090908", value: "KNEE PROSTHESES SPACERS" },
        { key: "P090980", value: "KNEE PROSTHESES - ACCESSORIES" },
        { key: "P09098001", value: "KNEE PROSTHESES AUGMENTS" },
        { key: "P09098002", value: "KNEE PROSTHESES ADAPTERS (INCLUDING CONES AND SLEEVES)" },
        { key: "P09098003", value: "KNEE PROSTHESES OBTURATORS AND PLUGS" },
        { key: "P09098004", value: "KNEE PROSTHESES CENTRALISERS" },
        { key: "P09098006", value: "KNEE PROSTHESES STEMS" },
        { key: "P0909800601", value: "KNEE PROSTHESES FEMORAL STEMS" },
        { key: "P0909800602", value: "KNEE PROSTHESES TIBIAL STEMS" },
        { key: "P09098099", value: "KNEE PROSTHESES - ACCESSORIES - OTHER" },
        { key: "P090999", value: "KNEE PROSTHESES - OTHER" },
        { key: "P0910", value: "LIGAMENT PROSTHESES" },
        { key: "P0912", value: "OSTEOSYNTHESIS DEVICES, DEVICES FOR TENDON AND LIGAMENT SYNTHESIS" },
        { key: "P091201", value: "OSTEOSYNTHESIS STAPLES AND ANCHORS" },
        { key: "P09120101", value: "OSTEOSYNTHESIS STAPLES" },
        { key: "P09120102", value: "ANCHORS, TENDON AND LIGAMENT SYNTHESIS" },
        { key: "P091202", value: "BONE FIXATION NAILS" },
        { key: "P09120201", value: "INTRAMEDULLARY NAILS" },
        { key: "P09120202", value: "INTRAMEDULLARY NAILS IN COMPLEX SYSTEMS" },
        { key: "P09120299", value: "OSTEOSYNTHESIS NAILS - OTHER" },
        { key: "P091203", value: "BONE FIXATION WIRES" },
        { key: "P09120301", value: "KIRSCHNER BONE WIRES" },
        { key: "P09120302", value: "CERCLAGE DEVICES, WIRES AND BINDERS" },
        { key: "P09120399", value: "BONE FIXATION WIRES - OTHER" },
        { key: "P091204", value: "EXTERNAL BONE FIXATION SYSTEMS" },
        { key: "P09120401", value: "BONE FIXATION SYSTEMS" },
        { key: "P0912040101", value: "RADIAL BONE FIXATION SYSTEMS" },
        { key: "P0912040102", value: "AXIAL BONE FIXATION SYSTEMS" },
        { key: "P09120402", value: "SCREWS" },
        { key: "P09120403", value: "OSTEOSYNTHESIS DISTRACTORS" },
        { key: "P09120499", value: "EXTERNAL BONE FIXATION SYSTEMS - OTHER" },
        { key: "P091205", value: "BONE FIXATION PLATES" },
        { key: "P09120501", value: "OSTEOSYNTHESIS COMPRESSION PLATES" },
        { key: "P09120502", value: "OSTEOSYNTHESIS NEUTRALISATION AND SUPPORT PLATES" },
        { key: "P09120503", value: "OSTEOSYNTHESIS SCREW-PLATE SYSTEMS" },
        { key: "P09120504", value: "OSTEOSYNTHESIS BLADE-PLATE SYSTEMS" },
        { key: "P09120599", value: "BONE FIXATION PLATES - OTHER" },
        { key: "P091206", value: "BONE FIXATION SCREWS, TENDON AND LIGAMENT SYNTHESIS SCREWS" },
        { key: "P09120601", value: "CORTICAL SCREWS" },
        { key: "P09120602", value: "CANCELLOUS SCREWS" },
        { key: "P09120603", value: "CANNULATED SCREWS" },
        { key: "P09120604", value: "OSTEOSYNTHESIS NAIL-SCREW SYSTEMS" },
        { key: "P09120605", value: "INTERFERENCE SCREWS" },
        { key: "P09120606", value: "OSTEOSYNTHESIS DEVICES, BIODEGRADABLE SCREWS AND BARS" },
        { key: "P09120699", value: "BONE FIXATION SCREWS, TENDON AND LIGAMENT SYNTHESIS SCREWS - OTHER" },
        { key: "P091280", value: "OSTEOSYNTHESIS DEVICES, DEVICES FOR TENDON AND LIGAMENT SYNTHESIS - ACCESSORIES" },
        { key: "P091299", value: "OSTEOSYNTHESIS DEVICES, DEVICES FOR TENDON AND LIGAMENT SYNTHESIS - OTHER" },
        { key: "P0913", value: "ORTHOPAEDIC IMPLANT INSTRUMENTS, SINGLE-USE" },
        { key: "P091301", value: "ORTHOPAEDIC IMPLANT REAMERS, SINGLE-USE" },
        { key: "P091302", value: "ORTHOPAEDIC IMPLANT BLADES, SINGLE-USE" },
        { key: "P091303", value: "ORTHOPAEDIC IMPLANT DRILL BITS, SINGLE-USE" },
        { key: "P091304", value: "CRANIAL PERFORATORS, SINGLE-USE" },
        { key: "P091305", value: "BONE SAWS, SINGLE-USE" },
        { key: "P091399", value: "ORTHOPAEDIC IMPLANT INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "P0990", value: "ORTHOPAEDIC PROSTHESES - VARIOUS" },
        { key: "P099001", value: "ORTHOPAEDIC PROSTHESES CEMENTS AND ACCESSORIES FOR MIXING" },
        { key: "P099002", value: "ORTHOPAEDIC CEMENT PREPARATION AND APPLICATION DEVICES AND KITS" },
        { key: "P099003", value: "ORTHOPAEDIC PROSTHESES FIXING ELEMENTS - NOT OTHERWISE CLASSIFIED" },
        { key: "P0999", value: "ORTHOPAEDIC PROSTHESES, OSTEOSYNTHESIS DEVICES, DEVICES FOR TENDON AND LIGAMENT SYNTHESIS - OTHER" },
        { key: "P10", value: "EXTRA-VASCULAR SUPPORT PROSTHESES" },
        { key: "P1001", value: "LOWER LIMB EXTRAVENOUS VALVE SUPPORT PROSTHESES" },
        { key: "P1002", value: "CORONARY BYPASS EXTRAVENOUS SUPPORTS" },
        { key: "P1099", value: "EXTRAVASCULAR SUPPORT PROSTHESES - OTHER" },
        { key: "P90", value: "IMPLANTABLE PROSTHETIC AND OSTEOSYNTHESIS DEVICES - VARIOUS" },
        { key: "P9001", value: "TEMPORARY TISSUE EXPANDERS" },
        { key: "P900101", value: "CYLINDRICAL TISSUE EXPANDERS" },
        { key: "P900102", value: "ELLIPTICAL TISSUE EXPANDERS" },
        { key: "P900103", value: "BREAST TISSUE EXPANDERS" },
        { key: "P900104", value: "RECTANGULAR TISSUE EXPANDERS" },
        { key: "P900105", value: "ROUND TISSUE EXPANDERS" },
        { key: "P900106", value: "SEMILUNAR OR CRESCENT TISSUE EXPANDERS" },
        { key: "P900199", value: "TISSUE EXPANDERS - OTHER" },
        { key: "P9002", value: "SURGICAL MESHES" },
        { key: "P900201", value: "POLYGLYCOLIC ACID AND ASSOCIATIONS MESHES" },
        { key: "P900202", value: "POLYPROPYLENE SURGICAL MESHES" },
        { key: "P900203", value: "PTFE SURGICAL MESHES" },
        { key: "P900204", value: "SURGICAL MESHES, MORE THAN ONE COMPONENT" },
        { key: "P900205", value: "POLYESTER SURGICAL MESHES" },
        { key: "P900206", value: "METALLIC SURGICAL MESHES" },
        { key: "P900299", value: "SURGICAL MESHES - OTHER" },
        { key: "P9003", value: "TISSUE PATCHES" },
        { key: "P900301", value: "PTFE TISSUE PATCHES" },
        { key: "P900302", value: "POLYESTER TISSUE PATCHES" },
        { key: "P900399", value: "TISSUE PATCHES - OTHER" },
        { key: "P9004", value: "STRUCTURES FILLING, REPLACEMENT AND RECONSTRUCTION DEVICES" },
        { key: "P900401", value: "BONE AND TENDON REPLACEMENT DEVICES" },
        { key: "P900402", value: "RESORBABLE FILLING AND RECONSTRUCTION DEVICES" },
        { key: "P900403", value: "NON-RESORBABLE FILLING AND RECONSTRUCTION DEVICES" },
        { key: "P900404", value: "AUTOLOGOUS GRAFT SUPPORTS" },
        { key: "P9005", value: "IMPLANTABLE SPACERS FOR PROTECTION DURING RADIATION THERAPY" },
        { key: "P9099", value: "IMPLANTABLE PROSTHETIC DEVICES - OTHER" },
        { key: "Q", value: "DENTAL, OPHTHALMOLOGIC AND ENT DEVICES" },
        { key: "Q01", value: "DENTAL DEVICES" },
        { key: "Q0101", value: "DEVICES FOR CONSERVATIVE DENTISTRY AND ENDODONTICS" },
        { key: "Q010101", value: "DENTAL RESTORATION DEVICES" },
        { key: "Q01010101", value: "DENTAL CONSERVATION AMALGAMS" },
        { key: "Q01010102", value: "TEMPORARY AND PERMANENT DENTAL RESTORATION CEMENTS" },
        { key: "Q0101010201", value: "DENTAL BASE CEMENTS" },
        { key: "Q0101010202", value: "ROOT CANAL CEMENTS" },
        { key: "Q0101010203", value: "TEMPORARY DENTAL CEMENTS" },
        { key: "Q0101010204", value: "ENDODONTIC SURGERY CEMENTS" },
        { key: "Q0101010299", value: "TEMPORARY AND PERMANENT DENTAL RESTORATION CEMENTS - OTHER" },
        { key: "Q01010103", value: "DENTAL CONSERVATION COMPOSITES" },
        { key: "Q01010104", value: "DENTAL BONDING AGENTS" },
        { key: "Q01010105", value: "DENTAL RESTORATION COMPOMERS" },
        { key: "Q01010106", value: "DENTAL RESTORATION GLASS IONOMERS" },
        { key: "Q01010199", value: "DENTAL RESTORATION DEVICES - OTHER" },
        { key: "Q010102", value: "ROOT CANAL FILLING DEVICES" },
        { key: "Q01010201", value: "ROOT CANAL FILLING DENTAL PASTES" },
        { key: "Q01010202", value: "ROOT CANAL FILLING DENTAL CEMENTS" },
        { key: "Q01010203", value: "DENTAL CONES" },
        { key: "Q01010299", value: "ROOT CANAL FILLING DEVICES - OTHER" },
        { key: "Q010103", value: "DENTAL MEDICATION DEVICES" },
        { key: "Q01010301", value: "DENTAL MEDICATION COMPOUNDS WITH DISINFECTANTS, ANTIBIOTICS AND ANTI-INFLAMMATORIES" },
        { key: "Q01010399", value: "DENTAL MEDICATION DEVICES - OTHER" },
        { key: "Q010104", value: "DENTAL PROCEDURE DEVICES - VARIOUS" },
        { key: "Q01010401", value: "PAPER AND GUTTA-PERCHA TIPS, MATRICES AND WEDGES FOR DENTISTRY" },
        { key: "Q01010402", value: "ENAMEL-DENTINAL ETCHING MATERIALS" },
        { key: "Q01010403", value: "DENTAL ABRASIVE AND POLISHING MATERIALS" },
        { key: "Q010105", value: "RECONSTRUCTION ENDODONTIC PINS" },
        { key: "Q010199", value: "CONSERVATIVE DENTISTRY AND ENDODONTICS DEVICES - OTHER" },
        { key: "Q0102", value: "DEVICES FOR PROSTHETIC DENTISTRY" },
        { key: "Q010201", value: "DENTAL IMPRESSION MATERIALS" },
        { key: "Q01020101", value: "DENTAL IMPRESSION ALGINATES" },
        { key: "Q01020102", value: "DENTAL IMPRESSION VINYLSILOXANS" },
        { key: "Q01020103", value: "DENTAL IMPRESSION POLYETHERS" },
        { key: "Q01020104", value: "DENTAL IMPRESSION SILICONES" },
        { key: "Q01020199", value: "DENTAL IMPRESSION MATERIALS - OTHER" },
        { key: "Q010202", value: "DENTAL CONTACT INDICATORS" },
        { key: "Q01020201", value: "ARTICULATION PAPERS" },
        { key: "Q01020202", value: "SPRAY AND LIQUID DENTAL CONTACT INDICATORS" },
        { key: "Q01020203", value: "OCCLUSAL WAXES" },
        { key: "Q01020299", value: "DENTAL CONTACT INDICATORS - OTHER" },
        { key: "Q010204", value: "RETRACTION WIRES AND GINGIVAL RETRACTORS" },
        { key: "Q010205", value: "PRE-FORMED RESINS AND DENTAL CROWNS" },
        { key: "Q01020501", value: "DENTISTRY RESINS" },
        { key: "Q0102050101", value: "TEMPORARY TEETH RESINS" },
        { key: "Q0102050102", value: "DENTAL REBASING RESINS" },
        { key: "Q0102050199", value: "DENTISTRY RESINS - OTHER" },
        { key: "Q01020502", value: "PRE-FORMED DENTAL CROWNS" },
        { key: "Q010206", value: "DENTAL PROSTHESES (FOR DENTAL IMPLANTS SEE P010201)" },
        { key: "Q01020601", value: "MOBILE DENTAL PROSTHESES" },
        { key: "Q01020602", value: "COMBINED DENTAL PROSTHESES" },
        { key: "Q01020603", value: "SKELETAL DENTAL PROSTHESES" },
        { key: "Q01020604", value: "ORTHODONTIC DENTAL PROSTHESES" },
        { key: "Q01020605", value: "TEMPORARY DENTAL PROSTHESES" },
        { key: "Q010207", value: "DENTAL IMPRESSION DEVICES FOR PROSTHETIC DENTISTRY" },
        { key: "Q010280", value: "PROSTHETIC DENTISTRY DEVICES - ACCESSORIES" },
        { key: "Q010299", value: "PROSTHETIC DENTISTRY DEVICES - OTHER" },
        { key: "Q0103", value: "SURGICAL DENTAL DEVICES" },
        { key: "Q010301", value: "PERIODONTAL MEMBRANES" },
        { key: "Q010302", value: "DENTAL GRAFT DEVICES" },
        { key: "Q010303", value: "RETROGRADE FILLING DEVICES" },
        { key: "Q010304", value: "PERIODONTAL DRESSINGS" },
        { key: "Q010305", value: "SURGICAL DENTISTRY CEMENTS" },
        { key: "Q010399", value: "SURGICAL DENTAL DEVICES - OTHER" },
        { key: "Q0104", value: "ORTHODONTIC DEVICES" },
        { key: "Q010401", value: "ORTHODONTIC FACE BOWS" },
        { key: "Q010402", value: "ORTHODONTIC BANDS" },
        { key: "Q010403", value: "ORTHODONTIC BRACKETS AND BUTTONS" },
        { key: "Q010404", value: "ORTHODONTIC ELASTICS, CHAINS AND SPRINGS" },
        { key: "Q010405", value: "ORTHODONTIC WIRES" },
        { key: "Q010406", value: "ORTHODONTIC LIGATURES" },
        { key: "Q010407", value: "ORTHODONTIC CEMENTS" },
        { key: "Q010499", value: "ORTHODONTIC DEVICES - OTHER" },
        { key: "Q0105", value: "INSTRUMENTS FOR DENTISTRY, SINGLE-USE" },
        { key: "Q010501", value: "DENTAL BURS AND ABRASIVE DISKS, SINGLE-USE" },
        { key: "Q010502", value: "DENTAL POLISHING CUPS, SINGLE-USE" },
        { key: "Q010503", value: "IMPRESSION MATERIAL TRAYS, SINGLE-USE" },
        { key: "Q010504", value: "DENTISTRY MIRRORS AND STYLETS, SINGLE-USE" },
        { key: "Q010505", value: "AMALGAM APPLICATORS, SINGLE-USE" },
        { key: "Q010506", value: "PASTE APPLICATORS, SINGLE-USE" },
        { key: "Q010507", value: "ENDODONTIC INSTRUMENTS (CANAL ENLARGERS, FILES, RASPS, ETC.), SINGLE-USE" },
        { key: "Q010508", value: "DENTAL SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "Q010599", value: "DENTAL INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "Q0106", value: "MATERIALS FOR THE PREPARATION OF CUSTOM-MADE DENTAL DEVICES" },
        { key: "Q010601", value: "DENTAL ALLOYS" },
        { key: "Q010699", value: "MATERIALS FOR THE PREPARATION OF CUSTOM-MADE DENTAL DEVICES - OTHER" },
        { key: "Q0190", value: "DENTAL DEVICES - VARIOUS" },
        { key: "Q019001", value: "SALIVA ASPIRATORS AND SALIVA ABSORBENTS" },
        { key: "Q019002", value: "DENTISTRY DAMS AND HOOKS, SINGLE-USE" },
        { key: "Q019003", value: "DENTAL FLOSS AND OTHER DEVICES FOR ORAL HYGIENE (FOR PROFESSIONAL USE)" },
        { key: "Q019004", value: "DENTAL COTTON ROLLS" },
        { key: "Q019005", value: "CASTABLE DENTAL POSTS" },
        { key: "Q019006", value: "DENTAL MATERIAL APPLICATION TIPS AND BRUSHES, SINGLE-USE" },
        { key: "Q019007", value: "BUCCAL TOPICAL TREATMENT PREPARATIONS NOT INCLUDED IN OTHER CLASSES" },
        { key: "Q019008", value: "DENTINAL DESENSITISERS" },
        { key: "Q0199", value: "ODONTOLOGY DEVICES - OTHER" },
        { key: "Q02", value: "OPHTHALMIC DEVICES" },
        { key: "Q0201", value: "OPHTHALMIC MICROKNIVES AND CUTTING DEVICES" },
        { key: "Q020101", value: "OPHTHALMIC MICROKNIVES" },
        { key: "Q02010101", value: "OPHTHALMIC MICROKNIVES, STRAIGHT" },
        { key: "Q02010102", value: "OPHTHALMIC MICROKNIVES, ANGLED" },
        { key: "Q02010103", value: "OPHTHALMIC CALIBRATED MICROKNIVES, PHACO (UPPER SHARPENED BEVEL UP, DOUBLE EDGED, GLAZED)" },
        { key: "Q02010199", value: "OPHTHALMIC MICROKNIVES - OTHER" },
        { key: "Q020102", value: "SCLERAL SCALPELS" },
        { key: "Q020199", value: "OPHTHALMIC CUTTING DEVICES - OTHER" },
        { key: "Q0202", value: "DEVICES FOR CORNEA EXPLANTATION AND TRANSPLANTATION" },
        { key: "Q020201", value: "CORNEAL PUNCHES AND TREPHINES, SINGLE-USE" },
        { key: "Q020202", value: "CORNEAL DRILLS, SINGLE-USE (MECHANICAL AND HAND-ASSISTED)" },
        { key: "Q020203", value: "CORNEAL MARKERS" },
        { key: "Q020204", value: "CORNEAL EXPLANTS STORING AND TRANSPORT SUBSTANCES" },
        { key: "Q020299", value: "CORNEA EXPLANTATION AND TRANSPLANTATION DEVICES - OTHER" },
        { key: "Q0203", value: "GASEOUS, LIQUID AND VISCOELASTIC FLUIDS FOR OPHTHALMIC SURGERY AND CLINICAL OPHTHALMOLOGY" },
        { key: "Q020301", value: "OPHTHALMIC SURGERY, GASEOUS FLUIDS" },
        { key: "Q02030101", value: "INTRAOCULAR FLUORINATED DERIVATIVES" },
        { key: "Q02030199", value: "OPHTHALMIC SURGERY, GASEOUS FLUIDS – OTHER" },
        { key: "Q020302", value: "OPHTHALMOLOGY, LIQUID FLUIDS" },
        { key: "Q02030201", value: "OPHTHALMIC DYES" },
        { key: "Q02030202", value: "OPHTHALMIC SURGERY, SILICONE OILS, PURE AND COMBINED WITH OTHER SUBSTANCES" },
        { key: "Q02030203", value: "OPHTHALMIC SURGERY BALANCED SALINE SOLUTIONS" },
        { key: "Q02030204", value: "CONTACT LENSES STORING AND CLEANING SOLUTIONS" },
        { key: "Q02030205", value: "OPHTHALMIC SURGERY, PERFLUOROCARBONS PURE AND COMBINED WITH OTHER SUBSTANCES" },
        { key: "Q02030206", value: "EYE LUBRICANT SOLUTIONS" },
        { key: "Q02030299", value: "OPHTHALMOLOGY, LIQUID FLUIDS - OTHER" },
        { key: "Q020303", value: "OPHTHALMOLOGY, VISCOELASTIC FLUIDS" },
        { key: "Q02030301", value: "OPHTHALMOLOGY, HYALURONIC ACID AND DERIVATIVES" },
        { key: "Q02030399", value: "OPHTHALMOLOGY, VISCOELASTIC FLUIDS - OTHER" },
        { key: "Q0204", value: "VITRECTOMY DEVICES" },
        { key: "Q020401", value: "ANTERIOR VITRECTOMY SETS" },
        { key: "Q020402", value: "POSTERIOR VITRECTOMY SETS" },
        { key: "Q020403", value: "OPHTHALMOLOGY LASER THERAPY FIBERS, SINGLE-USE" },
        { key: "Q02040301", value: "OCULAR ENDOPHOTOCOAGULATION FIBERS, SINGLE-USE" },
        { key: "Q02040302", value: "OCULAR CYCLOPHOTOCOAGULATION FIBERS, SINGLE-USE" },
        { key: "Q02040399", value: "OPHTHALMOLOGY LASER THERAPY FIBERS, SINGLE-USE - OTHER" },
        { key: "Q020499", value: "VITRECTOMY DEVICES - OTHER" },
        { key: "Q0205", value: "RETINAL DETACHMENT DEVICES" },
        { key: "Q020501", value: "RETINAL CERCLAGE BANDS" },
        { key: "Q020502", value: "RETINAL DETACHMENT RAILS" },
        { key: "Q020503", value: "RETINAL SPONGES" },
        { key: "Q020504", value: "RETINAL DETACHMENT CLIPS, METALLIC" },
        { key: "Q020599", value: "RETINAL DETACHMENT DEVICES - OTHER" },
        { key: "Q0206", value: "PHACOEMULSIFICATION DEVICES" },
        { key: "Q020601", value: "PHACOEMULSIFICATION SETS" },
        { key: "Q020680", value: "PHACOEMULSIFICATION DEVICES - ACCESSORIES" },
        { key: "Q020699", value: "PHACOEMULSIFICATION DEVICES - OTHER" },
        { key: "Q0207", value: "LACRIMAL DUCT DEVICES" },
        { key: "Q020701", value: "LACRIMAL DUCT DILATORS" },
        { key: "Q020702", value: "LACRIMAL DUCT OCCLUDERS" },
        { key: "Q020703", value: "LACRIMAL DUCT PLUGS" },
        { key: "Q020704", value: "LACRIMAL TUBES, SETS" },
        { key: "Q020705", value: "LACRIMAL DYSFUNCTIONS, TESTS" },
        { key: "Q020706", value: "LACRIMAL TUBES, SILICONE" },
        { key: "Q020799", value: "LACRIMAL DUCT DEVICES - OTHER" },
        { key: "Q0208", value: "GLAUCOMA DRAINAGES AND KITS" },
        { key: "Q0209", value: "STRABISMUS DEVICES" },
        { key: "Q0210", value: "CORRECTIVE OPTICAL DEVICES" },
        { key: "Q021001", value: "OPHTHALMIC LENSES" },
        { key: "Q02100101", value: "ORGANIC OPHTHALMIC LENSES (PLASTIC MATERIALS)" },
        { key: "Q0210010101", value: "MONOFOCAL ORGANIC OPHTHALMIC LENSES" },
        { key: "Q0210010102", value: "MULTIFOCAL ORGANIC OPHTHALMIC LENSES (BIFOCAL, TRIFOCAL)" },
        { key: "Q0210010103", value: "PROGRESSIVE ORGANIC OPHTHALMIC LENSES" },
        { key: "Q0210010199", value: "ORGANIC OPHTHALMIC LENSES - OTHER" },
        { key: "Q02100102", value: "MINERAL OPHTHALMIC LENSES (GLASS)" },
        { key: "Q0210010201", value: "MONOFOCAL MINERAL OPHTHALMIC LENSES" },
        { key: "Q0210010202", value: "MULTIFOCAL MINERAL OPHTHALMIC LENSES (BIFOCAL, TRIFOCAL)" },
        { key: "Q0210010203", value: "PROGRESSIVE MINERAL OPHTHALMIC LENSES" },
        { key: "Q0210010299", value: "MINERAL OPHTHALMIC LENSES - OTHER" },
        { key: "Q021002", value: "SPECTACLE FRAMES WITHOUT LENSES" },
        { key: "Q02100201", value: "METAL SPECTACLE FRAMES WITHOUT LENSES" },
        { key: "Q02100202", value: "PLASTIC SPECTACLE FRAMES WITHOUT LENSES" },
        { key: "Q02100203", value: "METAL AND PLASTIC SPECTACLE FRAMES WITHOUT LENSES" },
        { key: "Q02100299", value: "SPECTACLE FRAMES WITHOUT LENSES - OTHER" },
        { key: "Q021003", value: "READY TO WEAR SPECTACLES" },
        { key: "Q02100301", value: "READY TO WEAR SPECTACLES WITH ORGANIC LENSES" },
        { key: "Q0210030101", value: "READY TO WEAR METAL SPECTACLES WITH ORGANIC LENSES" },
        { key: "Q0210030102", value: "READY TO WEAR PLASTIC SPECTACLES WITH ORGANIC LENSES" },
        { key: "Q0210030103", value: "READY TO WEAR METAL AND PLASTIC SPECTACLES WITH ORGANIC LENSES" },
        { key: "Q0210030199", value: "READY TO WEAR SPECTACLES WITH ORGANIC LENSES - OTHER" },
        { key: "Q02100302", value: "READY TO WEAR SPECTACLES WITH MINERAL LENSES" },
        { key: "Q0210030201", value: "READY TO WEAR METAL SPECTACLES WITH MINERAL LENSES" },
        { key: "Q0210030202", value: "READY TO WEAR PLASTIC SPECTACLES WITH MINERAL LENSES" },
        { key: "Q0210030203", value: "READY TO WEAR METAL AND PLASTIC SEPECTACLES WITH MINERAL LENSES" },
        { key: "Q0210030299", value: "READY TO WEAR SPECTACLES WITH MINERAL LENSES - OTHER" },
        { key: "Q021004", value: "CONTACT LENSES" },
        { key: "Q02100401", value: "CONTACT LENSES - HYDROGEL" },
        { key: "Q0210040101", value: "CONTACT LENSES - HYDROGEL, SINGLE-USE" },
        { key: "Q021004010101", value: "CONTACT LENSES - HYDROGEL, DAILY SINGLE-USE" },
        { key: "Q021004010102", value: "CONTACT LENSES - HYDROGEL, EXTENDED SINGLE-USE" },
        { key: "Q0210040102", value: "CONTACT LENSES - HYDROGEL, REUSABLE" },
        { key: "Q02100402", value: "CONTACT LENSES - NON HYDROGEL" },
        { key: "Q02100499", value: "CONTACT LENSES - OTHER" },
        { key: "Q021099", value: "CORRECTIVE OPTICAL DEVICES - OTHER" },
        { key: "Q0211", value: "OPHTHALMIC SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "Q021101", value: "OCCULAR IRRIGATION AND ASPIRATION CANNULAS, SINGLE-USE" },
        { key: "Q021102", value: "OPHTHALMIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "Q021103", value: "OPHTHALMIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "Q021104", value: "OPHTHALMIC SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "Q021105", value: "OPHTHALMIC SURGERY NEEDLE HOLDERS, SINGLE-USE" },
        { key: "Q021106", value: "OPHTHALMIC SURGERY DILATORS, SINGLE-USE" },
        { key: "Q021107", value: "OPHTHALMIC SURGERY RETRACTORS, SINGLE-USE" },
        { key: "Q021108", value: "OPHTHALMIC SURGERY PROBES, SINGLE-USE" },
        { key: "Q021109", value: "OPHTHALMIC SURGERY SPATULAS, SINGLE-USE" },
        { key: "Q021110", value: "OPHTHALMIC SURGERY SPOONS, SINGLE-USE" },
        { key: "Q021111", value: "OCULAR IMPLANT INSTRUMENTS, SINGLE-USE" },
        { key: "Q021112", value: "OCULAR ADNEXA INSTRUMENTS, SINGLE-USE" },
        { key: "Q021113", value: "OPHTHALMIC SURGERY INSTRUMENT KITS, SINGLE-USE" },
        { key: "Q021199", value: "OPHTHALMIC SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "Q0290", value: "OPHTHALMIC DEVICES - VARIOUS" },
        { key: "Q029001", value: "RIGID MONOCULAR MASKS" },
        { key: "Q029002", value: "OPHTHALMOLOGICAL DIAGNOSTIC ELECTRODES, SINGLE-USE" },
        { key: "Q029003", value: "CORNEAL PROTECTION MECHANICAL DEVICES" },
        { key: "Q0299", value: "OPHTHALMIC DEVICES - OTHER" },
        { key: "Q03", value: "ENT DEVICES" },
        { key: "Q0301", value: "NASOPHARYNGEAL DEVICES" },
        { key: "Q030101", value: "TURBINATE REDUCTION DEVICES" },
        { key: "Q03010101", value: "RADIOFREQUENCY TURBINATE REDUCTION DEVICES " },
        { key: "Q03010199", value: "DEVICES FOR TURBINATE REDUCTION - OTHER" },
        { key: "Q030102", value: "ANTISNORING AND OBSTRUCTIVE SLEEP APNOEA DEVICES" },
        { key: "Q03010201", value: "RADIOFREQUENCY ANTISNORING AND OBSTRUCTIVE SLEEP APNOEA DEVICES" },
        { key: "Q03010299", value: "ANTISNORING AND OBSTRUCTIVE SLEEP APNOEA DEVICES - OTHER" },
        { key: "Q030103", value: "NASAL IRRIGATION SOLUTIONS" },
        { key: "Q030199", value: "NASOPHARYNGEAL DEVICES - OTHER" },
        { key: "Q0302", value: "EPISTAXIS DEVICES" },
        { key: "Q030201", value: "EPISTAXIS CATHETERS" },
        { key: "Q030299", value: "EPISTAXIS DEVICES - OTHER" },
        { key: "Q0303", value: "ENT SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "Q030301", value: "ENT SURGERY BLADES, SINGLE-USE" },
        { key: "Q030302", value: "ENT SURGERY BURS AND HANDPIECES, SINGLE-USE" },
        { key: "Q030303", value: "NASAL MIRRORS, SINGLE-USE" },
        { key: "Q030304", value: "ENT SURGERY FORCEPS, SINGLE-USE" },
        { key: "Q030305", value: "ENT SURGERY SCISSORS, SINGLE-USE" },
        { key: "Q030306", value: "ENT SURGERY CURETTES, SINGLE-USE" },
        { key: "Q030307", value: "ENT SURGERY DISSECTORS, SINGLE-USE" },
        { key: "Q030308", value: "ENT SURGERY DILATORS, SINGLE-USE" },
        { key: "Q030309", value: "ADENOTOMES, SINGLE-USE" },
        { key: "Q030310", value: "ENT SURGERY HOOKS, SINGLE-USE" },
        { key: "Q030311", value: "ENT SURGERY RASPS AND FILES, SINGLE-USE" },
        { key: "Q030312", value: "ENT SURGERY SPATULAS, SINGLE-USE" },
        { key: "Q030313", value: "ENT SURGERY PROBES, SINGLE-USE" },
        { key: "Q030314", value: "ENT SURGERY SPOONS, SINGLE-USE" },
        { key: "Q030315", value: "ENT SURGERY MANIPULATORS, SINGLE-USE" },
        { key: "Q030316", value: "ENT SURGERY INSTRUMENT KITS NOT INCLUDED IN OTHER CLASSES, SINGLE-USE" },
        { key: "Q030399", value: "INSTRUMENTS FOR ENT SURGERY, SINGLE-USE - OTHER" },
        { key: "Q0304", value: "OTOLOGY DEVICES" },
        { key: "Q030401", value: "EAR DRAINAGE AND VENTILATION DEVICES" },
        { key: "Q03040101", value: "EAR DRAINAGE AND VENTILATION CATHETERS AND CANNULAS" },
        { key: "Q03040102", value: "ENDOLYMPHATIC SHUNTS" },
        { key: "Q03040199", value: "EAR DRAINAGE AND VENTILATION DEVICES - OTHER" },
        { key: "Q030402", value: "EAR IRRIGATION DEVICES" },
        { key: "Q03040201", value: "EAR DROPPERS" },
        { key: "Q03040299", value: "EAR IRRIGATION DEVICES - OTHER" },
        { key: "Q030499", value: "OTOLOGY DEVICES - OTHER" },
        { key: "Q0399", value: "ENT DEVICES - OTHER" },
        { key: "R", value: "RESPIRATORY AND ANAESTHESIA DEVICES" },
        { key: "R01", value: "INTUBATION DEVICES" },
        { key: "R0101", value: "NASO-OROPHARYNGEAL TUBES" },
        { key: "R010101", value: "NASOPHARYNGEAL TUBES" },
        { key: "R010102", value: "GUEDEL AIRWAY TUBES" },
        { key: "R010199", value: "NASO-OROPHARYNGEAL TUBES - OTHER" },
        { key: "R0102", value: "LARYNGEAL MASKS AND TUBES" },
        { key: "R010201", value: "LARYNGEAL MASKS" },
        { key: "R01020101", value: "LARYNGEAL MASKS, SINGLE-LUMEN" },
        { key: "R01020102", value: "LARYNGEAL MASKS, DOUBLE-LUMEN" },
        { key: "R01020199", value: "LARYNGEAL MASKS - OTHER" },
        { key: "R010202", value: "LARYNGEAL TUBES" },
        { key: "R010203", value: "LARYNGEAL KITS" },
        { key: "R010280", value: "LARYNGEAL MASKS AND TUBES - ACCESSORIES" },
        { key: "R010299", value: "LARYNGEAL MASKS AND TUBES - OTHER" },
        { key: "R0103", value: "ENDOTRACHEAL TUBES" },
        { key: "R010301", value: "ENDOTRACHEAL TUBES, CUFFLESS" },
        { key: "R01030101", value: "ENDOTRACHEAL TUBES, CUFFLESS, NOT REINFORCED" },
        { key: "R01030102", value: "ENDOTRACHEAL TUBES, CUFFLESS, REINFORCED" },
        { key: "R010302", value: "ENDOTRACHEAL TUBES, CUFFED" },
        { key: "R01030201", value: "ENDOTRACHEAL TUBES, CUFFED, NOT REINFORCED" },
        { key: "R01030202", value: "ENDOTRACHEAL TUBES, CUFFED, REINFORCED" },
        { key: "R010380", value: "ENDOTRACHEAL TUBES - ACCESSORIES" },
        { key: "R01038001", value: "ENDOTRACHEAL TUBE CUFFS INFLATION SYSTEMS" },
        { key: "R01038099", value: "ENDOTRACHEAL TUBES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R010399", value: "ENDOTRACHEAL TUBES - OTHER" },
        { key: "R0104", value: "ENDOBRONCHIAL TUBES" },
        { key: "R010401", value: "ENDOBRONCHIAL TUBES, RIGHT" },
        { key: "R01040101", value: "ENDOBRONCHIAL TUBES, RIGHT, SINGLE-LUMEN" },
        { key: "R01040102", value: "ENDOBRONCHIAL TUBES, RIGHT, DOUBLE-LUMEN" },
        { key: "R01040103", value: "ENDOBRONCHIAL TUBES, RIGHT, DOUBLE-LUMEN, TRACHEOSTOMY" },
        { key: "R01040199", value: "ENDOBRONCHIAL TUBES, RIGHT - OTHER" },
        { key: "R010402", value: "ENDOBRONCHIAL TUBES, LEFT" },
        { key: "R01040201", value: "ENDOBRONCHIAL TUBES, LEFT, SINGLE-LUMEN" },
        { key: "R01040202", value: "ENDOBRONCHIAL TUBES, LEFT, DOUBLE-LUMEN" },
        { key: "R01040203", value: "ENDOBRONCHIAL TUBES, LEFT, DOUBLE-LUMEN, TRACHEOSTOMY" },
        { key: "R01040299", value: "ENDOBRONCHIAL TUBES, LEFT - OTHER" },
        { key: "R010480", value: "ENDOBRONCHIAL TUBES - ACCESSORIES" },
        { key: "R010499", value: "ENDOBRONCHIAL TUBES - OTHER" },
        { key: "R0105", value: "TRACHEOSTOMY AND LARINGECTOMY CANNULAS" },
        { key: "R010501", value: "TRACHEOSTOMY AND LARINGECTOMY CANNULAS AND KITS, UNCUFFED" },
        { key: "R01050101", value: "TRACHEOSTOMY CANNULAS, CUFFLESS, NOT REINFORCED, AND KITS" },
        { key: "R0105010101", value: "TRACHEOSTOMIC CANNULAS, CUFFLESS, NOT REINFORCED, WITH FIXED FLANGE, AND KITS" },
        { key: "R0105010102", value: "TRACHEOSTOMIC CANNUALS, CUFFLESS, NOT REINFORCED, WITH ADJUSTABLE FLANGE, AND KITS" },
        { key: "R01050102", value: "TRACHEOSTOMIC CANNULAS, CUFFLESS, REINFORCED, AND KITS" },
        { key: "R0105010201", value: "TRACHEOSTOMIC CANNULAS, CUFFLESS, REINFORCED, WITH FIXED FLANGE, AND KITS" },
        { key: "R0105010202", value: "TRACHEOSTOMIC CANNULAS, CUFFLESS, REINFORCED, WITH ADJUSTABLE FLANGE, AND KITS" },
        { key: "R010502", value: "TRACHEOSTOMY AND LARINGECTOMY CANNULAS AND KITS, CUFFED" },
        { key: "R01050201", value: "TRACHEOSTOMY CANNULAS, CUFFED, NOT REINFORCED, AND KITS" },
        { key: "R0105020101", value: "TRACHEOSTOMIC CANNULAS, CUFFED, NOT REINFORCED, WITH FIXED FLANGE, AND KITS" },
        { key: "R0105020102", value: "TRACHEOSTOMIC CANNULAS, CUFFED, NOT REINFORCED, WITH ADJUSTABLE FLANGE, AND KITS" },
        { key: "R01050202", value: "TRACHEOSTOMY CANNULAS, CUFFED, REINFORCED, AND KITS" },
        { key: "R0105020201", value: "TRACHEOSTOMIC CANNULAS, CUFFED, REINFORCED, WITH FIXED FLANGE, AND KITS" },
        { key: "R0105020202", value: "TRACHEOSTOMIC CANNULAS, CUFFED, REINFORCED, WITH ADJUSTABLE FLANGE, AND KITS" },
        { key: "R010503", value: "TRACHEOSTOMY INNER CANNULAS" },
        { key: "R010580", value: "TRACHEOSTOMY AND LARINGECTOMY CANNULAS - ACCESSORIES" },
        { key: "R01058001", value: "TRACHEOSTOMIC CANNULAS SUPPORTS" },
        { key: "R01058002", value: "TRACHEOSTOMY FILTERS" },
        { key: "R01058099", value: "TRACHEOSTOMY AND LARYNGECTOMY CANNULAS - VARIOUS ACCESSORIES" },
        { key: "R010599", value: "TRACHEOSTOMY AND LARYNGECTOMY CANNULAS - OTHER" },
        { key: "R0106", value: "PERCUTANEOUS TRACHEOSTOMY KITS" },
        { key: "R010601", value: "CIAGLIA TRACHEOSTOMY KITS" },
        { key: "R010602", value: "FANTONI TRACHEOSTOMY KITS" },
        { key: "R010603", value: "GRIGGS TRACHEOSTOMY KITS" },
        { key: "R010604", value: "SELDINGER TRACHEOSTOMY KITS" },
        { key: "R010699", value: "PERCUTANEOUS TRACHEOSTOMY KITS - OTHER" },
        { key: "R0180", value: "INTUBATION DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R018001", value: "INTUBATION DEVICE SPINDLES" },
        { key: "R018002", value: "INTUBATION DEVICE SUPPORTS" },
        { key: "R018003", value: "CARBON DIOXIDE ABSORBERS" },
        { key: "R018004", value: "INTUBATION DEVICE GUIDES" },
        { key: "R018099", value: "INTUBATION DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R0199", value: "INTUBATION DEVICES - OTHER" },
        { key: "R02", value: "BREATHING CIRCUITS AND CATHETER MOUNTS" },
        { key: "R0201", value: "RESPIRATORY CIRCUITS AND KITS" },
        { key: "R020101", value: "STANDARD BREATHING CIRCUITS" },
        { key: "R02010101", value: "BREATHING CIRCUITS, W/O WATER TRAP" },
        { key: "R02010102", value: "BREATHING CIRCUITS, WITH WATER TRAP" },
        { key: "R02010199", value: "STANDARD BREATHING CIRCUITS - OTHER" },
        { key: "R020102", value: "COAXIAL BREATHING CIRCUITS" },
        { key: "R020103", value: "INSULATED BREATHING CIRCUITS" },
        { key: "R020104", value: "CPAP AND NIV BREATHING CIRCUITS" },
        { key: "R02010401", value: "CPAP CIRCUITS" },
        { key: "R02010402", value: "NIV CIRCUITS" },
        { key: "R020106", value: "IPPB CIRCUITS" },
        { key: "R020107", value: "THERMOREGULATED BREATHING CIRCUITS" },
        { key: "R020108", value: "RESPIRATORY GAS MONITORING AND SAMPLING CIRCUITS AND KITS" },
        { key: "R020109", value: "SPIROMETRY CIRCUITS AND KITS" },
        { key: "R020199", value: "BREATHING CIRCUITS AND KITS - OTHER" },
        { key: "R0202", value: "CATHETER MOUNTS" },
        { key: "R020201", value: "FIXED CATHETER MOUNTS" },
        { key: "R020202", value: "MOBILE CATHETER MOUNTS" },
        { key: "R020299", value: "MOUNT CATHETERS - OTHER" },
        { key: "R0203", value: "ANAESTHESIA AND RESUSCITATION CONNECTORS" },
        { key: "R020301", value: "RESPIRATORY CIRCUITS CONNECTION PIPES" },
        { key: "R020302", value: "RESPIRATORY CIRCUITS ADAPTERS AND CONNECTORS" },
        { key: "R020399", value: "ANESTHESIA AND RESUSCITATION CONNECTORS - OTHER" },
        { key: "R0280", value: "BREATHING CIRCUITS AND CATHETER MOUNTS - ACCESSORIES" },
        { key: "R028001", value: "RESPIRATORY CIRCUITS VALVES" },
        { key: "R028002", value: "RESPIRATORY CIRCUITS SUPPORTS" },
        { key: "R028003", value: "RESPIRATORY CIRCUITS WATER TRAPS" },
        { key: "R028099", value: "RESPIRATORY CIRCUITS AND MOUNT CATHETERS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R03", value: "RESPIRATORY MASKS AND BALLOONS, SINGLE-USE AND REUSABLE" },
        { key: "R0301", value: "RESPIRATORY MASKS" },
        { key: "R030101", value: "VENTILATION MASKS" },
        { key: "R03010101", value: "ANAESTHETIC FACE MASKS" },
        { key: "R03010102", value: "CPAP AND NIV MASKS" },
        { key: "R0301010201", value: "CPAP MASKS" },
        { key: "R0301010202", value: "NIV MASKS" },
        { key: "R03010104", value: "CPAP AND NIV HELMETS AND KITS" },
        { key: "R0301010401", value: "CPAP HELMETS AND KITS" },
        { key: "R0301010402", value: "NIV HELMETS AND KITS" },
        { key: "R03010180", value: "ARTIFICIAL VENTILATION MASKS - ACCESSORIES" },
        { key: "R03010199", value: "VENTILATION MASKS - OTHER" },
        { key: "R030102", value: "AIR/OXYGEN MASKS AND NASAL CANNULAS" },
        { key: "R03010201", value: "AIR/OXYGEN MASKS" },
        { key: "R03010202", value: "VENTURI MASKS" },
        { key: "R03010203", value: "OXYGEN THERAPY NASAL CANNULAS" },
        { key: "R0301020301", value: "OXYGEN THERAPY STANDARD NASAL CANNULAS (GOGGLES)" },
        { key: "R0301020302", value: "HIGH FLOW THERAPY NASAL CANNULAS (HFNC)" },
        { key: "R03010204", value: "OXYGEN ADMINISTRATION TUBINGS" },
        { key: "R03010205", value: "TRACHEOSTOMY O2 SUPPLIERS" },
        { key: "R03010206", value: "MASKS WITH RESERVOIR" },
        { key: "R03010207", value: "OXYGEN THERAPY KITS" },
        { key: "R03010280", value: "OXYGEN THERAPY MASKS AND NASAL CANNULAS - ACCESSORIES" },
        { key: "R03010299", value: "OXYGEN THERAPY MASKS AND NASAL CANNULAS - OTHER" },
        { key: "R030103", value: "AEROSOL THERAPY MASKS AND SYSTEMS" },
        { key: "R03010301", value: "AEROSOL THERAPY MASKS" },
        { key: "R03010302", value: "AEROSOL PORTABLE INHALERS" },
        { key: "R03010303", value: "AEROSOL THERAPY TUBINGS" },
        { key: "R03010304", value: "AEROSOL THERAPY KITS" },
        { key: "R03010380", value: "AEROSOL THERAPY SYSTEMS - ACCESSORIES" },
        { key: "R03010399", value: "AEROSOL THERAPY SYSTEMS - OTHER" },
        { key: "R030180", value: "RESPIRATORY MASKS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R030199", value: "RESPIRATORY MASKS - OTHER" },
        { key: "R0302", value: "RESPIRATORY BALLOONS" },
        { key: "R030201", value: "VENTILATION BALLOONS" },
        { key: "R03020101", value: "ANAESTHESIA BALLOONS" },
        { key: "R03020102", value: "CPAP BALLOONS" },
        { key: "R03020199", value: "VENTILATION BALLOONS - OTHER" },
        { key: "R030202", value: "MANUALLY OPERATED VENTILATION BALLOONS" },
        { key: "R03020201", value: "MANUALLY OPERATED PULMONARY RESUSCITATORS" },
        { key: "R03020202", value: "SELF-INFLATING VENTILATION BALLOONS" },
        { key: "R030280", value: "RESPIRATORY BALLONS - ACCESSORIES" },
        { key: "R030299", value: "RESPIRATORY BALLOONS - OTHER" },
        { key: "R04", value: "RESPIRATORY FILTERS" },
        { key: "R0401", value: "VENTILATION FILTERS" },
        { key: "R040101", value: "ANTIBACTERIAL AND ANTIVIRAL RESPIRATORY FILTERS" },
        { key: "R040102", value: "ANTIBACTERIAL AND ANTIVIRAL RESPIRATORY FILTERS HUMIDIFIERS" },
        { key: "R040199", value: "VENTILATION FILTERS - OTHER" },
        { key: "R0402", value: "NATURAL BREATHING FILTERS" },
        { key: "R040201", value: "TRACHEOSTOMY HUMIDIFIERS" },
        { key: "R040299", value: "NATURAL BREATHING FILTERS - OTHER" },
        { key: "R0490", value: "RESPIRATORY FILTERS - VARIOUS" },
        { key: "R049001", value: "PULMONARY FUNCTION TEST FILTERS" },
        { key: "R0499", value: "RESPIRATORY FILTERS - OTHER" },
        { key: "R05", value: "SUCTION AND DILATATION SYSTEMS FOR THE RESPIRATORY SYSTEM" },
        { key: "R0501", value: "RESPIRATORY SUCTION PROBES AND SYSTEMS" },
        { key: "R050101", value: "RESPIRATORY SUCTION PROBES" },
        { key: "R05010101", value: "RESPIRATORY SUCTION PROBES WITHOUT A CONTROL HOLE" },
        { key: "R05010102", value: "RESPIRATORY SUCTION PROBES WITH CONTROL HOLE" },
        { key: "R050102", value: "CLOSED-CIRCUIT RESPIRATORY SUCTION AND IRRIGATION SYSTEMS (NON-ENDOSCOPIC)" },
        { key: "R050103", value: "MUCOUS ASPIRATORS" },
        { key: "R05010301", value: "SINGLE-CHAMBER MUCOUS MEMBRANE ASPIRATORS" },
        { key: "R05010302", value: "DOUBLE-CHAMBER MUCOUS MEMBRANE ASPIRATORS" },
        { key: "R05010399", value: "MUCOSITY ASPIRATORS - OTHER" },
        { key: "R0502", value: "RESPIRATORY DILATION SYSTEMS" },
        { key: "R050201", value: "BRONCHIAL DILATION CATHETERS" },
        { key: "R050280", value: "RESPIRATORY TRACT EXPANSION SYSTEMS - ACCESSORIES" },
        { key: "R050299", value: "RESPIRATORY DILATION SYSTEMS - OTHER" },
        { key: "R0580", value: "RESPIRATORY SYSTEM SUCTION AND DILATATION SYSTEMS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R0599", value: "RESPIRATORY DEVICES, SUCTION AND DILATION SYSTEMS - OTHER" },
        { key: "R06", value: "NEBULISATION AND HUMIDIFICATION SYSTEMS" },
        { key: "R0601", value: "NEBULISATION SYSTEMS" },
        { key: "R060101", value: "COLD NEBULISATION SYSTEMS" },
        { key: "R060102", value: "HOT NEBULISATION SYSTEMS" },
        { key: "R0602", value: "HUMIDIFICATION SYSTEMS" },
        { key: "R060201", value: "ACTIVE VENTILATION HUMIDIFICATION SYSTEMS," },
        { key: "R060202", value: "OXYGEN ADMINISTRATION HUMIDIFICATION SYSTEMS" },
        { key: "R060203", value: "INHALATION THERAPY HUMIDIFICATION LIQUIDS" },
        { key: "R060280", value: "HUMIDIFICATION SYSTEMS - ACCESSORIES" },
        { key: "R060299", value: "HUMIDIFICATION SYSTEMS - OTHER" },
        { key: "R0680", value: "NEBULISATION AND HUMIDIFICATION SYSTEMS - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R0699", value: "NEBULISATION AND HUMIDIFICATION SYSTEMS - OTHER" },
        { key: "R07", value: "BRONCHOPULMONARY ENDOSCOPY DEVICES, SINGLE-USE" },
        { key: "R0701", value: "BRONCHOPULMONARY ENDOSCOPY PROBES, SINGLE-USE" },
        { key: "R070101", value: "BRONCHOSCOPY PROBES, SINGLE-USE" },
        { key: "R070102", value: "RESPIRATORY SYSTEM ENDOSCOPIC HEMOSTASIS PROBES, SINGLE-USE" },
        { key: "R070103", value: "BRONCHIAL ASPIRATION AND WASHING PROBES, SINGLE-USE" },
        { key: "R070180", value: "BRONCHOPULMONARY ENDOSCOPY PROBES, SINGLE-USE - ACCESSORIES" },
        { key: "R070199", value: "BRONCHOPULMONARY ENDOSCOPY PROBES, SINGLE-USE - OTHER" },
        { key: "R0702", value: "BRONCHOSCOPIC SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "R070201", value: "BRONCHOSCOPIC SURGERY FORCEPS, SINGLE-USE" },
        { key: "R07020101", value: "BRONCHOSCOPIC SURGERY BIOPTIC FORCEPS, SINGLE-USE" },
        { key: "R0702010101", value: "BRONCHOSCOPIC SURGERY COLD BIOPTIC FORCEPS, SINGLE-USE" },
        { key: "R0702010102", value: "BRONCHOSCOPIC SURGERY HOT BIOPTIC FORCEPS, SINGLE-USE" },
        { key: "R07020102", value: "BRONCHOSCOPIC SURGERY EXTRACTION FORCEPS, SINGLE-USE" },
        { key: "R07020199", value: "BRONCHOSCOPIC SURGERY FORCEPS, SINGLE-USE - OTHER" },
        { key: "R070203", value: "BRONCOPULMONARY ENDOSCOPY BRUSHES, SINGLE-USE" },
        { key: "R07020301", value: "BRONCOPULMONARY CYTOLOGY BRUSHES, SINGLE-USE" },
        { key: "R070204", value: "BRONCHOSCOPIC SURGERY DISSECTORS, SINGLE-USE" },
        { key: "R070205", value: "BRONCHOSCOPIC SURGERY SCISSORS, SINGLE-USE" },
        { key: "R070206", value: "BRONCHOSCOPIC SURGERY CURETTES, SINGLE-USE" },
        { key: "R070207", value: "BRONCHOSCOPIC SURGERY CANNULAS, SINGLE-USE" },
        { key: "R070208", value: "BRONCHOSCOPIC SURGERY KITS, SINGLE-USE" },
        { key: "R070280", value: "BRONCHOSCOPIC SURGERY INSTRUMENTS, SINGLE-USE - ACCESSORIES" },
        { key: "R070299", value: "BRONCHOSCOPIC SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "R0799", value: "BRONCOPULMONARY ENDOSCOPY DEVICES, SINGLE-USE - OTHER" },
        { key: "R90", value: "RESPIRATORY AND ANAESTHESIA DEVICES - VARIOUS" },
        { key: "R9001", value: "RESPIRATORY MOUTHPIECES" },
        { key: "R9002", value: "LARYNGOSCOPE BLADES, SINGLE-USE" },
        { key: "R9003", value: "RESPIRATORY SYSTEM SURGERY INSTRUMENTS, SINGLE-USE" },
        { key: "R900301", value: "RESPIRATORY SYSTEM SURGERY FORCEPS, SINGLE-USE" },
        { key: "R900302", value: "RESPIRATORY SYSTEM SURGERY DILATORS, SINGLE-USE" },
        { key: "R900399", value: "RESPIRATORY SYSTEM SURGERY INSTRUMENTS, SINGLE-USE - OTHER" },
        { key: "R9004", value: "PLEURAL TALCAGE DEVICES" },
        { key: "R9005", value: "ENDOBRONCHIAL VALVES AND RELEASE SYSTEMS" },
        { key: "R9006", value: "PHONATION VALVES" },
        { key: "R900602", value: "PHONATION VALVES FOR TRACHEOSTOMY" },
        { key: "R90060201", value: "PHONATION VALVES FOR TRACHEOSTOMY FOR VENTILATOR USE" },
        { key: "R90060202", value: "PHONATION VALVES FOR TRACHEOSTOMY NOT FOR VENTILATOR USE" },
        { key: "R900680", value: "PHONATION VALVES - ACCESSORIES" },
        { key: "R9007", value: "LUNG FUNCTIONALITY TESTING DEVICES, SINGLE-USE - NOT INCLUDED IN OTHER CLASSES" },
        { key: "R9008", value: "RESPIRATORY SYSTEM ACTIVE SUBSTANCES" },
        { key: "R9009", value: "RESPIRATORY THERAPY AIDS" },
        { key: "R900901", value: "INHALERS" },
        { key: "R900902", value: "INSPIRATORY AND EXPIRATORY FLOW STIMULATORS/RESPIRATORY MUSCLES TRAINERS" },
        { key: "R9080", value: "RESPIRATORY AND ANESTHESIA DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "R9099", value: "RESPIRATORY AND ANAESTHESIA DEVICES - OTHER" },
        { key: "S", value: "STERILISATION DEVICES (EXCLUDING CAT. D - Z) " },
        { key: "S01", value: "DEVICES FOR STERILISATION AND PACKAGING (EXCLUDING CAT. D - Z)" },
        { key: "S0101", value: "STERILISATION POUCHES" },
        { key: "S010101", value: "STERILISATION POUCHES, PAPER/PLASTIC FILM" },
        { key: "S01010101", value: "STERILISATION POUCHES, FLAT, PAPER/PLASTIC FILM" },
        { key: "S01010102", value: "STERILISATION POUCHES, GUSSETED, PAPER/PLASTIC FILM" },
        { key: "S010102", value: "STERILISATION POUCHES, TYVEK/PLASTIC FILM" },
        { key: "S01010201", value: "FLAT STERILISATION POUCHES, TYVEK/PLASTIC FILM" },
        { key: "S010103", value: "STERILISATION POUCHES, POLYETHYLENE" },
        { key: "S01010301", value: "FLAT STERILISATION POUCHES, POLYETHYLENE" },
        { key: "S010199", value: "STERILISATION POUCHES - OTHER" },
        { key: "S0102", value: "STERILISATION REELS" },
        { key: "S010201", value: "STERILISATION REELS, PAPER/PLASTIC FILM" },
        { key: "S01020101", value: "FLAT STERILISATION REELS, PAPER/PLASTIC FILM" },
        { key: "S01020102", value: "STERILISATION REELS, GUSSETED, PAPER/PLASTIC FILM" },
        { key: "S010202", value: "STERILISATION REELS, TYVEK/PLASTIC FILM" },
        { key: "S01020201", value: "FLAT STERILISATION REELS, TYVEK/PLASTIC FILM" },
        { key: "S010203", value: "STERILISATION REELS, POLYETHYLENE" },
        { key: "S01020301", value: "FLAT STERILISATION REELS, POLYETHYLENE" },
        { key: "S010299", value: "STERILISATION REELS - OTHER" },
        { key: "S0103", value: "MATERIALS FOR PACKAGING PACKS TO BE STERILIZED" },
        { key: "S010301", value: "MEDICAL CREPE PAPER FOR STERILISATION" },
        { key: "S010302", value: "NON-WOVEN FABRIC FOR STERILISATION" },
        { key: "S010399", value: "MATERIALS FOR PACKAGING PACKS TO BE STERILIZED - OTHER" },
        { key: "S0104", value: "CONTAINERS FOR STERILISATION" },
        { key: "S010401", value: "TRAYS, BASKETS, TUBS FOR STERILISATION AND THEIR COMPONENTS" },
        { key: "S010402", value: "FILTERS FOR STERILISATION CONTAINERS" },
        { key: "S010499", value: "STERILISATION CONTAINERS - OTHER" },
        { key: "S0199", value: "DEVICES FOR STERILISATION AND PACKAGING (EXCLUDING CAT. D - Z) - OTHER" },
        { key: "S90", value: "DEVICES FOR STERILISATION (EXCLUDING CAT. D - Z) - VARIOUS" },
        { key: "S9001", value: "DEVICES FOR GAS PLASMA STERILISATION (EXCLUDING CAT. D - Z)  " },
        { key: "S900101", value: "HYDROGEN PEROXIDE CARTRIDGES" },
        { key: "S900102", value: "HYDROGEN PEROXIDE DIFFUSERS" },
        { key: "S900103", value: "DIFFUSER ADAPTORS" },
        { key: "S900199", value: "DEVICES FOR GAS PLASMA STERILISATION (EXCLUDING CAT. D - Z) - OTHER" },
        { key: "S9002", value: "DEVICES FOR STERILISATION WITH PERACETIC ACID (EXCLUDING CAT. D - Z)  " },
        { key: "S9003", value: "DEVICES FOR STERILISATION WITH ETHYLENE OXIDE (EXCLUDING CAT. D - Z)  " },
        { key: "S9080", value: "DEVICES FOR STERILISATION (EXCLUDING CAT. D - Z) - ACCESSORIES" },
        { key: "S9099", value: "STERILISATION DEVICES (EXCLUDING CAT. D - Z) - OTHER" },
        { key: "T", value: "PATIENT PROTECTIVE EQUIPMENT AND INCONTINENCE AIDS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T01", value: "GLOVES (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0101", value: "SURGICAL GLOVES" },
        { key: "T010101", value: "LATEX SURGICAL GLOVES" },
        { key: "T01010101", value: "POWDERED LATEX SURGICAL GLOVES" },
        { key: "T01010102", value: "NON-POWDERED LATEX SURGICAL GLOVES" },
        { key: "T010102", value: "SYNTHETIC SURGICAL GLOVES" },
        { key: "T01010201", value: "POLYCHLOROPREN SURGICAL GLOVES" },
        { key: "T01010202", value: "NITRILE SURGICAL GLOVES" },
        { key: "T01010203", value: "POLYISOPREN SURGICAL GLOVES" },
        { key: "T01010299", value: "SYNTHETIC SURGICAL GLOVES - OTHER" },
        { key: "T010199", value: "SURGICAL GLOVES - OTHER" },
        { key: "T0102", value: "EXAMINATION / TREATMENT GLOVES" },
        { key: "T010201", value: "LATEX EXAMINATION / TREATMENT GLOVES" },
        { key: "T010202", value: "SYNTHETIC EXAMINATION / TREATMENT GLOVES" },
        { key: "T01020201", value: "VINYL EXAMINATION / TREATMENT GLOVES" },
        { key: "T01020202", value: "POLYETHYLENE EXAMINATION / TREATMENT GLOVES" },
        { key: "T01020203", value: "POLYCHLOROPREN EXAMINATION / TREATMENT GLOVES" },
        { key: "T01020204", value: "NITRILE EXAMINATION / TREATMENT GLOVES" },
        { key: "T01020299", value: "SYNTHETIC EXAMINATION / TREATMENT GLOVES - OTHER" },
        { key: "T010299", value: "EXAMINATION / TREATMENT GLOVES - OTHER" },
        { key: "T0199", value: "GLOVES - OTHER" },
        { key: "T02", value: "PROTECTIVE CLOTHING AND DRAPES (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0201", value: "SURGICAL DRAPES" },
        { key: "T020101", value: "INCISION DRAPES" },
        { key: "T02010101", value: "INCISION DRAPES, WITHOUT ANTIBACTERIAL AGENT" },
        { key: "T02010102", value: "INCISION DRAPES, WITH ANTIBACTERIAL AGENT" },
        { key: "T020102", value: "SPECIALISTIC SURGERY DRAPES" },
        { key: "T020103", value: "SURGICAL THERMAL DRAPES" },
        { key: "T020199", value: "SURGICAL DRAPES - OTHER" },
        { key: "T0202", value: "SURGICAL PROCEDURAL KITS (EXCLUDING SURGICAL INSTRUMENT KITS)" },
        { key: "T0203", value: "DRESSING AND ASSISTANCE KITS" },
        { key: "T0204", value: "SURGICAL GOWNS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T020401", value: "STANDARD SURGICAL GOWNS" },
        { key: "T020402", value: "REINFORCED SURGICAL GOWNS" },
        { key: "T020499", value: "SURGICAL GOWNS - OTHER" },
        { key: "T0205", value: "NON-SURGICAL GOWNS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0206", value: "MEDICAL USE FACE MASKS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T020603", value: "MEDICAL USE FACE MASKS, TYPE I (NOT FOR HEALTHCARE PROFESSIONALS)" },
        { key: "T020604", value: "MEDICAL USE FACE MASKS, TYPE II AND IIR" },
        { key: "T020699", value: "MEDICAL USE FACE MASKS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE) - OTHER" },
        { key: "T0207", value: "CAPS AND HEADWEAR (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0208", value: "SHOE COVERS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0209", value: "SURGICAL APRONS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE)" },
        { key: "T0210", value: "NON-SURGICAL DRAPES" },
        { key: "T0299", value: "PROTECTION DRAPES AND GARMENTS - OTHER" },
        { key: "T03", value: "PROTECTIONS (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT PPE)" },
        { key: "T0301", value: "INSTRUMENTS AND EQUIPMENT COVERS" },
        { key: "T030101", value: "COVER CAPS, INSTRUMENTS AND EQUIPMENT" },
        { key: "T030102", value: "COVER SHEATHS, INSTRUMENTS AND EQUIPMENTS" },
        { key: "T030103", value: "ATRAUMATIC INSERTS FOR INSTRUMENTS" },
        { key: "T030199", value: "COVERS, INSTRUMENTS AND EQUIPMENT - OTHER" },
        { key: "T0302", value: "ROBOTIC SURGERY COVERS" },
        { key: "T030201", value: "MECHANICAL ARMS COVERS" },
        { key: "T030202", value: "CAMERAS COVERS" },
        { key: "T030203", value: "OPTICS COVERS" },
        { key: "T030299", value: "ROBOTIC SURGERY COVERS - OTHER" },
        { key: "T0303", value: "NON-SURGICAL HEATING COVERS" },
        { key: "T030301", value: "AIR FLOW BLANKETS" },
        { key: "T030399", value: "HEATING COVERS - OTHER" },
        { key: "T0304", value: "RADIOTHERAPY PROTECTION DEVICES" },
        { key: "T030401", value: "RADIOTHERAPY PROTECTION MASKS " },
        { key: "T030402", value: "RADIOTHERAPY PROTECTION SHEATHS" },
        { key: "T030403", value: "RADIOTHERAPY PROTECTIVE SCREENS" },
        { key: "T030404", value: "RADIOTHERAPY PROTECTIVE DRAPES" },
        { key: "T030405", value: "RADIOTHERAPY EYE PROTECTION" },
        { key: "T030406", value: "LEAD HANDS" },
        { key: "T030499", value: "RADIOTHERAPY PROTECTION DEVICES - OTHER" },
        { key: "T0305", value: "HEALTH SERVICE PREMISES PROTECTION DEVICES" },
        { key: "T030501", value: "OPERATION ROOMS AND VISIT ROOMS HYGIENIC COVERS" },
        { key: "T030502", value: "BED AND STRETCHER HYGIENIC COVERS" },
        { key: "T030599", value: "HEALTH SERVICE PREMISES PROTECTION DEVICES - OTHER" },
        { key: "T0306", value: "PATIENT PROTECTION DEVICES DURING CLINICAL PROCEDURES" },
        { key: "T0399", value: "PROTECTION DEVICES (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT PPE) - OTHER" },
        { key: "T04", value: "INCONTINENCE DEVICES" },
        { key: "T0401", value: "URINE ABSORBING DEVICES" },
        { key: "T040101", value: "INCONTINENCE NAPPIES" },
        { key: "T04010101", value: "RECTANGULAR INCONTINENCE NAPPIES" },
        { key: "T04010102", value: "SHAPED INCONTINENCE NAPPIES" },
        { key: "T04010103", value: "INCONTINENCE NAPPIES WITH INTEGRATED FIXING SYSTEM" },
        { key: "T04010104", value: "NET PANTS" },
        { key: "T04010199", value: "INCONTINENCE NAPPIES - OTHER" },
        { key: "T040102", value: "ABSORBENT BED PADS" },
        { key: "T04010201", value: "UNTUCKABLE UNDERPADS" },
        { key: "T04010202", value: "TUCKABLE UNDERPADS" },
        { key: "T04010203", value: "ABSORBENT ANTIMICROBIAL UNDERPADS" },
        { key: "T04010299", value: "ABSORBENT UNDERPADS - OTHER" },
        { key: "T0499", value: "INCONTINENCE DEVICES - OTHER" },
        { key: "T99", value: "PROTECTIVE DEVICES AND AIDS FOR INCONTINENCE (EXCLUDING PERSONAL PROTECTIVE EQUIPMENT - PPE) - OTHER" },
        { key: "U", value: "DEVICES FOR UROGENITAL SYSTEM" },
        { key: "U01", value: "URETHRAL, PROSTATIC AND BLADDER CATHETERS" },
        { key: "U0101", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, WITHOUT BALLOON" },
        { key: "U010101", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, CONICAL-OLIVARY TIP (URETHRAL CALIBRATION)" },
        { key: "U010102", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, COUVELAIRE" },
        { key: "U010103", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, MALECOT" },
        { key: "U010104", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, MERCIER" },
        { key: "U010105", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, NELATON" },
        { key: "U01010501", value: "NELATON CATHETERS, SELF-LUBRICATING" },
        { key: "U01010502", value: "NELATON CATHETERS, NON SELF-LUBRICATING" },
        { key: "U010106", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, TIEMANN" },
        { key: "U01010601", value: "TIEMANN CATHETERS, SELF-LUBRICATING" },
        { key: "U01010602", value: "TIEMANN CATHETERS, NON SELF-LUBRICATING" },
        { key: "U010107", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, PEZZER" },
        { key: "U010199", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, NOT SELF-RETAINED - OTHER" },
        { key: "U0102", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, WITH BALLOON" },
        { key: "U010201", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, NELATON, WITH BALLOON" },
        { key: "U010202", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, COUVELAIRE, WITH BALLOON" },
        { key: "U010203", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, DELINOTTE, WITH BALLOON" },
        { key: "U010204", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, DUFOUR, WITH BALLOON" },
        { key: "U010205", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, MERCIER, WITH BALLOON" },
        { key: "U010206", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, TIEMANN WITH BALLOON" },
        { key: "U010299", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS, WITH BALLOON - OTHER" },
        { key: "U0103", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS WITH TEMPERATURE SENSORS" },
        { key: "U0180", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS - ACCESSORIES" },
        { key: "U0199", value: "URETHRAL PROSTATIC AND BLADDER CATHETERS - OTHER" },
        { key: "U02", value: "URETERAL CATHETERS AND STENTS" },
        { key: "U0201", value: "URETERAL CATHETERS WITHOUT BALLOON" },
        { key: "U020101", value: "URETERAL CATHETERS WITH CYLINDRICAL TIP" },
        { key: "U020102", value: "URETERALCATHETERS WITH OPEN FLUTE BEAK TIP" },
        { key: "U020103", value: "URETERAL CATHETERS WITH CHEVASSU TIP" },
        { key: "U020104", value: "URETERAL CATHETERS WITH OLIVARE TIP" },
        { key: "U020199", value: "URETERAL CATHETERS WITHOUT BALLOON - OTHER" },
        { key: "U0202", value: "URETERAL CATHETERS WITH BALLOON" },
        { key: "U020201", value: "URETERAL CATHETERS FOR OCCLUSION" },
        { key: "U020202", value: "URETERAL CATHETERS WITH FLUTE TIP WITH BALLOON" },
        { key: "U020299", value: "URETERAL CATHETERS WITH BALLOON - OTHER" },
        { key: "U0203", value: "URETERAL STENTS" },
        { key: "U020301", value: "SINGLE LOOP URETERAL STENTS" },
        { key: "U020302", value: "DOUBLE LOOP URETERAL STENTS" },
        { key: "U020399", value: "URETERAL STENTS - OTHER" },
        { key: "U0204", value: "TRANSILLUMINATING URETERAL CATHETERS" },
        { key: "U0280", value: "URETERAL CATHETERS AND STENTS - ACCESSORIES" },
        { key: "U0299", value: "URETERAL CATHETERS - OTHER" },
        { key: "U03", value: "DEVICES FOR URETHRAL, URETERAL AND NEPHROSTOMIC DILATION" },
        { key: "U0301", value: "DEVICES FOR RIGID DILATION OF THE URINARY TRACT" },
        { key: "U030101", value: "SEQUENTIAL DILATORS FOR PERCUTANEOUS NEPHROSTOMY" },
        { key: "U03010101", value: "AMPLATZ CANNULAS FOR URINARY DILATION" },
        { key: "U03010199", value: "PERCUTANEOUS NEPHROSTOMY, SEQUENTIAL DILATORS - OTHER" },
        { key: "U030102", value: "URETHRAL AND URETERAL DILATORS" },
        { key: "U03010201", value: "URETHRAL DILATORS" },
        { key: "U03010202", value: "URETERAL DILATORS" },
        { key: "U0302", value: "DEVICES FOR PNEUMATIC DILATION OF THE URINARY TRACT" },
        { key: "U030201", value: "URETHRAL DILATORS, WITH BALLOON" },
        { key: "U030202", value: "URETERAL DILATORS, WITH BALLOON" },
        { key: "U0380", value: "DEVICES FOR URINARY TRACT DILATION - ACCESSORIES" },
        { key: "U0399", value: "DEVICES FOR URINARY TRACT DILATION - OTHER" },
        { key: "U04", value: "DEVICES FOR PERCUTANEOUS URINARY DRAINAGE AND NEPHROSTOMY CATHETERS" },
        { key: "U0401", value: "DEVICES FOR SUPRAPUBIC URINARY DRAINAGE" },
        { key: "U040101", value: "KITS WITH DRAINAGE CATHETERS, DIRECT PUNCTURE" },
        { key: "U040102", value: "KITS WITH DRAINAGE CATHETERS AND INTRODUCERS" },
        { key: "U040199", value: "DEVICES FOR SUPRAPUBIC URINARY DRAINAGE - OTHER" },
        { key: "U0402", value: "DEVICES FOR PERCUTANEOUS NEPHROSTOMY" },
        { key: "U040201", value: "NEPHROSTOMY KITS, DIRECT PUNCTURE" },
        { key: "U040202", value: "NEPHROSTOMY KITS, SELDINGER METHOD" },
        { key: "U040203", value: "NEPHROSTOMY CATHETERS" },
        { key: "U040299", value: "DEVICES FOR PERCUTANEOUS NEPHROSTOMY - OTHER" },
        { key: "U0403", value: "DEVICES FOR URETERAL DIVERSION AND URETEROCUTANEOSTOMY" },
        { key: "U040301", value: "URETERAL DIVERSION PROBES, BRACCI" },
        { key: "U040302", value: "URETEROCUTANEOSTOMY PROBES" },
        { key: "U040399", value: "DEVICES FOR URETERAL DIVERSION AND URETEROCUTANEOSTOMY - OTHER" },
        { key: "U0480", value: "DEVICES FOR PERCUTANEOUS URINARY DRAINAGE - ACCESSORIES" },
        { key: "U0499", value: "DEVICES FOR PERCUTANEOUS URINARY DRAINAGE - OTHER" },
        { key: "U05", value: "URODYNAMICS DEVICES" },
        { key: "U0501", value: "CYSTOMANOMETRY AND URETHROMANOMETRY CATHETERS" },
        { key: "U050101", value: "CYSTOMANOMETRY CATHETERS, WITHOUT BALLOON" },
        { key: "U05010101", value: "CYSTOMANOMETRY CATHETERS, WITHOUT BALLOON, 2-WAY" },
        { key: "U05010102", value: "CYSTOMANOMETRY CATHETERS, WITHOUT BALLOON, 3-WAY" },
        { key: "U050199", value: "CYSTOMANOMETRY AND URETHROMANOMETRY CATHETERS - OTHER" },
        { key: "U0502", value: "URINARY PRESSURE-FLOW STUDY CATHETERS" },
        { key: "U050201", value: "FILLING CATHETERS FOR URINARY PRESSURE-FLOW STUDY" },
        { key: "U050202", value: "BLADDER PRESSURE-FLOW STUDY CATHETERS" },
        { key: "U050299", value: "URINARY PRESSURE-FLOW STUDY CATHETERS - OTHER" },
        { key: "U0503", value: "URETHRAL PRESSURE PROFILE CATHETERS" },
        { key: "U050301", value: "URETHRAL PRESSURE PROFILE CATHETERS WITHOUT BALLOON" },
        { key: "U05030101", value: "URETHRAL PRESSURE PROFILE CATHETERS WITHOUT BALLOON, 1-WAY" },
        { key: "U05030102", value: "URETHRAL PRESSURE PROFILE CATHETERS WITHOUT BALLOON, 2-WAY" },
        { key: "U050399", value: "URETHRAL PRESSURE PROFILE CATHETERS - OTHER" },
        { key: "U0504", value: "INTRA-ABDOMINAL PRESSURE MEASUREMENT CATHETERS" },
        { key: "U050401", value: "INTRA-ABDOMINAL PRESSURE MEASUREMENT CATHETERS, WITHOUT BALLOON" },
        { key: "U050402", value: "INTRA-ABDOMINAL PRESSURE MEASUREMENT CATHETERS, WITH BALLOON" },
        { key: "U0505", value: "CAVERNOSOMETRY AND CAVERNOSOGRAPHY PROBES" },
        { key: "U0580", value: "URODYNAMICS DEVICES - ACCESSORIES" },
        { key: "U0599", value: "URODYNAMICS DEVICES - OTHER" },
        { key: "U06", value: "UROLOGICAL GUIDEWIRES" },
        { key: "U0601", value: "UROLOGICAL GUIDEWIRES, HYDROPHILIC" },
        { key: "U0602", value: "UROLOGICAL GUIDEWIRES, NOT HYDROPHILIC" },
        { key: "U0699", value: "UROLOGICAL GUIDEWIRES - OTHER" },
        { key: "U07", value: "DEVICES FOR THE TREATMENT OF INCONTINENCE" },
        { key: "U0701", value: "INTERNAL SYSTEMS FOR THE TREATMENT OF INCONTINENCE" },
        { key: "U070101", value: "SLING SYSTEMS FOR THE TREATMENT OF INCONTINENCE" },
        { key: "U070199", value: "INTERNAL SYSTEMS FOR THE TREATMENT OF INCONTINENCE - OTHER" },
        { key: "U0702", value: "EXTERNAL DEVICES FOR THE TREATMENT OF INCONTINENCE" },
        { key: "U070201", value: "SHEATH CATHETER FOR THE TREATMENT OF INCONTINENCE" },
        { key: "U070299", value: "EXTERNAL DEVICES FOR THE TREATMENT OF INCONTINENCE - OTHER" },
        { key: "U0703", value: "PELVIC FLOOR REHABILITATION DEVICES" },
        { key: "U070301", value: "PELVIC FLOOR REHABILITATION DEVICES, BIOFEEDBACK, SINGLE-USE" },
        { key: "U070302", value: "PELVIC FLOOR REHABILITATION DEVICES, FUNCTIONAL ELECTROSTIMULATION, SINGLE-USE" },
        { key: "U070399", value: "PELVIC FLOOR REHABILITATION DEVICES - OTHER" },
        { key: "U0780", value: "DEVICES FOR THE TREATMENT OF INCONTINENCE - ACCESSORIES" },
        { key: "U0799", value: "DEVICES FOR THE TREATMENT OF INCONTINENCE - OTHER" },
        { key: "U08", value: "GYNAECOLOGICAL DEVICES" },
        { key: "U0801", value: "GYNAECOLOGICAL CATHETERS" },
        { key: "U080101", value: "CATHETERS FOR ENDOMETRIAL ABLATION" },
        { key: "U080102", value: "CATHETERS FOR HYSTEROSALPINGOGRAPHY" },
        { key: "U080103", value: "CATHETERS FOR HYSTEROSCOPY" },
        { key: "U080199", value: "GYNAECOLOGICAL CATHETERS - OTHER" },
        { key: "U0802", value: "DEVICES FOR ASSISTED REPRODUCTION" },
        { key: "U080201", value: "CATHETERS FOR ASSISTED REPRODUCTION" },
        { key: "U08020101", value: "CATHETERS FOR INSEMINATION" },
        { key: "U08020102", value: "CATHETERS FOR EMBRYO TRANSFER" },
        { key: "U08020180", value: "ASSISTED REPRODUCTION CATHETERS - ACCESSORIES" },
        { key: "U08020199", value: "ASSISTED REPRODUCTION CATHETERS - OTHER" },
        { key: "U080202", value: "NEEDLES AND SETS FOR OOCYTE RETRIEVAL FOR ASSISTED REPRODUCTION" },
        { key: "U08020201", value: "SINGLE LUMEN NEEDLES AND SETS/SYSTEMS FOR OOCYTE RETRIEVAL" },
        { key: "U08020202", value: "DOUBLE LUMEN NEEDLES AND SETS/SYSTEMS FOR OOCYTE RETRIEVAL" },
        { key: "U080203", value: "DEVICES FOR MICROMANIPULATION OF BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION" },
        { key: "U08020301", value: "PIPETTES FOR ASSISTED REPRODUCTION" },
        { key: "U0802030101", value: "BIOPSY PIPETTES FOR ASSISTED REPRODUCTION" },
        { key: "U0802030102", value: "DENUDING PIPETTES" },
        { key: "U0802030103", value: "HANDLING PIPETTES" },
        { key: "U0802030104", value: "HATCHING/DRILLING PIPETTES" },
        { key: "U0802030105", value: "HOLDING PIPETTES" },
        { key: "U0802030106", value: "ICSI PIPETTES" },
        { key: "U0802030107", value: "PASTEUR PIPETTES FOR ASSISTED REPRODUCTION" },
        { key: "U0802030108", value: "PZD PIPETTES" },
        { key: "U0802030199", value: "PIPETTES FOR ASSISTED REPRODUCTION - OTHER" },
        { key: "U08020302", value: "SYSTEMS FOR MICROMANIPULATION OF BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION" },
        { key: "U0802030201", value: "TIPS FOR ASSISTED REPRODUCTION" },
        { key: "U0802030202", value: "HANDPIECES FOR TIPS FOR ASSISTED REPRODUCTION" },
        { key: "U08020380", value: "DEVICES FOR MICROMANIPULATION OF BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION - ACCESSORIES" },
        { key: "U08020399", value: "DEVICES FOR MICROMANIPULATION OF BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION - OTHER" },
        { key: "U080204", value: "CRYOPRESERVATION CONTAINERS/SETS FOR ASSISTED REPRODUCTION" },
        { key: "U08020401", value: "CRYOPRESERVATION CONTAINERS/STRAWS/VIALS FOR ASSISTED REPRODUCTION" },
        { key: "U080205", value: "SUBSTRATES FOR STORING/HANDLING BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION" },
        { key: "U08020501", value: "MATERIALS/SOLUTIONS FOR FREEZING/THAWING FOR ASSISTED REPRODUCTION" },
        { key: "U08020502", value: "MATERIALS/SOLUTIONS FOR PREPARATION/HANDLING FOR ASSISTED REPRODUCTION" },
        { key: "U08020503", value: "MATERIALS/CULTURE MEDIA FOR ASSISTED REPRODUCTION" },
        { key: "U08020599", value: "SUBSTRATES FOR STORING/HANDLING BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION - OTHER" },
        { key: "U080206", value: "CULTURE PLATES FOR ASSISTED REPRODUCTION" },
        { key: "U080207", value: "CONTAINERS FOR PREPARATION OF BIOLOGICAL MATERIAL FOR ASSISTED REPRODUCTION" },
        { key: "U080299", value: "DEVICES FOR ASSISTED REPRODUCTION - OTHER" },
        { key: "U0803", value: "VAGINAL DEVICES IN THE FORM OF SOLUTIONS/CREAMS/OVA/TABLETS" },
        { key: "U0890", value: "DEVICES FOR GYNECOLOGY - VARIOUS" },
        { key: "U089002", value: "DEVICES FOR GYNAECOLOGICAL CYTOLOGY" },
        { key: "U089003", value: "HYSTEROMETERS, SINGLE-USE" },
        { key: "U089005", value: "PESSARIANS" },
        { key: "U089006", value: "VAGINAL SPECULUM, SINGLE-USE" },
        { key: "U089009", value: "VAGINAL APPLICATORS, SINGLE-USE" },
        { key: "U089010", value: "UTERINE CURETTES, SINGLE-USE" },
        { key: "U0899", value: "GYNAECOLOGICAL DEVICES - OTHER" },
        { key: "U09", value: "UROGENITAL ENDOSCOPIC DEVICES" },
        { key: "U0901", value: "URINARY STONE RETRIEVAL DEVICES" },
        { key: "U090101", value: "URINARY STONE RETRIEVAL BASKETS" },
        { key: "U090102", value: "URINARY STONE RETRIEVAL BALLOON CATHETERS" },
        { key: "U090199", value: "URINARY STONE RETRIEVAL DEVICES - OTHER" },
        { key: "U0902", value: "UROGENITAL ENDOSCOPIC RESECTION INSTRUMENTS" },
        { key: "U090201", value: "UROGENITAL THERMOABLATION, NEEDLES AND KITS" },
        { key: "U090202", value: "PROSTATECTOMY LOOPS" },
        { key: "U090203", value: "GYNAECOLOGY LOOPS" },
        { key: "U090204", value: "BLADDER EVACUATORS" },
        { key: "U090299", value: "UROGENITAL ENDOSCOPIC RESECTION INSTRUMENTS - OTHER" },
        { key: "U0903", value: "SINGLE-USE INSTRUMENTS FOR UROGENITAL ENDOSCOPY" },
        { key: "U090301", value: "FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE" },
        { key: "U09030101", value: "BIOPSY FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE" },
        { key: "U0903010101", value: "COLD BIOPSY FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE" },
        { key: "U0903010102", value: "HOT BIOPSY FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE" },
        { key: "U09030102", value: "EXTRACTION FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE" },
        { key: "U09030199", value: "FORCEPS FOR UROGENITAL ENDOSCOPY, SINGLE-USE - OTHER" },
        { key: "U090303", value: "UROGENITAL ENDOSCOPY BRUSHES" },
        { key: "U09030301", value: "UROGENITAL CYTOLOGY BRUSHES" },
        { key: "U090399", value: "SINGLE-USE INSTRUMENTS FOR UROGENITAL ENDOSCOPY - OTHER" },
        { key: "U0999", value: "UROGENITAL ENDOSCOPIC DEVICES - OTHER" },
        { key: "U10", value: "OBSTETRICS DEVICES" },
        { key: "U1001", value: "OBSTETRICS CATHETERS" },
        { key: "U100101", value: "CATHETERS FOR VOLUNTARY TERMINATION OF PREGNANCY" },
        { key: "U100102", value: "POSTPARTUM INTRAUTERINE CATHETERS" },
        { key: "U100199", value: "OBSTETRICAL CATHETERS - OTHER" },
        { key: "U1002", value: "FETAL STUDY DEVICES" },
        { key: "U100201", value: "FOETAL SCALP ELECTRODES" },
        { key: "U100299", value: "FOETAL STUDY DEVICES - OTHER" },
        { key: "U1003", value: "PUERPERIUM DEVICES" },
        { key: "U1004", value: "MANUAL OBSTETRICAL EXTRACTORS, SINGLE-USE" },
        { key: "U1005", value: "AMNIOTIC MEMBRANE PERFORATORS" },
        { key: "U1006", value: "SINGLE-USE RIGID AMNIOSCOPES" },
        { key: "U1007", value: "UTERINE CERCLAGE DEVICES" },
        { key: "U1080", value: "OBSTETRICS DEVICES - ACCESSORIES" },
        { key: "U1099", value: "OBSTETRICS DEVICES - OTHER" },
        { key: "U11", value: "CONTRACEPTIVE DEVICES" },
        { key: "U1101", value: "MALE CONTRACEPTIVE DEVICES" },
        { key: "U110101", value: "CONDOMS" },
        { key: "U110102", value: "DEVICES FOR LIGATION OF THE VASA DEFERENTIA" },
        { key: "U110199", value: "DEVICES FOR MALE CONTRACEPTION - OTHER" },
        { key: "U1102", value: "DEVICES FOR FEMALE CONTRACEPTION" },
        { key: "U110201", value: "INTRAUTERINE COILS" },
        { key: "U110202", value: "VAGINAL DIAPHRAGMS" },
        { key: "U110203", value: "FEMALE CONDOMS" },
        { key: "U110299", value: "DEVICES FOR FEMALE CONTRACEPTION - OTHER" },
        { key: "U12", value: "SINGLE-USE INSTRUMENTATION FOR UROGENITAL SYSTEM (NON-ENDOSCOPIC)" },
        { key: "U1201", value: "NON-ENDOSCOPIC SINGLE-USE FORCEPS FOR UROGENITAL SYSTEM" },
        { key: "U1202", value: "SINGLE-USE NON-ENDOSCOPIC UROGENITAL SCISSORS" },
        { key: "U1299", value: "SINGLE-USE UROGENITAL INSTRUMENTATION (NON-ENDOSCOPIC) - OTHER" },
        { key: "U13", value: "SOLUTIONS AND KITS FOR BLADDER WASHING AND INSTILLATION" },
        { key: "U1301", value: "SOLUTIONS FOR BLADDER WASHING AND INSTILLATION" },
        { key: "U1302", value: "KITS FOR BLADDER WASHING AND INSTILLATION" },
        { key: "U99", value: "DEVICES FOR UROGENITAL SYSTEM - OTHER" },
        { key: "V", value: "VARIOUS MEDICAL DEVICES" },
        { key: "V01", value: "CUTTING DEVICES, SINGLE-USE" },
        { key: "V0101", value: "SCALPELS, SINGLE-USE" },
        { key: "V010101", value: "SCALPELS WITH SAFETY SYSTEMS, SINGLE-USE" },
        { key: "V010102", value: "SCALPELS WITHOUT SAFETY SYSTEMS, SINGLE-USE" },
        { key: "V0102", value: "STAPLE REMOVER KNIVES, SINGLE-USE" },
        { key: "V0103", value: "BLADES, SINGLE-USE - NOT INCLUDED IN OTHER CLASSES" },
        { key: "V010301", value: "BLADES WITH SAFETY SYSTEMS, SINGLE-USE - NOT INCLUDED IN OTHER CLASSES" },
        { key: "V010302", value: "BLADES WITHOUT SAFETY SYSTEMS, SINGLE-USE - NOT INCLUDED IN OTHER CLASSES" },
        { key: "V0104", value: "LANCETS, SINGLE-USE" },
        { key: "V010401", value: "LANCETS WITH SAFETY SYSTEMS, SINGLE-USE" },
        { key: "V010402", value: "LANCETS WITHOUT SAFETY SYSTEMS, SINGLE-USE" },
        { key: "V0199", value: "CUTTING DEVICES, SINGLE-USE - OTHER" },
        { key: "V02", value: "NEONATOLOGY AND PAEDIATRIC DEVICES" },
        { key: "V0201", value: "PHOTOTHERAPY MASKS" },
        { key: "V0202", value: "UMBILICAL CLAMPS AND CLIPPERS, SINGLE-USE" },
        { key: "V0203", value: "NEWBORN NUTRITION DEVICES" },
        { key: "V020301", value: "MANUAL BREAST PUMPERS AND KITS" },
        { key: "V020302", value: "BABY BOTTLES AND KIT" },
        { key: "V020303", value: "TEATS" },
        { key: "V020380", value: "NEWBORN NUTRITION DEVICES - ACCESSORIES" },
        { key: "V020399", value: "NEWBORN NUTRITION DEVICES - OTHER" },
        { key: "V0280", value: "NEONATOLOGY AND PEDIATRICS DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V028002", value: "NEONATOLOGY CARE KITS" },
        { key: "V028099", value: "NEONATOLOGY AND PEDIATRICS DEVICES - ACCESSORIES NOT INCLUDED IN OTHER CLASSES - OTHER" },
        { key: "V0299", value: "NEONATOLOGY AND PAEDIATRIC DEVICES - OTHER" },
        { key: "V03", value: "MEASUREMENT DEVICES" },
        { key: "V0301", value: "BODY TEMPERATURE MEASUREMENT DEVICES" },
        { key: "V030101", value: "THERMOMETERS" },
        { key: "V03010102", value: "DIGITAL THERMOMETERS" },
        { key: "V0301010201", value: "CONTACT DIGITAL THERMOMETERS" },
        { key: "V0301010202", value: "NON-CONTACT DIGITAL THERMOMETERS" },
        { key: "V0301010299", value: "DIGITAL THERMOMETERS - OTHER" },
        { key: "V03010104", value: "LIQUID EXPANSION THERMOMETERS" },
        { key: "V03010199", value: "THERMOMETERS - OTHER" },
        { key: "V030102", value: "BODY TEMPERATURE MONITORING PROBES" },
        { key: "V03010201", value: "TEMPERATURE MONITORING CUTANEOUS PROBES" },
        { key: "V03010299", value: "BODY TEMPERATURE MONITORING PROBES - OTHER" },
        { key: "V030180", value: "BODY TEMPERATURE MEASURING DEVICES - ACCESSORIES" },
        { key: "V030199", value: "BODY TEMPERATURE MEASURING DEVICES - OTHER" },
        { key: "V0302", value: "CLINICAL DIMENSIONAL PARAMETERS MEASURING DEVICES" },
        { key: "V030201", value: "CALIPERS" },
        { key: "V030202", value: "GONIOMETERS" },
        { key: "V030203", value: "OPHTHALMOLOGY MEASUREMENT DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030204", value: "IMPLANT MEASUREMENT DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030205", value: "OBSTETRICS AND GYNECOLOGY MEASUREMENT DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030206", value: "UROLOGY MEASUREMENT DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030207", value: "SENSITIVITY MEASUREMENTS DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030208", value: "ENT MEASUREMENT DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V030209", value: "CLINICAL ALTIMETERS" },
        { key: "V030210", value: "WEIGHING SCALES (EXCLUDING THOSE FOR NEONATOLOGY)" },
        { key: "V030211", value: "MULTIDIMENSIONAL MEASUREMENTS STATIONS" },
        { key: "V03021101", value: "CLINICAL ALTIMETERS WITH WEIGHING SCALE" },
        { key: "V03021199", value: "MULTIDIMENSIONAL MEASUREMENTS STATIONS - OTHER" },
        { key: "V030299", value: "DIMENSIONAL CLINICAL PARAMETERS MEASURING DEVICES - OTHER" },
        { key: "V0380", value: "DEVICES WITH MEASURING FUNCTIONS - ACCESSORIES" },
        { key: "V0399", value: "MEASUREMENT DEVICES - OTHER" },
        { key: "V04", value: "CLINICAL USE CONTAINERS (NON-IVD)" },
        { key: "V0401", value: "CLINICAL USE BOTTLES" },
        { key: "V0402", value: "CLINICAL USE TRAYS AND BOWLS" },
        { key: "V0480", value: "CLINICAL USE CONTAINERS (NON-IVD) - ACCESSORIES" },
        { key: "V0499", value: "CLINICAL USE CONTAINERS (NON-IVD) - OTHER" },
        { key: "V05", value: "CLINICAL PROCEDURES KITS NOT INCLUDED IN OTHER CLASSES" },
        { key: "V0501", value: "CLINICAL EMERGENCY KITS" },
        { key: "V0502", value: "CLINICAL ADMINISTRATION KITS NOT INCLUDED IN OTHER CLASSES" },
        { key: "V0599", value: "CLINICAL PROCEDURES KITS NOT INCLUDED IN OTHER CLASSES - OTHER" },
        { key: "V06", value: "CLINICAL PROCEDURE SIMULATION DEVICES" },
        { key: "V0601", value: "ORTHOPAEDIC AND TRAUMATOLOGY PROCEDURES SIMULATION DEVICES" },
        { key: "V060101", value: "ORTHOPAEDIC PROSTHESES TESTING DEVICES" },
        { key: "V06010101", value: "HIP PROSTHESES TESTING DEVICES" },
        { key: "V06010102", value: "KNEE PROSTHESES TESTING DEVICES" },
        { key: "V06010103", value: "SHOULDER PROSTHESES TESTING DEVICES" },
        { key: "V06010199", value: "ORTHOPAEDIC PROSTHESES TESTING DEVICES - OTHER" },
        { key: "V060102", value: "SPINAL SURGERY TESTING DEVICES" },
        { key: "V0602", value: "VASCULAR PROCEDURES SIMULATION DEVICES" },
        { key: "V0603", value: "DENTAL PROCEDURES SIMULATION DEVICES" },
        { key: "V0604", value: "GENERAL SURGICAL PROCEDURES SIMULATION DEVICES" },
        { key: "V0605", value: "OPHTHALMOLOGICAL PROCEDURES SIMULATION DEVICES" },
        { key: "V0606", value: "BREAST SURGERY TESTING DEVICES" },
        { key: "V0607", value: "OSTEOSYNTHESIS IMPLANTS TESTING DEVICES" },
        { key: "V0680", value: "CLINICAL PROCEDURES SIMULATION DEVICES - ACCESSORIES" },
        { key: "V0699", value: "CLINICAL PROCEDURES SIMULATION DEVICES - OTHER" },
        { key: "V07", value: "MEDICAL DEVICE CLEANING DEVICES, NOT OTHERWISE CLASSIFIED" },
        { key: "V0701", value: "CLEANING BRUSHES" },
        { key: "V070101", value: "ENDOSCOPES CLEANING BRUSHES - FOR GENERIC USE" },
        { key: "V070102", value: "DIGESTIVE ENDOSCOPY ENDOSCOPES CLEANING BRUSHES" },
        { key: "V070103", value: "NEPHRO-CISTOSCOPIC OPTICS CLEANING BRUSHES" },
        { key: "V070104", value: "BRONCHOSCOPIC OPTICS CLEANING BRUSHES" },
        { key: "V070105", value: "INSTRUMENTS CLEANING BRUSHES" },
        { key: "V0702", value: "CANNULATED INSTRUMENTS AND DEVICES CLEANING BRUSHES" },
        { key: "V0703", value: "ELECTRODES CLEANING SPONGES" },
        { key: "V0704", value: "CANNULATED INSTRUMENTS AND DEVICES CLEANING STYLETS" },
        { key: "V0799", value: "PRODUCTS FOR CLEANING MEDICAL DEVICES NOT INCLUDED IN OTHER CLASSES - OTHER" },
        { key: "V08", value: "HEALTHCARE ACTIVITIES SUPPORTIVE EQUIPMENT AND AIDS" },
        { key: "V0802", value: "MEDICAL CHAIRS" },
        { key: "V080201", value: "ELECTRIC MEDICAL CHAIRS" },
        { key: "V08020101", value: "GENERIC USE ELECTRIC MEDICAL CHAIRS" },
        { key: "V08020102", value: "ELECTRIC MEDICAL CHAIRS WITH WEIGHING SYSTEM" },
        { key: "V08020199", value: "ELECTRIC MEDICAL CHAIRS - OTHER" },
        { key: "V080202", value: "MANUAL MEDICAL CHAIRS" },
        { key: "V080280", value: "MEDICAL CHAIRS - ACCESSORIES" },
        { key: "V080299", value: "MEDICAL CHAIRS - OTHER" },
        { key: "V0803", value: "MEDICAL CUSHIONS" },
        { key: "V080301", value: "ANTI-DECUBITUS MEDICAL CUSHIONS" },
        { key: "V08030101", value: "ACTIVE ANTI-DECUBITUS MEDICAL CUSHIONS" },
        { key: "V08030102", value: "NON-ACTIVE ANTI-DECUBITUS MEDICAL CUSHIONS" },
        { key: "V080302", value: "PATIENT POSITIONING MEDICAL CUSHIONS" },
        { key: "V080399", value: "MEDICAL CUSHIONS - OTHER" },
        { key: "V0804", value: "PATIENT IMMOBILISERS (in diagnostic or therapeutic procedures)" },
        { key: "V0805", value: "PATIENT TRANSFER EQUIPMENT" },
        { key: "V080501", value: "PATIENT TRANSFER STRETCHERS" },
        { key: "V08050101", value: "GENERIC USE STRETCHERS" },
        { key: "V08050102", value: "SELF-LOADING STRETCHERS" },
        { key: "V08050103", value: "EMERGENCY AND TRAUMATOLOGY STRETCHERS" },
        { key: "V08050104", value: "BIO-CONTAINMENT STRETCHERS" },
        { key: "V08050199", value: "PATIENT TRANSFER STRETCHERS - OTHER" },
        { key: "V080502", value: "PATIENT TRANSFER CHAIRS" },
        { key: "V080503", value: "PATIENT TRANSFER LIFTS" },
        { key: "V08050301", value: "MOBILE LIFTS" },
        { key: "V0805030101", value: "MANUAL MOBILE LIFTS" },
        { key: "V0805030102", value: "ELECTRIC MOBILE LIFTS" },
        { key: "V08050302", value: "ELECTRIC FIXED LIFTS" },
        { key: "V08050303", value: "BATH LIFTS" },
        { key: "V08050380", value: "PATIENT TRANSFER LIFTS - ACCESSORIES" },
        { key: "V0805038001", value: "RIGID SUPPORTS FOR LIFTS (STRETCHERS)" },
        { key: "V0805038002", value: "NON-RIGID SUPPORTS FOR LIFTS (HARNESSES)" },
        { key: "V08050399", value: "PATIENT TRANSFER LIFTS - OTHER" },
        { key: "V080504", value: "PATIENT TRANSFER BOARDS AND TABLES" },
        { key: "V0806", value: "MEDICAL BEDS" },
        { key: "V080601", value: "ELECTRIC MEDICAL BEDS" },
        { key: "V08060101", value: "HOSPITAL/HOME CARE ELECTRIC MEDICAL BEDS" },
        { key: "V08060102", value: "INTENSIVE CARE OR RESUSCITATION ELECTRIC MEDICAL BEDS" },
        { key: "V08060103", value: "SEMI-INTENSIVE THERAPY OR CARDIAC INTENSIVE CARE UNITS (CICU) ELECTRIC MEDICAL BEDS" },
        { key: "V08060104", value: "BURN PATIENT ELECTRIC MEDICAL BEDS" },
        { key: "V08060105", value: "ELECTRIC MEDICAL BEDS WITH WEIGHING SYSTEM" },
        { key: "V08060106", value: "BARIATRIC ELECTRIC MEDICAL BEDS" },
        { key: "V08060107", value: "PEDIATRIC ELECTRIC MEDICAL BEDS" },
        { key: "V0806010701", value: "HOSPITAL/HOME CARE PEDIATRIC ELECTRIC MEDICAL BEDS" },
        { key: "V0806010702", value: "INTENSIVE CARE PEDIATRIC ELECTRIC MEDICAL BEDS" },
        { key: "V08060199", value: "ELECTRIC MEDICAL BEDS - OTHER" },
        { key: "V080602", value: "MANUAL MEDICAL BEDS" },
        { key: "V080603", value: "TREATMENT, DIAGNOSIS AND MONITORING MEDICAL BEDS" },
        { key: "V080680", value: "MEDICAL BEDS - ACCESSORIES" },
        { key: "V08068001", value: "BED RAILS" },
        { key: "V08068002", value: "BED SUPPORTS" },
        { key: "V08068099", value: "MEDICAL BEDS - OTHER ACCESSORIES" },
        { key: "V080699", value: "MEDICAL BEDS - OTHER" },
        { key: "V0807", value: "ANTI-DECUBITUS MEDICAL MATTRESSES" },
        { key: "V080701", value: "ACTIVE ANTI-DECUBITUS MEDICAL MATTRESSES" },
        { key: "V080702", value: "NON ACTIVE ANTI-DECUBITUS MEDICAL MATTRESSES" },
        { key: "V0808", value: "MEDICAL CROSSBARS" },
        { key: "V0809", value: "MANUAL CLINICAL CRIBS FOR NEWBORNS" },
        { key: "V0810", value: "NEWBORN POSITIONERS" },
        { key: "V0811", value: "HEEL, ELBOW AND KNEE ANTI-DECUBITUS PROTECTION AIDS" },
        { key: "V0812", value: "FECES AND URINE COLLECTION AIDS (BED PANS AND PARROTS)" },
        { key: "V0880", value: "MEDICAL SUPPORT EQUIPMENT - ACCESSORIES" },
        { key: "V0899", value: "MEDICAL SUPPORT EQUIPMENT - OTHER" },
        { key: "V09", value: "FLUIDS/GASES FOR CLINICAL/THERAPEUTIC USE" },
        { key: "V0901", value: "CLINICAL/THERAPEUTIC APPLICATIONS CARBON DIOXIDE" },
        { key: "V0902", value: "CLINICAL/THERAPEUTIC APPLICATIONS LIQUID NITROGEN" },
        { key: "V0903", value: "CLINICAL/THERAPEUTIC APPLICATIONS GAS MIXTURES" },
        { key: "V0904", value: "CLINICAL/THERAPEUTIC APPLICATIONS NITROUS OXIDE" },
        { key: "V0905", value: "CLINICAL/THERAPEUTIC APPLICATIONS ARGON" },
        { key: "V0999", value: "FLUIDS/GASES FOR CLINICAL/THERAPEUTICAL USE - OTHER" },
        { key: "V80", value: "CLINICAL USE ACCESSORIES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V90", value: "VARIOUS DEVICES NOT INCLUDED IN OTHER CLASSES" },
        { key: "V9001", value: "TONGUE DEPRESSORS, SINGLE-USE" },
        { key: "V9002", value: "ENTEROCLYSIS DEVICES" },
        { key: "V9003", value: "TOURNIQUETS" },
        { key: "V9004", value: "SKIN MARKING DERMOGRAPHIC PENCILS AND PENS" },
        { key: "V9005", value: "RUBBER SQUIRTS FOR IRRIGATION" },
        { key: "V9007", value: "STERILE INSTRUMENT LUBRICANTS" },
        { key: "V9010", value: "PARASITE ELIMINATION MECHANICAL DEVICES" },
        { key: "V901001", value: "LICE ELIMINATION MECHANICAL DEVICES " },
        { key: "V901099", value: "PARASITE ELIMINATION MECHANICAL DEVICES - OTHER" },
        { key: "V9011", value: "MULTIFUNCTIONAL TRANSDUCERS" },
        { key: "V9012", value: "NON-SPECIALIST SURGICAL INSTRUMENTS AND KITS, SINGLE-USE" },
        { key: "V9015", value: "ELECTRODES AND PROBES CUTANEOUS CONDUCTIVE SUBSTANCES" },
        { key: "V9016", value: "SPECIALIST SURGICAL INSTRUMENTS AND KITS NOT INCLUDED IN OTHER CLASSES, SINGLE-USE" },
        { key: "V901601", value: "PLASTIC SURGERY AND NON-AESTHETIC PURPOSES GENERIC USE INSTRUMENTS AND KITS, SINGLE-USE" },
        { key: "V901602", value: "DERMOSURGERY INSTRUMENTS AND KITS, SINGLE-USE" },
        { key: "V901603", value: "SUPERFICIAL TREATMENTS INSTRUMENTS AND KITS, SINGLE-USE" },
        { key: "V901699", value: "SPECIALIST SURGICAL INSTRUMENTS AND KITS NOT INCLUDED IN OTHER CLASSES, SINGLE-USE - OTHER" },
        { key: "V9017", value: "ORAL ADMINISTRATION PREPARATIONS NOT INCLUDED IN OTHER CLASSES" },
        { key: "V9018", value: "TRICHOTOMY MANUAL DEVICES" },
        { key: "V9099", value: "VARIOUS DEVICES NOT INCLUDED IN OTHER CLASSES - OTHER" },
        { key: "V92", value: "MEDICAL DEVICE SOFTWARE - NOT INCLUDED IN OTHER CLASSES" },
        { key: "W", value: "IN VITRO DIAGNOSTIC MEDICAL DEVICES" },
        { key: "W01", value: "REAGENTS" },
        { key: "W0101", value: "CLINICAL CHEMISTRY" },
        { key: "W010101", value: "ENZYMES" },
        { key: "W01010101", value: "5'-NUCLEOTIDASE" },
        { key: "W01010102", value: "ACID PHOSPHATASE (CC)" },
        { key: "W01010103", value: "ALANINE AMINO-TRANSFERASE" },
        { key: "W01010104", value: "ALDOLASE" },
        { key: "W01010105", value: "ALKALINE PHOSPHATASE - TOTAL" },
        { key: "W01010106", value: "ALKALINE PHOSPHATASE ISOENZYMES (CC)" },
        { key: "W01010107", value: "AMYLASE - TOTAL" },
        { key: "W01010108", value: "AMYLASE ISOENZYMES" },
        { key: "W01010109", value: "ANGIOTENSIN CONVERTING ENZYME (CC)" },
        { key: "W01010110", value: "ASPARTATE AMINO-TRANSFERASE" },
        { key: "W01010111", value: "CHOLINESTERASE" },
        { key: "W01010112", value: "CHYMOTRYPSIN" },
        { key: "W01010113", value: "CREATINE KINASE - TOTAL" },
        { key: "W01010114", value: "CREATINE KINASE - MB ACTIVITY (CC)" },
        { key: "W01010115", value: "CREATINE KINASE ISOENZYMES" },
        { key: "W01010116", value: "GAMMA GLUTAMYLTRANSFERASE" },
        { key: "W01010117", value: "GLUTAMATE DEHYDROGENASE" },
        { key: "W01010118", value: "HYDROXYBUTYRATE DEHYDROGENASE" },
        { key: "W01010119", value: "LACTATE DEHYDROGENASE L  ( LDH - L --> P )" },
        { key: "W01010120", value: "LACTATE DEHYDROGENASE P ( LDH - P --> L )" },
        { key: "W01010121", value: "LACTATE DEHYDROGENASE ISOENZYMES" },
        { key: "W01010122", value: "LEUCINE AMINOPEPTIDASE" },
        { key: "W01010123", value: "LIPASE" },
        { key: "W01010124", value: "LYSOZYME" },
        { key: "W01010125", value: "MALATE DEHYDROGENASE" },
        { key: "W01010126", value: "N-ACETYL-B, D-GLUCOSAMINIDASE" },
        { key: "W01010127", value: "PEPSIN" },
        { key: "W01010128", value: "PHOSPHO HEXOSE ISOMERASE" },
        { key: "W01010129", value: "SORBITOL DEHYDROGENASE" },
        { key: "W01010130", value: "TRYPSIN" },
        { key: "W01010131", value: "HEXOKINASE ADP" },
        { key: "W01010199", value: "ENZYMES - OTHER" },
        { key: "W010102", value: "SUBSTRATES" },
        { key: "W01010201", value: "ALBUMIN (CC)" },
        { key: "W01010202", value: "BILE ACIDS" },
        { key: "W01010203", value: "BILIRUBIN" },
        { key: "W01010204", value: "UREA/BLOOD UREA NITROGEN" },
        { key: "W01010205", value: "CHOLESTEROL" },
        { key: "W01010206", value: "COPPER" },
        { key: "W01010207", value: "CREATININE" },
        { key: "W01010208", value: "D-XYLOSE" },
        { key: "W01010209", value: "DELTA-AMINOLAEVULINIC ACID" },
        { key: "W01010210", value: "FRUCTOSAMINE" },
        { key: "W01010211", value: "FRUCTOSE" },
        { key: "W01010212", value: "GALACTOSE" },
        { key: "W01010213", value: "GLUCOSE" },
        { key: "W01010214", value: "GLYCOSYLATED/GLYCATED HAEMOGLOBIN (CC)" },
        { key: "W01010215", value: "HIGH DENSITY LIPOPROTEIN CHOLESTEROL" },
        { key: "W01010216", value: "IRON (CC)" },
        { key: "W01010217", value: "IRON BINDING CAPACITY - TOTAL (CC)" },
        { key: "W01010218", value: "LACTATE" },
        { key: "W01010219", value: "LECITHIN" },
        { key: "W01010220", value: "LIPOPROTEIN, CHEMICAL DETERMINATION/DETECTION" },
        { key: "W01010221", value: "LOW DENSITY LIPOPROTEIN CHOLESTEROL INCLUDING SD-LDL" },
        { key: "W01010222", value: "NON ESTERIFIED FATTY ACIDS" },
        { key: "W01010223", value: "OXALATE" },
        { key: "W01010224", value: "PHOSPHOLIPIDS" },
        { key: "W01010225", value: "PORPHOBILINOGEN" },
        { key: "W01010226", value: "PYRUVATE" },
        { key: "W01010227", value: "THYMOL" },
        { key: "W01010228", value: "TOTAL LIPIDS" },
        { key: "W01010229", value: "TOTAL PORPHYRINE" },
        { key: "W01010230", value: "TOTAL PROTEIN" },
        { key: "W01010231", value: "TRIGLYCERIDES" },
        { key: "W01010232", value: "URIC ACID" },
        { key: "W01010233", value: "ZINC" },
        { key: "W01010234", value: "LIPOPROTEIN ELECTROPORESIS" },
        { key: "W01010235", value: "PROTEIN ELECTROPORESIS" },
        { key: "W01010236", value: "PHENYLKETONURIA" },
        { key: "W01010299", value: "SUBSTRATES - OTHER" },
        { key: "W010103", value: "ELECTROLYTES REAGENTS (EXCLUDING ELECTRODES)" },
        { key: "W01010301", value: "AMMONIA" },
        { key: "W01010302", value: "BICARBONATE" },
        { key: "W01010303", value: "CALCIUM" },
        { key: "W01010304", value: "CHLORIDE" },
        { key: "W01010305", value: "LITHIUM" },
        { key: "W01010306", value: "MAGNESIUM" },
        { key: "W01010307", value: "PHOSPHATE INORGANIC / PHOSPHORUS" },
        { key: "W01010308", value: "POTASSIUM" },
        { key: "W01010309", value: "SODIUM" },
        { key: "W01010399", value: "ELECTROLYTES - OTHER" },
        { key: "W010104", value: "MULTIPLE PARAMETERS - CLINICAL CHEMISTRY" },
        { key: "W01010401", value: "MULTIPLE ENZYMES ONLY - CLIN. CHEM LAB REAGENTS." },
        { key: "W01010402", value: "MULTIPLE SUBSTRATES ONLY - CLIN. CHEM LAB R." },
        { key: "W01010403", value: "MULTIPLE ELECTROLYTES ONLY - CLIN. CHEM LAB R." },
        { key: "W01010404", value: "MULTIPLE PARAMETERS (MIX OF ALL) - CLIN. CHEM LAB R." },
        { key: "W01010499", value: "MULTIPLE CLIN. CHEM LAB REAGENTS - OTHER" },
        { key: "W010105", value: "CONTROLS/STANDARDS/CALIBRATORS CLINICAL CHEMISTRY" },
        { key: "W01010501", value: "MULTICOMPONENT CONTROLS (CLINICAL CHEMISTRY)" },
        { key: "W0101050101", value: "ASSAYED MULTICOMPONENT CONTROLS (CC)" },
        { key: "W0101050102", value: "UNASSAYED MULTICOMPONENT CONTROLS (CC)" },
        { key: "W0101050199", value: "MULTICOMPONENT CONTROLS (CC) - OTHER" },
        { key: "W01010502", value: "SPECIFIC CONTROLS (CLINICAL CHEMISTRY)" },
        { key: "W0101050201", value: "ENZYME CONTROLS" },
        { key: "W0101050202", value: "LIPID CONTROLS" },
        { key: "W0101050203", value: "BILIRUBIN CONTROLS" },
        { key: "W0101050204", value: "ELECTROLYTE CONTROLS" },
        { key: "W0101050205", value: "DIABETES CONTROLS" },
        { key: "W0101050207", value: "URINE CONTROLS" },
        { key: "W0101050208", value: "CSF CONTROLS" },
        { key: "W0101050299", value: "SPECIFIC CONTROLS (CC) - OTHER" },
        { key: "W01010503", value: "CALIBRATORS AND STANDARDS (CLINICAL CHEMISTRY)" },
        { key: "W0101050301", value: "CALIBRATORS MULTICOMPONENT (CC)" },
        { key: "W0101050302", value: "CALIBRATORS SINGLE COMPONENT (CC)" },
        { key: "W0101050303", value: "AQUEOUS STANDARDS (CC)" },
        { key: "W0101050399", value: "CALIBRATORS AND STANDARDS (CLINICAL CHEMISTRY) - OTHER" },
        { key: "W010106", value: "CLINICAL CHEMISTRY - RAPID TESTS & POC" },
        { key: "W01010601", value: "BLOOD TEST STRIPS (CC) - RT & POC" },
        { key: "W0101060101", value: "GLUCOSE TEST STRIPS" },
        { key: "W0101060102", value: "CHOLESTEROL TEST STRIPS" },
        { key: "W0101060103", value: "HDL TEST STRIPS" },
        { key: "W0101060104", value: "LACTATE TEST STRIPS" },
        { key: "W0101060105", value: "TRIGLYCERIDE TEST STRIPS" },
        { key: "W0101060106", value: "UREA TEST STRIPS" },
        { key: "W0101060107", value: "HBA1C TEST STRIPS" },
        { key: "W0101060108", value: "CONTROLS/STANDRDS/CALIBRATORS (BLOOD TEST STRIPS)" },
        { key: "W010106010801", value: "BLOOD TEST STRIPS CONTROLS" },
        { key: "W010106010802", value: "BLOOD TEST STRIPS CALIBRATORS AND STANDARDS" },
        { key: "W0101060109", value: "MULTIPLE PARAMETER BLOOD TEST" },
        { key: "W0101060110", value: "KETONE TEST STRIPS (Β-HYDROXYBUTYRATE TEST STRIPS)" },
        { key: "W0101060111", value: "LDL TEST STRIPS" },
        { key: "W0101060112", value: "CREATININE ANALYSIS TEST STRIPS" },
        { key: "W0101060199", value: "BLOOD TEST STRIPS (CC) - RAPID TESTS AND \"POINT OF CARE\" - OTHER" },
        { key: "W01010602", value: "URINE TESTING (CC) - RT & POC" },
        { key: "W0101060201", value: "URINE SINGLE TEST STRIPS (INCL. TABLETS)" },
        { key: "W0101060203", value: "URINE SEDIMENTTEST KIT" },
        { key: "W010106020301", value: "URINE SEDIMENTTEST KIT (MANUAL)" },
        { key: "W010106020302", value: "URINE SEDIMENT TEST KIT (AUTOMATED)" },
        { key: "W0101060204", value: "URINE MULTI-CONSTITUENT TEST STRIPS (MANUAL)" },
        { key: "W0101060205", value: "URINE MULTI-CONSTITUENT TEST STRIPS (AUTOMATED)" },
        { key: "W0101060206", value: "URINE TESTING CONTROLS CALIBRATORS AND STANDARDS" },
        { key: "W010106020601", value: "URINE TESTING CONTROLS" },
        { key: "W010106020602", value: "URINE TESTING CALIBRATORS AND STANDARDS" },
        { key: "W0101060299", value: "URINE TESTING - OTHER" },
        { key: "W01010603", value: "FAECES TESTS (CC) - RT & POC" },
        { key: "W0101060301", value: "GUAIAC-BASED FECAL FAECAL OCCULT BLOOD (CC)" },
        { key: "W0101060302", value: "ALBUMIN IN STOOL (MECONIUM)" },
        { key: "W0101060303", value: "PANCREAS-ELASTASE" },
        { key: "W0101060399", value: "FAECES TESTS - RAPID TESTS AND \"POINT OF CARE\" - OTHER" },
        { key: "W01010604", value: "MULTIPLE PARAMETERS POC" },
        { key: "W0101060401", value: "MULTIPLE ENZYMES &/OR SUBSTRATES &/OR ELECTROLYTES" },
        { key: "W0101060402", value: "MULTIPLE PARAMETERS POC CONTROLS CALIBRATORS AND STANDARDS" },
        { key: "W010106040201", value: "MULTIPLE PARAMETERS POC CONTROLS" },
        { key: "W010106040202", value: "MULTIPLE PARAMETERS POC CALIBRATORS AND STANDARDS" },
        { key: "W0101060499", value: "MULTIPLE PARAMETERS POC - OTHER" },
        { key: "W01010606", value: "ELECTRODES OR CASSETTES FOR BLOOD GAS ANALYSIS INCL. ELECTROLYTES / METABOLITES - POC" },
        { key: "W0101060601", value: "CARBON DIOXIDE - ELECTRODES (BG)" },
        { key: "W0101060602", value: "PH - ELECTRODES (BG)" },
        { key: "W0101060603", value: "OXYGEN - ELECTRODES (BG)" },
        { key: "W0101060604", value: "PH/PO2/PCO2 - ELECTRODES (BG)" },
        { key: "W0101060605", value: "BG &/OR ISE &/OR METABOLITES - ELECTRODES (BG)" },
        { key: "W0101060606", value: "BLOOD GAS BUFFERS AND SOLUTIONS - ELECTRODES OR CASSETTE" },
        { key: "W0101060607", value: "BLOOD GAS CONTROLS -ELECTRODES OR CASSETTE" },
        { key: "W0101060608", value: "BLOOD GAS CALIBRATORS AND STANDARDS ELECTRODES OR CASSETTE" },
        { key: "W0101060609", value: "BLOOD GAS INCL. ELECTROLYTES / METABOLITES - UNITARY USE CASSETTE" },
        { key: "W0101060610", value: "BLOOD GAS INCL. ELECTROLYTES / METABOLITES - MULTI USE CASSETTE" },
        { key: "W0101060699", value: "BLOOD GAS ELECTRODES OR CASSETTE POC - OTHER" },
        { key: "W01010699", value: "CLIN. CHEM. RT & POC - OTHER" },
        { key: "W010107", value: "ELECTRODES AND BIOSENSORS - LABORATORY" },
        { key: "W01010701", value: "ELECTROLYTE ELECTRODES" },
        { key: "W0101070101", value: "AMMONIA - ELECTRODES" },
        { key: "W0101070102", value: "CALCIUM - ELECTRODES" },
        { key: "W0101070103", value: "CHLORIDE - ELECTRODES" },
        { key: "W0101070104", value: "LITHIUM - ELECTRODES" },
        { key: "W0101070105", value: "MAGNESIUM - ELECTRODES" },
        { key: "W0101070106", value: "POTASSIUM - ELECTRODES" },
        { key: "W0101070107", value: "SODIUM - ELECTRODES" },
        { key: "W0101070108", value: "CARBON DIOXIDE (BICARBONATE)   - ELECTRODES (CC)" },
        { key: "W0101070199", value: "ELECTROLYTE ELECTRODES - OTHER" },
        { key: "W01010702", value: "SUBSTRATE ELECTRODES / BIOSENSORS" },
        { key: "W0101070201", value: "CREATININE - ELECTRODES" },
        { key: "W0101070202", value: "GLUCOSE - ELECTRODES" },
        { key: "W0101070203", value: "GLYCATED HAEMOGLOBIN - ELECTRODES" },
        { key: "W0101070204", value: "LACTATE - ELECTRODES" },
        { key: "W0101070205", value: "UREA - ELECTRODES" },
        { key: "W0101070206", value: "BILIRUBIN - ELECTRODES" },
        { key: "W0101070299", value: "SUBSTRATE - ELECTRODES / BIOSENSORS - OTHER" },
        { key: "W01010703", value: "REFERENCE MATERIAL AND BUFFERS (ELECTROLYTES)" },
        { key: "W0101070301", value: "REFERENCE ELECTRODES" },
        { key: "W0101070302", value: "ELECTROLYTE ELECTRODE BUFFERS AND SOLUTIONS" },
        { key: "W0101070303", value: "SUBSTRATE ELECTRODE BUFFERS AND SOLUTIONS" },
        { key: "W0101070304", value: "COMMON BUFFERS AND SOLUTIONS (ELECTROLYTES)" },
        { key: "W0101070399", value: "REFERENCE MATERIALS AND BUFFERS (ELECTROLYTES) - OTHER" },
        { key: "W010108", value: "MULTIPLE PARAMETER ELECTRODES/BIOSENSORS" },
        { key: "W01010801", value: "MULTIPLE ENZYMES ONLY - ELECTRODES/BIOSENSORS" },
        { key: "W01010802", value: "MULTIPLE SUBSTRATES ONLY - ELECTRODES/BIOSENSORS" },
        { key: "W01010803", value: "MULTIPLE ELECTROLYTES ONLY - ELECTRODES/BIOSENSORS" },
        { key: "W01010804", value: "MULTIPLE BLOOD GAS ONLY - ELECTRODES/BIOSENSORS" },
        { key: "W01010805", value: "MULTIPLE PARAMETERS (MIX OF ALL) - ELECTRODES/BIOSENSORS" },
        { key: "W01010899", value: "MULTIPLE PARAMETER - ELECTRODES/BIOSENSORS - OTHER" },
        { key: "W010109", value: "URINE MULTIPLE PARAMETERS TESTING (CC) - LAB REAGENTS" },
        { key: "W01010901", value: "URINE MULTI-CONSTITUENT TEST STRIPS / CASSETTES (AUTOMATED)" },
        { key: "W01010902", value: "URINE SEDIMENT TEST KIT (AUTOMATED)" },
        { key: "W01010999", value: "MULTIPLE PARAMETERS URINE TESTING - OTHER" },
        { key: "W010190", value: "OTHER CLINICAL CHEMISTRY" },
        { key: "W01019001", value: "BUFFERS (UNASSIGNABLE), SUPPLEM. REAGENTS, ETC (CC)" },
        { key: "W01019002", value: "ELECTROPHORESIS MEDIA (UNASSIGNABLE)" },
        { key: "W01019099", value: "CLINICAL CHEMISTRY REAGENTS - OTHER" },
        { key: "W0102", value: "IMMUNOCHEMISTRY (IMMUNOLOGY)" },
        { key: "W010201", value: "SPECIFIC PROTEINS" },
        { key: "W01020101", value: "IMMUNOGLOBULINS (EXCEPT IGE)" },
        { key: "W0102010101", value: "IMMUNOGLOBULIN A" },
        { key: "W0102010102", value: "IMMUNOGLOBULIN A SUBCLASS REAGENTS" },
        { key: "W0102010103", value: "IMMUNOGLOBULIN D" },
        { key: "W0102010104", value: "IMMUNOGLOBULIN D SUBCLASS REAGENTS" },
        { key: "W0102010105", value: "IMMUNOGLOBULIN G" },
        { key: "W0102010106", value: "IMMUNOGLOBULIN G SUBCLASS REAGENTS" },
        { key: "W0102010107", value: "IMMUNOGLOBULIN M" },
        { key: "W0102010108", value: "IMMUNOGLOBULIN M SUBCLASS REAGENTS" },
        { key: "W0102010109", value: "KAPPA AND LAMBDA CHAIN" },
        { key: "W0102010110", value: "IMMUNOELECTROPHORESIS KITS" },
        { key: "W0102010111", value: "IMMUNOFIXATION KITS" },
        { key: "W0102010112", value: "ANTI HUMAN IG POLYVALENT ANTISERA" },
        { key: "W0102010113", value: "HUMAN ANTI-MOUSE ANTIBODY" },
        { key: "W0102010114", value: "BUFFERS (UNASSIGNABLE), SUPPLEM. REAGENTS, ETC (IG'S)" },
        { key: "W0102010199", value: "IMMUNOGLOBULINS - OTHER" },
        { key: "W01020102", value: "COMPLEMENT COMPONENTS" },
        { key: "W0102010201", value: "COMPLEMENT COMPONENT C1Q" },
        { key: "W0102010202", value: "COMPLEMENT COMPONENT C1 INHIBITOR" },
        { key: "W0102010203", value: "COMPLEMENT COMPONENT C3/C3C" },
        { key: "W0102010204", value: "COMPLEMENT COMPONENT FOR BB" },
        { key: "W0102010205", value: "COMPLEMENT COMPONENT C4" },
        { key: "W0102010206", value: "COMPLEMENT COMPONENT C5A" },
        { key: "W0102010207", value: "COMPLEMENT COMPONENT C59" },
        { key: "W0102010208", value: "TOTAL COMPLEMENT ACTIVITY (CH50)" },
        { key: "W0102010299", value: "COMPLEMENT COMPONENTS - OTHER" },
        { key: "W01020103", value: "TRANSPORT PROTEINS" },
        { key: "W0102010301", value: "CERULOPLASMIN" },
        { key: "W0102010302", value: "HAPTOGLOBIN" },
        { key: "W0102010303", value: "HEMOPEXIN" },
        { key: "W0102010304", value: "LACTOFERRIN" },
        { key: "W0102010305", value: "PRE-ALBUMIN / TRANSTHYRETIN" },
        { key: "W0102010306", value: "RETINOL BINDING PROTEIN" },
        { key: "W0102010307", value: "TRANSFERRIN" },
        { key: "W0102010308", value: "TRANSCOBALAMIN (S)" },
        { key: "W0102010309", value: "ALBUMIN (IC) INCL. UALBUMIN" },
        { key: "W0102010399", value: "TRANSPORT PROTEINS - OTHER" },
        { key: "W01020104", value: "LIPOPROTEINS" },
        { key: "W0102010401", value: "APOLIPOPROTEIN A I" },
        { key: "W0102010402", value: "APOLIPOPROTEIN A II" },
        { key: "W0102010403", value: "APOLIPOPROTEIN B" },
        { key: "W0102010404", value: "APOLIPOPROTEIN E SUB-TYPING " },
        { key: "W0102010405", value: "LIPOPROTEIN ( A )" },
        { key: "W0102010499", value: "LIPOPROTEINS - OTHER" },
        { key: "W01020190", value: "OTHER SPECIFIC PROTEINS" },
        { key: "W0102019001", value: "A1-ACID GLYCOPROTEIN (OROSOMUCOID)" },
        { key: "W0102019002", value: "A1-ANTITRYPSIN (PROTEASE INHIBITOR)" },
        { key: "W0102019003", value: "A2-MACROGLOBULIN" },
        { key: "W0102019004", value: "A1-MICROGLOBULIN" },
        { key: "W0102019005", value: "FIBRONECTIN" },
        { key: "W0102019006", value: "TRYPSIN-A1-ANTITRYPSIN (ELASTASE)" },
        { key: "W0102019007", value: "IMMUNO REACTIVE TRYPSIN" },
        { key: "W0102019008", value: "CYSTATIN C" },
        { key: "W0102019009", value: "CALPROTECTIN" },
        { key: "W0102019010", value: "ADENOSINE DEAMINASE" },
        { key: "W0102019011", value: "ADRENOMEDULLIN" },
        { key: "W0102019012", value: "AMYLOID BETA-DERIVED DIFFUSIBLE LIGAND (BETA-AMYLOID OLIGOMER)" },
        { key: "W0102019013", value: "BETA-AMYLOID (1-40)" },
        { key: "W0102019014", value: "BETA-AMYLOID (1-42)" },
        { key: "W0102019015", value: "TOTAL TAU" },
        { key: "W0102019016", value: "HUMAN TAU (HTAU)" },
        { key: "W0102019017", value: "PHOSPHORYLATED TAU (PTAU)" },
        { key: "W0102019099", value: "SPECIFIC PROTEINS - OTHER" },
        { key: "W010202", value: "ALLERGY" },
        { key: "W01020201", value: "IMMUNOGLOBULIN E - TOTAL" },
        { key: "W01020202", value: "IMMUNOGLOBULIN E - SPECIFIC, MONOTEST/MONORESULT" },
        { key: "W01020203", value: "IMMUNOGLOBULIN E - MONOTEST/MONORESULT - MULTI AG" },
        { key: "W01020204", value: "IMMUNOGLOBULIN E - MONOTEST/PLURIRESULT-MULTI AG" },
        { key: "W01020205", value: "IMMUNOGLOBULIN E - SCREEN" },
        { key: "W01020206", value: "LEUKOTRIENE STIMULATION TEST" },
        { key: "W01020207", value: "ALLERGENE SPECIFIC IGA" },
        { key: "W01020208", value: "ALLERGENE SPECIFIC IGG" },
        { key: "W01020209", value: "HISTAMINE" },
        { key: "W01020299", value: "ALLERGY TESTS - OTHER" },
        { key: "W010203", value: "TUMOUR MARKERS" },
        { key: "W01020301", value: "CANCER ANTIGENS" },
        { key: "W0102030101", value: "BLADDER TUMOUR ANTIGEN" },
        { key: "W0102030102", value: "CANCER ANTIGEN 15-3" },
        { key: "W0102030103", value: "CANCER ANTIGEN 19-9" },
        { key: "W0102030104", value: "CANCER ANTIGEN 50" },
        { key: "W0102030105", value: "CANCER ANTIGEN 72-4" },
        { key: "W0102030106", value: "CANCER ANTIGEN 125" },
        { key: "W0102030107", value: "CANCER ANTIGEN 195" },
        { key: "W0102030108", value: "CANCER ANTIGEN 242" },
        { key: "W0102030109", value: "CANCER ANTIGEN 549" },
        { key: "W0102030110", value: "CANCER ANTIGEN 27.29" },
        { key: "W0102030111", value: "CYFRA 21-1" },
        { key: "W0102030112", value: "CARCINOEMBRYONIC ANTIGEN" },
        { key: "W0102030113", value: "TOTAL PROSTATIC SPECIFIC ANTIGEN" },
        { key: "W0102030114", value: "FREE PROSTATIC SPECIFIC ANTIGEN" },
        { key: "W0102030115", value: "COMPLEXED PROSTATIC SPECIFIC ANTIGEN" },
        { key: "W0102030116", value: "SQUAMOUS CELL CARCINOMA ANTIGEN" },
        { key: "W0102030117", value: "TUMOR POLYPEPTIDE ANTIGEN (TPA - INCL. TPS)" },
        { key: "W0102030118", value: "CANCER ASSOCIATED SERUM ANTIGEN" },
        { key: "W0102030119", value: "HUMAN EPIDIDYMIS PROTEIN 4" },
        { key: "W0102030120", value: "PROSTATIC ACID PHOSPHATASE (IC)" },
        { key: "W0102030121", value: "PRO-GASTRIN-RELEASING PEPTIDE" },
        { key: "W0102030122", value: "EARLY PROSTATE CANCER ANTIGEN - 2" },
        { key: "W0102030123", value: "NUCLEAR MATRIX PROTEIN 22" },
        { key: "W0102030124", value: "CANCER ANTIGEN P16" },
        { key: "W0102030125", value: "CANCER ANTIGEN P63" },
        { key: "W0102030126", value: "CYTOKERATINS" },
        { key: "W0102030127", value: "(2)PROPSA" },
        { key: "W0102030199", value: "CANCER ANTIGENS - OTHER" },
        { key: "W01020302", value: "RECEPTOR ASSAYS" },
        { key: "W0102030201", value: "ESTROGEN RECEPTOR ASSAYS" },
        { key: "W0102030202", value: "PROGESTERONE RECEPTOR ASSAYS" },
        { key: "W0102030299", value: "RECEPTOR ASSAYS - OTHER" },
        { key: "W01020303", value: "ONCOPROTEINS" },
        { key: "W0102030301", value: "HER-2/NEU" },
        { key: "W0102030302", value: "P53" },
        { key: "W0102030399", value: "OTHER ONCOPROTEINS" },
        { key: "W01020390", value: "OTHER TUMOUR MARKERS" },
        { key: "W0102039001", value: "ALPHAFETOPROTEIN" },
        { key: "W0102039002", value: "BETA2-MICROGLOBULIN" },
        { key: "W0102039003", value: "CATHEPSIN-D" },
        { key: "W0102039004", value: "5 HIAA" },
        { key: "W0102039005", value: "HUMAN PLACENTA LIKE ALKALINE PHOSPHATASE" },
        { key: "W0102039006", value: "LAMININ" },
        { key: "W0102039007", value: "NEURON SPECIFIC ENOLASE" },
        { key: "W0102039008", value: "THYMIDINE KINASE" },
        { key: "W0102039009", value: "TISSUE ASSOCIATED PROTEIN" },
        { key: "W0102039010", value: "MATRIX-METALLOPROTEINASES" },
        { key: "W0102039011", value: "SEROTONINE" },
        { key: "W0102039013", value: "FECAL OCCULT BLOOD (IC)" },
        { key: "W0102039014", value: "CHROMOGRANIN A" },
        { key: "W0102039015", value: "ALPHA SUBUNIT" },
        { key: "W0102039017", value: "PROTEIN INDUCED BY VITAMIN K ABSENCE OR ANTAGONIST-II (PIVKA-II)" },
        { key: "W0102039018", value: "ALPHA-FUCOSIDASE" },
        { key: "W0102039019", value: "SOLUBLE MESOTHELIN-RELATED PEPTIDES" },
        { key: "W0102039099", value: "TUMOUR MARKERS - OTHER" },
        { key: "W010204", value: "THYROID FUNCTION HORMONES" },
        { key: "W01020401", value: "FREE TRIIODOTHYRONINE" },
        { key: "W01020402", value: "FREE THYROXINE" },
        { key: "W01020403", value: "NEONATAL THYROID STIMULATING HORMONE" },
        { key: "W01020404", value: "REVERSE TRIIODOTHYRONINE" },
        { key: "W01020405", value: "TRIIODOTHYRONINE" },
        { key: "W01020406", value: "T- UPTAKE" },
        { key: "W01020407", value: "THYROXINE" },
        { key: "W01020408", value: "THYROGLOBULIN" },
        { key: "W01020409", value: "THYROID BINDING GLOBULIN" },
        { key: "W01020410", value: "THYROID STIMULATING HORMONE" },
        { key: "W01020411", value: "NEONATAL THYROXINE" },
        { key: "W01020499", value: "THYROID HORMONES - OTHER" },
        { key: "W010205", value: "FERTILITY / PREGNANCY HORMONES / PROTEINS" },
        { key: "W01020501", value: "FERTILITY FUNCTION HORMONES / PROTEINS" },
        { key: "W0102050101", value: "ANDROSTENEDIONE" },
        { key: "W0102050102", value: "DEHYDRO-EPIANDROSTERONE SULPHATE (INCL. DHEA)" },
        { key: "W0102050103", value: "ESTRADIOL" },
        { key: "W0102050104", value: "FOLLICLE STIMULATING HORMONE" },
        { key: "W0102050105", value: "LUTEINISING HORMONE" },
        { key: "W0102050106", value: "PROGESTERONE" },
        { key: "W0102050107", value: "17 OH PROGESTERONE" },
        { key: "W0102050108", value: "PROLACTIN" },
        { key: "W0102050109", value: "SEX HORMONE BINDING GLOBULIN" },
        { key: "W0102050110", value: "TESTOSTERONE (WITH DEHYDRO AND FREE TESTOSTERONE)" },
        { key: "W0102050111", value: "ANDROSTERONE" },
        { key: "W0102050112", value: "ANDROSTANEDIOL-GLUCURONIDE" },
        { key: "W0102050114", value: "11-DESOXYCORTISOL" },
        { key: "W0102050115", value: "CORTICOSTERON (R/M)" },
        { key: "W0102050199", value: "FERTILITY FUNCTION HORMONES - OTHER" },
        { key: "W01020502", value: "PREGNANCY TESTING HORMONES / PROTEINS" },
        { key: "W0102050201", value: "ALPHA2-PREGNANCY ASSOCIATED GLYCOPROTEIN" },
        { key: "W0102050202", value: "ESTRIOL" },
        { key: "W0102050203", value: "UNCONJUGATED (FREE) ESTRIOL" },
        { key: "W0102050204", value: "ESTRONE" },
        { key: "W0102050205", value: "TOTAL HUMAN CHORIONIC GONADOTROPIN " },
        { key: "W0102050206", value: "B- HUMAN CHORIONIC GONADOTROPIN (INCL. SUBUNIT)" },
        { key: "W0102050207", value: "HUMAN PLACENTAL LACTOGEN" },
        { key: "W0102050208", value: "PREGNANCY SPECIFIC B1 -GLYCOPROTEIN" },
        { key: "W0102050209", value: "GLYCOPROTEIN A SUBUNIT" },
        { key: "W0102050210", value: "PREGNANCY ASSOCIATED PLASMA PROTEIN - A (DOWNS)" },
        { key: "W0102050211", value: "PLACENTAL GROWTH FACTOR (PRE-ECLAMPSIA)" },
        { key: "W0102050212", value: "SOLUBLE FMS-LIKE TYROSINE KINASE-1" },
        { key: "W0102050213", value: "FREE BETA HCG (PRENATAL SCREENING)" },
        { key: "W0102050214", value: "INHIBIN A/B (PRENATAL SCREENING)" },
        { key: "W0102050215", value: "ANTI-MÛLLERIAN HORMONE" },
        { key: "W0102050299", value: "PREGNANCY TESTING HORMONES - OTHER" },
        { key: "W010206", value: "INDIVIDUAL AND SPECIFIC HORMONES / PROTEINS" },
        { key: "W01020601", value: "DIABETES ASSAYS (HORMONES)" },
        { key: "W0102060101", value: "C-PEPTIDE" },
        { key: "W0102060102", value: "GLUCAGON" },
        { key: "W0102060103", value: "INSULIN" },
        { key: "W0102060104", value: "INSULIN ANTIBODY" },
        { key: "W0102060105", value: "GAD II ANTIBODIES AND OTHER ICA" },
        { key: "W0102060106", value: "THYROSIN PHOSPHATASE IA2 ANTIBODIES" },
        { key: "W0102060107", value: "PROINSULIN" },
        { key: "W0102060108", value: "ISLET CELL AB" },
        { key: "W0102060109", value: "GLYCOSYLATED/GLYCATED HAEMOGLOBIN (IC)" },
        { key: "W0102060199", value: "DIABETES ASSAYS - OTHER" },
        { key: "W01020602", value: "RENAL METABOLISM ASSAYS" },
        { key: "W0102060201", value: "ALDOSTERONE" },
        { key: "W0102060202", value: "ANGIOTENSIN I / II" },
        { key: "W0102060203", value: "CORTISOL" },
        { key: "W0102060204", value: "RENINE (PLASMA RENINE ACTIVITY)" },
        { key: "W0102060205", value: "ANGIOTENSIN CONVERTING ENZYME (IC)" },
        { key: "W0102060206", value: "RENINE DIRECT" },
        { key: "W0102060207", value: "NEUTROPHIL GELATINASE ASSOCIATED LIPOCALIN (LIPOCALIN 2)" },
        { key: "W0102060208", value: "TISSUE INHIBITOR OF METALLOPROTEINASE-2 / INSULINE-LIKE GROWTH FACTOR - BINDING PROTEIN-7" },
        { key: "W0102060299", value: "RENAL METABOLISM TESTS - OTHER" },
        { key: "W01020603", value: "BONE AND MINERAL METABOLISM ASSAYS" },
        { key: "W0102060301", value: "CALCITONIN" },
        { key: "W0102060302", value: "COLLAGEN TYPE I C-TERMINAL PROPEPTIDE" },
        { key: "W0102060303", value: "COLLAGEN TYPE III C-TERMINAL PROPEPTIDE" },
        { key: "W0102060304", value: "CROSS-LINKED C-TELOPEPTIDES" },
        { key: "W0102060305", value: "CROSS-LINKED N-TELOPEPTIDES" },
        { key: "W0102060306", value: "CYCLIC ADENOSIN MONOPHOSPHATE" },
        { key: "W0102060307", value: "DEOXYPYRIDINOLINE" },
        { key: "W0102060308", value: "1.25-DIHYDROXYVITAMIN D" },
        { key: "W0102060309", value: "25-HYDROXYVITAMIN D" },
        { key: "W0102060310", value: "HYDROXYPROLINE" },
        { key: "W0102060311", value: "OSTEOCALCINE" },
        { key: "W0102060312", value: "PARATHYROID HORMONE INTACT" },
        { key: "W0102060313", value: "PARATHYROID HORMONE (C-/N-TERMINAL, M-REGIONAL)" },
        { key: "W0102060314", value: "PARATHYROID HORMONE RELATED PEPTIDE" },
        { key: "W0102060315", value: "PYRIDINOLINE" },
        { key: "W0102060316", value: "TARTRATE-RESISTANT ACID PHOSPHATASE 5B" },
        { key: "W0102060317", value: "PROCOLLAGEN TYPE I N TERMINAL PROPEPTIDE" },
        { key: "W0102060318", value: "BONE ALKALINE PHOSPHATASE (IC)" },
        { key: "W0102060399", value: "BONE METABOLISM TESTS - OTHER" },
        { key: "W01020604", value: "ENDOCRINE HORMONES AND PEPTIDES" },
        { key: "W0102060401", value: "ADRENOCORTIOTROPIC HORMONE" },
        { key: "W0102060402", value: "HUMAN GROWTH HORMONE" },
        { key: "W0102060403", value: "INSULIN-LIKE GROWTH FACTOR I (SOMATOMEDIN C)" },
        { key: "W0102060404", value: "INSULIN-LIKE GROWTH FACTOR II" },
        { key: "W0102060405", value: "INSULIN-LIKE GROWTH FACTOR BINDING PROTEIN 1" },
        { key: "W0102060406", value: "INSULIN-LIKE GROWTH FACTOR BINDING PROTEIN 3" },
        { key: "W0102060407", value: "VASOINTESTINAL PEPTIDE" },
        { key: "W0102060408", value: "VASOPRESSIN" },
        { key: "W0102060499", value: "ENDOCRINE HORMONES (GROWTH FACTORS) - OTHER" },
        { key: "W01020605", value: "NEUROENDOCRINE FUNCTION ASSAYS" },
        { key: "W0102060501", value: "BOMBESIN" },
        { key: "W0102060502", value: "B-ENDORPHIN" },
        { key: "W0102060503", value: "17-HYDROXY-KETOSTERONE" },
        { key: "W0102060504", value: "17-KETOGENIC STEROIDS" },
        { key: "W0102060505", value: "17-KETOSTEROIDS" },
        { key: "W0102060506", value: "A-MELANOCITE STIMULATING HORMONES" },
        { key: "W0102060507", value: "NEUROTENSIN" },
        { key: "W0102060508", value: "SOMATOSTATIN" },
        { key: "W0102060509", value: "SUBSTANCE P" },
        { key: "W0102060599", value: "NEOENDOCRINE FUNCTION ASSAYS - OTHER" },
        { key: "W01020606", value: "MULTIPLE HORMONES - INDIVIDUAL AND SPECIFIC" },
        { key: "W0102060601", value: "ADRENALIN / NORADRENALINE / DOPAMINE" },
        { key: "W0102060699", value: "MULTIPLE INDIVIDUAL HORMONES - OTHER" },
        { key: "W01020690", value: "VARIOUS INDIVIDUAL AND SPECIFIC HORMONES" },
        { key: "W0102069001", value: "GASTRIN" },
        { key: "W0102069002", value: "GONADOTROPIN-RELEASING HORMONE" },
        { key: "W0102069003", value: "MELATONINE" },
        { key: "W0102069004", value: "NEOPTERINE" },
        { key: "W0102069005", value: "OXYTOCIN" },
        { key: "W0102069006", value: "PEPSINOGEN" },
        { key: "W0102069007", value: "PROSTAGLANDIN" },
        { key: "W0102069008", value: "SEROTONIN-UPTAKE (PLATELETS)" },
        { key: "W0102069009", value: "ELASTASE (PANCREATIC POLYPEPTIDE)" },
        { key: "W0102069010", value: "ADRENALIN" },
        { key: "W0102069011", value: "NORADRENALIN" },
        { key: "W0102069012", value: "DOPAMINE" },
        { key: "W0102069013", value: "PROCALCITONIN" },
        { key: "W0102069014", value: "LEPTIN" },
        { key: "W0102069015", value: "MOTILIN" },
        { key: "W0102069016", value: "CYCLIC GUANOSINE MONOPHOSPHATE" },
        { key: "W0102069017", value: "MID-REGIONAL PROADRENOMEDULLIN (MR-PROADM)" },
        { key: "W0102069099", value: "INDIVIDUAL AND SPECIFIC HORMONES - OTHER" },
        { key: "W010207", value: "ANEMIA RELATED / VITAMIN TESTS" },
        { key: "W01020701", value: "ANEMIA" },
        { key: "W0102070101", value: "ERYTHROPOIETIN" },
        { key: "W0102070102", value: "FERRITIN" },
        { key: "W0102070103", value: "FOLATE" },
        { key: "W0102070104", value: "SOLUBLE TRANSFERRIN RECEPTOR" },
        { key: "W0102070105", value: "RETICULOCYTE HAEMOGLOBIN CONTENT" },
        { key: "W0102070106", value: "IRON (IC)" },
        { key: "W0102070107", value: "IRON BINDING CAPACITY - TOTAL (IC)" },
        { key: "W0102070199", value: "ANEMIA - OTHER" },
        { key: "W01020702", value: "VITAMINES" },
        { key: "W0102070201", value: "VITAMIN B1" },
        { key: "W0102070202", value: "VITAMIN B2" },
        { key: "W0102070203", value: "VITAMIN B6" },
        { key: "W0102070204", value: "VITAMIN B12" },
        { key: "W0102070205", value: "INTRINSIC FACTOR (BLOCKING ANTIBODY)" },
        { key: "W0102070206", value: "VITAMIN D (CHOLECALCIFEROL)" },
        { key: "W0102070299", value: "VITAMIN TESTS - OTHER" },
        { key: "W01020703", value: "MULTIPLE - ANEMIA RELATED / VITAMIN TESTS" },
        { key: "W0102070301", value: "VITAMIN B 12 / FOLATE" },
        { key: "W0102070399", value: "MULTIPLE ANEMIA / VITAMIN TESTS - OTHER" },
        { key: "W010208", value: "THERAPEUTIC DRUG MONITORING" },
        { key: "W01020801", value: "CARDIOVASCULAR TDM" },
        { key: "W0102080101", value: "DIGOXIN" },
        { key: "W0102080102", value: "DIGITOXIN" },
        { key: "W0102080103", value: "DISOPYRAMIDE" },
        { key: "W0102080104", value: "FLECAINIDE" },
        { key: "W0102080105", value: "LIDOCAINE" },
        { key: "W0102080106", value: "N-ACETYLPROCAINAMIDE" },
        { key: "W0102080107", value: "PROCAINAMIDE" },
        { key: "W0102080108", value: "PROPRANOLOL" },
        { key: "W0102080109", value: "QUINIDINE" },
        { key: "W0102080199", value: "CARDIOVASCULAR TDM - OTHER" },
        { key: "W01020802", value: "CENTRAL NERVOUS SYSTEMS TDM" },
        { key: "W0102080201", value: "CARBAMAZEPINE" },
        { key: "W0102080202", value: "ETHOSUXIMIDE" },
        { key: "W0102080203", value: "FREE CARBAMAZEPINE" },
        { key: "W0102080204", value: "FREE PHENYTOIN" },
        { key: "W0102080205", value: "FREE PRIMIDONE" },
        { key: "W0102080206", value: "FREE VALPROIC ACID" },
        { key: "W0102080207", value: "PHENOBARBITAL" },
        { key: "W0102080208", value: "PHENYTOIN" },
        { key: "W0102080209", value: "PRIMIDONE" },
        { key: "W0102080210", value: "VALPROIC ACID" },
        { key: "W0102080211", value: "GABAPENTIN" },
        { key: "W0102080212", value: "LAMOTRIGINE" },
        { key: "W0102080213", value: "TOPIRAMATE" },
        { key: "W0102080214", value: "ZONISAMIDE" },
        { key: "W0102080215", value: "LEVETIRACETAM" },
        { key: "W0102080299", value: "CENTRAL NERVOUS SYSTEM TDM - OTHER" },
        { key: "W01020803", value: "ANTIBIOTIC TDM / ANTIVIRUS TDM" },
        { key: "W0102080301", value: "AMIKACIN" },
        { key: "W0102080303", value: "CHLORAMPHENICOL" },
        { key: "W0102080305", value: "DIBEKACIN" },
        { key: "W0102080307", value: "GENTAMICIN" },
        { key: "W0102080309", value: "KANAMYCIN" },
        { key: "W0102080311", value: "NETILMYCIN" },
        { key: "W0102080313", value: "SISOMYCIN" },
        { key: "W0102080315", value: "STREPTOMYCIN" },
        { key: "W0102080317", value: "TOBRAMYCIN" },
        { key: "W0102080319", value: "VANCOMYCIN" },
        { key: "W0102080321", value: "TEICOPLANINE" },
        { key: "W0102080399", value: "ANTIBIOTICS TDM - OTHER" },
        { key: "W01020804", value: "ANTI-ASTHMA TDM" },
        { key: "W0102080401", value: "CAFFEINE" },
        { key: "W0102080402", value: "THEOPHYLLINE" },
        { key: "W0102080499", value: "ANTI-ASTHMA TDM - OTHER" },
        { key: "W01020805", value: "ANTI-NEOPLASTIC TDM" },
        { key: "W0102080501", value: "METHOTREXATE" },
        { key: "W0102080599", value: "ANTI-NEOPLASTIC TDM - OTHER" },
        { key: "W01020806", value: "IMMUNOSUPPRESSANT TDM" },
        { key: "W0102080601", value: "CYCLOSPORINE TOTAL" },
        { key: "W0102080602", value: "CYCLOSPORINE SPECIFIC" },
        { key: "W0102080603", value: "TACROLIMUS" },
        { key: "W0102080604", value: "RAPAMYCIN (SIROLIMUS)" },
        { key: "W0102080605", value: "MYCOPHENOLATE" },
        { key: "W0102080606", value: "EVEROLIMUS" },
        { key: "W0102080699", value: "IMMUNOSUPPRESSANT TDM - OTHER" },
        { key: "W01020807", value: "AUTOIMMUNE DISEASE TDM" },
        { key: "W0102080701", value: "INFLIXIMAB" },
        { key: "W0102080702", value: "ADALIMUMAB" },
        { key: "W0102080703", value: "ETANERCEP" },
        { key: "W0102080704", value: "RITUXIMAB" },
        { key: "W0102080799", value: "AUTOIMMUNE DISEASE TDM - OTHER" },
        { key: "W01020899", value: "THERAPEUTIC DRUG MONITORING - OTHER" },
        { key: "W010209", value: "DRUGS OF ABUSE / TOXICOLOGY" },
        { key: "W01020901", value: "DRUGS OF ABUSE" },
        { key: "W0102090101", value: "AMPHETAMINES GROUP" },
        { key: "W0102090102", value: "AMPHETAMINE/METHAMPHETAMINE SPECIFIC" },
        { key: "W0102090103", value: "BARBITURATES" },
        { key: "W0102090104", value: "BENZODIAZEPINES" },
        { key: "W0102090105", value: "CANNABINOIDS" },
        { key: "W0102090106", value: "COCAINE + COCAINE METABOLITES" },
        { key: "W0102090107", value: "CODEINE" },
        { key: "W0102090108", value: "COTININE" },
        { key: "W0102090109", value: "LYSERGIC ACID DIETHYLAMIDE" },
        { key: "W0102090110", value: "METHADONE" },
        { key: "W0102090111", value: "METHAQUALONE" },
        { key: "W0102090112", value: "MORPHINES" },
        { key: "W0102090113", value: "OPIATES" },
        { key: "W0102090114", value: "PHENCYCLIDINE" },
        { key: "W0102090115", value: "PROPOXYPHENE" },
        { key: "W0102090116", value: "6-ACETHYLMORPHIUM" },
        { key: "W0102090117", value: "BUPRENORPHINE" },
        { key: "W0102090118", value: "DEXTROMETHORPHAN" },
        { key: "W0102090119", value: "MDMA (ECSTASY)" },
        { key: "W0102090120", value: "EDDP SPECIFIC (METHADONE METABOLITES)" },
        { key: "W0102090121", value: "TRAMADOL" },
        { key: "W0102090122", value: "FENTANYL" },
        { key: "W0102090123", value: "OXYCODINE" },
        { key: "W0102090199", value: "DRUGS OF ABUSE - OTHER" },
        { key: "W01020902", value: "TOXICOLOGY" },
        { key: "W0102090201", value: "ACETAMINOPHENE (PARACETAMOL)" },
        { key: "W0102090202", value: "5-AMINOLEVULINATE DEHYDRATASE" },
        { key: "W0102090203", value: "AMITRIPTYLINE" },
        { key: "W0102090204", value: "CATECHOLAMINES" },
        { key: "W0102090205", value: "DESIPRAMINE" },
        { key: "W0102090206", value: "DOXEPIN PLUS METABOLITES" },
        { key: "W0102090207", value: "ETHANOL (ALCOHOL)" },
        { key: "W0102090208", value: "HIPPURIC ACID" },
        { key: "W0102090209", value: "IMIPRAMINE" },
        { key: "W0102090210", value: "NORTRIPTYLINE" },
        { key: "W0102090211", value: "PHENOLS" },
        { key: "W0102090212", value: "PROTOPORPHYRIN IX" },
        { key: "W0102090213", value: "SALICYLATE" },
        { key: "W0102090214", value: "TRICHLOROACETIC ACID" },
        { key: "W0102090215", value: "TRICYCLIC ANTIDEPRESSANTS (TOTAL)" },
        { key: "W0102090216", value: "URO/COPROPORPHYRINS" },
        { key: "W0102090217", value: "VANILLYLMANDELIC ACID" },
        { key: "W0102090218", value: "HOMOVANILLIC ACID" },
        { key: "W0102090220", value: "ETHYL GLUCURONIDE" },
        { key: "W0102090299", value: "TOXICOLOGY - OTHER" },
        { key: "W010210", value: "MARKERS FOR AUTO-IMMUNE DISEASES" },
        { key: "W01021001", value: "AUTOIMMUNE CONNECTIVE TISSUE DISEASES" },
        { key: "W0102100101", value: "ANA SCREENING" },
        { key: "W0102100102", value: "ENA SCREENING" },
        { key: "W0102100105", value: "DS DNA - ANTIBODIES" },
        { key: "W0102100106", value: "SS DNA - ANTIBODIES" },
        { key: "W0102100107", value: "HISTONES (H1, H2A, H3, H4,…HN)" },
        { key: "W0102100108", value: "JO-1" },
        { key: "W0102100109", value: "PM-SCL - ANTIBODIES" },
        { key: "W0102100110", value: "SCL-70" },
        { key: "W0102100111", value: "SM" },
        { key: "W0102100112", value: "SS-A" },
        { key: "W0102100113", value: "SS-B" },
        { key: "W0102100114", value: "U1-SNRNP - ANTIBODIES" },
        { key: "W0102100115", value: "ANTI-CENTROMERE ANTIBODIES" },
        { key: "W0102100117", value: "NUCLEOSOME ANTIBODIES" },
        { key: "W0102100118", value: "RIBOSOMAL PHOSPHOPROTEIN ANTIBODIES" },
        { key: "W0102100199", value: "AUTOIMMUNE CONNECTIVE TISSUE DISEASES TESTING - OTHER" },
        { key: "W01021002", value: "NEURO-AUTO-IMMUNE DISEASE" },
        { key: "W0102100201", value: "ANTI-GANGLIOSIDE-ANTIBODIES TOTAL" },
        { key: "W0102100202", value: "ANTI-GM1" },
        { key: "W0102100203", value: "ASIALO-GM1" },
        { key: "W0102100204", value: "ANTI-GD1B" },
        { key: "W0102100205", value: "GAL (ß1-3)" },
        { key: "W0102100206", value: "GALNAC" },
        { key: "W0102100207", value: "ANTI-MAG (MYELIN ASSOCIATED GLYCOPROTEIN)" },
        { key: "W0102100208", value: "ANTI-CAR (CANCER ASSOCIATED RETINOPATHY)" },
        { key: "W0102100209", value: "ANTI-HU ANTIBODY" },
        { key: "W0102100210", value: "ANTI-YO ANTIBODY" },
        { key: "W0102100211", value: "ANTI-RI ANTIBODY" },
        { key: "W0102100212", value: "ANTI-GQ1B" },
        { key: "W0102100299", value: "NEURO-AUTO-IMMUNE DISEASE - OTHER" },
        { key: "W01021003", value: "THYROID-AUTO-IMMUNE DISEASE" },
        { key: "W0102100301", value: "THYROID PEROXIDASE (INCL. MICROSOMAL) ANTIBODIES" },
        { key: "W0102100302", value: "TSH RECEPTOR ANTIBODIES" },
        { key: "W0102100303", value: "THYROGLOBULIN AUTOANTIBODY" },
        { key: "W0102100304", value: "THYROID STIMULATING IMMUNOGLOBULIN" },
        { key: "W0102100399", value: "THYROID-AUTO-IMMUNE DISEASE - OTHER" },
        { key: "W01021004", value: "VASCULITIS" },
        { key: "W0102100401", value: "ANCA SCREENING" },
        { key: "W0102100402", value: "MPO ANCA" },
        { key: "W0102100403", value: "PR3 ANCA" },
        { key: "W0102100499", value: "VASCULITIS - OTHER" },
        { key: "W01021005", value: "ANTI-PHOSPHOLIPID SYNDROM" },
        { key: "W0102100501", value: "ANTI-CARDIOLIPIN ANTIBODIES" },
        { key: "W0102100502", value: "ANTI-PHOSPHATIDYLSERIN ANTIBODIES" },
        { key: "W0102100503", value: "ANTI-B2-GLYCOPROTEIN I ANTIBODIES" },
        { key: "W0102100504", value: "APLS SCREENING (OR ANTI-CARDIOLIPIN / ANTI-B2-GLYCOPROTEIN COMBITEST)" },
        { key: "W0102100599", value: "ANTI-PHOSPHOLIP SYNDROME - OTHER" },
        { key: "W01021006", value: "CELIAC DISEASE" },
        { key: "W0102100601", value: "TISSUE TRANSGLUTAMINASE ANTIBODIES" },
        { key: "W0102100602", value: "TISSUE TRANSGLUTAMINASE/ GLIADIN ANTIBODIES COMBITEST" },
        { key: "W0102100603", value: "ANTIBODIES TO ENDOMYSIAL AUTOANTIGENES" },
        { key: "W0102100604", value: "GLIADIN ANTIBODIES" },
        { key: "W0102100699", value: "CELIAC DISEASE - OTHER" },
        { key: "W01021007", value: "AUTOIMMUNE HEPATITIS" },
        { key: "W0102100701", value: "HEPATITIS AUTOANTIBODY SCREENING" },
        { key: "W0102100702", value: "ANTI-MITOCHONDRIAL ANTIBODIES" },
        { key: "W0102100703", value: "LKM1 AND RELATED PROTEINS ANTIBODIES" },
        { key: "W0102100704", value: "ANTI-ACTIN ANTIBODIES" },
        { key: "W0102100705", value: "PARIETAL CELL ANTIBODIES" },
        { key: "W0102100706", value: "SP 100 ANTIBODIES" },
        { key: "W0102100707", value: "ANTIBODIES TO SOLUBLE LIVERANTIGENES" },
        { key: "W0102100799", value: "AUTOIMMUNE HEPATITIS - OTHER" },
        { key: "W01021008", value: "INFLAMATORY BOWEL DISEASE (IBD)" },
        { key: "W0102100801", value: "SACCHAROMYCES CEREVISIAE ANTIBODIES" },
        { key: "W0102100802", value: "PERINUCLEAR ANTI-NEUTROPHIL CYTOPLASMIC ANTIBODIES" },
        { key: "W0102100899", value: "OTHERS INFLAMATORY BOWEL DISEASE" },
        { key: "W01021090", value: "VARIOUS AUTO-IMMUNE DISEASE" },
        { key: "W0102109005", value: "COMPLEMENT ACTIVATION" },
        { key: "W0102109007", value: "GOODPASTURE ANTIBODIES" },
        { key: "W0102109013", value: "SPERM ANTIBODIES" },
        { key: "W0102109014", value: "ANTIBODIES TO GLOMERULAR BASAL MEMBRANE" },
        { key: "W0102109022", value: "ACETYLCHOLIN RECEPTOR ANTIBODIES" },
        { key: "W0102109023", value: "LDL ANTIBODIES" },
        { key: "W0102109099", value: "AUTO-IMMUNE DISEASE TESTS - OTHER" },
        { key: "W010211", value: "RHEUMATOID - INFLAMMATORY DISEASES MARKERS" },
        { key: "W01021101", value: "ANTI-STREPTOCOCCAL DEOXYRIBONUCLEASE B (ANTI-DNAASE B)" },
        { key: "W01021102", value: "ANTI-STREPTOCOCCAL HYALURONIDASE" },
        { key: "W01021103", value: "ANTI-STREPTOKINASE" },
        { key: "W01021104", value: "ANTI-STREPTOLYSIN O (QUANTITATIVE)" },
        { key: "W01021105", value: "ANTI-STREPTOLYSIN O REACTION TIME / TITRE (QUALITATIVE)" },
        { key: "W01021106", value: "ANTI-STAPHYLOLYSIN (QUANTITATIVE)" },
        { key: "W01021107", value: "ANTI-STAPHYLOLYSIN REACTION TIME / TITRE (QUALITATIVE)" },
        { key: "W01021108", value: "CIRCULATING IMMUNE COMPLEXES" },
        { key: "W01021109", value: "C-REACTIVE PROTEIN" },
        { key: "W01021110", value: "RHEUMATOID FACTORS" },
        { key: "W01021111", value: "ANTI-STREPTOCOCCAL SCREENING" },
        { key: "W01021112", value: "ANTI-CYCLIC CITRULLINATED PEPTIDE" },
        { key: "W01021199", value: "RHEUMATOID / INFLAMMATORY DISEASE MARKERS - OTHER" },
        { key: "W010212", value: "SPECIFIC ORGAN FUNCTION ASSAYS" },
        { key: "W01021201", value: "LIVER FUNCTION    (IMMUNOCHEMISTRY)" },
        { key: "W0102120101", value: "MEGX" },
        { key: "W0102120102", value: "CARBO HYDRATE DEFICIENT TRANSFERRIN" },
        { key: "W0102120103", value: "HYALURONIC ACID" },
        { key: "W0102120104", value: "PROCOLLAGEN III AMINO TERMINAL PEPTIDE" },
        { key: "W0102120105", value: "TISSUE INHIBITOR OF METALLOPROTEINASE 1" },
        { key: "W0102120199", value: "LIVER FUNCTION - OTHER" },
        { key: "W01021299", value: "ORGAN FUNCTION ASSAYS - OTHER" },
        { key: "W010213", value: "CARDIAC MARKERS" },
        { key: "W01021301", value: "BNP / PROBNP (INCLUDING OTHER NATRIURIC PEPTIDES)" },
        { key: "W01021302", value: "HEART-TYPE FATTY ACID BINDING PROTEIN" },
        { key: "W01021303", value: "GLYCOGEN PHOSPHORYLASE BB" },
        { key: "W01021304", value: "MYOGLOBIN" },
        { key: "W01021305", value: "MYOSIN LIGHT CHAIN" },
        { key: "W01021306", value: "TROPONIN I/T" },
        { key: "W01021307", value: "HOMOCYSTEINE" },
        { key: "W01021308", value: "HIGH-SENSITIVITY C-.REACTIVE PROTEIN" },
        { key: "W01021309", value: "ISCHEMIA MODIFIED ALBUMIN" },
        { key: "W01021310", value: "MYELOPEROXIDASE" },
        { key: "W01021311", value: "CREATINE KINASE - MB MASS (IC)" },
        { key: "W01021312", value: "LIPOPROTEIN-ASSOCIATED PHOSPHOLIPASE A2" },
        { key: "W01021313", value: "GALECTIN-3" },
        { key: "W01021314", value: "ST2" },
        { key: "W01021315", value: "COPEPTIN" },
        { key: "W01021316", value: "MID-REGIONAL PRO ATRIAL NATRIURETIC PEPTIDE (MR-PROANP)" },
        { key: "W01021399", value: "CARDIAC MARKERS - OTHER" },
        { key: "W010214", value: "MULTIPLE PARAMETERS -  IMMUNOCHEMISTRY" },
        { key: "W01021499", value: "MULTIPLE IMMUNOCHEMISTRY REAGENTS - OTHER" },
        { key: "W010215", value: "IMMUNOCHEMISTRY CONTROLS/STANDARDS/CALIBRATORS" },
        { key: "W01021520", value: "CONTROLS - IMMUNOCHEMISTRY" },
        { key: "W0102152001", value: "TDM/DRUG CONTROLS" },
        { key: "W0102152002", value: "HORMONE CONTROLS" },
        { key: "W0102152003", value: "SPECIFIC PROTEIN CONTROLS" },
        { key: "W0102152004", value: "CARDIAC MARKER CONTROLS" },
        { key: "W0102152005", value: "TUMOUR MARKER CONTROLS" },
        { key: "W0102152006", value: "ANAEMIA RELATED/VITAMIN CONTROLS" },
        { key: "W0102152008", value: "CONTROLS FOR INDIVIDUAL AND SPECIFIC HORMONES" },
        { key: "W0102152009", value: "CONTROLS FOR NARCOTICS / TOXICOLOGY" },
        { key: "W0102152010", value: "CONTROLS FOR RHEUMATOLOGY" },
        { key: "W0102152011", value: "CONTROLS FOR AUTOIMMUNITY" },
        { key: "W0102152099", value: "CONTROLS- IMMUNOCHEMISTRY - OTHER" },
        { key: "W01021521", value: "MULTICOMPONENT IMMUNOCHEMISTRY CONTROLS" },
        { key: "W01021522", value: "STANDARDS AND CALIBRATORS IMMUNOCHEMISTRY" },
        { key: "W0102152201", value: "TDM/DRUG STANDARDS AND CALIBRATORS" },
        { key: "W0102152202", value: "HORMONE STANDARDS AND CALIBRATORS" },
        { key: "W0102152203", value: "SPECIFIC PROTEIN STANDARDS AND CALIBRATORS" },
        { key: "W0102152204", value: "CARDIAC MARKER STANDARDS AND CALIBRATORS" },
        { key: "W0102152205", value: "TUMOUR MARKER STANDARDS AND CALIBRATORS" },
        { key: "W0102152206", value: "ANAEMIA RELATED/VITAMIN STANDARDS AND CALIBRATORS" },
        { key: "W0102152208", value: "STANDARDS AND CALIBRATORS FOR INDIVIDUAL AND SPECIFIC HORMONES /PROTEINS" },
        { key: "W0102152209", value: "DRUGS OF ABUSE / TOXICOLOGY STANDARDS AND CALIBRATORS" },
        { key: "W0102152210", value: "STANDARDS AND CALIBRATORS FOR RHEUMATOLOGY" },
        { key: "W0102152211", value: "STANDARDS AND CALIBRATORS FOR AUTOIMMUNITY" },
        { key: "W0102152299", value: "STANDARDS AND CALIBRATORS - IMMUNOCHEMISTRY - OTHER" },
        { key: "W010216", value: "IMMUNOCHEMISTRY - RAPID TESTS & POINT OF CARE" },
        { key: "W01021601", value: "SPECIFIC PROTEINS RT & POC" },
        { key: "W0102160101", value: "ALBUMIN INCL. UALBUMIN RT & POC" },
        { key: "W0102160102", value: "GLYCOSYLATED/GLYCATED HAEMOGLOBIN (IC) RT & POC" },
        { key: "W0102160199", value: "SPECIFIC PROTEINS RT & POC - OTHER" },
        { key: "W01021602", value: "TUMOUR MARKERS RT & POC" },
        { key: "W0102160201", value: "BTA - RT & POC" },
        { key: "W0102160202", value: "PSA - RT & POC" },
        { key: "W0102160203", value: "FECAL OCCULT BLOOD - RT & POC" },
        { key: "W0102160299", value: "TUMOUR MARKER RT & POC - OTHER" },
        { key: "W01021603", value: "FERTILITY / PREGNANCY RT & POC" },
        { key: "W0102160301", value: "FSH - RT & POC" },
        { key: "W0102160302", value: "HCG - RT & POC" },
        { key: "W0102160303", value: "HPL - RT & POC" },
        { key: "W0102160304", value: "LH - RT & POC" },
        { key: "W0102160399", value: "FERTILITY/PREGNANCY RT & POC - OTHER" },
        { key: "W01021604", value: "THERAPEUTIC DRUG MONITORING (TDM) RT & POC" },
        { key: "W0102160401", value: "THEOPHYLLINE - RT & POC" },
        { key: "W0102160499", value: "TDM RT & POC - OTHER" },
        { key: "W01021605", value: "DRUGS OF ABUSE/TOXICOLOGY RT & POC" },
        { key: "W0102160501", value: "AMPHETAMINES - RT & POC" },
        { key: "W0102160502", value: "AMPHETAMINE/METHAMPHETAMINE SPECIFIC (+ECSTASY) - RT & POC" },
        { key: "W0102160503", value: "BARBITURATES - RT & POC" },
        { key: "W0102160504", value: "BENZODIAZEPINES - RT & POC" },
        { key: "W0102160505", value: "CANNABINOIDS - RT & POC" },
        { key: "W0102160506", value: "COCAINE + COCAINE METABOLITES - RT & POC" },
        { key: "W0102160507", value: "METHADONE INCL. EDDP - RT & POC" },
        { key: "W0102160508", value: "OPIATES - RT & POC" },
        { key: "W0102160509", value: "PHENCYCLIDINE - RT & POC" },
        { key: "W0102160510", value: "TRICYCLIC ANTIDEPRESSANTS - RT & POC" },
        { key: "W0102160511", value: "MULTIPLE DRUGS OF ABUSE/TOXICOLOGY RT & POC" },
        { key: "W0102160599", value: "DRUGS OF ABUSE/TOXICOLOGY RT & POC - OTHER" },
        { key: "W01021606", value: "RHEUMATOID / INFLAMMATORY DISEASE RT & POC" },
        { key: "W0102160601", value: "C-REACTIVE PROTEIN - RT & POC" },
        { key: "W0102160699", value: "RHEUMATOID / INFLAMMATORY DISEASE RT & POC - OTHER" },
        { key: "W01021607", value: "CARDIAC MARKERS - RT & POC" },
        { key: "W0102160701", value: "CREATINE KINASE - MB MASS - RT & POC" },
        { key: "W0102160702", value: "MYOGLOBIN - RT & POC" },
        { key: "W0102160703", value: "TROPONIN I/T - RT & POC" },
        { key: "W0102160704", value: "BNP / PROBNP - RT & POC (INCLUDING OTHER NATRIURIC PEPTIDES)" },
        { key: "W0102160705", value: "HEART-TYPE FATTY ACID-BINDING PROTEIN - RT & POC" },
        { key: "W0102160706", value: "MULTIPLE CARDIAC MARKERS - RT & POC" },
        { key: "W0102160799", value: "CARDIAC MARKERS - RT & POC - OTHER" },
        { key: "W01021608", value: "CONTROLS / STANDARDS / CALIBRATORS IMMUNOCHEM - RT & POC" },
        { key: "W0102160801", value: "CONTROLS IMMUNOCHEM - RT & POC" },
        { key: "W0102160802", value: "STANDARDS AND CALIBRATORS IMMUNOCHEM - RT & POC" },
        { key: "W01021609", value: "INDIVIDUAL AND SPECIFIC HORMONES/PROTEINS RT & POC" },
        { key: "W0102160901", value: "LIPOCALIN-2 GRANULOCYTE GELATINASE ASSOCIATED - RT & POC" },
        { key: "W0102160902", value: "PARATHYROID HORMONE - RT & POC" },
        { key: "W0102160903", value: "THYROID-STIMULATING HORMONE - RT & POC" },
        { key: "W0102160999", value: "INDIVIDUAL AND SPECIFIC HORMONES/PROTEINS RT & POC - OTHER" },
        { key: "W01021699", value: "RAPID TESTS & POINT OF CARE - IMMUNOCHEMISTRY - OTHER" },
        { key: "W010217", value: "TRAUMATIC BRAIN INJURY" },
        { key: "W01021701", value: "GLIAL FIBRILLARY ACIDIC PROTEIN / UBIQUITIN C-TERMINAL HYDROLASE-L1" },
        { key: "W01021702", value: "PROTEIN S-100 B" },
        { key: "W01021799", value: "OTHER TRAUMATIC BRAIN INJURY MARKERS" },
        { key: "W010290", value: "OTHER IMMUNOCHEMISTRY" },
        { key: "W01029001", value: "ANTISERA (MONOVALENT AND POLYVALENT)" },
        { key: "W01029002", value: "AMANITIN ( ORGANIC POISONS )" },
        { key: "W01029003", value: "BUFFERS (UNASSIGNABLE), SUPPLEM. REAGENTS, ETC (IC)" },
        { key: "W01029004", value: "COATED TUBES AND BEADS (UNASSIGNABLE) (IC)" },
        { key: "W01029099", value: "IMMUNOCHEMISTRY REAGENTS - OTHER" },
        { key: "W0103", value: "HAEMATOLOGY / HAEMOSTASIS / IMMUNOHAEMATOLOGY / HISTOLOGY / CYTOLOGY" },
        { key: "W010301", value: "HAEMATOLOGY REAGENTS" },
        { key: "W01030101", value: "REAGENTS FOR (AUTOMATED) HAEMATOLOGY ANALYZER" },
        { key: "W0103010102", value: "SPECIFIC RETICULOCYTE REAGENTS" },
        { key: "W0103010103", value: "COMPLETE CELL COUNT" },
        { key: "W0103010104", value: "SMALL CELL COUNT" },
        { key: "W0103010105", value: "CBC-REAGENTS (CLEANING-/DILUTING-/LYSING-/SHEAT-FLUIDS)" },
        { key: "W0103010199", value: "REAGENTS FOR (AUTOMATED) HAEMATOLOGY ANALYZER - OTHER" },
        { key: "W01030102", value: "HAEMOGLOBIN (TYPES) TESTING" },
        { key: "W0103010201", value: "HAEMOGLOBIN DETERMINATIONS (TOTAL HB)" },
        { key: "W0103010202", value: "HAEMOGLOBIN SUBTYPES HBA2, HBC, HBF, HBS, ETC.(EXCL. HBA1)" },
        { key: "W0103010299", value: "OTHER HAEMOGLOBIN (TYPES) TESTING - OTHER" },
        { key: "W01030103", value: "CELLULAR STAINS FOR MICROSCOPY" },
        { key: "W0103010301", value: "HISTO / CYTO STAINS" },
        { key: "W0103010302", value: "ROMANOWSKY STAINS" },
        { key: "W0103010399", value: "HAEMATOLOGY STAINS FOR MICROSCOPY - OTHER" },
        { key: "W01030105", value: "HAEMATOLOGY CONTROLS AND CALIBRATORS" },
        { key: "W0103010501", value: "NORMAL BLOOD CONTROLS" },
        { key: "W0103010502", value: "ABNORMAL BLOOD CONTROLS" },
        { key: "W0103010503", value: "MULTILEVEL BLOOD CONTROLS" },
        { key: "W0103010504", value: "HAEMOGLOBIN CONTROLS" },
        { key: "W0103010505", value: "PLATELET CONTROLS" },
        { key: "W0103010506", value: "RETICULOCYTE CONTROLS" },
        { key: "W0103010507", value: "WHOLE BLOOD CALIBRATORS" },
        { key: "W0103010599", value: "HAEMATOLOGY CONTROLS - OTHER" },
        { key: "W01030106", value: "HAEMATOLOGY TESTS - RT & POC" },
        { key: "W0103010601", value: "HAEMOGLOBIN (HB)" },
        { key: "W0103010602", value: "ERYTHROCYTES (ERY)" },
        { key: "W0103010603", value: "HAEMATOCRIT (HCT)" },
        { key: "W0103010604", value: "WHITE BLOOD CELLS (WBC)" },
        { key: "W0103010605", value: "PLATELETS" },
        { key: "W0103010606", value: "HAEMATOLOGY CONTROLS - RT & POC" },
        { key: "W0103010607", value: "HAEMATOLOGY STANDARDS AND CALIBRATORS - RT & POC" },
        { key: "W0103010699", value: "HAEMATOLOGY RAPID TESTS & POINT OF CARE - OTHER" },
        { key: "W01030107", value: "ERYTHROCYTE SEDIMENTATION RATE (ESR) TEST" },
        { key: "W01030190", value: "OTHER HAEMATOLOGY REAGENTS" },
        { key: "W0103019001", value: "CELLULAR ENZYME DETERMINATION REAGENTS (G-6-PDH, PYUVATE KINASE)" },
        { key: "W01030199", value: "HAEMATOLOGY REAGENTS - OTHER" },
        { key: "W010302", value: "HAEMOSTASIS REAGENTS (COAGULATION)" },
        { key: "W01030201", value: "GENERAL COAGULATION TESTS" },
        { key: "W0103020101", value: "PROTHROMBIN TIME ( QUICK TEST )" },
        { key: "W0103020102", value: "ACTIVATED PARTIAL THROMBOPLASTIN TIME" },
        { key: "W0103020103", value: "THROMBIN TIME / REPTILASE / BATROXBIN TIME" },
        { key: "W0103020104", value: "ACTIVATED CLOTTING TIME" },
        { key: "W0103020199", value: "GENERAL COAGULATION TESTS - OTHER" },
        { key: "W01030202", value: "COAGULATION FACTORS" },
        { key: "W0103020201", value: "FIBRINOGEN ASSAYS (FACTOR I)" },
        { key: "W0103020202", value: "COAGULATION FACTOR II ( PROTHROMBIN )" },
        { key: "W0103020203", value: "COAGULATION FACTOR II A ( THROMBIN )" },
        { key: "W0103020204", value: "COAGULATION FACTOR V" },
        { key: "W0103020205", value: "COAGULATION FACTOR VII" },
        { key: "W0103020206", value: "COAGULATION FACTOR VII A" },
        { key: "W0103020207", value: "COAGULATION FACTOR VIII" },
        { key: "W0103020208", value: "COAGULATION FACTOR IX" },
        { key: "W0103020209", value: "COAGULATION FACTOR X" },
        { key: "W0103020210", value: "COAGULATION FACTOR XI" },
        { key: "W0103020211", value: "COAGULATION FACTOR XII" },
        { key: "W0103020212", value: "COAGULATION FACTOR XII A" },
        { key: "W0103020213", value: "COAGULATION FACTOR XIII" },
        { key: "W0103020214", value: "COAGULATION FACTOR HMW-KININOGEN (FITZGERALD)" },
        { key: "W0103020215", value: "COAGULATION FACTOR VON WILLEBRAND (AG)" },
        { key: "W0103020216", value: "PREKALLIKREIN / KALLIKREIN (FLETCHER FACTOR)" },
        { key: "W0103020217", value: "COAGULATION FACTOR VON WILLEBRAND ACTIVITY / RISTOCETIN COFACTOR ACTIVITY (RCO)" },
        { key: "W0103020218", value: "COAGULATION FACTOR VON WILLEBRAND COLLAGEN BINDING ASSAY (CBA)" },
        { key: "W0103020299", value: "COAGULATION FACTORS - OTHER" },
        { key: "W01030203", value: "SPECIAL COAGULATION TESTS" },
        { key: "W0103020301", value: "FIBRIN SENSITIVITY MONOMER" },
        { key: "W0103020302", value: "FIBRINOPEPTIDE A" },
        { key: "W0103020303", value: "STANDARD HEPARIN" },
        { key: "W0103020304", value: "HIRUDIN TEST" },
        { key: "W0103020305", value: "PLASMIN - A2 - ANTIPLASMIN COMPLEX" },
        { key: "W0103020306", value: "PROTHROMBIN FRAGMENT 1 + 2" },
        { key: "W0103020307", value: "THROMBIN-ANTITHROMBIN III-COMPLEX" },
        { key: "W0103020308", value: "LOW MOLECULAR WEIGHT HEPARIN" },
        { key: "W0103020309", value: "ANTI XA ACTIVITY FOR HEPARIN AND DOAC" },
        { key: "W0103020310", value: "ANTI IIA ACTIVITY FOT DOAC" },
        { key: "W0103020311", value: "ADAMTS13 (ACTIVITY, AG, AB, INHIBITOR) SPECIFIC VON WILLEBRAND FACTOR (VWF) - CLEAVING PROTEASE" },
        { key: "W0103020399", value: "SPECIAL COAGULATION TESTS - OTHER" },
        { key: "W01030204", value: "PLATELET FACTORS" },
        { key: "W0103020401", value: "AGGREGATION REAGENTS" },
        { key: "W0103020402", value: "PLATELET FACTOR 4" },
        { key: "W0103020403", value: "PROSTACYCLIN" },
        { key: "W0103020404", value: "THROMBOXANE" },
        { key: "W0103020405", value: "ß-THROMBOGLOBULIN" },
        { key: "W0103020406", value: "SCREENING FOR PRIMARY HEMOSTASIS" },
        { key: "W0103020407", value: "P2Y12 RECEPTOR" },
        { key: "W0103020499", value: "PRIMARY HEMOSTASIS/PLATELET FACTORS - OTHER" },
        { key: "W01030205", value: "FIBRINOLYSIS" },
        { key: "W0103020501", value: "A2-ANTIPLASMIN" },
        { key: "W0103020502", value: "FIBRINOGEN DEGRADATION PRODUCTS" },
        { key: "W0103020503", value: "D-DIMER" },
        { key: "W0103020504", value: "PLASMIN" },
        { key: "W0103020505", value: "PLASMINOGEN" },
        { key: "W0103020506", value: "PLASMINOGEN ACTIVATOR-INHIBITORS" },
        { key: "W0103020507", value: "TISSUE PLASMINOGEN ACTIVATOR" },
        { key: "W0103020508", value: "UROKINASE PLASMINOGEN ACTIVATOR" },
        { key: "W0103020509", value: "THROMBIN ACTIVATING FIBRINOLYSIS INHIBITOR" },
        { key: "W0103020599", value: "FIBRINOLYSIS TESTS - OTHER" },
        { key: "W01030206", value: "COAGULATION INHIBITORS/THROMBOPHILIA MARKERS" },
        { key: "W0103020601", value: "ANTI-PHOSPHOLIPID ANTIBODIES" },
        { key: "W0103020602", value: "ANTITHROMBIN" },
        { key: "W0103020603", value: "COAGULATION FACTOR VIII INHIBITOR" },
        { key: "W0103020604", value: "COAGULATION FACTOR IX INHIBITOR" },
        { key: "W0103020605", value: "COAGULATION FACTOR X INHIBITOR" },
        { key: "W0103020606", value: "LUPUS ANTICOAGULANT" },
        { key: "W0103020607", value: "PROTEIN C" },
        { key: "W0103020608", value: "PROTEIN S ACTIVITY" },
        { key: "W0103020609", value: "HEPARIN COFACTOR II - TISSUE FACTOR PATHWAY INHIBITOR" },
        { key: "W0103020610", value: "APC RESISTANCE" },
        { key: "W0103020611", value: "PRO C GLOBAL" },
        { key: "W0103020612", value: "FREE PROTEIN S ANTIGEN" },
        { key: "W0103020613", value: "TOTAL PROTEIN S ANTIGEN" },
        { key: "W0103020614", value: "HOMOCYSTEINE" },
        { key: "W0103020615", value: "COAGULATION INHIBITORS/THROMBOPHILIA MARKERS FOR HEPARIN INDUCED THROMBOCYTOPENIA TEST (HIT)" },
        { key: "W0103020699", value: "COAGULATION INHIBITORS - OTHER" },
        { key: "W01030207", value: "HAEMOSTASIS CALIBRATORS/CONTROLS" },
        { key: "W0103020701", value: "CALIBRATION PLASMA FOR HAEMOSTASIS" },
        { key: "W0103020702", value: "CONTROL PLASMA FOR HAEMOSTASIS" },
        { key: "W0103020799", value: "HAEMOSTASIS CONTROLS - OTHER" },
        { key: "W01030208", value: "HAEMOSTASIS RAPID TESTS - RT & POC" },
        { key: "W0103020801", value: "PROTHROMBIN TIME RT & POC" },
        { key: "W0103020802", value: "ACTIVATED PARTIAL THROMBOPLASTIN TIME - RT & POC" },
        { key: "W0103020803", value: "D-DIMER - RT & POC" },
        { key: "W0103020804", value: "ACTIVATED CLOTTING TIME RT & POC" },
        { key: "W0103020805", value: "CONTROLS/ STANDARDS / CALIBRATORS FOR RT & POC" },
        { key: "W010302080501", value: "HEMOSTASIS CONTROLS RT & POC" },
        { key: "W010302080502", value: "HAEMOSTASIS STANDARDS AND CALIBRATORS RT & POC" },
        { key: "W0103020806", value: "HEPARIN INDUCED THROMBOCYTOPENIA TEST (HIT) RT & POC" },
        { key: "W0103020899", value: "HAEMOSTASIS RT & POC - OTHER" },
        { key: "W01030209", value: "AUXILIARY REAGENTS AND SUPPLEMENTS (HAEMOSTASIS)" },
        { key: "W0103020901", value: "CALCIUM CHLORIDE" },
        { key: "W0103020902", value: "CITRATE" },
        { key: "W0103020903", value: "BUFFERS (HAEMOSTASIS)" },
        { key: "W0103020904", value: "COATED TUBES (CITRATE, HEPARIN ETC.)" },
        { key: "W0103020999", value: "AUXILIARY REAGENTS (HAEMOSTASIS) - OTHER" },
        { key: "W01030299", value: "HAEMOSTASIS REAGENTS - OTHER" },
        { key: "W010303", value: "IMMUNOHAEMATOLOGY (BLOOD GROUPING)" },
        { key: "W01030301", value: "ABO TYPING" },
        { key: "W0103030101", value: "ABO GROUPING CELLS" },
        { key: "W0103030102", value: "ABO SERA" },
        { key: "W0103030199", value: "ABO TYPING TESTS - OTHER" },
        { key: "W01030302", value: "RHESUS TYPING" },
        { key: "W0103030201", value: "RHESUS D" },
        { key: "W0103030202", value: "RHESUS PHENOTYPES" },
        { key: "W0103030299", value: "RHESUS TYPING ASSAYS OTHER" },
        { key: "W01030303", value: "ANTIBODY DETECTION (IMMUNOHAEMATOLOGY)" },
        { key: "W0103030301", value: "ANTOBODY 1 CELL SCREENING" },
        { key: "W0103030302", value: "ANTIBODY 2 CELL SCREENING" },
        { key: "W0103030303", value: "ANTIBODY IDENTIFICATION CELL PANELS" },
        { key: "W0103030304", value: "POLYSPECIFIC ANTIHUMAN SERUM" },
        { key: "W0103030305", value: "MONOSPECIFIC ANTIHUMAN SERUM" },
        { key: "W0103030306", value: "ENHANCEMENT MEDIA (E.G. BOVINE ALBUMIN, LISS, PEG)" },
        { key: "W0103030307", value: "ENZYMES (E.G. BROMELIN / PAPAIN, ETC.)" },
        { key: "W0103030308", value: "ANTIBODY 3 CELL SCREENING" },
        { key: "W0103030399", value: "ANTIBODY DETECTION (IMMUNOHAEMATOLOGY) - OTHER" },
        { key: "W01030304", value: "IMMUNOHAEMATOLOGY CONTROLS" },
        { key: "W0103030401", value: "COOMBS CONTROL CELLS" },
        { key: "W0103030402", value: "CONTROL KITS  (IMMUNOHAEMATOLOGY)" },
        { key: "W0103030499", value: "IMMUNOHAEMATOLOGY CONTROLS - OTHER" },
        { key: "W01030305", value: "OTHER ANTIGEN TYPING" },
        { key: "W0103030501", value: "OTHER ANTIGEN TYPING REAGENTS" },
        { key: "W01030309", value: "COMBINED ABO TYPING + RHESUS TYPING" },
        { key: "W0103030901", value: "COMBINED ABO TYPING + RHESUS D" },
        { key: "W0103030902", value: "COMBINED ABO TYPING + RHESUS PHENOTYPES" },
        { key: "W0103030999", value: "COMBINED ABO TYPING + RHESUS TYPING TEST - OTHER" },
        { key: "W01030399", value: "IMMUNOHAEMATOLOGY  (BLOOD GROUPING) TESTS - OTHER" },
        { key: "W010304", value: "TISSUE TYPING REAGENTS" },
        { key: "W01030401", value: "COMPLEMENT FOR HLA TESTING" },
        { key: "W01030402", value: "HLA ANTIBODY SCREENING" },
        { key: "W01030403", value: "HLA ANTIGEN TYPING" },
        { key: "W01030404", value: "HLA CONTROL CELLS" },
        { key: "W01030405", value: "LYMPHOCYTE SEPARATION MEDIA" },
        { key: "W01030406", value: "LYMPHOCYTE STABILIZING MEDIA" },
        { key: "W01030499", value: "TISSUE TYPING REAGENTS - OTHER" },
        { key: "W010306", value: "CYTOKINES (LYMPHOKINES) / IMMUNMODULATORS" },
        { key: "W01030601", value: "INTERFERONS (α, β, ɣ…)" },
        { key: "W01030602", value: "SOLUBLE ANTIGENS / RECEPTORS" },
        { key: "W01030603", value: "TUMOUR NECROSIS FACTORS (TNFα,TNFβ, ...)" },
        { key: "W01030604", value: "TUMOUR NECROSIS FACTORS RECEPTORS (TNF-R I,TNF-R II)" },
        { key: "W01030605", value: "COLONY STIMULATING FACTORS (G-CSF,M-CSF,GM-CSF)" },
        { key: "W01030606", value: "OTHER INTERLEUKINS (EXCEPT FOR IL-6)" },
        { key: "W01030607", value: "INTERLEUKINS RECEPTORS (IL-2R,IL6R ...)" },
        { key: "W01030608", value: "CYTOKINES CALIBRATORS/CONTROLS" },
        { key: "W01030609", value: "INTERLEUKIN 6 (IL-6)" },
        { key: "W01030699", value: "LYMPHOKINES /IMMUNMODULATORS - OTHER" },
        { key: "W010307", value: "HISTOLOGY/CYTOLOGY REAGENTS" },
        { key: "W01030701", value: "CHROMOSOME CULTURE KITS / REAGENTS" },
        { key: "W01030702", value: "CYTOCHEMICAL STAINING REAGENTS" },
        { key: "W01030703", value: "DNA IN SITU HYBRIDISATION REAGENTS" },
        { key: "W01030704", value: "EMBEDDING MEDIA (HISTOLOGY/CYTOLOGY)" },
        { key: "W01030705", value: "FIXING REAGENTS (HISTOLOGY/CYTOLOGY)" },
        { key: "W01030706", value: "MOUNTING MEDIA (HISTOLOGY/CYTOLOGY)" },
        { key: "W01030707", value: "STAIN POWDERS (HISTOLOGY/CYTOLOGY)" },
        { key: "W01030708", value: "STAIN SOLUTIONS (HISTOLOGY/CYTOLOGY)" },
        { key: "W01030709", value: "PRIMARY ANTISERA FOR IMMUNOHISTOLOGY" },
        { key: "W01030710", value: "SECONDARY ANTISERA FOR IMMUNOHISTOLOGY" },
        { key: "W01030711", value: "IMMUNOHISTOLOGY KITS" },
        { key: "W01030799", value: "HISTOLOGY / CYTOLOGY REAGENTS - OTHER" },
        { key: "W010308", value: "MONOCLONAL ANTIBODIES / FLOW CYTOMETRY" },
        { key: "W01030801", value: "MONOCLONAL ANTIBODIES FOR CELL SURFACE ANTIGENS" },
        { key: "W0103080101", value: "ANTIBODIES FOR B AND T-CELL SUBTYPING" },
        { key: "W0103080102", value: "ANTIBODIES FOR HLA CLASS II DETERMINANTS" },
        { key: "W0103080103", value: "ANTIBODIES FOR LYMPHOMA TYPING (EXCEPT B-&T-CELL TYPING)" },
        { key: "W0103080104", value: "ANTIBODIES FOR RECOGNIZING CELL SURFACE RECEPTORS" },
        { key: "W0103080105", value: "ANTIBODIES FOR SUBTYPING OF LEUKEMIA (EXCEPT B-&T-CELL TYPING)" },
        { key: "W0103080106", value: "ANTIBODIES FOR LYMPHOCYTE SUBTYPING" },
        { key: "W0103080199", value: "MONOCLONAL ANTIBODIES FOR CELL SURFACE ANTIGENS - OTHER" },
        { key: "W01030802", value: "MONOCLONAL ANTIBODIES FOR CYTOPLASMATIC ANTIGENS" },
        { key: "W0103080201", value: "MONOCLONAL ANTIBODIES FOR RECOGNIZING ENZYMES" },
        { key: "W0103080202", value: "IGA, IGD, IGM, IGG, IGE" },
        { key: "W0103080203", value: "MONOCLONAL ANTIBODIES FOR DETECTING CELLS EXSPRESSING KAPPA OR LAMBDA LIGHT CHAINS" },
        { key: "W0103080204", value: "PROLIFERATION MARKERS" },
        { key: "W0103080299", value: "MONOCLONAL ANTIBODIES FOR CYTOPLASMATIC ANTIGENS - OTHER" },
        { key: "W01030803", value: "STEM CELL ENUMERATION REAGENTS" },
        { key: "W01030804", value: "FLOW CYTOMETRY CONTROLS" },
        { key: "W0103080401", value: "SETUP BEADS" },
        { key: "W0103080402", value: "LEUCOCYTE CONTROLS" },
        { key: "W0103080403", value: "LYMPHOCYTE SUBTYPING CONTROLS" },
        { key: "W0103080404", value: "STEM CELL ENUMERATION CONTROLS" },
        { key: "W0103080499", value: "FLOW CYTOMETRY CONTROLS - OTHER" },
        { key: "W01030805", value: "AUXILIARY & SUPPLEMENTAL REAGENTS FOR FLOW CYTOMETRY" },
        { key: "W0103080501", value: "CELL STAINING REAGENTS FOR CELL NUCLEAR STAINING" },
        { key: "W0103080502", value: "CELL STAINING REAGENTS FOR DETECTING RETICULOCYTES" },
        { key: "W0103080599", value: "AUXILIARY & SUPPLEMENTAL REAGENTS FOR FLOW CYTOMETRY - OTHER" },
        { key: "W01030806", value: "OTHER REAGENTS FOR FLOW CYTOMETRY" },
        { key: "W0103080699", value: "REAGENTS FOR FLOW CYTOMETRY - OTHER" },
        { key: "W010399", value: "HAEMATOLOGY / HAEMOSTASIS / IMMUNOHAEMATOLOGY / HISTOLOGY / CYSTOLOGY REAGENTS - OTHER" },
        { key: "W0104", value: "MICROBIOLOGY (CULTURE)" },
        { key: "W010401", value: "BACTERIOLOGY - CULTURE MEDIA" },
        { key: "W01040101", value: "DEHYDRATED CULTURE MEDIA (DCM - BACTERIOLOGY))" },
        { key: "W0104010101", value: "DEHYDRATED CULTURE MEDIA (DCM)" },
        { key: "W0104010103", value: "RAW MATERIALS (AGAR, PEPTONES, …)" },
        { key: "W0104010104", value: "ADDITIVES FOR DCM (GROWTH SUPPLEMENTS, SELECTIVE AGENTS, ...)" },
        { key: "W0104010199", value: "DCM - OTHER" },
        { key: "W01040102", value: "PREPARED MEDIA IN TUBES (BACTERIOLOGY)" },
        { key: "W0104010203", value: "TRANSPORT MEDIA" },
        { key: "W0104010204", value: "SAMPLE TRANSPORT FOR NA TESTING" },
        { key: "W0104010206", value: "MEDIA IN TUBES (SOLID & LIQUID)" },
        { key: "W0104010299", value: "MEDIA IN TUBES - OTHER" },
        { key: "W01040103", value: "PREPARED MEDIA IN BOTTLES (BACTERIOLOGY)" },
        { key: "W0104010306", value: "CULTURE MEDIA IN BOTTLES" },
        { key: "W01040104", value: "PREPARED MEDIA IN PLATES (BACTERIOLOGY)" },
        { key: "W0104010402", value: "CHROMOGENIC ID MEDIA (PLATES)" },
        { key: "W0104010403", value: "SUSCEPTIBILITY TEST MEDIA (PLATES)" },
        { key: "W0104010404", value: "CHROMOGENIC RESISTANCE MARKER MEDIA (PLATES) - MRSA, VRE, ESBL …" },
        { key: "W0104010405", value: "NON-CHROMOGENIC MEDIA (PLATES)" },
        { key: "W0104010407", value: "BI-PLATES - INCLUDING NON-CHROMOGENIC & CHROMOGENIC MEDIA COMBINATION" },
        { key: "W0104010499", value: "PREPARED MEDIA IN PLATES - OTHER" },
        { key: "W01040105", value: "BLOOD CULTURE - MANUAL & AUTOMATED" },
        { key: "W0104010501", value: "BOTTLES FOR MANUAL BLOOD CULTURE" },
        { key: "W0104010504", value: "BOTTLES FOR AUTOMATED BLOOD CULTURE" },
        { key: "W0104010599", value: "MANUAL BLOOD CULTURES - (CONCENTRATORS, ANTIBOTIC INACTIVATORS,ETC.) - OTHER" },
        { key: "W01040106", value: "MYCOBACTERIA CULTURE (MANUAL & AUTOMATED)" },
        { key: "W0104010603", value: "AUTOMATED MYCOBACTERIA MEDIA (BOTTLES)" },
        { key: "W0104010604", value: "MANUAL MYCOBACTERIA MEDIA (TUBES & BOTTLES)" },
        { key: "W0104010699", value: "MEDIA FOR MYCOBACTERIA CULTURES - MANUAL & AUTOMATED (FOR AST DRUGS, SUPPLEMENTS) - OTHER" },
        { key: "W01040107", value: "URINE SCREENING (BACTERIOLOGY)" },
        { key: "W0104010701", value: "URINE SCREENING REAGENTS - AUTOMATED" },
        { key: "W0104010702", value: "URINE SCREENING MANUAL - STRIPS, ETC.)" },
        { key: "W0104010703", value: "URINE SCREENING MANUAL (DIPSLIDES ETC.)" },
        { key: "W0104010799", value: "URINE SCREENING (BACTERIOLOGY) - OTHER" },
        { key: "W01040108", value: "STAINS, BUFFERS (BACTERIOLOGY)" },
        { key: "W0104010804", value: "STAINS" },
        { key: "W0104010805", value: "BUFFERS" },
        { key: "W0104010899", value: "BUFFERS, STAINS - OTHER" },
        { key: "W01040109", value: "ENVIRONMENTAL GENERATING SYSTEMS" },
        { key: "W0104010901", value: "GAS GENERATING KITS" },
        { key: "W0104010999", value: "ENVIRONMENTAL GENERATING SYSTEMS - OTHER" },
        { key: "W010403", value: "MYCOLOGY" },
        { key: "W01040301", value: "DEHYDRATED CULTURE MEDIA   (MYCOLOGY)" },
        { key: "W0104030101", value: "DCM FOR YEASTS AND FUNGI" },
        { key: "W0104030199", value: "DCM (MYCOLOGY) - OTHER" },
        { key: "W01040302", value: "PREPARED MEDIA IN PLATES   (MYCOLOGY)" },
        { key: "W0104030201", value: "PPM FOR YEASTS AND FUNGI" },
        { key: "W0104030202", value: "CHROMOGENIC MEDIA FOR YEASTS AND FUNGI" },
        { key: "W0104030299", value: "PREPARED MEDIA IN PLATES - OTHER" },
        { key: "W01040303", value: "TUBES AND BOTTLED MEDIA FOR YEASTS AND FUNGI" },
        { key: "W0104030301", value: "TUBES FOR YEASTS AND FUNGI" },
        { key: "W0104030302", value: "DIP SLIDES (MYCOLOGY)" },
        { key: "W0104030303", value: "BOTTLED MEDIA FOR YEASTS AND FUNGI" },
        { key: "W0104030399", value: "TUBES MEDIA FOR YEASTS AND FUNGI - OTHER" },
        { key: "W01040304", value: "IDENTIFICATION   (MYCOLOGY)" },
        { key: "W0104030403", value: "IDENTIFICATION SYSTEMS FOR YEASTS AND FUNGI - AUTOMATED" },
        { key: "W0104030404", value: "IDENTIFICATION SYSTEMS FOR YEASTS AND FUNGI / NA REAGENTS" },
        { key: "W0104030405", value: "IDENTIFICATION SYSTEMS FOR YEASTS AND FUNGI - MANUAL" },
        { key: "W0104030499", value: "IDENTIFICATION SYSTEMS FOR YEAST AND FUNGI - OTHER" },
        { key: "W01040305", value: "SEROLOGICAL IDENTIFICATION   (MYCOLOGY)" },
        { key: "W0104030501", value: "SEROLOGICAL IDENTIFICATION OF YEASTS AND FUNGI" },
        { key: "W0104030599", value: "SEROLOGICAL IDENTIFICATION SYSTEMS OF YEAST AND FUNGI - OTHER" },
        { key: "W01040306", value: "SUSCEPTIBILITY TESTING   (MYCOLOGY)" },
        { key: "W0104030601", value: "SUSCEPTIBILITY TESTING SYSTEMS FOR YEASTS AND FUNGI" },
        { key: "W010403060101", value: "SUSCEPTIBILITY TESTING SYSTEMS FOR YEASTS AND FUNGI - MANUAL" },
        { key: "W010403060102", value: "SUSCEPTIBILITY TESTING SYSTEMS FOR YEASTS AND FUNGI - AUTOMATED" },
        { key: "W010403060199", value: "SUSCEPTIBILITY TESTING SYSTEMS FOR YEASTS AND FUNGI - OTHER" },
        { key: "W010404", value: "TISSUE CULTURE FOR VIROLOGY" },
        { key: "W01040401", value: "CELLS FOR TISSUE CULTURE" },
        { key: "W01040402", value: "MEDIA FOR TISSUE CULTURE" },
        { key: "W01040403", value: "SERUM FOR TISSUE CULTURE" },
        { key: "W01040404", value: "OTHER TISSUE CULTURE ADDITIVES AND SOLUTIONS" },
        { key: "W01040499", value: "VIRAL CULTURE REAGENTS - OTHER" },
        { key: "W010405", value: "PARASITOLOGY ( MICROBIOLOGY )" },
        { key: "W01040501", value: "PARASITOLOGY REAGENTS" },
        { key: "W0104050101", value: "PARASITOLOGY EXTRACTION REAGENTS" },
        { key: "W0104050102", value: "PARASITOLOGY STAINS" },
        { key: "W0104050199", value: "PARASITOLOGY REAGENTS - OTHER" },
        { key: "W01040502", value: "DETECTION AND IDENTIFICATION (PARASITOLOGY)" },
        { key: "W0104050201", value: "PNEUMOCYSTIS JIROVECII (PNEUMOCYSTIS CARINII)" },
        { key: "W0104050202", value: "PLASMODIUM FALCIPARUM" },
        { key: "W0104050203", value: "CRYPTOSPORIDIUM" },
        { key: "W0104050299", value: "DETECTION AND IDENTIFICATION (PARASITOLOGY) - OTHER" },
        { key: "W010406", value: "CONTROLS/STANDARDS/CALIBRATORS - MICROBIOLOGY" },
        { key: "W01040601", value: "QC STRAINS BACTERIOLOGY" },
        { key: "W01040699", value: "CONTROLS, STANDARDS, CALIBRATORS, MICROBIOLOGY - OTHER" },
        { key: "W010407", value: "MICROBIOLOGY RT & POC" },
        { key: "W010408", value: "BACTERIOLOGY - IDENTIFICATION AND SUSCEPTIBILITY TESTING" },
        { key: "W01040801", value: "BIOCHEMICAL IDENTIFICATION AND SUSCEPTIBILITY TESTING - AUTOMATED" },
        { key: "W0104080101", value: "GRAM NEGATIVE IDENTIFICATION - AUTOMATED" },
        { key: "W0104080103", value: "GRAM POSITIVE IDENTIFICATION - AUTOMATED" },
        { key: "W0104080105", value: "ANAEROBIC AND OTHER PATHOGENIC GERMS IDENTIFICATION - AUTOMATED" },
        { key: "W0104080107", value: "GRAM NEGATIVE SUSCEPTIBILITY TESTING - AUTOMATED" },
        { key: "W0104080108", value: "GRAM POSITIVE SUSCEPTIBILITY TESTING - AUTOMATED" },
        { key: "W0104080109", value: "COMBINED SUSCEPTIBILITY AND IDENTIFICATION SYSTEMS GRAM NEGATIVES - AUTOMATED" },
        { key: "W0104080110", value: "COMBINED SUSCEPTIBILITY AND IDENTIFICATION SYSTEMS GRAM POSITIVES - AUTOMATED" },
        { key: "W0104080111", value: "ANAEROBES AND FASTIDIOUS SUSCEPT TESTING - AUTOMATED" },
        { key: "W0104080112", value: "OTHER AUTOMATED IDENTIFICATION TESTING (INCL. CONSUMABLES...)" },
        { key: "W0104080113", value: "OTHER AUTOMATED SUSCEPTIBILITY TESTING (INCL CONSUMABLES...)" },
        { key: "W01040802", value: "BIOCHEMICAL IDENTIFICATION - MANUAL" },
        { key: "W0104080201", value: "GRAM NEGATIVE - MANUAL IDENTIFICATION" },
        { key: "W0104080203", value: "GRAM POSITIVE - MANUAL IDENTIFICATION" },
        { key: "W0104080207", value: "MYCOPLASMA / UREAPLASMA - (INCL. COMBINED ID-AST)" },
        { key: "W0104080208", value: "SINGLE TESTS (DISCS, STRIPS, DROPPERS...)" },
        { key: "W0104080209", value: "MANUAL IDENTIFICATION KITS - ANAEROBES, PATHOGENS - OTHER" },
        { key: "W0104080299", value: "MANUAL IDENTIFICATION - OTHER" },
        { key: "W01040803", value: "IMMUNOLOGICAL IDENTIFICATION BY CULTURE" },
        { key: "W0104080301", value: "SEROTYPING (E.COLI, SALMONELLA, SHIGELLA, ETC)" },
        { key: "W0104080302", value: "STREPTOCOCCI GROUPING SLIDE TESTS" },
        { key: "W0104080303", value: "STAPHYLOCOCCI SLIDE TESTS" },
        { key: "W0104080304", value: "MENINGITIS SLIDE TESTS" },
        { key: "W0104080399", value: "IMMUNOLOGICAL IDENTIFICATION - OTHER" },
        { key: "W01040805", value: "MANUAL SUSCEPTIBILITY TESTING" },
        { key: "W0104080501", value: "MIC SYSTEMS - DILUTION METHODS (INCL. E-TEST)" },
        { key: "W0104080502", value: "IMPREGNATED DISKS, MULTI-DISKS & TABLETS" },
        { key: "W0104080503", value: "MANUAL ANTIMICROBIAL SUCEPTIBILITY TESTING (AST)-  STRIPS / CASSETTES/GALLERIES" },
        { key: "W0104080504", value: "TARGETED RESISTANCE TESTS - MRSA" },
        { key: "W0104080505", value: "TARGETED RESISTANCE TESTS - ESBL" },
        { key: "W0104080506", value: "TARGETED RESISTANCE TESTS - CARBAPENEMASE" },
        { key: "W0104080590", value: "TARGETED RESISTANCE TESTS - OTHER" },
        { key: "W0104080599", value: "MANUAL SUSCEPTIBILITY TESTING - OTHER" },
        { key: "W01040806", value: "NUCLEIC ACID IDENTIFICATION (BACTERIOLOGY)" },
        { key: "W0104080601", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED BACTERIA SPP / SSPP" },
        { key: "W0104080602", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED MRSA AND/OR MSSA" },
        { key: "W0104080604", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED VRE" },
        { key: "W0104080605", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED ESBL" },
        { key: "W0104080606", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED CARBAPENEMASE" },
        { key: "W0104080607", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED OTHER RESISTANCE MARKERS" },
        { key: "W0104080608", value: "NUCLEIC ACID IDENTIFICATION - MANUAL / AUTOMATED ESBL / CARBAPENEMASE COMBINED" },
        { key: "W0104080699", value: "NUCLEIC ACID IDENTIFICATION (BACTERIOLOGY) MANUAL / AUTOMATED - OTHER" },
        { key: "W010499", value: "MICROBIOLOGY TESTS - OTHER" },
        { key: "W0105", value: "INFECTIOUS DISEASES" },
        { key: "W010501", value: "BACTERIOLOGY (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050101", value: "CHLAMYDIA" },
        { key: "W0105010107", value: "CHLAMYDIA TRACHOMATIS ANTIGEN DETECTION" },
        { key: "W0105010108", value: "CHLAMYDIA TRACHOMATIS ANTIBODY ASSAYS TOTAL" },
        { key: "W0105010109", value: "CHLAMYDIA TRACHOMATIS ANTIBODY IGA" },
        { key: "W0105010110", value: "CHLAMYDIA TRACHOMATIS ANTIBODY IGG" },
        { key: "W0105010111", value: "CHLAMYDIA TRACHOMATIS ANTIBODY IGM" },
        { key: "W0105010112", value: "CHLAMYDIA PNEUMONIAE ANTIGEN DETECTION" },
        { key: "W0105010113", value: "CHLAMYDIA PNEUMONIAE ANTIBODY ASSAYS TOTAL" },
        { key: "W0105010114", value: "CHLAMYDIA PNEUMONIAE ANTIBODY IGA" },
        { key: "W0105010115", value: "CHLAMYDIA PNEUMONAIE ANTIBODY IGG" },
        { key: "W0105010116", value: "CHLAMYDIA PNEUMONIAE ANTIBODY IGM" },
        { key: "W0105010117", value: "CHLAMYDIA TRACHOMATIS DETECTION BY NA REAGENTS" },
        { key: "W0105010118", value: "CHLAMYDIA PNEUMONIAE DETECTION BY NA REAGENTS" },
        { key: "W0105010199", value: "CHLAMYDIA REAGENTS - OTHER" },
        { key: "W01050102", value: "GONOCOCCI (NEISSERIA GONORRHOEAE)" },
        { key: "W0105010201", value: "GONOCOCCAL ANTIGEN DETECTION" },
        { key: "W0105010202", value: "GONOCOCCAL ANTIBODY ASSAYS TOTAL" },
        { key: "W0105010203", value: "GONOCOCCAL DETECTION BY NA REAGENTS" },
        { key: "W0105010299", value: "GONOCOCCI REAGENTS - OTHER" },
        { key: "W01050103", value: "SYPHILIS (TREPONEMA PALLIDUM)" },
        { key: "W0105010301", value: "SYPHILIS ANTIGEN DETECTION" },
        { key: "W0105010302", value: "SYPHILIS ANTIBODY ASSAYS TOTAL" },
        { key: "W0105010303", value: "SYPHILIS ANTIBODY IGG" },
        { key: "W0105010304", value: "SYPHILIS ANTIBODY IGM" },
        { key: "W0105010305", value: "SYPHILIS DETECTION BY NA REAGENTS" },
        { key: "W0105010399", value: "SYPHILIS REAGENTS OTHER" },
        { key: "W01050104", value: "HELICOBACTER PYLORI" },
        { key: "W0105010401", value: "H. PYLORI ANTIGEN DETECTION" },
        { key: "W0105010402", value: "H. PYLORI ANTIBODY ASSAYS" },
        { key: "W0105010403", value: "H. PYLORI DETECTION BY NA REAGENTS" },
        { key: "W0105010499", value: "H. PYLORI REAGENTS - OTHER" },
        { key: "W01050105", value: "LEGIONELLA" },
        { key: "W0105010501", value: "LEGIONELLA ANTIGEN DETECTION" },
        { key: "W0105010502", value: "LEGIONELLA ANTIBODY ASSAYS" },
        { key: "W0105010503", value: "LEGIONELLA DETECTION BY NA REAGENTS" },
        { key: "W0105010599", value: "LEGIONELLA REAGENTS - OTHER" },
        { key: "W01050106", value: "LYME BORRELIOSIS" },
        { key: "W0105010601", value: "LYME ANTIGEN DETECTION" },
        { key: "W0105010602", value: "LYME ANTIBODY TOTAL" },
        { key: "W0105010603", value: "LYME ANTIBODY IGG" },
        { key: "W0105010604", value: "LYME ANTIBODY IGM" },
        { key: "W0105010605", value: "LYME DETECTION BY NA REAGENTS" },
        { key: "W0105010699", value: "LYME BORRELIOSIS REAGENTS - OTHER" },
        { key: "W01050107", value: "MYCOBACTERIA GENUS + SPECIES" },
        { key: "W0105010701", value: "MYCOBACTERIAL ANTIGEN DETECTION" },
        { key: "W0105010702", value: "MYCOBACTERIAL ANTIBODY ASSAYS" },
        { key: "W0105010703", value: "MYCOBACTERIAL DETECTION BY NA REAGENTS" },
        { key: "W0105010704", value: "TB-IGRA (INTERFERON-‐GAMMA-‐RELEASE ASSAY)" },
        { key: "W0105010799", value: "MYCOBACTERIA REAGENTS - OTHER" },
        { key: "W01050108", value: "MYCOPLASMA" },
        { key: "W0105010801", value: "MYCOPLASMA ANTIGEN DETECTION" },
        { key: "W0105010802", value: "MYCOPLASMA ANTIBODY ASSAYS" },
        { key: "W0105010803", value: "MYCOPLASMA DETECTION BY NA REAGENTS" },
        { key: "W0105010899", value: "MYCOPLASMA REAGENTS - OTHER" },
        { key: "W01050109", value: "PSEUDOMONAS AERUGINOSA" },
        { key: "W0105010901", value: "PSEUDOMONAS AERUGINOSA ANTIBODY IGG" },
        { key: "W0105010902", value: "PSEUDOMONAS DETECTION BY NA REAGENTS" },
        { key: "W0105010999", value: "PSEUDOMONAS AERUGINOSA REAGENTS - OTHER" },
        { key: "W01050110", value: "SALMONELLA" },
        { key: "W0105011001", value: "SALMONELLA ANTIGEN DETECTION" },
        { key: "W0105011002", value: "SALMONELLA ANTIBODY ASSAYS" },
        { key: "W0105011003", value: "SALMONELLA DETECTION BY NA REAGENTS" },
        { key: "W0105011099", value: "SALMONELLA REAGENTS - OTHER" },
        { key: "W01050111", value: "STREPTOCOCCI" },
        { key: "W0105011101", value: "STREPTOCOCCAL DIRECT ANTIGEN DETECTION" },
        { key: "W0105011102", value: "STREPTOCOCCAL  DETECTION BY NA REAGENTS" },
        { key: "W0105011103", value: "STREP. A DETECTION BY NA REAGENTS" },
        { key: "W0105011104", value: "STREP. B DETECTION BY NA REAGENTS" },
        { key: "W0105011105", value: "STREP. PNEUMONIAE DETECTION BY NA REAGENTS" },
        { key: "W0105011199", value: "STREPTOCOCCAL REAGENTS - OTHER" },
        { key: "W01050112", value: "STAPHYLOCOCCI" },
        { key: "W0105011201", value: "STAPHYLOCOCCAL DIRECT ANTIGEN DETECTION" },
        { key: "W0105011202", value: "STAPHYLOTOXIN" },
        { key: "W0105011203", value: "SAPHYLOCOCCAL DETECTION BY NA REAGENTS" },
        { key: "W0105011299", value: "STAPHYLOCOCCI REAGENTS - OTHER" },
        { key: "W01050113", value: "LISTERIA" },
        { key: "W0105011301", value: "LISTERIA ANTIGEN DETECTION" },
        { key: "W0105011302", value: "LISTERIA ANTIBODY ASSAYS" },
        { key: "W0105011303", value: "LISTERIA MONOCYTOGENES DIRECT ANTIGEN DETECTION" },
        { key: "W0105011304", value: "LISTERIA MONOCYTOGENES ANTIBODY ASSAYS" },
        { key: "W0105011305", value: "LISTERIA DETECTION BY NA REAGENTS" },
        { key: "W0105011399", value: "LISTERIA REAGENTS - OTHER" },
        { key: "W01050114", value: "CAMPYLOBACTER" },
        { key: "W0105011401", value: "CAMPYLOBACTER DIRECT ANTIGEN DETECTION" },
        { key: "W0105011402", value: "CAMPYLOBACTER DETECTION BY NA REAGENTS" },
        { key: "W0105011499", value: "CAMPYLOBACTER REAGENTS - OTHER" },
        { key: "W01050115", value: "ESCHERICHIA COLI" },
        { key: "W0105011501", value: "E. COLI DIRECT ANTIGEN DETECTION" },
        { key: "W0105011502", value: "E. COLI TOXIN" },
        { key: "W0105011503", value: "E. COLI DETECTION BY NA REAGENTS" },
        { key: "W0105011599", value: "E. COLI REAGENTS - OTHER" },
        { key: "W01050116", value: "OTHER BACTERIOLOGY - NA REAGENTS" },
        { key: "W0105011601", value: "BRUCELLA - NA REAGENTS" },
        { key: "W0105011603", value: "COXIELLA BURNETII (Q FEVER) - NA REAGENTS" },
        { key: "W0105011604", value: "LEPTOSPIRA - NA REAGENTS" },
        { key: "W0105011605", value: "RICKETTSIA - NA REAGENTS" },
        { key: "W0105011606", value: "YERSINIA - NA REAGENTS" },
        { key: "W0105011607", value: "BORDETELLA PERTUSSIS / PARAPERTUSSIS - NA REAGENTS" },
        { key: "W0105011608", value: "DIPHTERIA (CORYNEBACTERIUM D.) - NA REAGENTS" },
        { key: "W0105011609", value: "TETANUS (CLOSTRIDIUM T.) - NA REAGENTS" },
        { key: "W0105011610", value: "HAEMOPHILUS INFLUENZAE - NA REAGENTS" },
        { key: "W0105011611", value: "NEISSERIA MENINGITIDIS - NA REAGENTS" },
        { key: "W0105011612", value: "PROTEUS - NA REAGENTS" },
        { key: "W0105011613", value: "PSEUDOMONAS - NA REAGENTS" },
        { key: "W0105011614", value: "SHIGELLA - NA REAGENTS" },
        { key: "W0105011699", value: "BACTERIOLOGY - NA REAGENTS - OTHER" },
        { key: "W01050117", value: "OTHER BACTERIOLOGY IMMUNOASSAYS" },
        { key: "W0105011701", value: "BRUCELLA" },
        { key: "W0105011703", value: "COXIELLA BURNETII (Q FEVER)" },
        { key: "W0105011704", value: "LEPTOSPIRA" },
        { key: "W0105011705", value: "RICKETTSIA" },
        { key: "W0105011706", value: "YERSINIA" },
        { key: "W0105011707", value: "BORDETELLA PERTUSSIS / PARAPERTUSSIS" },
        { key: "W0105011708", value: "DIPHTERIA (CORYNEBACTERIUM D.)" },
        { key: "W0105011709", value: "TETANUS (CLOSTRIDIUM T.)" },
        { key: "W0105011710", value: "HAEMOPHILUS INFLUENZAE" },
        { key: "W0105011711", value: "NEISSERIA MENINGITIDIS" },
        { key: "W0105011712", value: "PROTEUS" },
        { key: "W0105011713", value: "PSEUDOMONAS" },
        { key: "W0105011714", value: "SHIGELLA" },
        { key: "W0105011799", value: "BACTERIOLOGY IMMUNOASSAY - OTHER" },
        { key: "W01050118", value: "CLOSTRIDIUM DIFFICILE" },
        { key: "W0105011801", value: "C.DIFFICILE GDH DETECTION" },
        { key: "W0105011802", value: "C.DIFFICILE TOXIN A/B DETECTION" },
        { key: "W0105011803", value: "C.DIFFICILE GDH AND TOXIN A/B COMBINED DETECTION" },
        { key: "W0105011804", value: "C.DIFFICILE BY NA REAGENTS" },
        { key: "W0105011899", value: "C.DIFFICILE REAGENTS - OTHER" },
        { key: "W010502", value: "HEPATITIS VIRUSES (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050201", value: "HEPATITIS A VIRUS" },
        { key: "W0105020101", value: "HAV ANTIGEN CONFIRMATORY" },
        { key: "W0105020102", value: "HAV ANTIBODY (TOTAL)" },
        { key: "W0105020103", value: "HAV ANTIBODY IGG" },
        { key: "W0105020104", value: "HAV ANTIBODY IGM" },
        { key: "W0105020105", value: "HEPATITIS A VIRUS - NA REAGENTS" },
        { key: "W0105020199", value: "HAV REAGENTS - OTHER" },
        { key: "W01050202", value: "HEPATITIS B VIRUS" },
        { key: "W0105020201", value: "HEPATITIS B SURFACE ANTIGEN" },
        { key: "W0105020202", value: "HEPATITIS B SURFACE ANTIGEN - CONFIRMATORY" },
        { key: "W0105020203", value: "HEPATITIS B SURFACE ANTIBODY (TOTAL)" },
        { key: "W0105020204", value: "HEPATITIS B SURFACE ANTIBODY IGG" },
        { key: "W0105020205", value: "HEPATITIS B SURFACE ANTIBODY IGM" },
        { key: "W0105020206", value: "HEPATITIS B CORE ANTIGEN" },
        { key: "W0105020207", value: "HEPATITIS B CORE ANTIGEN - CONFIRMATORY" },
        { key: "W0105020208", value: "HEPATITIS B CORE ANTIBODY (TOTAL)" },
        { key: "W0105020209", value: "HEPATITIS B CORE ANTIBODY IGG" },
        { key: "W0105020210", value: "HEPATITIS B CORE ANTIBODY IGM" },
        { key: "W0105020211", value: "HEPATITIS B ANTIGEN" },
        { key: "W0105020212", value: "HEPATITIS B ANTIGEN - CONFIRMATORY" },
        { key: "W0105020213", value: "HEPATITIS B ANTIBODY (TOTAL)" },
        { key: "W0105020214", value: "HEPATITIS B ANTIBODY IGG" },
        { key: "W0105020215", value: "HEPATITIS B ANTIBODY IGM" },
        { key: "W0105020216", value: "HEPATITIS B VIRUS - NA REAGENTS" },
        { key: "W0105020217", value: "HEPATITIS B SURFACE ANTIGEN - QUANTITATIVE" },
        { key: "W0105020218", value: "HEPATITIS B VIRUS - GENOTYPING - NA REAGENTS" },
        { key: "W0105020299", value: "HBV REAGENTS - OTHER" },
        { key: "W01050203", value: "HEPATITIS C VIRUS" },
        { key: "W0105020301", value: "HCV ANTIGEN" },
        { key: "W0105020302", value: "HCV ANTIGEN - CONFIRMATORY" },
        { key: "W0105020303", value: "HCV ANTIBODY (TOTAL)" },
        { key: "W0105020304", value: "HCV ANTIBODY IGG" },
        { key: "W0105020305", value: "HCV ANTIBODY IGM" },
        { key: "W0105020306", value: "HCV ANTIBODY - CONFIRMATORY" },
        { key: "W0105020307", value: "HEPATITIS C VIRUS - NA REAGENTS" },
        { key: "W0105020308", value: "HEPATITIS C VIRUS (HCV) ANTIGEN/ANTIBODY COMBO TEST" },
        { key: "W0105020309", value: "HEPATITIS C VIRUS (HCV) GENOTYPING - NA REAGENTS" },
        { key: "W0105020399", value: "HCV REAGENTS - OTHER" },
        { key: "W01050204", value: "HEPATITIS DELTA VIRUS" },
        { key: "W0105020401", value: "HEPATITIS DELTA ANTIGEN" },
        { key: "W0105020402", value: "HEPATITIS DELTA ANTIGEN - CONFIRMATORY" },
        { key: "W0105020403", value: "HEPATITIS DELTA ANTIBODY (TOTAL)" },
        { key: "W0105020404", value: "HEPATITIS DELTA ANTIBODY IGG" },
        { key: "W0105020405", value: "HEPATITIS DELTA ANTIBODY IGM" },
        { key: "W0105020406", value: "HEPATITIS DELTA VIRUS - NA REAGENTS" },
        { key: "W0105020499", value: "HDV REAGENTS - OTHER" },
        { key: "W01050205", value: "HEPATITIS E VIRUS" },
        { key: "W0105020501", value: "HEV ANTIGEN" },
        { key: "W0105020502", value: "HEV ANTIGEN - CONFIRMATORY" },
        { key: "W0105020503", value: "HEV ANTIBODY (TOTAL)" },
        { key: "W0105020504", value: "HEV ANTIBODY IGG" },
        { key: "W0105020505", value: "HEV ANTIBODY IGM" },
        { key: "W0105020506", value: "HEV ANTIBODY - CONFIRMATORY" },
        { key: "W0105020507", value: "HEPATITIS E VIRUS - NA REAGENTS" },
        { key: "W0105020599", value: "HEV REAGENTS - OTHER" },
        { key: "W01050206", value: "HEPATITIS G VIRUS" },
        { key: "W0105020601", value: "HGV ANTIGEN" },
        { key: "W0105020602", value: "HGV ANTIGEN - CONFIRMATORY" },
        { key: "W0105020603", value: "HGV ANTIBODY (TOTAL)" },
        { key: "W0105020604", value: "HGV ANTIBODY IGG" },
        { key: "W0105020605", value: "HGV ANTIBODY IGM" },
        { key: "W0105020606", value: "HEPATITIS G VIRUS - NA REAGENTS" },
        { key: "W0105020699", value: "HGV REAGENTS - OTHER" },
        { key: "W01050207", value: "HEPATITIS X VIRUS" },
        { key: "W0105020701", value: "HXV ANTIGEN" },
        { key: "W0105020702", value: "HXV ANTIGEN - CONFIRMATORY" },
        { key: "W0105020703", value: "HXV ANTIBODY (TOTAL)" },
        { key: "W0105020704", value: "HXV ANTIBODY IGG" },
        { key: "W0105020705", value: "HXV ANTIBODY IGM" },
        { key: "W0105020706", value: "HEPATITIS X VIRUS - NA REAGENTS" },
        { key: "W0105020799", value: "HXV REAGENTS - OTHER" },
        { key: "W01050290", value: "OTHER HEPATITIS VIRUSES" },
        { key: "W0105029099", value: "HEPATITIS VIRUSES REAGENTS - OTHER" },
        { key: "W010503", value: "RETROVIRUSES (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050301", value: "HIV 1" },
        { key: "W0105030101", value: "HIV 1 ANTIGEN" },
        { key: "W0105030102", value: "HIV 1 ANTIGEN - CONFIRMATORY" },
        { key: "W0105030103", value: "HIV 1 ANTIBODY (TOTAL)" },
        { key: "W0105030104", value: "HIV 1 ANTIBODY IGG" },
        { key: "W0105030105", value: "HIV 1 ANTIBODY IGM" },
        { key: "W0105030106", value: "HIV 1 ANTIBODY - CONFIRMATORY" },
        { key: "W0105030107", value: "HIV 1 - NA REAGENTS" },
        { key: "W0105030108", value: "HIV 1 GENOTYPING - NA REAGENTS" },
        { key: "W0105030199", value: "HIV 1 REAGENTS - OTHER" },
        { key: "W01050302", value: "HIV 2" },
        { key: "W0105030201", value: "HIV 2 ANTIGEN" },
        { key: "W0105030202", value: "HIV 2 ANTIBODY" },
        { key: "W0105030203", value: "HIV 2 ANTIBODY - CONFIRMATORY" },
        { key: "W0105030204", value: "HIV 2 - NA REAGENTS" },
        { key: "W0105030205", value: "HIV 2 GENOTYPING - NA REAGENTS" },
        { key: "W0105030299", value: "HIV 2 REAGENTS - OTHER" },
        { key: "W01050303", value: "HIV P24" },
        { key: "W0105030301", value: "HIV P24 ANTIGEN" },
        { key: "W0105030302", value: "HIV P24 ANTIBODY" },
        { key: "W0105030303", value: "HIV P24 - NA REAGENTS" },
        { key: "W0105030399", value: "HIV P24 REAGENTS - OTHER" },
        { key: "W01050304", value: "HIV - MULTIPLE ( 1 / 2 )" },
        { key: "W0105030401", value: "HIV MULTIPLE ANTIGEN" },
        { key: "W0105030402", value: "HIV MULTIPLE ANTIBODY" },
        { key: "W0105030403", value: "HIV MULTIPLE ANTIBODY - CONFIRMATORY" },
        { key: "W0105030404", value: "HIV MULTIPLE AG/AB COMBI TEST" },
        { key: "W0105030405", value: "HIV MULTIPLE - NA REAGENTS" },
        { key: "W0105030499", value: "HIV MULTIPLE (1/2) REAGENTS - OTHER" },
        { key: "W01050305", value: "HTLV I" },
        { key: "W0105030501", value: "HTLV I ANTIGEN" },
        { key: "W0105030502", value: "HTLV I ANTIBODY" },
        { key: "W0105030503", value: "HTLV I ANTIBODY - CONFIRMATORY" },
        { key: "W0105030504", value: "HTLV I - NA REAGENTS" },
        { key: "W0105030599", value: "HTLV I REAGENTS - OTHER" },
        { key: "W01050306", value: "HTLV II" },
        { key: "W0105030601", value: "HTLV II ANTIGEN" },
        { key: "W0105030602", value: "HTLV II ANTIBODY" },
        { key: "W0105030603", value: "HTLV II ANTIBODY - CONFIRMATORY" },
        { key: "W0105030604", value: "HTLV II - NA REAGENTS" },
        { key: "W0105030699", value: "HTLV II REAGENTS - OTHER" },
        { key: "W01050307", value: "HTLV MULTIPLE" },
        { key: "W0105030701", value: "HTLV MULTIPLE ANTIGEN" },
        { key: "W0105030702", value: "HTLV MULTIPLE ANTIBODY" },
        { key: "W0105030703", value: "HTLV MULTIPLE ANTIBODY - CONFIRMATORY" },
        { key: "W0105030704", value: "HTLV MULTIPLE - NA REAGENTS" },
        { key: "W0105030799", value: "HTLV MULTIPLE REAGENTS - OTHER" },
        { key: "W010504", value: "OTHER VIROLOGY TESTS (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050401", value: "RUBELLA VIRUS" },
        { key: "W0105040101", value: "RUBELLA VIRUS ANTIBODIES - TOTAL" },
        { key: "W0105040102", value: "RUBELLA VIRUS IGG" },
        { key: "W0105040103", value: "RUBELLA VIRUS IGM" },
        { key: "W0105040104", value: "RUBELLA - NA REAGENTS" },
        { key: "W0105040199", value: "RUBELLA VIRUS REAGENTS - OTHER" },
        { key: "W01050402", value: "CYTOMEGALOVIRUS" },
        { key: "W0105040201", value: "CMV ANTIGEN" },
        { key: "W0105040202", value: "CMV ANTIBODIES - TOTAL" },
        { key: "W0105040203", value: "CMV IGG" },
        { key: "W0105040204", value: "CMV IGM" },
        { key: "W0105040205", value: "CMV - NA REAGENTS" },
        { key: "W0105040206", value: "CMV IGG - AVIDITY" },
        { key: "W0105040299", value: "CMV REAGENTS - OTHER" },
        { key: "W01050403", value: "HERPES SIMPLEX VIRUS" },
        { key: "W0105040301", value: "HSV ANTIGEN" },
        { key: "W0105040302", value: "HSV 1+2 ANTIBODIES - TOTAL" },
        { key: "W0105040303", value: "HSV 1+2 IGG" },
        { key: "W0105040304", value: "HSV 1+2 IGM" },
        { key: "W0105040305", value: "HSV 1 ANTIBODIES - TOTAL" },
        { key: "W0105040306", value: "HSV 1 IGG" },
        { key: "W0105040307", value: "HSV 1 IGM" },
        { key: "W0105040308", value: "HSV 2 ANTIBODIES - TOTAL" },
        { key: "W0105040309", value: "HSV 2 IGG" },
        { key: "W0105040310", value: "HSV 2 IGM" },
        { key: "W0105040311", value: "HSV - NA REAGENTS" },
        { key: "W0105040399", value: "HSV REAGENTS - OTHER" },
        { key: "W01050404", value: "EPSTEIN BARR VIRUS" },
        { key: "W0105040401", value: "EBV ANTIBODIES" },
        { key: "W010504040101", value: "EBV ANTIBODIES - TOTAL" },
        { key: "W010504040102", value: "EBV IGG - TOTAL" },
        { key: "W010504040103", value: "EBV IGM - TOTAL" },
        { key: "W010504040104", value: "EBV VCA IGM" },
        { key: "W010504040105", value: "EBV VCA IGG" },
        { key: "W010504040106", value: "EBV EBNA IGG" },
        { key: "W010504040107", value: "EBV EA IGM" },
        { key: "W010504040108", value: "EBV EA IGG" },
        { key: "W010504040199", value: "EBV ANTIBODIES - OTHER" },
        { key: "W0105040403", value: "EBV - NA REAGENTS" },
        { key: "W0105040499", value: "EBV REAGENTS - OTHER" },
        { key: "W01050405", value: "OTHER VIROLOGY - NA REAGENTS" },
        { key: "W0105040501", value: "ADENOVIRUS - NA REAGENTS" },
        { key: "W0105040502", value: "ENTEROVIRUS - NA REAGENTS" },
        { key: "W0105040504", value: "INFLUENZA & PARA INFLUENZA - NA REAGENTS" },
        { key: "W0105040505", value: "RESPIRATORY SYNCYTIAL VIRUS (RSV) - NA REAGENTS" },
        { key: "W0105040506", value: "ROTAVIRUS - NA REAGENTS" },
        { key: "W0105040509", value: "PARVOVIRUS B 19 - NA REAGENTS" },
        { key: "W0105040511", value: "DENGUE VIRUS - NA REAGENTS" },
        { key: "W0105040512", value: "FSME VIRUS - NA REAGENTS" },
        { key: "W0105040513", value: "LCM VIRUS - NA REAGENTS" },
        { key: "W0105040514", value: "HANTAVIRUS / BUNYAVIRUS - NA REAGENTS" },
        { key: "W0105040515", value: "AVIAN INFLUENZA - NA REAGENTS" },
        { key: "W0105040516", value: "NOROVIRUS - NA REAGENTS" },
        { key: "W0105040517", value: "HUMAN METAPNEUMOVIRUS - NA REAGENTS" },
        { key: "W0105040518", value: "BOCAVIRUS - NA REAGENTS" },
        { key: "W0105040520", value: "RHINOVIRUS - NA REAGENTS" },
        { key: "W0105040521", value: "PARECHOVIRUS - NA REAGENTS" },
        { key: "W0105040522", value: "BK VIRUS - NA REAGENTS" },
        { key: "W0105040523", value: "JC VIRUS - NA REAGENTS" },
        { key: "W0105040524", value: "HHV-6,7,8 - NA REAGENTS" },
        { key: "W0105040525", value: "CHIKUNGUNYA VIRUS - NA REAGENTS" },
        { key: "W0105040526", value: "WEST NILE VIRUS - NA REAGENT" },
        { key: "W0105040528", value: "EBOLA (FILOVIRUS) - NA REAGENTS" },
        { key: "W0105040529", value: "CRIMEAN–CONGO HEMORRHAGIC FEVER (CCHF) - NA REAGENTS" },
        { key: "W0105040530", value: "ASTROVIRUS - NA REAGENTS" },
        { key: "W0105040531", value: "ZIKA VIRUS - NA REAGENTS" },
        { key: "W0105040532", value: "MONKEYPOX VIRUS / MPOX - NA REAGENT" },
        { key: "W0105040599", value: "VIROLOGY - NA REAGENTS - OTHER" },
        { key: "W01050406", value: "OTHER VIROLOGY ANTIGEN/ANTIBODY DETECTION" },
        { key: "W0105040601", value: "ADENOVIRUS" },
        { key: "W0105040602", value: "ENTEROVIRUS" },
        { key: "W0105040604", value: "INFLUENZA & PARA INFLUENZA" },
        { key: "W0105040605", value: "RESPIRATORY SYNCYTIAL VIRUS (RSV)" },
        { key: "W0105040606", value: "ROTAVIRUS" },
        { key: "W0105040609", value: "PARVOVIRUS B 19" },
        { key: "W0105040611", value: "DENGUE VIRUS" },
        { key: "W0105040612", value: "FSME VIRUS" },
        { key: "W0105040613", value: "LCM VIRUS" },
        { key: "W0105040614", value: "HANTAVIRUS / BUNYAVIRUS" },
        { key: "W0105040615", value: "AVIAN INFLUENZA" },
        { key: "W0105040616", value: "NOROVIRUS" },
        { key: "W0105040617", value: "HUMAN METAPNEUMOVIRUS" },
        { key: "W0105040618", value: "BOCAVIRUS" },
        { key: "W0105040620", value: "RHINOVIRUS" },
        { key: "W0105040621", value: "PARECHOVIRUS" },
        { key: "W0105040622", value: "BK VIRUS" },
        { key: "W0105040623", value: "JC VIRUS" },
        { key: "W0105040624", value: "HHV-6,7,8" },
        { key: "W0105040625", value: "CHIKUNGUNYA VIRUS" },
        { key: "W0105040626", value: "WEST NILE VIRUS" },
        { key: "W0105040627", value: "EBOLA (FILOVIRUS)" },
        { key: "W0105040628", value: "CRIMEAN–CONGO HEMORRHAGIC FEVER (CCHF)" },
        { key: "W0105040629", value: "ASTROVIRUS" },
        { key: "W0105040630", value: "ZIKA VIRUS" },
        { key: "W0105040699", value: "VIRAL ANTIGEN/ANTIBODY DETECTION - OTHER" },
        { key: "W01050407", value: "MEASLES VIRUS" },
        { key: "W0105040701", value: "MEASLES VIRUS ANTIBODIES - TOTAL" },
        { key: "W0105040702", value: "MEASLES VIRUS IGG" },
        { key: "W0105040703", value: "MEASLES VIRUS IGM" },
        { key: "W0105040704", value: "MEASLES - NA REAGENTS" },
        { key: "W0105040799", value: "MEASLES VIRUS REAGENTS - OTHER" },
        { key: "W01050408", value: "MUMPS / PAROTITIS VIRUS" },
        { key: "W0105040801", value: "MUMPS / PAROTITIS VIRUS ANTIBODIES - TOTAL" },
        { key: "W0105040802", value: "MUMPS / PAROTITIS VIRUS IGG" },
        { key: "W0105040803", value: "MUMPS / PAROTITIS VIRUS IGM" },
        { key: "W0105040804", value: "MUMPS / PAROTITIS - NA REAGENTS" },
        { key: "W0105040899", value: "MUMPS / PAROTITIS VIRUS REAGENTS - OTHER" },
        { key: "W01050409", value: "VARICELLA ZOSTER VIRUS" },
        { key: "W0105040901", value: "VARICELLA ZOSTER VIRUS ANTIBODIES - TOTAL" },
        { key: "W0105040902", value: "VARICELLA ZOSTER VIRUS IGG" },
        { key: "W0105040903", value: "VARICELLA ZOSTER VIRUS IGM" },
        { key: "W0105040904", value: "VARICELLA ZOSTER  - NA REAGENTS" },
        { key: "W0105040999", value: "VARICELLA ZOSTER VIRUS REAGENTS - OTHER" },
        { key: "W01050410", value: "HUMAN PAPILLOMA VIRUS" },
        { key: "W0105041001", value: "HPV ANTIGEN / ANTIBODIES" },
        { key: "W0105041002", value: "SCREENING HIGH-RISK HPV - NA REAGENTS" },
        { key: "W0105041003", value: "PARTIAL GENOTYPING HIGH-RISK HPV - NA REAGENTS" },
        { key: "W0105041004", value: "FULL GENOTYPING HIGH-RISK + LOW-RISK HPV - NA REAGENTS" },
        { key: "W0105041005", value: "OTHER HPV - NA REAGENTS" },
        { key: "W0105041099", value: "HPV REAGENTS - OTHER" },
        { key: "W01050411", value: "CORONAVIRUS" },
        { key: "W0105041101", value: "CORONAVIRUS AG" },
        { key: "W0105041102", value: "CORONAVIRUS ANTIBODIES - TOTAL" },
        { key: "W0105041103", value: "CORONAVIRUS IGG" },
        { key: "W0105041104", value: "CORONAVIRUS IGM" },
        { key: "W0105041105", value: "CORONAVIRUS IGA" },
        { key: "W0105041106", value: "CORONAVIRUS - NA REAGENTS" },
        { key: "W0105041199", value: "OTHER CORONAVIRUS REAGENTS" },
        { key: "W01050499", value: "VIROLOGY REAGENTS - OTHER" },
        { key: "W010505", value: "PARASITOLOGY (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050501", value: "TOXOPLASMA" },
        { key: "W0105050101", value: "TOXOPLASMA ANTIBODY (TOTAL)" },
        { key: "W0105050102", value: "TOXOPLASMA ANTIBODY IGG" },
        { key: "W0105050103", value: "TOXOPLASMA ANTIBODY IGM" },
        { key: "W0105050104", value: "TOXOPLASMA ANTIBODY IGG - AVIDITY" },
        { key: "W0105050105", value: "TOXOPLASMA - NA REAGENTS" },
        { key: "W0105050199", value: "TOXOPLASMA REAGENTS - OTHER" },
        { key: "W01050502", value: "MISCELLANEOUS PARASITOLOGY IMMUNOASSAY" },
        { key: "W0105050201", value: "ENTAMOEBA HISTOLYTICA" },
        { key: "W0105050202", value: "CHAGAS" },
        { key: "W0105050203", value: "DISTOMATOSIS" },
        { key: "W0105050204", value: "ECHINOCOCCUS" },
        { key: "W0105050205", value: "LEISHMANIA" },
        { key: "W0105050206", value: "SCHISTOSOMA" },
        { key: "W0105050207", value: "CRYPTOSPORIDIUM" },
        { key: "W0105050208", value: "GIARDIA LAMBLIA" },
        { key: "W0105050209", value: "PLASMODIUM (MALARIA)" },
        { key: "W0105050210", value: "TRICHOMONAS" },
        { key: "W0105050299", value: "PARASITOLOGY - OTHER" },
        { key: "W01050503", value: "MISCELLANEOUS PARASITOLOGY - NA REAGENTS" },
        { key: "W0105050301", value: "ENTAMOEBA HISTOLYTICA - NA REAGENTS" },
        { key: "W0105050302", value: "CHAGAS - NA REAGENTS" },
        { key: "W0105050303", value: "DISTOMATOSIS - NA REAGENTS" },
        { key: "W0105050304", value: "ECHINOCOCCUS - NA REAGENTS" },
        { key: "W0105050305", value: "LEISHMANIA - NA REAGENTS" },
        { key: "W0105050306", value: "SCHISTOSOMA - NA REAGENTS" },
        { key: "W0105050307", value: "CRYPTOSPORIDIUM - NA REAGENTS" },
        { key: "W0105050308", value: "GIARDIA LAMBLIA - NA REAGENTS" },
        { key: "W0105050309", value: "PLASMODIUM (MALARIA) - NA REAGENTS" },
        { key: "W0105050310", value: "TRICHOMONAS - NA REAGENTS" },
        { key: "W0105050399", value: "OTHER PARASITOLOGY - NA REAGENTS" },
        { key: "W010506", value: "MYCOLOGY (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050603", value: "MYCOLOGY IMMUNOASSAYS" },
        { key: "W0105060301", value: "ASPERGILLUS" },
        { key: "W0105060302", value: "CANDIDA ALBICANS" },
        { key: "W0105060303", value: "CRYPTOCOCCUS" },
        { key: "W0105060399", value: "MYCOLOGY IMMUNOASSAYS - OTHER" },
        { key: "W01050604", value: "MYCOLOGY - NA REAGENTS" },
        { key: "W0105060401", value: "ASPERGILLUS - NA REAGENTS" },
        { key: "W0105060402", value: "CANDIDA ALBICANS - NA REAGENTS" },
        { key: "W0105060403", value: "CRYPTOCOCCUS - NA REAGENTS" },
        { key: "W0105060404", value: "CANDIDA AURIS - NA REAGENTS" },
        { key: "W0105060405", value: "PNEUMOCYSTIS - NA REAGENTS" },
        { key: "W0105060499", value: "MYCOLOGY NA REAGENTS - OTHER" },
        { key: "W010507", value: "MULTIPLE PARAMETERS - (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050702", value: "MULTIPLE BACTERIA / FUNGI PANELS" },
        { key: "W0105070201", value: "GRAM+ - GRAM- - FUNGI - MULTIPLEX NA REAGENTS" },
        { key: "W0105070202", value: "SEPSIS (BACTERIA & FUNGI) - MULTIPLEX NA REAGENTS" },
        { key: "W0105070203", value: "GRAM+ - GRAM- - FUNGI - MULTIPLEX ASSAYS" },
        { key: "W01050703", value: "MULTIPLE VIRUSES PANELS" },
        { key: "W0105070301", value: "HBV / HCV / HIV COMBINATION - MULTIPLEX NA REAGENTS" },
        { key: "W0105070302", value: "OTHER VIRUS COMBINATIONS - MULTIPLEX NA REAGENTS" },
        { key: "W0105070303", value: "IMMUNOSUPPRESSED / TRANSPLANTATION MONITORING - MULTIPLEX NA REAGENTS" },
        { key: "W0105070304", value: "INFLUENZA & PARA INFLUENZA / RESPIRATORY SYNCYTIAL VIRUS (RSV) / SARS-COV - MULTIPLEX NA REAGENTS" },
        { key: "W0105070399", value: "MULTIPLE VIRUSES - MULTIPLEX ASSAYS - OTHER" },
        { key: "W01050704", value: "MULTIPLE PARASITES PANELS" },
        { key: "W01050705", value: "MULTIPLE PANELS FOR INFECTIONS - VARIOUS" },
        { key: "W0105070501", value: "STIS / STDS (C.TRACHOMATIS, N.GONORRHOEAE ,M.GENITALIUM, T.VAGINALIS, UREAPLASMA SPP….) COMBINATION - MULTIPLEX NA REAGENTS" },
        { key: "W0105070502", value: "OTHER MULTIPLE INFECTIOUS - MULTIPLEX NA REAGENTS" },
        { key: "W0105070503", value: "RESPIRATORY TRACT INFECTIONS - MULTIPLEX NA REAGENTS" },
        { key: "W0105070504", value: "GASTROINTESTINAL INFECTIONS - MULTIPLEX NA REAGENTS" },
        { key: "W0105070505", value: "MENINGITIS / ENCEPHALITIS INFECTIONS - MULTIPLEX NA REAGENTS" },
        { key: "W0105070506", value: "TROPICAL FEVER - MULTIPLEX NA REAGENTS" },
        { key: "W0105070507", value: "TICK BORNE DISEASES - MULTIPLEX NA REAGENTS" },
        { key: "W0105070599", value: "MULTIPLE INFECTIOUS - MULTIPLEX ASSAYS - OTHER" },
        { key: "W01050799", value: "MULTIPLE VIRUSES - OTHER" },
        { key: "W010508", value: "CONTROLS/STANDARDS/CALIBRATORS - (INFECT. IMMUNOLOGY/NAT)" },
        { key: "W01050808", value: "CONTROLS - INFECT. IMMUNOLOGY" },
        { key: "W0105080801", value: "BACTERIOLOGY CONTROLS - INF.IMM." },
        { key: "W0105080802", value: "HEPATITIS VIRUS CONTROLS - INF.IMM." },
        { key: "W0105080803", value: "RETROVIRUS CONTROLS - INF.IMM." },
        { key: "W0105080804", value: "OTHER VIROLOGY CONTROLS - INF.IMM." },
        { key: "W0105080805", value: "PARASITOLOGY CONTROLS - INF.IMM." },
        { key: "W0105080806", value: "MYCOLOGY CONTROLS - INF.IMM." },
        { key: "W0105080807", value: "MULTICONSTITUENT CONTROLS - INF.IMM." },
        { key: "W0105080808", value: "ALL INFECTIOUS DISEASES CONTROLS - NAT" },
        { key: "W0105080899", value: "CONTROLS - INF. IMMUNOLOGY - OTHER" },
        { key: "W01050809", value: "STANDARDS AND CALIBRATORS - INFECT. IMMUNOLOGY/NAT" },
        { key: "W0105080901", value: "BACTERIOLOGY STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080902", value: "HEPATITIS VIRUS STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080903", value: "RETROVIRUS STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080904", value: "OTHER VIROLOGY STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080905", value: "PARASITOLOGY STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080906", value: "MYCOLOGY STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080907", value: "MULTICONSTITUENT STANDARDS AND CALIBRATORS - INF.IMM." },
        { key: "W0105080908", value: "STANDARDS AND CALIBRATORS FOR ALL INFECTIONS/ NAT" },
        { key: "W0105080999", value: "STANDARDS AND CALIBRATORS - INF. IMMUNOLOGY - OTHER" },
        { key: "W010509", value: "INFECTIOUS IMMUNOLOGY - RAPID TESTS & POINT OF CARE" },
        { key: "W01050901", value: "BACTERIOLOGY - RT & POC" },
        { key: "W0105090101", value: "CHLAMYDIA AG - RT & POC" },
        { key: "W0105090102", value: "H. PYLORI - RT & POC" },
        { key: "W0105090103", value: "STREP. A - RT & POC" },
        { key: "W0105090104", value: "STREP. B - RT & POC" },
        { key: "W0105090105", value: "SYPHILIS - RT & POC" },
        { key: "W0105090106", value: "CLOST. DIFF. INCL GDH AND/OR TOXIN A AND B - RT & POC" },
        { key: "W0105090107", value: "MENINGITIS CAUSITIVE AGENTS - RT & POC" },
        { key: "W0105090108", value: "LEGIONELLA - RT & POC" },
        { key: "W0105090109", value: "STREP. PNEUMONIAE - RT & POC" },
        { key: "W0105090199", value: "BACTERIOLOGY - RT & POC - OTHER" },
        { key: "W01050902", value: "HEPATITIS VIRUSES - RT & POC" },
        { key: "W0105090201", value: "HBSAG - RT & POC" },
        { key: "W0105090202", value: "HCV ANTIBODY -RT & POC" },
        { key: "W0105090299", value: "HEPATITIS VIRUSES - RT & POC - OTHER" },
        { key: "W01050903", value: "RETROVIRUSES RT & POC" },
        { key: "W0105090301", value: "HIV 1 - RT & POC" },
        { key: "W0105090302", value: "HIV 1 / 2 - RT & POC" },
        { key: "W0105090303", value: "HIV AG/AB COMBI - RT & POC" },
        { key: "W0105090399", value: "RETROVIRUSES - RT & POC - OTHER" },
        { key: "W01050904", value: "PARASITOLOGY RT & POC" },
        { key: "W0105090401", value: "PLASMODIUM (MALARIA) - RT & POC" },
        { key: "W0105090499", value: "PARASITES - RT & POC - OTHER" },
        { key: "W01050905", value: "CORONAVIRUS RT & POC" },
        { key: "W0105090501", value: "CORONAVIRUS ANTIGEN (AG) - RT & POC" },
        { key: "W0105090502", value: "CORONAVIRUS ANTIBODY (AB) - RT & POC" },
        { key: "W0105090599", value: "OTHER CORONAVIRUS - RT & POC" },
        { key: "W01050906", value: "MULTIPLE PATHOGENS - RT & POC" },
        { key: "W0105090601", value: "CORONAVIRUS / INFLUENZA - RT & POC" },
        { key: "W0105090699", value: "OTHER MULTIPLE PATHOGENS - RT & POC" },
        { key: "W01050940", value: "CONTROLS, STANDARDS AND CALIBRATORS INFECTIOUS IMMUNOLOGY/NAT - RT & POC" },
        { key: "W0105094001", value: "CONTROLS INFECTIOUS IMMUNOLOGY/NAT - RT & POC" },
        { key: "W0105094002", value: "STANDARDS AND CALIBRATORS INFECTIOUS IMMUNOLOGY/NAT - RT & POC" },
        { key: "W01050990", value: "OTHER VIROLOGY RT & POC" },
        { key: "W0105099001", value: "CMV - RT & POC" },
        { key: "W0105099002", value: "RSV - RT & POC" },
        { key: "W0105099003", value: "MONONUCLEOSIS (EBV) - RT & POC" },
        { key: "W0105099004", value: "INFLUENZA A AND /OR B - RT & POC" },
        { key: "W0105099006", value: "VZV - RT & POC" },
        { key: "W0105099007", value: "DENGUE - RT & POC" },
        { key: "W0105099008", value: "MONKEYPOX VIRUS / MPOX RT & POC" },
        { key: "W0105099099", value: "VIROLOGY - RT & POC - OTHER" },
        { key: "W010590", value: "OTHER INFECTIOUS IMMUNOLOGY/NAT" },
        { key: "W01059001", value: "INFECTIOUS IMMUNOLOGY" },
        { key: "W0105900101", value: "REAGENTS FOR DNA AND/OR RNA EXTRACTION AND PREPARATION: BACTERIA AND/OR VIRUS" },
        { key: "W0105900102", value: "REAGENTS FOR DNA AND/OR RNA AMPLIFICATION AND/OR DETECTION: BACTERIA AND/OR VIRUS" },
        { key: "W0105900103", value: "SUPPLEMENTAL NA REAGENTS" },
        { key: "W01059002", value: "OTHER INFECTIOUS IMMUNOLOGY REAGENTS" },
        { key: "W0105900201", value: "BUFFERS (UNASSIGNABLE ), SUPPLEM. REAGENTS, ETC" },
        { key: "W0105900299", value: "INFECTIOUS IMMUNOLOGY - OTHER" },
        { key: "W0106", value: "GENETIC TESTING" },
        { key: "W010601", value: "INBORN GENE OR CHROMOSOME ALTERATIONS" },
        { key: "W01060101", value: "MONOGENETIC DISORDERS" },
        { key: "W0106010101", value: "CYSTIC FIBROSIS" },
        { key: "W0106010102", value: "DUCHENNE MUSCULAR DYSTROPHY" },
        { key: "W0106010103", value: "FACTOR V LEIDEN" },
        { key: "W0106010104", value: "FRAGILE X SYNDROME" },
        { key: "W0106010105", value: "HAEMOCHROMATOSIS" },
        { key: "W0106010106", value: "HAEMOPHILIA" },
        { key: "W0106010107", value: "HUNTINGTON CHOREA" },
        { key: "W0106010108", value: "POLYCYSTIC KIDNEY DISEASE" },
        { key: "W0106010109", value: "SICKLE CELL ANEMIA" },
        { key: "W0106010110", value: "TAY SACHS DISEASE" },
        { key: "W0106010111", value: "THALASSAEMIA" },
        { key: "W0106010112", value: "FRIEDREICH'S ATAXIA" },
        { key: "W0106010113", value: "SPIHOCEREBELLAR ATAXINS TYPE 1,2,3,6,7,8" },
        { key: "W0106010114", value: "PROTHROMBIN MUTATION" },
        { key: "W0106010115", value: "COMBINED FACTOR II / FACTOR V LEIDEN" },
        { key: "W0106010116", value: "OTHER THROMBOPHILIA MUTATIONS (PROC, PROS1, MTHFR, SERPINC1, SEPINE1, F11, F12, F13, OTHER F2/F5)" },
        { key: "W0106010117", value: "OTHER HEMOPHILIA MUTATIONS (VWF, F8, F9)" },
        { key: "W0106010199", value: "MONOGENETIC DISORDERS TESTS - OTHER" },
        { key: "W01060102", value: "POLYGENETIC DISORDERS" },
        { key: "W0106010201", value: "ALZHEIMER'S DISEASE" },
        { key: "W0106010202", value: "ASTHMA" },
        { key: "W0106010203", value: "ATHEROSCLEROSIS" },
        { key: "W0106010204", value: "DIABETES" },
        { key: "W0106010205", value: "HYPERTENSION" },
        { key: "W0106010206", value: "MULTIPLE SCLEROSIS" },
        { key: "W0106010207", value: "OSTEOPOROSIS" },
        { key: "W0106010299", value: "POLYGENETIC DISORDERS TESTS - OTHER" },
        { key: "W01060103", value: "CHROMOSOMAL DISORDERS" },
        { key: "W0106010301", value: "DOWN'S SYNDROME" },
        { key: "W0106010302", value: "EDWARDS SYNDROME" },
        { key: "W0106010303", value: "KLINEFELTER SYNDROME" },
        { key: "W0106010304", value: "PÄTAU SYNDROME" },
        { key: "W0106010305", value: "TURNER SYNDROME" },
        { key: "W0106010399", value: "CHROMOSOMAL DISORDERS TESTS - OTHER" },
        { key: "W01060104", value: "POLYMORPHISMS" },
        { key: "W0106010401", value: "HLA-TYPING" },
        { key: "W0106010499", value: "POLYMORPHISM TESTS - OTHER" },
        { key: "W010602", value: "ACQUIRED GENE OR CHROMOSOME ALTERATIONS" },
        { key: "W01060201", value: "P53" },
        { key: "W01060202", value: "K-RAS" },
        { key: "W01060203", value: "BRCA 1+2" },
        { key: "W01060204", value: "RET" },
        { key: "W01060205", value: "C-MYC" },
        { key: "W01060206", value: "HNPCC" },
        { key: "W01060207", value: "APC" },
        { key: "W01060208", value: "T (9;22)" },
        { key: "W01060209", value: "T (8;14)" },
        { key: "W01060210", value: "T (14;18)" },
        { key: "W01060211", value: "INV (16)" },
        { key: "W01060212", value: "TELOMERASE" },
        { key: "W01060213", value: "HER-2/NEU (BREAST CANCER)" },
        { key: "W01060214", value: "COLORECTAL CANCER (MSI-H / DMMR)" },
        { key: "W01060215", value: "BLADDER CANCER DETECTION / MONITORING" },
        { key: "W01060299", value: "TESTS FOR ACQUIRED GENETIC OR CHROMOSOMAL ALTERATIONS - OTHER" },
        { key: "W010603", value: "MULTIPLE PARAMETERS - GENETIC TESTING" },
        { key: "W01060301", value: "PHARMACOGENOMICS" },
        { key: "W0106030101", value: "CYP 450 - INDIVIDUAL TEST" },
        { key: "W0106030102", value: "CYP 450 - MULTIPLE TESTS ON MICRO-ARRAYS" },
        { key: "W0106030103", value: "CYP2C9" },
        { key: "W0106030104", value: "CYP2C19" },
        { key: "W0106030105", value: "VKORC1" },
        { key: "W010699", value: "GENETIC TESTS - OTHER" },
        { key: "W02", value: "IVD INSTRUMENTS" },
        { key: "W0201", value: "CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS" },
        { key: "W020101", value: "CHEMISTRY INSTRUMENTS" },
        { key: "W02010101", value: "CHEMISTRY ANALYSERS" },
        { key: "W0201010101", value: "CHEMISTRY ANALYSERS - LOW ROUTINE (Random access without ISE mode test/h <= 400)" },
        { key: "W0201010102", value: "CHEMISTRY ANALYSERS - MODERATE ROUTINE (Random access without ISE mode test/h > 400 and <= 800)" },
        { key: "W0201010103", value: "CHEMISTRY ANALYSERS - MODERATE TO HIGH ROUTINE (Random access without ISE mode test/h > 800 and <= 1.200)" },
        { key: "W0201010104", value: "CHEMISTRY ANALYSERS - HIGH ROUTINE (Random access without ISE mode test/h > 1.200)" },
        { key: "W0201010105", value: "CHEMISTRY ANALYSERS - LOW ROUTINE (with ISE mode test/h <= 400)" },
        { key: "W0201010106", value: "CHEMISTRY ANALYSERS - MODERATE ROUTINE (with ISE mode test/h > 400 and <= 800)" },
        { key: "W0201010107", value: "CHEMISTRY ANALYSERS - MODERATE TO HIGH ROUTINE (with ISE mode test/h > 800 and <= 1.200)" },
        { key: "W0201010108", value: "CHEMISTRY ANALYSERS - HIGH ROUTINE (with ISE mode test/h > 1.200)" },
        { key: "W0201010180", value: "CHEMISTRY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201010182", value: "CHEMISTRY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201010185", value: "CHEMISTRY ANALYSERS - CONSUMABLES" },
        { key: "W0201010192", value: "CHEMISTRY ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02010102", value: "LIMITED PANEL CHEMISTRY ANALYSERS" },
        { key: "W0201010201", value: "URINE ANALYSERS" },
        { key: "W020101020101", value: "URINE STRIP READERS" },
        { key: "W020101020102", value: "SEMI-AUTOMATED URINE ANALYSERS" },
        { key: "W020101020103", value: "AUTOMATED URINE ANALYSERS" },
        { key: "W020101020180", value: "AUTOMATED URINE ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W020101020182", value: "AUTOMATED URINE ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W020101020185", value: "AUTOMATED URINE ANALYSERS - CONSUMABLES" },
        { key: "W020101020192", value: "AUTOMATED URINE ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0201010202", value: "URINARY SEDIMENT DEVICES" },
        { key: "W0201010203", value: "BLOOD-AMMONIA CHECKERS" },
        { key: "W0201010280", value: "LIMITED PANEL CHEMISTRY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201010282", value: "LIMITED PANEL CHEMISTRY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201010285", value: "LIMITED PANEL CHEMISTRY ANALYSERS - CONSUMABLES" },
        { key: "W0201010292", value: "LIMITED PANEL CHEMISTRY ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0201010299", value: "LIMITED PANEL CHEMISTRY ANALYSERS - OTHER" },
        { key: "W02010199", value: "CHEMISTRY INSTRUMENTS - OTHER" },
        { key: "W020102", value: "IMMUNOCHEMISTRY INSTRUMENTS" },
        { key: "W02010201", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS" },
        { key: "W0201020101", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - LOW ROUTINE (Throughput <= 100 test/h)" },
        { key: "W0201020102", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - MODERATE ROUTINE (Throughput > 100 and <= 250 test/h)" },
        { key: "W0201020103", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - MODERATE TO HIGH ROUTINE (Throughput > 250 and <= 700 test/h)" },
        { key: "W0201020104", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - HIGH ROUTINE (Throughput > 700 test/h)" },
        { key: "W0201020180", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201020182", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201020185", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - CONSUMABLES" },
        { key: "W0201020192", value: "AUTOMATED IMMUNOCHEMISTRY ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02010202", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS" },
        { key: "W0201020201", value: "IMMUNOCHEMISTRY READERS" },
        { key: "W0201020202", value: "BETA PARTICLES COUNTERS" },
        { key: "W0201020203", value: "GAMMA COUNTERS" },
        { key: "W0201020204", value: "NEPHELOMETERS" },
        { key: "W0201020205", value: "TURBIDIMETERS" },
        { key: "W0201020280", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201020282", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201020285", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS - CONSUMABLES" },
        { key: "W0201020292", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS - IVD MEDICAL DEVICE SOFTWAE" },
        { key: "W0201020299", value: "LIMITED PANEL IMMUNOCHEMISTRY ANALYSERS - OTHER" },
        { key: "W02010299", value: "IMMUNOCHEMISTRY INSTRUMENTS - OTHER" },
        { key: "W020103", value: "INTEGRATED / MODULAR CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS" },
        { key: "W02010301", value: "MIXED PANEL MULTIPARAMETER ANALYSERS" },
        { key: "W0201030101", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - LOW ROUTINE (Throughput <= 800 test/h)" },
        { key: "W0201030102", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - MODERATE ROUTINE (Throughput > 800 and <= 2000 test/h)" },
        { key: "W0201030103", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - HIGH ROUTINE (Throughput > 2000 test/h)" },
        { key: "W0201030180", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201030182", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201030185", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - CONSUMABLES" },
        { key: "W0201030192", value: "MIXED PANEL MULTIPARAMETER ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02010399", value: "INTEGRATED / MODULAR CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - OTHER" },
        { key: "W020104", value: "BLOOD GAS ANALYSIS / ELECTROLYTE INSTRUMENTS" },
        { key: "W02010401", value: "BLOOD GAS ANALYSERS" },
        { key: "W0201040101", value: "BLOOD GAS ANALYSERS - WITH CLASSIC PROFILE (pH, pO2, pCO2, HCT + electrolytes)" },
        { key: "W0201040102", value: "BLOOD GAS ANALYSERS - WITH ADDITIONAL PARAMETERS (pH, pO2, pCO2, Hct + metabolites + electrolytes, CO-oximeter parameters and coagulation parameters)" },
        { key: "W0201040180", value: "BLOOD GAS ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0201040182", value: "BLOOD GAS ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0201040185", value: "BLOOD GAS ANALYSERS - CONSUMABLES" },
        { key: "W0201040192", value: "BLOOD GAS ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02010402", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTES" },
        { key: "W0201040201", value: "ION SELECTIVE ELECTROLYTE ANALYSERS" },
        { key: "W0201040202", value: "FLAME PHOTOMETERS" },
        { key: "W0201040203", value: "CHLORIDE ANALYSERS" },
        { key: "W0201040280", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTE - HARDWARE ACCESSORIES" },
        { key: "W0201040282", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTES - SOFTWARE ACCESSORIES" },
        { key: "W0201040285", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTES - CONSUMABLES" },
        { key: "W0201040292", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTES - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0201040299", value: "LIMITED PANEL ANALYSERS FOR BLOOD GAS ANALYSIS / ELECTROLYTES - OTHER" },
        { key: "W02010499", value: "BLOOD GAS ANALYSIS / ELECTROLYTE INSTRUMENTS - OTHER" },
        { key: "W020105", value: "ELECTROPHORESIS / CHROMATOGRAPHY INSTRUMENTS" },
        { key: "W02010501", value: "ELECTROPHORESIS INSTRUMENTS" },
        { key: "W0201050101", value: "AUTOMATED ELECTROPHORESIS SYSTEMS" },
        { key: "W0201050102", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS" },
        { key: "W020105010201", value: "SEMI-.AUTOMATED ELECTROPHORESIS SYSTEMS" },
        { key: "W020105010202", value: "CAPILLARY ELECTROPHORESIS SYSTEMS" },
        { key: "W020105010203", value: "DENSITOMETERS" },
        { key: "W020105010280", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W020105010282", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W020105010285", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS - CONSUMABLES" },
        { key: "W020105010292", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W020105010299", value: "LIMITED PANEL ELECTROPHORESIS ANALYSERS - OTHER" },
        { key: "W0201050190", value: "VARIOUS ELECTROPHORESIS INTRUMENTS" },
        { key: "W020105019001", value: "ELECTROPHORETIC GEL PROCESSORS" },
        { key: "W020105019002", value: "GEL DOCUMENTATION SYSTEMS" },
        { key: "W020105019080", value: "VARIOUS ELECTROPHORESIS INTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W020105019082", value: "VARIOUS ELECTROPHORESIS INTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W020105019085", value: "VARIOUS ELECTROPHORESIS INTRUMENTS - CONSUMABLES" },
        { key: "W020105019092", value: "VARIOUS ELECTROPHORESIS INTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W020105019099", value: "VARIOUS ELECTROPHORESIS INTRUMENTS - OTHER" },
        { key: "W02010502", value: "CHROMATOGRAPHY INSTRUMENTS (HPLC)" },
        { key: "W0201050201", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS" },
        { key: "W0201050280", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "W0201050282", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "W0201050285", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS - CONSUMABLES" },
        { key: "W0201050292", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0201050299", value: "HIGH PERFORMANCE LIQUID CHROMATOGRAPHY SYSTEMS - OTHER" },
        { key: "W020106", value: "CHEMISTRY / IMMUNOCHEMISTRY RAPID TESTS + POC TESTS" },
        { key: "W02010601", value: "DIABETES MONITORING" },
        { key: "W0201060101", value: "GLYCOSILATED HEMOGLOBIN DEVICEs" },
        { key: "W0201060102", value: "BLOOD GLUCOSE METERS" },
        { key: "W0201060190", value: "VARIOUS DIABETES MONITORING INSTRUMENTS" },
        { key: "W020106019080", value: "VARIOUS DIABETES MONITORING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W020106019082", value: "VARIOUS DIABETES MONITORING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W020106019085", value: "VARIOUS DIABETES MONITORING INSTRUMENTS - CONSUMABLES" },
        { key: "W020106019092", value: "VARIOUS DIABETES MONITORING INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W020106019099", value: "VARIOUS DIABETES MONITORING INSTRUMENTS - OTHER" },
        { key: "W02010690", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS (\"POINT OF CARE\" AND/OR EMERGENCY)" },
        { key: "W0201069001", value: "CARDIAC MARKER PORTABLE ANALYSERS" },
        { key: "W0201069002", value: "BLOOD GAS PORTABLE ANALYSERS" },
        { key: "W0201069003", value: "ALCOHOL ANALYSERS" },
        { key: "W0201069004", value: "BILIRUBINOMETERS" },
        { key: "W0201069005", value: "HEMOXIMETERS" },
        { key: "W0201069080", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W0201069082", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W0201069085", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - CONSUMABLES" },
        { key: "W0201069092", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0201069099", value: "VARIOUS RAPID TEST CHEMISTRY / IMMUNOCHEMISTRY INSTRUMENTS - OTHER" },
        { key: "W020107", value: "URINALYSIS (UR) - LABORATORY ANALYSERS" },
        { key: "W02010701", value: "URINALYSIS (UR) - LABORATORY ANALYSERS- INSTRUMENTS" },
        { key: "W02010780", value: "URINALYSIS (UR) - LABORATORY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W02010782", value: "URINALYSIS (UR) - LABORATORY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W02010785", value: "URINALYSIS (UR) - LABORATORY ANALYSERS - CONSUMABLES" },
        { key: "W02010792", value: "URINALYSIS (UR) - LABORATORY ANALYSERS- IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0202", value: "HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS" },
        { key: "W020201", value: "HAEMATOLOGY / CELL COUNTING" },
        { key: "W02020101", value: "AUTOMATED 5 PART DIFFERENTIAL HEMATOLOGY ANALYSERS" },
        { key: "W0202010101", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - LOW ROUTINE (Throughput <= 100 samples/hr)" },
        { key: "W0202010102", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - MODERATE ROUTINE (Throughput > 100 and <= 120 samples/hr)" },
        { key: "W0202010103", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - HIGH ROUTINE (Throughput > 120 samples/hr)" },
        { key: "W0202010180", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0202010182", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0202010185", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - CONSUMABLES" },
        { key: "W0202010192", value: "AUTOMATED WHOLE BLOOD HEMATOLOGY ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020102", value: "LIMITED PANEL CELL COUNTING ANALYSERS" },
        { key: "W0202010201", value: "AUTOMATED 3 PART HEMATOLOGY ANALYSERS" },
        { key: "W0202010202", value: "SEMI-AUTOMATED HEMATOLOGY ANALYSERS" },
        { key: "W0202010280", value: "LIMITED PANEL CELL COUNTING ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0202010282", value: "LIMITED PANEL CELL COUNTING ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0202010285", value: "LIMITED PANEL CELL COUNTING ANALYSERS - CONSUMABLES" },
        { key: "W0202010292", value: "LIMITED PANEL CELL COUNTING ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0202010299", value: "LIMITED PANEL CELL COUNTING ANALYSERS - OTHER" },
        { key: "W02020199", value: "CELL COUNTING INSTRUMENTS - OTHER" },
        { key: "W020202", value: "HEMOSTASIS" },
        { key: "W02020201", value: "COAGULOMETERS" },
        { key: "W0202020101", value: "SEMI-AUTOMATED COAGULOMETERS" },
        { key: "W0202020102", value: "AUTOMATED COAGULOMETERS" },
        { key: "W0202020180", value: "COAGULOMETERS - HARDWARE ACCESSORIES" },
        { key: "W0202020182", value: "COAGULOMETERS - SOFTWARE ACCESSORIES" },
        { key: "W0202020185", value: "COAGULOMETERS - CONSUMABLES" },
        { key: "W0202020192", value: "COAGULOMETERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020290", value: "VARIOUS HEMOSTASIS INSTRUMENTS" },
        { key: "W0202029001", value: "THROMBELASTOGRAPHS" },
        { key: "W0202029080", value: "VARIOUS HEMOSTASIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W0202029082", value: "VARIOUS HEMOSTASIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W0202029085", value: "VARIOUS HEMOSTASIS INSTRUMENTS - CONSUMABLES" },
        { key: "W0202029092", value: "VARIOUS HEMOSTASIS INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0202029099", value: "VARIOUS HEMOSTASIS INSTRUMENTS - OTHER" },
        { key: "W020203", value: "BLOOD GROUPING INSTRUMENTS" },
        { key: "W02020301", value: "BLOOD GROUPING ANALYSERS" },
        { key: "W0202030101", value: "BLOOD GROUPING ANALYSERS - MANUAL OR SEMI-AUTOMATED" },
        { key: "W0202030102", value: "AUTOMATED BLOOD GROUPING ANALYSERS" },
        { key: "W0202030180", value: "BLOOD GROUPING ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0202030182", value: "BLOOD GROUPING ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0202030185", value: "BLOOD GROUPING ANALYSERS - CONSUMABLES" },
        { key: "W0202030192", value: "BLOOD GROUPING ANALYSERS - MEDICAL DEVICE SOFTWARE" },
        { key: "W02020302", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS" },
        { key: "W0202030201", value: "IMMUNOHEMATOLOGY READERS" },
        { key: "W0202030202", value: "TRANSILLUMINATORS" },
        { key: "W0202030203", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS - OTHER" },
        { key: "W0202030280", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0202030282", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0202030285", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS - CONSUMABLES" },
        { key: "W0202030292", value: "LIMITED PANEL BLOOD GROUPING ANALYSERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020399", value: "BLOOD GROUPING INSTRUMENTS - OTHER" },
        { key: "W020204", value: "FLOW CYTOMETRY INSTRUMENTS" },
        { key: "W02020401", value: "CYTOFLOWMETERS" },
        { key: "W0202040101", value: "CYTOFLOWMETERS - LOW ROUTINE" },
        { key: "W0202040102", value: "CYTOFLOWMETERS - MODERATE ROUTINE" },
        { key: "W0202040103", value: "CYTOFLOWMETERS - HIGH ROUTINE" },
        { key: "W0202040180", value: "CYTOFLOWMETERS - HARDWARE ACCESSORIES" },
        { key: "W0202040182", value: "CYTOFLOWMETERS - SOFTWARE ACCESSORIES" },
        { key: "W0202040185", value: "CYTOFLOWMETERS - CONSUMABLES" },
        { key: "W0202040192", value: "CYTOFLOWMETERS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020499", value: "FLOW CYTOMETRY INSTRUMENTS - OTHER" },
        { key: "W020205", value: "HISTOLOGY / CYTOLOGY" },
        { key: "W02020501", value: "HISTOLOGICAL SAMPLES ANALYSERS" },
        { key: "W02020502", value: "CERVICAL SCREENING SYSTEMS" },
        { key: "W02020503", value: "LABORATORY INSTRUMENTS FOR MICROSCOPIC INVESTIGATIONS" },
        { key: "W0202050301", value: "ELECTRON MICROSCOPES" },
        { key: "W0202050302", value: "LASER SCANNING MICROSCOPES" },
        { key: "W0202050303", value: "OPTICAL LABORATORY MICROSCOPES" },
        { key: "W0202050304", value: "DIGITAL LABORATORY MICROSCOPES" },
        { key: "W0202050380", value: "LABORATORY INSTRUMENTS FOR MICROSCOPIC INVESTIGATIONS - HARDWARE ACCESSORIES" },
        { key: "W0202050382", value: "LABORATORY INSTRUMENTS FOR MICROSCOPIC INVESTIGATIONS - SOFTWARE ACCESSORIES" },
        { key: "W0202050385", value: "LABORATORY INSTRUMENTS FOR MICROSCOPIC INVESTIGATIONS - CONSUMABLES" },
        { key: "W0202050392", value: "LABORATORY INSTRUMENTS FOR MICROSCOPIC INVESTIGATIONS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020590", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY" },
        { key: "W0202059001", value: "IMMUNOHISTOCHEMISTRY PROCESSORS" },
        { key: "W0202059002", value: "AUTOMATED SLIDE STAINERS" },
        { key: "W0202059003", value: "CRYOSTAT MICROTOMES" },
        { key: "W0202059004", value: "TISSUE EMBEDDING PROCESSORS" },
        { key: "W0202059005", value: "MICROTOMES" },
        { key: "W0202059006", value: "LASER MICRODISSECTION SYSTEMS" },
        { key: "W0202059007", value: "MICROMANIPULATORS" },
        { key: "W0202059008", value: "AUTOMATED COVERSLIPPERS" },
        { key: "W0202059009", value: "PARAFFIN DISPENSERS" },
        { key: "W0202059010", value: "TISSUE PROCESSORS" },
        { key: "W0202059011", value: "SAMPLE PREPARATION UNITS FOR CHROMOSOMIC ANALYSIS" },
        { key: "W0202059012", value: "COOLING PARAFFIN PLATES" },
        { key: "W0202059013", value: "HEATED FORCEPS" },
        { key: "W0202059014", value: "SOLVENT DISTILLERS" },
        { key: "W0202059015", value: "CUTTING STATION FOR HISTOLOGICAL SAMPLES" },
        { key: "W0202059016", value: "AUTOMATED DEWAXING SYSTEMS" },
        { key: "W0202059017", value: "CASSETTE / SLIDE PRINTERS" },
        { key: "W0202059080", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY - HARDWARE ACCESSORIES" },
        { key: "W0202059082", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY - SOFTWARE ACCESSORIES" },
        { key: "W0202059085", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY - CONSUMABLES" },
        { key: "W0202059092", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W0202059099", value: "VARIOUS PROCESSING INSTRUMENTS FOR HYSTOLOGY / CYTOLOGY - OTHER" },
        { key: "W020206", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS" },
        { key: "W02020601", value: "RAPID TEST CELL COUNT INSTRUMENTS" },
        { key: "W02020602", value: "RAPID TEST HEMOSTASIS INSTRUMENTS" },
        { key: "W02020680", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02020682", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02020685", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "W02020692", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02020699", value: "RAPID TEST HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - OTHER" },
        { key: "W020290", value: "VARIOUS HEMATOLOGY / HISTOLOGY /CYTOLOGY INSTRUMENTS" },
        { key: "W02029001", value: "ERYTHROCYTE SEDIMENTATION RATE DEVICES" },
        { key: "W02029002", value: "BLOOD PHOTODYNAMIC TREATMENT UNITS" },
        { key: "W02029003", value: "AUTOMATED BLOOD COMPONENT EXTRACTORS" },
        { key: "W02029005", value: "CYTOFLUOROMETRIC PREPARATION UNITS" },
        { key: "W02029006", value: "APHERESIS UNITS" },
        { key: "W02029007", value: "IMMUNOMAGNETIC CELLULAR SEPARATION SYSTEMS" },
        { key: "W02029008", value: "TUBING WELDERS" },
        { key: "W02029009", value: "BLOOD BAG PRESSES" },
        { key: "W02029010", value: "BAG SEALERS" },
        { key: "W02029080", value: "VARIOUS HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02029082", value: "VARIOUS HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02029085", value: "VARIOUS HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "W02029092", value: "VARIOUS HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02029099", value: "VARIOUS HEMATOLOGY / HISTOLOGY / CYTOLOGY INSTRUMENTS - OTHER" },
        { key: "W0203", value: "MICROBIOLOGY INSTRUMENTS (CULTURES)" },
        { key: "W020301", value: "MICROBIOLOGY SUSCEPTIBILITY / IDENTIFICATION" },
        { key: "W02030101", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS" },
        { key: "W0203010180", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS - HARDWARE ACCESSORIES" },
        { key: "W0203010182", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS - SOFTWARE ACCESSORIES" },
        { key: "W0203010185", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS - CONSUMABLES" },
        { key: "W0203010192", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS - MEDICAL DEVICE SOFTWARE" },
        { key: "W02030199", value: "ANTIBIOTIC SUSCEPTIBILITY ANALYSERS - OTHER" },
        { key: "W020302", value: "BLOOD CULTURES AND MYCOBACTERIA" },
        { key: "W02030201", value: "AUTOMATED BLOOD CULTURE ANALYSERS" },
        { key: "W02030299", value: "INSTRUMENTS FOR BLOOD CULTURES AND MYCOBACTERIA - OTHER" },
        { key: "W020303", value: "MASS - SPECTROMETRY SYSTEM" },
        { key: "W020304", value: "MICROBIOLOGY GRAM STAINER" },
        { key: "W020305", value: "PLATES STREAKER" },
        { key: "W020306", value: "URINARY SCREENING SYSTEM" },
        { key: "W020390", value: "VARIOUS MICROBIOLOGY INSTRUMENTS" },
        { key: "W02039001", value: "COLONY COUNTERS" },
        { key: "W02039002", value: "CARBON DIOXIDE INCUBATORS" },
        { key: "W02039003", value: "PETRI DISH FILLERS" },
        { key: "W02039004", value: "AUTOMATED SLIDE PREPARATION UNITS" },
        { key: "W02039005", value: "CULTURE MEDIUM PREPARATION UNITS" },
        { key: "W02039006", value: "DNA THERMAL CYCLERS" },
        { key: "W02039080", value: "VARIOUS MICROBIOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02039082", value: "VARIOUS MICROBIOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02039085", value: "VARIOUS MICROBIOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "W02039092", value: "VARIOUS MICROBIOLOGY INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02039099", value: "VARIOUS MICROBIOLOGY INSTRUMENTS - OTHER" },
        { key: "W0204", value: "INFECTIOUS IMMUNOLOGY INSTRUMENTS" },
        { key: "W0205", value: "NUCLEIC ACID TESTING INSTRUMENTS" },
        { key: "W020501", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS" },
        { key: "W02050101", value: "NUCLEIC ACID HYBRIDIZATION UNITS" },
        { key: "W02050102", value: "EUKARYOTIC CELL BIOREACTORS" },
        { key: "W02050103", value: "BLOTTING SYSTEMS" },
        { key: "W02050104", value: "KARYOTYPE PROCESSING AUTOMATED SYSTEMS" },
        { key: "W02050105", value: "ELECTROPORATION DEVICES" },
        { key: "W02050106", value: "DNA GENOMIC PREPARATION DEVICES" },
        { key: "W02050107", value: "MICRO-ARRAY SCANNERS" },
        { key: "W02050108", value: "GENETIC SYSTEM READERS" },
        { key: "W02050109", value: "CELL WASHERS" },
        { key: "W02050110", value: "MICROINJECTORS" },
        { key: "W02050111", value: "EPITHELIAL VOLTOHMMETERS" },
        { key: "W02050112", value: "GENIC EXPRESSION MONITORING SYSTEMS" },
        { key: "W02050113", value: "PEPTIDE SYNTHESIZERS" },
        { key: "W02050114", value: "MOLECULAR BIOLOGY SCANNERS" },
        { key: "W02050115", value: "DNA SYNTHESIZERS" },
        { key: "W02050116", value: "NUCLEIC ACID TESTING INTEGRETED EXTRATION /AMPLIFICATION /DETECTION SYSTEMS" },
        { key: "W02050180", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS - HARDWARE ACCESSORIES" },
        { key: "W02050182", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS - SOFTWARE ACCESSORIES" },
        { key: "W02050185", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS - CONSUMABLES" },
        { key: "W02050192", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02050199", value: "NUCLEIC ACID TESTING INSTRUMENTS EXCEPT MICRO-ARRAYS - OTHER" },
        { key: "W020502", value: "MICRO-ARRAY INSTRUMENTS" },
        { key: "W02050201", value: "MICRO-ARRAY ANALYSERS" },
        { key: "W02050202", value: "MICRO-ARRAYS PREPARATION UNITS" },
        { key: "W02050280", value: "MICRO-ARRAY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02050282", value: "MICRO-ARRAY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02050285", value: "MICRO-ARRAY INSTRUMENTS - CONSUMABLES" },
        { key: "W02050292", value: "MICRO-ARRAY INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02050299", value: "MICRO-ARRAY INSTRUMENTS - OTHER" },
        { key: "W020503", value: "NUCLEIC ACID TESTING INSTRUMENTS - RAPID AND POINT OF CARE TESTS" },
        { key: "W02050301", value: "NUCLEIC ACID TESTING APPARATUSES - RAPID AND POINT OF CARE TESTS" },
        { key: "W02050380", value: "NUCLEIC ACID TESTING INSTRUMENTS - RAPID AND POINT OF CARE TESTS - HARDWARE ACCESSORIES" },
        { key: "W02050382", value: "NUCLEIC ACID TESTING INSTRUMENTS- RAPID AND POINT OF CARE TESTS - SOFTWARE ACCESSORIES" },
        { key: "W02050385", value: "NUCLEIC ACID TESTING INSTRUMENTS - RAPID AND POINT OF CARE TESTS - CONSUMABLES" },
        { key: "W02050392", value: "NUCLEIC ACID TESTING INSTRUMENTS - RAPID AND POINT OF CARE TESTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02050399", value: "NUCLEIC ACID TESTING INSTRUMENTS - RAPID AND POINT OF CARE TESTS - OTHER" },
        { key: "W0206", value: "SAMPLE PROCESSING SYSTEMS" },
        { key: "W020601", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS" },
        { key: "W02060101", value: "AUTOMATED SYSTEMS FOR THE MANAGEMENT OF PRE AND POST-ANALYSIS" },
        { key: "W02060102", value: "AUTOMATED SAMPLE TRANSPORT SYSTEMS" },
        { key: "W02060180", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "W02060182", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "W02060185", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS - CONSUMABLES" },
        { key: "W02060192", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02060199", value: "ROBOTIC SAMPLE PROCESSING SYSTEMS - OTHER" },
        { key: "W020602", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS" },
        { key: "W02060201", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - INSTRUMENTS" },
        { key: "W02060280", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "W02060282", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "W02060285", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - CONSUMABLES" },
        { key: "W02060292", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02060299", value: "POST-ANALYSIS SAMPLE ARCHIVING SYSTEMS - OTHER" },
        { key: "W020690", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS" },
        { key: "W02069001", value: "AUTOSAMPLERS" },
        { key: "W02069002", value: "TEST TUBE APPARATUSES" },
        { key: "W02069003", value: "CENTRIFUGES" },
        { key: "W02069004", value: "CYTOCENTRIFUGES" },
        { key: "W02069005", value: "REFRIGERATED CENTRIFUGES" },
        { key: "W02069006", value: "ULTRACENTRIFUGES" },
        { key: "W02069080", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02069082", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02069085", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS - CONSUMABLES" },
        { key: "W02069092", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02069099", value: "VARIOUS SAMPLE PROCESSING INSTRUMENTS - OTHER" },
        { key: "W0207", value: "GENERAL PURPOSE IVD INSTRUMENTS" },
        { key: "W020701", value: "SCALES" },
        { key: "W02070101", value: "ANALYTICAL SCALES" },
        { key: "W02070102", value: "TECHNICAL SCALES" },
        { key: "W02070103", value: "BLOOD SCALES" },
        { key: "W020702", value: "CRYOGENICS / FROZEN" },
        { key: "W020703", value: "BIOLOGICAL HOODS AND CABINETS" },
        { key: "W02070301", value: "BIOLOGICAL HOODS" },
        { key: "W02070302", value: "FUME HOODS" },
        { key: "W02070303", value: "LAMINAR AIRFLOW HOODS" },
        { key: "W02070304", value: "CHEMICAL FILTRATION AIR CLOSETS" },
        { key: "W020704", value: "SHAKERS AND HOMOGENIZERS" },
        { key: "W02070401", value: "LABORATORY SHAKERS" },
        { key: "W02070402", value: "GRINDING MILLS" },
        { key: "W02070403", value: "HOMOGENIZERS" },
        { key: "W02070404", value: "BLOOD BAG MIXERS" },
        { key: "W020790", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS" },
        { key: "W02079001", value: "THERMOSTATIC WATER BATHS" },
        { key: "W02079002", value: "DILUTERS" },
        { key: "W02079003", value: "DISPENSERS" },
        { key: "W02079004", value: "EVAPORATORS" },
        { key: "W02079006", value: "BUNSEN BURNERS" },
        { key: "W02079007", value: "FREEZE DRYERS" },
        { key: "W02079008", value: "HEATING MANTLES" },
        { key: "W02079009", value: "PH METERS" },
        { key: "W02079011", value: "MELTING POINT DEVICES" },
        { key: "W02079012", value: "LABORATORY HOTPLATES" },
        { key: "W02079013", value: "LABORATORY REFRACTOMETERS" },
        { key: "W02079014", value: "LABWARE DRYERS" },
        { key: "W02079015", value: "LABORATORY TITRATORS" },
        { key: "W02079016", value: "VISCOSIMETERS" },
        { key: "W02079017", value: "OSMOMETERS" },
        { key: "W02079080", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "W02079082", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "W02079085", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS - CONSUMABLES" },
        { key: "W02079092", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS - IVD MEDICAL DEVICE SOFTWARE" },
        { key: "W02079099", value: "VARIOUS GENERAL PURPOSE IVD INSTRUMENTS - OTHER" },
        { key: "W0299", value: "IVD INSTRUMENTS - OTHER" },
        { key: "W05", value: "IVD GENERIC USE CONSUMABLES" },
        { key: "W0501", value: "SAMPLES COLLECTION DEVICES" },
        { key: "W050101", value: "BLOOD COLLECTION DEVICES" },
        { key: "W05010101", value: "VENOUS OR ARTERIOUS BLOOD COLLECTION DEVICES" },
        { key: "W0501010101", value: "BLOOD COLLECTION, CLOSED SYRINGES" },
        { key: "W050101010101", value: "BLOOD COLLECTION, CLOSED SYRINGES WITH ADDITIVES" },
        { key: "W050101010102", value: "BLOOD COLLECTION, CLOSED SYRINGES WITHOUT ADDITIVES" },
        { key: "W0501010102", value: "BLOOD COLLECTION, TUBES" },
        { key: "W050101010201", value: "BLOOD COLLECTION, TUBES WITH ADDITIVES OR SERUM SEPARATOR" },
        { key: "W050101010202", value: "BLOOD COLLECTION, TUBES WITHOUT ADDITIVES OR SERUM SEPARATOR" },
        { key: "W0501010103", value: "BLOOD GAS SAMPLES COLLECTION, SYRINGES WITHOUT NEEDLE" },
        { key: "W0501010180", value: "VENOUS OR ARTERIOUS BLOOD COLLECTION DEVICES - ACCESSORIES" },
        { key: "W0501010199", value: "VENOUS OR ARTERIOUS BLOOD COLLECTION DEVICES - OTHER" },
        { key: "W05010102", value: "CAPILLARY BLOOD COLLECTION DEVICES" },
        { key: "W0501010201", value: "CAPILLARY BLOOD COLLECTION SYSTEMS" },
        { key: "W0501010202", value: "CAPILLARY AND VENOUS BLOOD COLLECTION, INTEGRATED SYSTEMS" },
        { key: "W0501010203", value: "BLOOD COLLECTION, CAPILLARY TUBES" },
        { key: "W0501010280", value: "CAPILLARY BLOOD COLLECTION DEVICES - ACCESSORIES" },
        { key: "W0501010299", value: "CAPILLARY BLOOD COLLECTION DEVICES - OTHER" },
        { key: "W050102", value: "URINE COLLECTION DEVICES" },
        { key: "W05010201", value: "URINE COLLECTION, SYRINGES" },
        { key: "W0501020101", value: "URINE COLLECTION, SYRINGES WITH STABILIZER" },
        { key: "W0501020102", value: "URINE COLLECTION, SYRINGES WITHOUT STABILIZER" },
        { key: "W05010202", value: "URINE COLLECTION, TUBES" },
        { key: "W05010203", value: "URINE COLLECTION, CONTAINERS" },
        { key: "W05010280", value: "URINE COLLECTION DEVICES - ACCESSORIES" },
        { key: "W05010299", value: "URINE COLLECTION DEVICES - OTHER" },
        { key: "W050180", value: "SAMPLES COLLECTION DEVICES - OTHER ACCESSORIES" },
        { key: "W050190", value: "SAMPLES COLLECTION DEVICES - VARIOUS" },
        { key: "W05019001", value: "FAECES COLLECTION DEVICES" },
        { key: "W05019002", value: "SALIVA COLLECTION DEVICES" },
        { key: "W05019003", value: "SPUTUM COLLECTION DEVICES" },
        { key: "W05019005", value: "BIOPTICAL COLLECTION, FILTERS" },
        { key: "W05019099", value: "SAMPLES COLLECTION DEVICES - OTHER" },
        { key: "W0502", value: "DEVICES FOR SAMPLES TRANSPORT (non-generic laboratory products)" },
        { key: "W050201", value: "SAMPLES TRANSPORT, CONTAINERS" },
        { key: "W05020101", value: "SAMPLES TRANSPORT, POUCHES" },
        { key: "W05020102", value: "SAMPLES TRANSPORT, BOXES" },
        { key: "W05020103", value: "SAMPLES TRANSPORT, BOTTLES" },
        { key: "W05020104", value: "SAMPLES TRANSPORT, VASES" },
        { key: "W05020105", value: "SAMPLES TRANSPORT, BAGS" },
        { key: "W05020106", value: "BIOPSY CARTRIDGES" },
        { key: "W05020180", value: "SAMPLES TRANSPORT, CONTAINERS - ACCESSORIES" },
        { key: "W05020199", value: "SAMPLES TRANSPORT, CONTAINERS - OTHER" },
        { key: "W050280", value: "DEVICES FOR SAMPLES TRANSPORT - OTHER ACCESSORIES" },
        { key: "W050299", value: "DEVICES FOR SAMPLES TRANSPORT - OTHER" },
        { key: "W0503", value: "DEVICES FOR SAMPLES ANALYSES (no laboratory generic products)" },
        { key: "W050301", value: "ANALYSIS CONTAINERS" },
        { key: "W05030101", value: "SAMPLES ANALYSES, GLASS CONTAINERS" },
        { key: "W0503010101", value: "SAMPLES ANALYSES, GLASS TUBES" },
        { key: "W0503010102", value: "SAMPLES ANALYSES, GLASS CUVETTES" },
        { key: "W0503010103", value: "SAMPLES ANALYSES, GLASSES" },
        { key: "W0503010104", value: "SAMPLES ANALYSES, GLASS BOTTLES" },
        { key: "W0503010105", value: "SAMPLES ANALYSES, GLASS TUBING" },
        { key: "W0503010106", value: "SAMPLES ANALYSES, GLASS TRAYS" },
        { key: "W0503010180", value: "SAMPLES ANALYSES, GLASS CONTAINERS - ACCESSORIES" },
        { key: "W0503010199", value: "SAMPLES ANALYSES, GLASS CONTAINERS - OTHER" },
        { key: "W05030102", value: "SAMPLES ANALYSES, PLASTIC CONTAINERS" },
        { key: "W0503010201", value: "SAMPLES ANALYSES, PLASTIC TUBES" },
        { key: "W050301020101", value: "SAMPLES ANALYSES, PLASTIC TUBES WITH ADDITIVES" },
        { key: "W050301020102", value: "SAMPLES ANALYSES, PLASTIC TUBES WITHOUT ADDITIVES" },
        { key: "W050301020180", value: "SAMPLES ANALYSES, PLASTIC TUBES - ACCESSORIES" },
        { key: "W0503010202", value: "SAMPLES ANALYSES, PLASTIC MICROTUBES" },
        { key: "W050301020201", value: "SAMPLES ANALYSES, PLASTIC MICROTUBES WITH ADDITIVES" },
        { key: "W050301020202", value: "SAMPLES ANALYSES, PLASTIC MICROTUBES WITHOUT ADDITIVES" },
        { key: "W050301020280", value: "SAMPLES ANALYSES, PLASTIC MICROTUBES - ACCESSORIES" },
        { key: "W0503010203", value: "SAMPLES ANALYSES, PLASTIC CUVETTES" },
        { key: "W0503010204", value: "SAMPLES ANALYSES, PLASTIC DISHES FOR MICROTECHNIQUES" },
        { key: "W0503010205", value: "SAMPLES ANALYSES, PLASTIC VASES" },
        { key: "W0503010206", value: "SAMPLES ANALYSES, PLASTIC GLASSES" },
        { key: "W0503010207", value: "SAMPLES ANALYSES, PLASTIC BOTTLES" },
        { key: "W0503010208", value: "SAMPLES ANALYSES, PLASTIC TUBING" },
        { key: "W0503010209", value: "SAMPLES ANALYSES, PLASTIC TRAYS" },
        { key: "W0503010280", value: "SAMPLES ANALYSES, PLASTIC CONTAINERS - OTHER ACCESSORIES" },
        { key: "W0503010290", value: "SAMPLES ANALYSES, PLASTIC CONTAINERS - VARIOUS" },
        { key: "W050301029001", value: "BLOOD COMPONENTS SEPARATORS, PLASTIC" },
        { key: "W050301029099", value: "SAMPLES ANALYSES, PLASTIC CONTAINERS - OTHER" },
        { key: "W05030199", value: "SAMPLES ANALYSES, CONTAINERS - OTHER" },
        { key: "W050302", value: "PIPETTES AND TIPS" },
        { key: "W05030201", value: "PIPETTES" },
        { key: "W0503020101", value: "SEROLOGICAL AND DILUTION PIPETTES" },
        { key: "W050302010101", value: "SEROLOGICAL AND DILUTION PIPETTES, GLASS" },
        { key: "W050302010102", value: "SEROLOGICAL AND DILUTION PIPETTES, PLASTIC" },
        { key: "W0503020180", value: "PIPETTES - ACCESSORIES" },
        { key: "W0503020199", value: "PIPETTES - OTHER" },
        { key: "W05030202", value: "PIPETTE TIPS" },
        { key: "W0503020201", value: "PIPETTE TIPS WITH FILTER" },
        { key: "W0503020202", value: "PIPETTES, TIPS WITHOUT FILTER" },
        { key: "W0503020280", value: "PIPETTES, TIPS - ACCESSORIES" },
        { key: "W050303", value: "MICROBIOLOGY DEVICES" },
        { key: "W05030301", value: "MICROBIOLOGICAL CULTURE DEVICES" },
        { key: "W0503030101", value: "PETRI DISHES" },
        { key: "W0503030199", value: "MICROBIOLOGICAL CULTURE DEVICES - OTHER" },
        { key: "W05030302", value: "MICROBIOLOGICAL CULTURE, LOOPS" },
        { key: "W05030380", value: "MICROBIOLOGY DEVICES - ACCESSORIES" },
        { key: "W05030399", value: "MICROBIOLOGY DEVICES - OTHER" },
        { key: "W050304", value: "CELL AND TISSUE CULTURES DEVICES" },
        { key: "W05030401", value: "CELL AND TISSUE CULTURES, CONTAINERS" },
        { key: "W0503040101", value: "CELL AND TISSUE CULTURES, FLASKS" },
        { key: "W0503040102", value: "CELL AND TISSUE CULTURES, DISHES" },
        { key: "W0503040103", value: "CELL AND TISSUE CULTURES, BOTTLES" },
        { key: "W0503040104", value: "CELL AND TISSUE CULTURES, TUBES" },
        { key: "W0503040105", value: "CELL AND TISSUE CULTURES, DISKS" },
        { key: "W0503040180", value: "CELL AND TISSUE CULTURES, CONTAINERS - ACCESSORIES" },
        { key: "W0503040199", value: "CELL AND TISSUE CULTURES, CONTAINERS - OTHER" },
        { key: "W05030402", value: "CELL AND TISSUE CULTURES, FILTERS" },
        { key: "W05030480", value: "CELL AND TISSUE CULTURES DEVICES - OTHER ACCESSORIES" },
        { key: "W05030499", value: "CELL AND TISSUE CULTURES DEVICES - OTHER" },
        { key: "W050305", value: "DEVICES FOR PATHOLOGY TESTS" },
        { key: "W05030501", value: "INCLUSION DEVICES, CASSETTES" },
        { key: "W05030502", value: "INCLUSION DEVICES, RINGS" },
        { key: "W05030580", value: "DEVICES FOR PATOLOGY TESTS - ACCESSORIES" },
        { key: "W05030599", value: "DEVICES FOR PATOLOGY TESTS - OTHER" },
        { key: "W050390", value: "DEVICES FOR SAMPLES ANALYSES - VARIOUS" },
        { key: "W05039001", value: "AGITATION DEVICES" },
        { key: "W0503900101", value: "AGITATION RODS" },
        { key: "W0503900102", value: "AGITATION ANCHORS" },
        { key: "W0503900199", value: "AGITATION DEVICES - OTHER" },
        { key: "W05039002", value: "SLIDES FOR SAMPLES ANALYSIS" },
        { key: "W0503900201", value: "MICROSCOPE SLIDES" },
        { key: "W0503900202", value: "MICROSCOPE SLIDES COVERSLIP" },
        { key: "W05039080", value: "DEVICES FOR SAMPLES ANALYSES - OTHER ACCESSORIES" },
        { key: "W05039099", value: "DEVICES FOR SAMPLES ANALYSES - OTHER" },
        { key: "W0580", value: "IVD GENERAL USE CONSUMABLES DEVICES - OTHER ACCESSORIES" },
        { key: "W0599", value: "IVD GENERAL USE CONSUMABLE DEVICES - OTHER" },
        { key: "X", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE (Annex XVI)" },
        { key: "X01", value: "CONTACT LENSES OR OTHER ITEMS INTENDED TO BE INTRODUCED INTO OR ONTO THE EYE WITHOUT AN INTENDED MEDICAL PURPOSE" },
        { key: "X0101", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – HYDROGEL" },
        { key: "X010101", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – HYDROGEL, SINGLE-USE" },
        { key: "X01010101", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – HYDROGEL, DAILY SINGLE-USE" },
        { key: "X01010102", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – HYDROGEL, EXTENDED WEAR SINGLE-USE" },
        { key: "X010102", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – HYDROGEL, REUSABLE" },
        { key: "X0102", value: "CONTACT LENSES WITHOUT AN INTENDED MEDICAL PURPOSE – NON HYDROGEL" },
        { key: "X02", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE TOTALLY OR PARTIALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OR FIXATION OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS" },
        { key: "X0201", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE TOTALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS" },
        { key: "X020101", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE TOTALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS – RESORBABLE" },
        { key: "X020102", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE TOTALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS – NON RESORBABLE" },
        { key: "X0202", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE PARTIALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS" },
        { key: "X020201", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE PARTIALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS – RESORBABLE" },
        { key: "X020202", value: "PRODUCTS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE PARTIALLY INTRODUCED INTO THE HUMAN BODY THROUGH SURGICALLY INVASIVE MEANS FOR THE PURPOSE OF MODIFYING THE ANATOMY OF BODY PARTS WITH THE EXCEPTION OF TATTOOING PRODUCTS AND PIERCINGS – NON RESORBABLE" },
        { key: "X03", value: "SUBSTANCES, COMBINATIONS OF SUBSTANCES, OR ITEMS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED FOR FACIAL OR OTHER DERMAL OR MUCOUS MEMBRANE FILLING BY SUBCUTANEOUS, SUBMUCOUS OR INTRADERMAL INJECTION OR OTHER INTRODUCTION, EXCLUDING THOSE FOR TATTOOING" },
        { key: "X0301", value: "SUBSTANCES, COMBINATIONS OF SUBSTANCES, OR ITEMS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED FOR FACIAL OR OTHER DERMAL OR MUCOUS MEMBRANE FILLING BY SUBCUTANEOUS, SUBMUCOUS OR INTRADERMAL INJECTION OR OTHER INTRODUCTION, EXCLUDING THOSE FOR TATTOOING – RESORBABLE" },
        { key: "X0302", value: "SUBSTANCES, COMBINATIONS OF SUBSTANCES, OR ITEMS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED FOR FACIAL OR OTHER DERMAL OR MUCOUS MEMBRANE FILLING BY SUBCUTANEOUS, SUBMUCOUS OR INTRADERMAL INJECTION OR OTHER INTRODUCTION, EXCLUDING THOSE FOR TATTOOING – NON RESORBABLE" },
        { key: "X0303", value: "SUBSTANCES, COMBINATIONS OF SUBSTANCES, OR ITEMS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED FOR FACIAL OR OTHER DERMAL OR MUCOUS MEMBRANE FILLING BY SUBCUTANEOUS, SUBMUCOUS OR INTRADERMAL INJECTION OR OTHER INTRODUCTION, BY A PREFILLED MEANS FOR INTRODUCTION, EXCLUDING THOSE FOR TATTOOING – RESORBABLE" },
        { key: "X0304", value: "SUBSTANCES, COMBINATIONS OF SUBSTANCES, OR ITEMS WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED FOR FACIAL OR OTHER DERMAL OR MUCOUS MEMBRANE FILLING BY SUBCUTANEOUS, SUBMUCOUS OR INTRADERMAL INJECTION OR OTHER INTRODUCTION, BY A PREFILLED MEANS FOR INTRODUCTION, EXCLUDING THOSE FOR TATTOOING – NON RESORBABLE" },
        { key: "X04", value: "EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED TO BE USED TO REDUCE, REMOVE OR DESTROY ADIPOSE TISSUE" },
        { key: "X0401", value: "EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE FOR LIPOSUCTION" },
        { key: "X0402", value: "EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE FOR LIPOLYSIS" },
        { key: "X0403", value: "EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE FOR LIPOPLASTY, OTHER THAN LIPOSUCTION OR LIPOLYSIS" },
        { key: "X05", value: "HIGH INTENSITY ELECTROMAGNETIC RADIATION EMITTING EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED FOR USE ON THE HUMAN BODY FOR SKIN RESURFACING, TATTOO OR HAIR REMOVAL OR OTHER SKIN TREATMENT" },
        { key: "X0501", value: "HIGH INTENSITY ELECTROMAGNETIC RADIATION EMITTING EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED FOR USE ON THE HUMAN BODY, FOR SKIN RESURFACING, TATTOO OR HAIR REMOVAL OR OTHER SKIN TREATMENT – LASER" },
        { key: "X0502", value: "HIGH INTENSITY ELECTROMAGNETIC RADIATION EMITTING EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED FOR USE ON THE HUMAN BODY, FOR SKIN RESURFACING, TATTOO OR HAIR REMOVAL OR OTHER SKIN TREATMENT – INTENSE PULSED LIGHT" },
        { key: "X0599", value: "HIGH INTENSITY ELECTROMAGNETIC RADIATION EMITTING EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED FOR USE ON THE HUMAN BODY, FOR SKIN RESURFACING, TATTOO OR HAIR REMOVAL OR OTHER SKIN TREATMENT – OTHER" },
        { key: "X06", value: "EQUIPMENT WITHOUT AN INTENDED MEDICAL PURPOSE INTENDED FOR BRAIN STIMULATION THAT APPLY ELECTRICAL CURRENTS OR MAGNETIC OR ELECTROMAGNETIC FIELDS THAT PENETRATE THE CRANIUM TO MODIFY NEURONAL ACTIVITY IN THE BRAIN" },
        { key: "Y", value: "DEVICES FOR PERSONS WITH DISABILITIES NOT INCLUDED IN OTHER CATEGORIES" },
        { key: "Y05", value: "ABILITIES LEARNING AND TRAINING DEVICES" },
        { key: "Y0501", value: "CONTINENCE TRAINING DEVICES (INCLUDING INCONTINENCE ALARM SYSTEMS)" },
        { key: "Y0502", value: "GAIT TRAINERS" },
        { key: "Y050201", value: "STANDING SUPPORT GAIT TRAINERS" },
        { key: "Y050202", value: "STANDING FRAMES" },
        { key: "Y0503", value: "HANDS AND FINGERS RE-EDUCATION DEVICES" },
        { key: "Y0504", value: "ARMS, TORSO AND LEGS RE-EDUCATION DEVICES" },
        { key: "Y0580", value: "LEARNING AND TRAINING DEVICES - ACCESSORIES" },
        { key: "Y0599", value: "LEARNING AND TRAINING DEVICES - OTHER" },
        { key: "Y06", value: "EXTERNAL PROSTHESES AND ORTHOSES" },
        { key: "Y0603", value: "SPINE ORTHOSES" },
        { key: "Y060303", value: "SACROILIAC SPINE ORTHOSES" },
        { key: "Y060306", value: "THORACOLUMBAR ORTHOSES" },
        { key: "Y060307", value: "THORACIC ORTHOSES" },
        { key: "Y060308", value: "LUMBOSACRAL SPINE ORTHOSES" },
        { key: "Y060309", value: "THORACOLUMBOSACRAL SPINE ORTHOSES" },
        { key: "Y060312", value: "CERVICAL SPINE ORTHOSES" },
        { key: "Y060315", value: "CERVICOTHORACIC SPINE ORTHOSES" },
        { key: "Y060318", value: "CERVICOTHORACOLUMBOSACRAL SPINE ORTHOSES" },
        { key: "Y060380", value: "SPINAL ORTHOSES - ACCESSORIES" },
        { key: "Y060399", value: "SPINE ORTHOSES - OTHER" },
        { key: "Y0604", value: "ABDOMINAL ORTHOSES" },
        { key: "Y060403", value: "ABDOMINAL MUSCLES SUPPORTS" },
        { key: "Y060406", value: "ABDOMINAL HERNIA SUPPORTS" },
        { key: "Y060499", value: "ABDOMINAL ORTHOSES - OTHER" },
        { key: "Y0606", value: "UPPER EXTREMITY ORTHOSES (SPLINTS AND BRACES)" },
        { key: "Y060603", value: "FINGERS ORTHOSES" },
        { key: "Y060606", value: "HAND ORTHOSES" },
        { key: "Y060609", value: "WRIST (FOREARM) ORTHOSES" },
        { key: "Y060612", value: "WRIST-HAND ORTHOSES" },
        { key: "Y060613", value: "WRIST-HAND-FINGERS ORTHOSES" },
        { key: "Y060615", value: "ELBOW ORTHOSES" },
        { key: "Y060618", value: "ELBOW-WRIST ORTHOSES" },
        { key: "Y060619", value: "ELBOW-WRIST-HAND ORTHOSES" },
        { key: "Y060621", value: "SHOULDER ORTHOSES" },
        { key: "Y060624", value: "SHOULDER-ELBOW ORTHOSES" },
        { key: "Y060627", value: "SHOULDER-ELBOW - WRIST ORTHOSES" },
        { key: "Y060630", value: "SHOULDER-ELBOW-WRIST- HAND ORTHOSES" },
        { key: "Y060680", value: "UPPER LIMB ORTHOSES - ACCESSORIES" },
        { key: "Y060699", value: "ORTHOSES, UPPER EXTREMITY - OTHER" },
        { key: "Y0612", value: "ORTHOSIS, LOWER EXTREMITY (INSOLES, LIFTS, SPLINTS, BRACES, CLAMPS)" },
        { key: "Y061203", value: "ORTHOSES, FOOT (INCLUDING INSOLES AND INSERTS)" },
        { key: "Y061206", value: "ANKLE-FOOT ORTHOSES" },
        { key: "Y06120601", value: "PASSIVE ANKLE-FOOT ORTHOSES" },
        { key: "Y06120602", value: "ENERGY RETURN ANKLE-FOOT ORTHOSES" },
        { key: "Y061209", value: "KNEE ORTHOSES" },
        { key: "Y061212", value: "KNEE-ANKLE-FOOT ORTHOSES" },
        { key: "Y06121201", value: "PASSIVE KNEE-ANKLE-FOOT ORTHOSES" },
        { key: "Y06121202", value: "ENERGY RETURN ORTHOSES FOR KNEE-ANKLE-FOOT" },
        { key: "Y06121203", value: "ACTIVE KNEE-ANKLE-FOOT ORTHOSES" },
        { key: "Y061215", value: "HIP ORTHOSES (INCLUDING ABDUCTION ORTHOSES)" },
        { key: "Y061216", value: "HIP-KNEE ORTHOSES" },
        { key: "Y061217", value: "THIGH ORTHOSES" },
        { key: "Y061218", value: "HIP-KNEE-ANKLE-FOOT ORTHOSES" },
        { key: "Y061219", value: "CHEST-LUMB-SACRAL-HIP-KNEE-ANKLE-FOOT ORTHOSES" },
        { key: "Y061280", value: "LOWER LIMB ORTHOSES - ACCESSORIES" },
        { key: "Y061299", value: "LOWER EXTREMITY ORTHOSES - OTHER" },
        { key: "Y0618", value: "UPPER EXTREMITY PROSTHESES" },
        { key: "Y061803", value: "PARTIAL HAND PROSTHESES (INCLUDING FINGERS PROSTHESES)" },
        { key: "Y061806", value: "WRIST DISARTICULATION PROSTHESES" },
        { key: "Y061809", value: "TRANSRADIAL PROSTHESES (FOR AMPUTATION UNDER ELBOW)" },
        { key: "Y061812", value: "ELBOW DISARTICULATION PROSTHESES" },
        { key: "Y061815", value: "TRANSHUMERAL PROSTHESES (FOR AMPUTATION ABOVE ELBOW)" },
        { key: "Y061818", value: "SHOULDER DISARTICULATION PROSTHESES" },
        { key: "Y061899", value: "UPPER EXTREMITY PROSTHESES - OTHER" },
        { key: "Y0624", value: "LOWER EXTREMITY PROSTHESES" },
        { key: "Y062403", value: "FOOT PARTIAL PROSTHESES (INCLUDING TOE PROSTHESES)" },
        { key: "Y062409", value: "TRANSTIBIAL PROSTHESES (FOR AMPUTATION UNDER KNEE)" },
        { key: "Y062412", value: "KNEE DISARTICULATION PROSTHESES" },
        { key: "Y062415", value: "TRANSFEMORAL PROSTHESES (FOR AMPUTATION ABOVE KNEE)" },
        { key: "Y062418", value: "HIP DISARTICULATION PROSTHESES" },
        { key: "Y062499", value: "LOWER EXTREMITY PROSTHESES - OTHER" },
        { key: "Y0627", value: "COSMETIC AND NON-FUNCTIONAL LOWER LIMB PROSTHESES" },
        { key: "Y062703", value: "AESTHETIC FILLERS, CALF AND THIGH" },
        { key: "Y0630", value: "NON-EXTREMITY PROSTHESES" },
        { key: "Y063018", value: "EXTERNAL BREAST PROSTHESES" },
        { key: "Y063021", value: "OCULAR PROSTHESES" },
        { key: "Y063099", value: "NON-EXTREMITY PROSTHESES - OTHER" },
        { key: "Y0633", value: "ORTHOTIC SHOES" },
        { key: "Y063303", value: "READY-MADE ORTHOTIC SHOES" },
        { key: "Y0699", value: "EXTERNAL PROSTHESES AND ORTHOSES - OTHER" },
        { key: "Y09", value: "PERSONAL CARE AIDS" },
        { key: "Y0903", value: "CLOTHES, FOOTWEAR AND COVERS FOR PROSTHESES" },
        { key: "Y090312", value: "GLOVES AND HANDLES FOR PROSTHESES" },
        { key: "Y090327", value: "SOCKS FOR PROSTHESES" },
        { key: "Y090342", value: "SHOES AND BOOTS FOR PROSTHESES" },
        { key: "Y090399", value: "CLOTHES, FOOTWEAR AND COVERS FOR PROSTHESES - OTHER" },
        { key: "Y0906", value: "BODY PROTECTION DEVICES" },
        { key: "Y090612", value: "ARM AND ELBOW PROTECTIONS" },
        { key: "Y090618", value: "LEG AND KNEE PROTECTIONS (INCLUDING SOCKS FOR AMPUTATED LEGS)" },
        { key: "Y090699", value: "DEVICES FOR BODY PROTECTION - OTHER" },
        { key: "Y0912", value: "DEJECTION DEVICES" },
        { key: "Y091203", value: "CHAIRS, TOILET AND SHOWER" },
        { key: "Y091209", value: "TOILET SEATS" },
        { key: "Y091212", value: "TOILET STOOLS" },
        { key: "Y091215", value: "TOILET SEATS, RAISED" },
        { key: "Y091299", value: "DEJECTION DEVICES - OTHER" },
        { key: "Y0933", value: "WASHING, BATHING AND SHOWERING DEVICES" },
        { key: "Y093303", value: "FIXED AND ROTARY CHAIRS FOR BATH AND SHOWER" },
        { key: "Y093312", value: "SHOWER STRETCHERS" },
        { key: "Y093399", value: "WASHING, BATHING AND SHOWERING DEVICES - OTHER" },
        { key: "Y0999", value: "PERSONAL CARE AIDS - OTHER" },
        { key: "Y12", value: "PERSONAL MOBILITY DEVICES" },
        { key: "Y1203", value: "WALKING DEVICES, ONE-HANDED OPERATION" },
        { key: "Y120303", value: "WHITE STICKS FOR BLIND PERSONS" },
        { key: "Y120306", value: "WALKING CRUTCHES" },
        { key: "Y12030601", value: "ELBOW CRUTCHES" },
        { key: "Y12030602", value: "CRUTCHES WITH ANTIBRACHIAL SUPPORT" },
        { key: "Y12030603", value: "CRUTCHES WITH UNDER-AXLE SUPPORT" },
        { key: "Y120315", value: "TRIPODS" },
        { key: "Y120318", value: "QUADRIPODS" },
        { key: "Y120380", value: "ONE ARM MANIPULATED WALKING AIDS - ACCESSORIES" },
        { key: "Y120399", value: "WALKING DEVICES, ONE-HANDED OPERATION - OTHER" },
        { key: "Y1206", value: "WALKING DEVICES, TWO-HANDED OPERATION" },
        { key: "Y120603", value: "WALKING FRAMES, 4 TIPS" },
        { key: "Y120606", value: "WHEELED WALKER" },
        { key: "Y120609", value: "WALKING FRAMES WITH CHAIR, 4 WHEELS" },
        { key: "Y120612", value: "WALKING TROLLEYS" },
        { key: "Y120615", value: "POWER ASSISTED MOBILITY ROLLATORS" },
        { key: "Y120680", value: "TWO ARMS MANIPULATED WALKING AIDS - ACCESSORIES" },
        { key: "Y120699", value: "WALKING DEVICES, TWO-HANDED OPERATION - OTHER" },
        { key: "Y1218", value: "CYCLES" },
        { key: "Y121801", value: "BICYCLES" },
        { key: "Y121806", value: "PEDAL TRICYCLES" },
        { key: "Y121809", value: "MANUALLY PROPELLED TRICYCLES" },
        { key: "Y121821", value: "RETRACTORS, BACKRESTS, BRACKETS AND SUPPORTS" },
        { key: "Y121899", value: "CYCLES - OTHER" },
        { key: "Y1221", value: "WHEELCHAIRS" },
        { key: "Y122103", value: "PUSH WHEELCHAIRS" },
        { key: "Y122106", value: "REAR SELF-PROPELLED WHEELCHAIRS" },
        { key: "Y122109", value: "FRONT SELF-PROPELLED WHEELCHAIRS" },
        { key: "Y122124", value: "ELECTRIC SCOOTERS" },
        { key: "Y122127", value: "ELECTRIC WHEELCHAIRS" },
        { key: "Y122130", value: "DISABILITY MOPEDS, 3-WHEELED" },
        { key: "Y122199", value: "WHEELCHAIRS - OTHER" },
        { key: "Y1224", value: "WHEELCHAIR ACCESSORIES" },
        { key: "Y122403", value: "WHEELCHAIR FOOTRESTS, SUPPORTS AND CONTROLS" },
        { key: "Y122406", value: "BELTS, SEATS AND ARMRESTS FOR WHEELCHAIRS" },
        { key: "Y122409", value: "HANDRIMS AND ONE-ARM-DRIVE SYSTEMS" },
        { key: "Y122410", value: "ELECTRIC PROPULSION UNIT" },
        { key: "Y122411", value: "WHEELCHAIR UNICYCLE" },
        { key: "Y122412", value: "WHEELCHAIR LIGHTS" },
        { key: "Y122499", value: "WHEELCHAIRS ACCESSORIES - OTHER" },
        { key: "Y1227", value: "NON-MOTORIZED VEHICLES AND MEANS OF TRANSPORT" },
        { key: "Y122703", value: "PUSHCHAIRS" },
        { key: "Y122799", value: "NON-MOTORIZED VEHICLES AND MEANS OF TRANSPORT - OTHER" },
        { key: "Y1299", value: "PERSONAL MOBILITY DEVICES - OTHER" },
        { key: "Y15", value: "DOMESTIC ACTIVITIES AIDS" },
        { key: "Y1509", value: "ASSISTIVE EATING AND DRINKING DEVICES" },
        { key: "Y150912", value: "CUTLERY" },
        { key: "Y150915", value: "GLASSES AND CUPS" },
        { key: "Y150918", value: "ADAPTABLE DISHES" },
        { key: "Y150921", value: "ADAPTABLE CUTTERS AND EDGES FOR DISHES" },
        { key: "Y150999", value: "ASSISTIVE EATING AND DRINKING DEVICES - OTHER" },
        { key: "Y1599", value: "HOUSEHOLD ACTIVITIES AIDS - OTHER" },
        { key: "Y18", value: "AIDS, FURNITURE AND HOME AIDS FOR PERSONS WITH DISABILITIES" },
        { key: "Y1803", value: "ASSISTIVE TABLES" },
        { key: "Y1809", value: "CHAIRS / POSTURE SYSTEMS / SEAT POSITIONING AIDS" },
        { key: "Y180918", value: "MULTIFUNCTIONAL CHAIRS" },
        { key: "Y180939", value: "MODULAR POSTURE SYSTEMS" },
        { key: "Y180980", value: "SEATING SYSTEMS / POSTURE SYSTEMS / SEATING AIDS - ACCESSORIES" },
        { key: "Y180999", value: "CHAIRS / POSTURE SYSTEMS / SEAT POSITIONING AIDS - OTHER" },
        { key: "Y1818", value: "SUPPORT SYSTEMS" },
        { key: "Y181803", value: "HANDRAILS" },
        { key: "Y181806", value: "HANDLES" },
        { key: "Y181809", value: "ARMRESTS" },
        { key: "Y181899", value: "SUPPORT SYSTEMS - OTHER" },
        { key: "Y1830", value: "LIFTING DEVICES (STAIRLIFTS)" },
        { key: "Y183012", value: "MOBILE STAIRLIFTS" },
        { key: "Y183015", value: "PORTABLE RAMPS" },
        { key: "Y183099", value: "LIFTING DEVICES (STAIRLIFTS) - OTHER" },
        { key: "Y1899", value: "AIDS, FURNITURE AND HOME AIDS FOR PERSONS WITH DISABILITIES - OTHER" },
        { key: "Y21", value: "COMMUNICATION AND INFORMATION MANAGEMENT AIDS" },
        { key: "Y2103", value: "OPTICAL AIDS " },
        { key: "Y210306", value: "PRISMATIC OPHTHALMIC LENSES FOR RAISING AND LOWERING THE EYE WITH PROSTHESES" },
        { key: "Y210321", value: "FAR SIGHTEDNESS TELESCOPIC SYSTEMS/SPECTACLES" },
        { key: "Y210324", value: "NEAR SIGHTEDNESS TELESCOPIC SYSTEMS/SPECTACLES" },
        { key: "Y210330", value: "MAGNIFYING ACHROMATIC DOUBLET LENSES" },
        { key: "Y210333", value: "PRISMATIC SPECTACLES" },
        { key: "Y210336", value: "OCCLUSION AND ANTI-RADIATION FILTERS" },
        { key: "Y210399", value: "OPTICAL AIDS - OTHER" },
        { key: "Y2106", value: "OPTICAL ELECTRONIC AIDS" },
        { key: "Y210603", value: "VIDEO MAGNIFIERS" },
        { key: "Y210606", value: "OCR SYSTEMS" },
        { key: "Y210609", value: "MAGNIFIERS FOR PERSONAL COMPUTERS" },
        { key: "Y210699", value: "ELECTRONIC OPTICAL AIDS - OTHER" },
        { key: "Y2109", value: "PERSONAL COMPUTER INPUT AND OUTPUT PERIPHERAL EQUIPMENT" },
        { key: "Y210905", value: "EXTERNAL SENSOR INTERFACES" },
        { key: "Y210906", value: "MOUSE AND KEYBOARD EMULATORS" },
        { key: "Y210915", value: "VOCAL SYNTHESIS DEVICES" },
        { key: "Y210924", value: "ARM SUPPORTS" },
        { key: "Y210999", value: "PERSONAL COMPUTER INPUT AND OUTPUT PERIPHERAL EQUIPMENT - OTHER" },
        { key: "Y2115", value: "WRITING MACHINES AND TEXT PROCESSING SYSTEMS" },
        { key: "Y211518", value: "WRITING SOFTWARE" },
        { key: "Y211599", value: "WRITING MACHINES AND TEXT PROCESSING SYSTEMS - OTHER" },
        { key: "Y2127", value: "NON-OPTICAL READING AIDS" },
        { key: "Y212703", value: "PAGE-TURNERS" },
        { key: "Y212706", value: "BOOKRESTS" },
        { key: "Y2136", value: "TELEPHONES AND TELEPHONING AIDS" },
        { key: "Y213603", value: "EASY ACCESS TELEPHONES" },
        { key: "Y213609", value: "TELEPHONE COMMUNICATORS" },
        { key: "Y213624", value: "TELEPHONE HANDSET REPLACEMENT DEVICES AND CALL SIGNALERS" },
        { key: "Y213699", value: "TELEPHONES AND TELEPHONING AIDS - OTHER" },
        { key: "Y2139", value: "SOUND TRANSMISSION SYSTEMS" },
        { key: "Y213924", value: "MF RECEIVER-TRANSMITTERS" },
        { key: "Y213999", value: "SOUND TRANSMISSION SYSTEMS - OTHER" },
        { key: "Y2142", value: "INTERPERSONAL COMUNICATION DEVICES" },
        { key: "Y214209", value: "ALPHABETIC AND SYMBOLIC COMMUNICATORS" },
        { key: "Y214212", value: "VOICE GENERATORS" },
        { key: "Y214224", value: "AUGMENTATIVE SOFTWARE" },
        { key: "Y214299", value: "DEVICES FOR INTERPERSONAL COMUNICATION - OTHER" },
        { key: "Y2145", value: "HEARING AIDS" },
        { key: "Y214506", value: "AIR CONDUCTION HEARING AIDS" },
        { key: "Y21450601", value: "BEHIND-THE-EAR HEARING AIDS (BTEs)" },
        { key: "Y2145060101", value: "BEHIND-THE-EAR HEARING AIDS WITH RECEIVER IN THE DEVICE (BTE)" },
        { key: "Y2145060102", value: "BEHIND-THE-EAR HEARING AIDS WITH RECEIVER IN THE CANAL (RIC, RITE)" },
        { key: "Y21450602", value: "IN-THE-EAR HEARING AIDS (ITEs)" },
        { key: "Y2145060201", value: "HEARING AID IN THE-EAR (ITE)" },
        { key: "Y2145060202", value: "HEARING AIDS IN-THE-CANAL (ITC)" },
        { key: "Y2145060203", value: "HEARING AIDS COMPLETELY-IN-THE-CANAL (CIC)" },
        { key: "Y2145060204", value: "HEARING AIDS INVISIBLE-IN-THE-CANAL (IIC)" },
        { key: "Y21450603", value: "BOX HEARING AIDS" },
        { key: "Y214509", value: "BONE CONDUCTION HEARING AIDS" },
        { key: "Y21450901", value: "SPECTACLE HEARING AIDS" },
        { key: "Y21450902", value: "HEADBAND HEARING AIDS" },
        { key: "Y21450903", value: "HEARING AIDS WITH ELASTIC BAND" },
        { key: "Y21450904", value: "HEARING AIDS USING ADHESIVE PATCH" },
        { key: "Y214580", value: "HEARING AIDS OR HEARING DEVICES - ACCESSORIES" },
        { key: "Y214599", value: "HEARING AIDS - OTHER" },
        { key: "Y2151", value: "ALARM SYSTEMS + SIGNALLING, INDICATION AND REMINDER AIDS" },
        { key: "Y215112", value: "CLOCKS FOR PERSONS WITH DISABILITIES" },
        { key: "Y215199", value: "ALARM SYSTEMS + SIGNALING, INDICATION AND REMINDER AIDS - OTHER" },
        { key: "Y2199", value: "COMMUNICATION AND INFORMATION MANAGEMENT AIDS - OTHER" },
        { key: "Y24", value: "OBJECT MANIPULATION DEVICES" },
        { key: "Y2409", value: "CONTROL DEVICES AND SYSTEMS" },
        { key: "Y240918", value: "CONTROL SENSORS" },
        { key: "Y240999", value: "CONTROL DEVICES AND SYSTEMS - OTHER" },
        { key: "Y2412", value: "AMBIENT CONTROL SYSTEMS" },
        { key: "Y241203", value: "PROGRAMMABLE REMOTE CONTROLS, HOME AUTOMATION SYSTEMS, CONTROL SATELLITES" },
        { key: "Y241299", value: "AMBIENT CONTROL SYSTEMS - OTHER" },
        { key: "Y2418", value: "ARM, HAND, FINGER FUNCTION AID AND/OR SUBSTITUTION DEVICES" },
        { key: "Y241815", value: "FUNCTIONAL HELMETS" },
        { key: "Y241899", value: "ARM, HAND, FINGER FUNCTION AID AND/OR SUBSTITUTION DEVICES - OTHER" },
        { key: "Y2421", value: "DEVICES FOR REACHING AND GRASPING OBJECTS" },
        { key: "Y242103", value: "MANUAL PREHENSILE GRIPPERS" },
        { key: "Y242199", value: "DEVICES FOR REACHING AND GRASPING OBJECTS - OTHER" },
        { key: "Y2499", value: "DEVICES FOR OBJECT MANIPULATION - OTHER" },
        { key: "Y99", value: "DEVICES FOR PERSONS WITH DISABILITIES NOT INCLUDED IN OTHER CATEGORIES - OTHER" },
        { key: "Z", value: "MEDICAL EQUIPMENT AND RELATED ACCESSORIES, SOFTWARE AND CONSUMABLES" },
        { key: "Z11", value: "BIOIMAGING AND RADIOTHERAPY INSTRUMENTS" },
        { key: "Z1101", value: "RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS" },
        { key: "Z110101", value: "LINEAR ACCELERATORS" },
        { key: "Z11010101", value: "SINGLE ENERGY LINEAR ACCELERATORS" },
        { key: "Z11010102", value: "MEDIUM AND MULTI ENERGY LINEAR ACCELERATORS" },
        { key: "Z11010103", value: "MULTI AND HIGH ENERGY LINEAR ACCELERATORS" },
        { key: "Z11010104", value: "INTRA-OPERATIVE LINEAR ACCELERATORS" },
        { key: "Z11010180", value: "LINEAR ACCELERATORS - HARDWARE ACCESSORIES" },
        { key: "Z11010182", value: "LINEAR ACCELERATORS - SOFTWARE ACCESSORIES" },
        { key: "Z11010185", value: "LINEAR ACCELERATORS - CONSUMABLES" },
        { key: "Z11010192", value: "LINEAR ACCELERATORS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11010199", value: "LINEAR ACCELERATORS – OTHER" },
        { key: "Z110102", value: "RADIOTHERAPY SIMULATION INSTRUMENTS" },
        { key: "Z11010201", value: "RADIOTHERAPY SIMULATORS" },
        { key: "Z11010202", value: "COMPUTED TOMOGRAPHY (CT) FOR RADIOTHERAPY SIMULATION" },
        { key: "Z11010280", value: "INSTRUMENTS FOR RADIOTHERAPY SIMULATION - HARDWARE ACCESSORIES" },
        { key: "Z11010282", value: "INSTRUMENTS FOR RADIOTHERAPY SIMULATION - SOFTWARE ACCESSORIES" },
        { key: "Z11010285", value: "INSTRUMENTS FOR RADIOTHERAPY SIMULATION - CONSUMABLES" },
        { key: "Z11010292", value: "INSTRUMENTS FOR RADIOTHERAPY SIMULATION - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110103", value: "BRACHYTHERAPY RADIATION INSTRUMENTS" },
        { key: "Z11010301", value: "BRACHYTHERAPY RADIATION SYSTEMS" },
        { key: "Z11010380", value: "BRACHYTHERAPY RADIATION SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11010382", value: "BRACHYTHERAPY RADIATION SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11010385", value: "BRACHYTHERAPY RADIATION SYSTEMS - CONSUMABLES" },
        { key: "Z11010392", value: "BRACHYTHERAPY RADIATION SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110104", value: "RADIOTHERAPY TREATMENT PLANNING INSTRUMENTS" },
        { key: "Z11010401", value: "RADIOTHERAPY TREATMENT PLANNING SYSTEMS" },
        { key: "Z11010480", value: "RADIOTHERAPY TREATMENT PLANNING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11010482", value: "RADIOTHERAPY TREATMENT PLANNING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11010485", value: "RADIOTHERAPY TREATMENT PLANNING INSTRUMENTS - CONSUMABLES" },
        { key: "Z11010492", value: "RADIOTHERAPY TREATMENT PLANNING INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110105", value: "INTRAVASCULAR RADIOTHERAPY INSTRUMENTS" },
        { key: "Z11010501", value: "INTRAVASCULAR RADIOTHERAPY SYSTEMS" },
        { key: "Z11010580", value: "INTRAVASCULAR RADIOTHERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11010582", value: "INTRAVASCULAR RADIOTHERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11010585", value: "INTRAVASCULAR RADIOTHERAPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11010592", value: "INTRAVASCULAR RADIOTHERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110107", value: "RADIOSURGERY INSTRUMENTS" },
        { key: "Z11010701", value: "RADIOSURGERY SYSTEMS" },
        { key: "Z11010780", value: "RADIOSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11010782", value: "RADIOSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11010785", value: "RADIOSURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11010792", value: "RADIOSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110108", value: "TOMOTHERAPY INSTRUMENTS" },
        { key: "Z11010801", value: "TOMOTHERAPY SYSTEMS" },
        { key: "Z11010880", value: "TOMOTHERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11010882", value: "TOMOTHERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11010885", value: "TOMOTHERAPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11010892", value: "TOMOTHERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110109", value: "MAGNETIC RESONANCE RADIOTHERAPY INSTRUMENTS" },
        { key: "Z11010901", value: "INTEGRATED SYSTEMS FOR MAGNETIC RESONANCE RADIOTHERAPY" },
        { key: "Z11010980", value: "MAGNETIC RESONANCE RADIOTHERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11010982", value: "MAGNETIC RESONANCE RADIOTHERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11010985", value: "MAGNETIC RESONANCE RADIOTHERAPY INSTRUMENTS - SPECIFIC MATERIALS" },
        { key: "Z11010992", value: "MAGNETIC RESONANCE RADIOTHERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110110", value: "INSTRUMENTS FOR PROTON THERAPY" },
        { key: "Z11011001", value: "PROTON THERAPY SYSTEMS" },
        { key: "Z11011080", value: "PROTON THERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11011082", value: "PROTON THERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11011085", value: "PROTON THERAPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11011092", value: "PROTON THERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110190", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS" },
        { key: "Z11019001", value: "CAESIUM THERAPY EQUIPMENT" },
        { key: "Z11019002", value: "COBALT THERAPY EQUIPMENT" },
        { key: "Z11019004", value: "AUTOMATIC CURVE TRACERS" },
        { key: "Z11019005", value: "SHIELDING BLOCK CUTTERS" },
        { key: "Z11019080", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11019082", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11019085", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11019092", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11019099", value: "VARIOUS RADIOTHERAPY AND RADIOSURGERY INSTRUMENTS - OTHER" },
        { key: "Z1102", value: "NUCLEAR MEDICINE INSTRUMENTS" },
        { key: "Z110201", value: "COMPUTERISED GAMMA CAMERAS" },
        { key: "Z11020101", value: "MOBILE GAMMA CAMERAS" },
        { key: "Z11020102", value: "FIXED STATION GAMMA CAMERAS WITH SINGLE HEAD - WITHOUT ‘TOTAL BODY' ACQUISITION" },
        { key: "Z11020103", value: "FIXED STATION GAMMA CAMERAS WITH SINGLE HEAD - WITH ‘TOTAL BODY’ ACQUISITION" },
        { key: "Z11020104", value: "FIXED STATION GAMMA CAMERAS WITH MULTIPLE HEADS - WITHOUT ‘TOTAL BODY’ ACQUISITION" },
        { key: "Z11020105", value: "FIXED STATION GAMMA CAMERAS WITH MULTIPLE HEADS - WITH ‘TOTAL BODY’ ACQUISITION" },
        { key: "Z11020180", value: "COMPUTERIZED GAMMA CAMERAS -HARDWARE ACCESSORIES" },
        { key: "Z11020182", value: "COMPUTERIZED GAMMA CAMERAS - SOFTWARE ACCESSORIES" },
        { key: "Z11020185", value: "COMPUTERISED GAMMA CAMERAS -CONSUMABLES" },
        { key: "Z11020192", value: "COMPUTERISED GAMMA CAMERAS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110202", value: "INTEGRATED CT/GAMMA CAMERA SYSTEMS" },
        { key: "Z11020201", value: "CT/GAMMA CAMERA SYSTEMS" },
        { key: "Z11020280", value: "INTEGRATED CT/GAMMA CAMERA SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11020282", value: "INTEGRATED CT/GAMMA CAMERA SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11020285", value: "IINTEGRATED CT/GAMMA CAMERA SYSTEMS - CONSUMABLES" },
        { key: "Z11020292", value: "IINTEGRATED CT/GAMMA CAMERA SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110203", value: "INTEGRATED CT/PET SYSTEMS" },
        { key: "Z11020301", value: "CT/PET SYSTEMS" },
        { key: "Z11020380", value: "INTEGRATED CT/PET SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11020382", value: "INTEGRATED CT/PET SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11020385", value: "INTEGRATED CT/PET SYSTEMS - CONSUMABLES" },
        { key: "Z11020392", value: "INTEGRATED CT/PET SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110204", value: "POSITRON EMISSION TOMOGRAPHY INSTRUMENTS" },
        { key: "Z11020401", value: "POSITRON EMISSION TOMOGRAPHS" },
        { key: "Z11020480", value: "POSITRON EMISSION TOMOGRAPHY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11020482", value: "POSITRON EMISSION TOMOGRAPHY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11020485", value: "POSITRON EMISSION TOMOGRAPHY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11020492", value: "POSITRON EMISSION TOMOGRAPHY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110205", value: "RADIOISOTOPE SCANNERS" },
        { key: "Z110206", value: "INTRAOPERATIVE RADIOISOTOPE SCANNERS" },
        { key: "Z110207", value: "INTEGRATED MRI/PET SYSTEMS" },
        { key: "Z11020701", value: "MRI/PET SYSTEMS" },
        { key: "Z11020780", value: "INTEGRATED MRI/PET SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11020782", value: "INTEGRATED MRI/PET SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11020785", value: "INTEGRATED MRI/PET SYSTEMS - CONSUMABLES" },
        { key: "Z11020792", value: "INTEGRATED MRI/PET SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110290", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE" },
        { key: "Z11029001", value: "BETA/GAMMA DETECTORS" },
        { key: "Z11029002", value: "CYCLOTRONS" },
        { key: "Z11029003", value: "LYMPHOSCINTIGRAPHS" },
        { key: "Z11029004", value: "RADIOACTIVE GAS PRODUCERS" },
        { key: "Z11029005", value: "AUTOMATIC DOSE CALIBRATORS" },
        { key: "Z11029080", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE - HARDWARE ACCESSORIES" },
        { key: "Z11029082", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE - SOFTWARE ACCESSORIES" },
        { key: "Z11029085", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE - CONSUMABLES" },
        { key: "Z11029092", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11029099", value: "VARIOUS INSTRUMENTS FOR NUCLEAR MEDICINE - OTHER" },
        { key: "Z1103", value: "DIAGNOSTIC AND INTERVENTIONAL RADIOLOGY INSTRUMENTS" },
        { key: "Z110301", value: "DIGITAL ANGIOGRAPHY SYSTEMS" },
        { key: "Z11030101", value: "MOBILE ANGIOGRAPHY SYSTEMS FOR ANGIOPLASTY AND CATHETERIZATION" },
        { key: "Z11030102", value: "STATIONARY ANGIOGRAPHY SYSTEMS FOR ANGIOGRAPHIC AND CARDIOLOGIC STUDIES" },
        { key: "Z11030103", value: "BIPLANAR ANGIOGRAPHY SYSTEMS" },
        { key: "Z11030180", value: "DIGITAL ANGIOGRAPHY SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11030182", value: "DIGITAL ANGIOGRAPHY SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11030185", value: "DIGITAL ANGIOGRAPHY SYSTEMS - CONSUMABLES" },
        { key: "Z11030192", value: "DIGITAL ANGIOGRAPHY SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110302", value: "MAMMOGRAPHY SYSTEMS" },
        { key: "Z11030201", value: "CONVENTIONAL MAMMOGRAPHY SYSTEMS" },
        { key: "Z11030202", value: "DIGITAL MAMMOGRAPHY SYSTEMS" },
        { key: "Z11030280", value: "MAMMOGRAPHY SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z1103028001", value: "STEREOTACTIC MODULES FOR MAMMOGRAPHY" },
        { key: "Z1103028099", value: "MAMMOGRAPHY SYSTEMS - HARDWARE - OTHER" },
        { key: "Z11030282", value: "MAMMOGRAPHY SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11030285", value: "MAMMOGRAPHY SYSTEMS - CONSUMABLES" },
        { key: "Z11030292", value: "MAMMOGRAPHY SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110303", value: "INSTRUMENTS FOR ORTHOPANTOMOGRAPHY AND PANORAMIC DENTAL RADIOLOGY" },
        { key: "Z11030301", value: "EQUIPMENT FOR ORTHOPANTOMOGRAPHY" },
        { key: "Z1103030101", value: "EQUIPMENT FOR CONVENTIONAL ORTHOPANTOMOGRAPHY" },
        { key: "Z1103030102", value: "EQUIPMENT FOR DIGITAL ORTHOPANTOMOGRAPHY" },
        { key: "Z11030302", value: "EQUIPMENT FOR PANORAMIC DENTAL RADIOLOGY" },
        { key: "Z11030380", value: "INSTRUMENTS FOR ORTHOPANTOMOGRAPHY AND PANORAMIC DENTAL RADIOLOGY - HARDWARE ACCESSORIES" },
        { key: "Z11030382", value: "INSTRUMENTS FOR ORTHOPANTOMOGRAPHY AND PANORAMIC DENTAL RADIOLOGY - SOFTWARE ACCESSORIES" },
        { key: "Z11030385", value: "INSTRUMENTS FOR ORTHOPANTOMOGRAPHY AND PANORAMIC DENTAL RADIOLOGY - CONSUMABLES" },
        { key: "Z11030392", value: "INSTRUMENTS FOR ORTHOPANTOMOGRAPHY AND PANORAMIC DENTAL RADIOLOGY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110304", value: "INSTRUMENTS FOR ENDORAL RADIOLOGY" },
        { key: "Z11030401", value: "ENDORAL RADIOLOGY EQUIPMENT" },
        { key: "Z1103040101", value: "EQUIPMENT FOR CONVENTIONAL ENDORAL RADIOLOGY" },
        { key: "Z1103040102", value: "EQUIPMENT FOR DIGITAL ENDORAL RADIOLOGY" },
        { key: "Z11030402", value: "SYSTEMS FOR INTRAORAL DIGITAL VIDEORADIOGRAPHY" },
        { key: "Z11030480", value: "INSTRUMENTS FOR ENDORAL RADIOLOGY - CONSUMABLES" },
        { key: "Z11030482", value: "INSTRUMENTS FOR RADIOLOGICAL SECTION" },
        { key: "Z11030485", value: "INSTRUMENTS FOR DIGITAL ENDORAL RADIOLOGY - CONSUMABLES" },
        { key: "Z11030492", value: "INSTRUMENTS FOR DIGITAL ENDORAL RADIOLOGY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110305", value: "RADIOLOGY INSTRUMENTS" },
        { key: "Z11030501", value: "COLUMN STANDS FOR RADIOLOGICAL EQUIPMENT" },
        { key: "Z11030502", value: "CEILING STANDS FOR RADIOLOGICAL EQUIPMENT" },
        { key: "Z11030503", value: "PATIENT TABLES FOR RADIOLOGICAL EQUIPMENT" },
        { key: "Z11030504", value: "TILTING TABLES FOR RADIOLOGY EQUIPMENT" },
        { key: "Z11030505", value: "TOMOGRAPHY TABLES" },
        { key: "Z11030506", value: "TELERADIOGRAPHS" },
        { key: "Z11030507", value: "TOMOGRAPHS" },
        { key: "Z11030580", value: "RADIOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11030582", value: "RADIOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11030585", value: "RADIOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z11030592", value: "RADIOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11030599", value: "RADIOLOGY INSTRUMENTS - OTHER" },
        { key: "Z110306", value: "COMPUTED TOMOGRAPHS (CT)" },
        { key: "Z11030601", value: "COMPUTED TOMOGRAPHS - NOT EXCEEDING 2 LAYERS" },
        { key: "Z11030602", value: "COMPUTED TOMOGRAPHS - EXCEEDING 2 LAYERS BUT LESS THAN 16 LAYERS" },
        { key: "Z11030603", value: "COMPUTED TOMOGRAPHS - 16 LAYERS OR MORE BUT LESS THAN 64 LAYERS" },
        { key: "Z11030605", value: "COMPUTED TOMOGRAPHS - 64 LAYERS OR MORE BUT LESS THAN 128 LAYERS" },
        { key: "Z11030606", value: "COMPUTED TOMOGRAPHS - 128 LAYERS OR MORE BUT LESS THAN 256 LAYERS" },
        { key: "Z11030607", value: "COMPUTED TOMOGRAPHS - 256 LAYERS OR MORE" },
        { key: "Z11030680", value: "COMPUTED TOMOGRAPHS (CT) - HARDWARE ACCESSORIES" },
        { key: "Z11030682", value: "COMPUTED TOMOGRAPHS (CT) - SOFTWARE ACCESSORIES" },
        { key: "Z11030685", value: "COMPUTED TOMOGRAPHS (CT) - CONSUMABLES" },
        { key: "Z11030692", value: "COMPUTED TOMOGRAPHS (CT) - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11030699", value: "COMPUTED TOMOGRAPHS (CT) - OTHER" },
        { key: "Z110307", value: "REMOTE CONTROL TABLES" },
        { key: "Z11030701", value: "CONVENTIONAL REMOTE CONTROL TABLES" },
        { key: "Z11030702", value: "DIGITAL REMOTE CONTROL TABLES" },
        { key: "Z11030703", value: "REMOTE CONTROL TABLES WITH CONVENTIONAL MULTIFUNCTIONAL ARCH" },
        { key: "Z11030704", value: "REMOTE CONTROL TABLES WITH DIGITAL MULTIFUNCTIONAL ARCH" },
        { key: "Z11030780", value: "REMOTE CONTROL TABLES - HARDWARE ACCESSORIES" },
        { key: "Z11030782", value: "REMOTE CONTROL TABLES - SOFTWARE ACCESSORIES" },
        { key: "Z11030785", value: "REMOTE CONTROL TABLES - CONSUMABLES" },
        { key: "Z11030792", value: "REMOTE CONTROL TABLES - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110310", value: "MULTIFUNCTIONAL SYSTEMS FOR TRADITIONAL RADIOLOGY" },
        { key: "Z110311", value: "DIRECT DIGITAL RADIOLOGY (DR) SYSTEMS" },
        { key: "Z11031101", value: "MULTIFUNCTIONAL SYSTEMS FOR DIRECT DIGITAL RADIOLOGY" },
        { key: "Z11031102", value: "DIRECT DIGITAL TELERADIOGRAPHS" },
        { key: "Z11031180", value: "SYSTEMS FOR DIRECT DIGITAL RADIOLOGY (DR) - HARDWARE ACCESSORIES" },
        { key: "Z11031182", value: "SYSTEMS FOR DIRECT DIGITAL RADIOLOGY (DR) - SOFTWARE ACCESSORIES" },
        { key: "Z11031192", value: "SYSTEMS FOR DIRECT DIGITAL RADIOLOGY (DR) - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110390", value: "VARIOUS INSTRUMENTS FOR RADIODIAGNOSTICS AND INTERVENTIONAL PROCEDURES" },
        { key: "Z11039001", value: "ANGIOGRAPHS" },
        { key: "Z11039002", value: "ARTERIOGRAPHS" },
        { key: "Z11039003", value: "MULTIFORMAT CAMERAS" },
        { key: "Z11039004", value: "TELEVISION SYSTEMS" },
        { key: "Z11039005", value: "RADIOGENIC COMPLEXES" },
        { key: "Z11039006", value: "RADIOLOGY CONTROL UNITS" },
        { key: "Z11039007", value: "CRANIOSTATS" },
        { key: "Z11039008", value: "AUTOMATIC EXPOSURE METERS" },
        { key: "Z11039009", value: "FLUOROSCOPY DEVICES" },
        { key: "Z11039010", value: "PHOTO CAMERAS" },
        { key: "Z11039011", value: "HIGH VOLTAGE X-RAY GENERATORS" },
        { key: "Z11039012", value: "X-RAY TUBE ASSEMBLY" },
        { key: "Z11039013", value: "ANGIOGRAPHIC INJECTORS" },
        { key: "Z11039014", value: "MULTIPLE CONTRAST AGENT INJECTORS" },
        { key: "Z11039015", value: "IMAGE INTENSIFIERS" },
        { key: "Z11039016", value: "MOBILE RADIOGRAPHIC UNITS" },
        { key: "Z11039017", value: "MOBILE RADIOSCOPIC UNITS" },
        { key: "Z11039018", value: "SERIALOGRAPHS" },
        { key: "Z11039019", value: "ANGIOGRAPHY TUBE SUPPORTS" },
        { key: "Z11039020", value: "ANGIOGRAPHY TABLES" },
        { key: "Z11039021", value: "RADIOGRAPHY VIDEO ACQUISITION SYSTEMS" },
        { key: "Z11039080", value: "VARIOUS RADIODIAGNOSTIC AND INTERVENTIONAL INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11039082", value: "VARIOUS RADIODIAGNOSTIC AND INTERVENTIONAL INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11039085", value: "VARIOUS RADIODIAGNOSTIC AND INTERVENTIONAL INSTRUMENTS - CONSUMABLES" },
        { key: "Z11039092", value: "VARIOUS RADIODIAGNOSTIC AND INTERVENTIONAL INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11039099", value: "VARIOUS RADIODIAGNOSTIC AND INTERVENTIONAL INSTRUMENTS – OTHER" },
        { key: "Z1104", value: "ECHOGRAPHY INSTRUMENTS" },
        { key: "Z110401", value: "ULTRASOUND SCANNERS" },
        { key: "Z11040101", value: "INTERNAL ULTRASOUND SCANNERS" },
        { key: "Z11040102", value: "CARDIOLOGY ULTRASOUND SCANNERS" },
        { key: "Z11040103", value: "PORTABLE ULTRASOUND SCANNERS" },
        { key: "Z11040104", value: "MULTIDISCIPLINARY ULTRASOUND SCANNERS (INTERNAL AND CARDIOLOGY, ETC.)" },
        { key: "Z11040105", value: "OBSTETRIC/GYNAECOLOGICAL ULTRASOUND SCANNERS" },
        { key: "Z11040106", value: "HANDHELD ULTRASOUND SCANNERS" },
        { key: "Z11040107", value: "ECHOPHTHALMOGRAPHS" },
        { key: "Z11040180", value: "ULTRASOUND SCANNERS - HARDWARE ACCESSORIES" },
        { key: "Z1104018099", value: "ULTRASOUND SCANNERS – HARDWARE ACCESSORIES – OTHER" },
        { key: "Z11040182", value: "ULTRASOUND SCANNERS - SOFTWARE ACCESSORIES" },
        { key: "Z11040185", value: "ULTRASOUND SCANNERS - CONSUMABLES" },
        { key: "Z11040192", value: "ULTRASOUND SCANNERS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11040199", value: "ULTRASOUND SCANNERS - OTHER" },
        { key: "Z110402", value: "ULTRASOUND PROBES" },
        { key: "Z11040201", value: "TRANSCUTANEOUS ULTRASOUND PROBES" },
        { key: "Z1104020101", value: "LINEAR–ARRAY TRANSCUTANEOUS ULTRASOUND PROBES" },
        { key: "Z110402010101", value: "TWO–DIMENSIONAL LINEAR–ARRAY TRANSCUTANEOUS ULTRASOUND PROBES" },
        { key: "Z110402010102", value: "MULTIDIMENSIONAL LINEAR–ARRAY TRANSCUTANEOUS ULTRASOUND PROBES" },
        { key: "Z1104020102", value: "CURVILINEAR TRANSCUTANEOUS ULTRASOUND PROBES (CONVEX–ARRAY)" },
        { key: "Z110402010201", value: "CURVILINEAR TRANSCUTANEOUS TWO–DIMENSIONAL ULTRASOUND PROBES  (CONVEX–ARRAY)" },
        { key: "Z110402010202", value: "CURVILINEAR TRANSCUTANEOUS MULTIDIMENSIONAL ULTRASOUND PROBES  (CONVEX–ARRAY)" },
        { key: "Z1104020103", value: "TRANSCUTANEOUS ULTRASOUND SECTOR PROBES (PHASED ARRAY)" },
        { key: "Z110402010301", value: "TRANSCUTANEOUS ULTRASOUND SECTOR PROBES (PHASED ARRAY), TWO–DIMENSIONAL " },
        { key: "Z110402010302", value: "TRANSCUTANEOUS ULTRASOUND SECTOR PROBES (PHASED ARRAY), MULTIDIMENSIONAL" },
        { key: "Z1104020104", value: "TRANSCUTANEOUS ULTRASOUND ACTIVE MATRIX PROBES" },
        { key: "Z110402010401", value: "TRANSCUTANEOUS ULTRASOUND ACTIVE MATRIX PROBES, TWO–DIMENSIONAL" },
        { key: "Z110402010402", value: "TRANSCUTANEOUS ULTRASOUND ACTIVE MATRIX PROBES, MULTIDIMENSIONAL" },
        { key: "Z1104020105", value: "CMUT ARRAY TRANSCUTANEOUS ULTRASOUND PROBES" },
        { key: "Z110402010501", value: "CMUT ARRAY TRANSCUTANEOUS ULTRASOUND PROBES, TWO–DIMENSIONAL" },
        { key: "Z110402010502", value: "CMUT ARRAY TRANSCUTANEOUS ULTRASOUND PROBES, MULTIDIMENSIONAL" },
        { key: "Z11040202", value: "ENDOCAVITARY ULTRASOUND PROBES" },
        { key: "Z1104020201", value: "ENDOCAVITARY ULTRASOUND PROBES, TWO–DIMENSIONAL" },
        { key: "Z1104020202", value: "ENDOCAVITARY ULTRASOUND PROBES, MULTIDIMENSIONAL" },
        { key: "Z11040203", value: "TRANSESOPHAGEAL ULTRASOUND PROBES" },
        { key: "Z1104020301", value: "TRANSESOPHAGEAL ULTRASOUND PROBES, TWO–DIMENSIONAL" },
        { key: "Z1104020302", value: "TRANSESOPHAGEAL ULTRASOUND PROBES, MULTIDIMENSIONAL" },
        { key: "Z11040299", value: "ULTRASOUND PROBES – OTHER" },
        { key: "Z110490", value: "VARIOUS ULTRASOUND INSTRUMENTS" },
        { key: "Z11049080", value: "VARIOUS ULTRASOUND INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11049082", value: "VARIOUS ULTRASOUND INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11049085", value: "VARIOUS ULTRASOUND INSTRUMENTS - CONSUMABLES" },
        { key: "Z11049092", value: "VARIOUS ULTRASOUND INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11049099", value: "VARIOUS ULTRASOUND INSTRUMENTS - OTHER" },
        { key: "Z1105", value: "MAGNETIC RESONANCE IMAGING (MRI) INSTRUMENTS" },
        { key: "Z110501", value: "MAGNETIC RESONANCE (MR) SYSTEMS" },
        { key: "Z11050101", value: "SECTORAL TOMOGRAPHS (FOR TOMOGRAPHIC EXAMINATIONS OF THE EXTREMITIES)" },
        { key: "Z11050102", value: "OPEN MAGNET MRI SCANNERS WITH MAGNETIC FIELD INTENSITY LESS THAN OR EQUAL TO 0.5T" },
        { key: "Z11050103", value: "OPEN MAGNET MRI SCANNERS WITH MAGNETIC FIELD INTENSITY GREATER THAN 0.5T" },
        { key: "Z11050104", value: "CLOSED MAGNET MRI SCANNERS WITH MAGNETIC FIELD LESS THAN OR EQUAL TO 2T" },
        { key: "Z11050105", value: "CLOSED MAGNET MRI SCANNERS WITH MAGNETIC FIELD GREATER THAN 2T AND LESS THAN OR EQUAL TO 4T" },
        { key: "Z11050106", value: "CLOSED MAGNET MRI SCANNERS WITH MAGNETIC FIELD GREATER THAN 4T" },
        { key: "Z11050180", value: "MAGNETIC RESONANCE (MR) SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z1105018001", value: "MAGNETIC RESONANCE (MR) RADIOFREQUENCY SURFACE COILS" },
        { key: "Z1105018002", value: "MAGNETIC RESONANCE (MR) RADIOFREQUENCY VOLUMETRIC COILS" },
        { key: "Z1105018099", value: "MAGNETIC RESONANCE (MR) SYSTEMS - HARDWARE ACCESSORIES - OTHER" },
        { key: "Z11050182", value: "MMAGNETIC RESONANCE (MR) SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11050185", value: "MAGNETIC RESONANCE (MR) SYSTEMS - CONSUMABLES" },
        { key: "Z11050192", value: "MAGNETIC RESONANCE (MR) SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110590", value: "VARIOUS MAGNETIC RESONANCE IMAGING (MRI) INSTRUMENTS" },
        { key: "Z11059001", value: "MAGNETIC RESONANCE INJECTORS" },
        { key: "Z11059080", value: "VARIOUS MAGNETIC RESONANCE IMAGING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z11059082", value: "VARIOUS MAGNETIC RESONANCE IMAGING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11059085", value: "VARIOUS MAGNETIC RESONANCE IMAGING INSTRUMENTS - CONSUMABLES" },
        { key: "Z11059092", value: "VARIOUS MAGNETIC RESONANCE IMAGING INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11059099", value: "VARIOUS MAGNETIC RESONANCE IMAGING INSTRUMENTS – OTHER" },
        { key: "Z1106", value: "DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS" },
        { key: "Z110601", value: "LASER IMAGING SCANNER" },
        { key: "Z110602", value: "DIGITAL COMPUTED RADIOGRAPHY (CR) SYSTEMS" },
        { key: "Z11060201", value: "SINGLE-INPUT COMPUTED RADIOGRAPHY (CR) SYSTEMS" },
        { key: "Z11060202", value: "MULTIPLE-INPUT COMPUTED RADIOGRAPHY (CR) SYSTEMS" },
        { key: "Z11060280", value: "DIGITAL COMPUTED RADIOGRAPHY (CR) SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z11060282", value: "DIGITAL COMPUTED RADIOGRAPHY (CR) SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11060285", value: "DIGITAL COMPUTED RADIOGRAPHY (CR) SYSTEMS - CONSUMABLES" },
        { key: "Z11060292", value: "DIGITAL COMPUTED RADIOGRAPHY (CR) SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z110603", value: "PICTURE ARCHIVING AND COMMUNICATION SYSTEMS" },
        { key: "Z110690", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS" },
        { key: "Z11069001", value: "BIOIMAGING PROCESSORS" },
        { key: "Z11069002", value: "JUKE BOXES FOR OPTICAL DISKS" },
        { key: "Z11069003", value: "BIOIMAGING SERVERS" },
        { key: "Z11069004", value: "IDENTIFICATION STATIONS" },
        { key: "Z11069005", value: "DIAGNOSTIC IMAGING WORKSTATIONS" },
        { key: "Z11069080", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS - HARDWARE" },
        { key: "Z11069082", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11069085", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z11069092", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11069099", value: "VARIOUS DIGITAL BIOIMAGING MANAGEMENT INSTRUMENTS - OTHER" },
        { key: "Z1107", value: "X–RAY FILM IMAGING SUPPORT INSTRUMENTS" },
        { key: "Z110701", value: "AUTOMATIC FILM LOADING SYSTEMS" },
        { key: "Z110702", value: "DIAPHANOSCOPE" },
        { key: "Z110703", value: "X–RAY FILM VIEWER" },
        { key: "Z110704", value: "X–RAY FILM PLAYERS" },
        { key: "Z110705", value: "LASER IMAGERS FOR BIOIMAGING" },
        { key: "Z110706", value: "VIDEO OR DIGITAL BIOIMAGING PLAYERS" },
        { key: "Z110707", value: "PROCESSORS" },
        { key: "Z11070701", value: "TRADITIONAL PROCESSORS" },
        { key: "Z11070702", value: "DAY-LIGHT PROCESSORS" },
        { key: "Z11070780", value: "PROCESSORS - HARDWARE ACCESSORIES" },
        { key: "Z11070785", value: "PROCESSORS - CONSUMABLES" },
        { key: "Z110790", value: "VARIOUS SUPPORTING INSTRUMENTS FOR X–RAY FILM IMAGING" },
        { key: "Z11079001", value: "X–RAY FILM DENSITOMETERS" },
        { key: "Z11079002", value: "SENSITOMETERS AND DENSITOMETERS FOR X–RAY FILMS" },
        { key: "Z11079003", value: "X–RAY SENSITOMETERS" },
        { key: "Z11079004", value: "LIQUID MIXERS FOR PROCESSORS" },
        { key: "Z11079005", value: "PRINTING MACHINES" },
        { key: "Z11079006", value: "CASSETTES WITH REINFORCEMENT SCREEN FOR X–RAY FILMS" },
        { key: "Z11079007", value: "CASSETTES FOR X–RAY FILMS" },
        { key: "Z11079008", value: "REINFORCEMENT SCREENS FOR X–RAY FILM CASSETTES" },
        { key: "Z11079080", value: "VARIOUS SUPPORTING INSTRUMENTS FOR X-RAY FILM SYSTEM - HARDWARE ACCESSORIES" },
        { key: "Z11079082", value: "VARIOUS X-RAY FILM IMAGING SUPPORT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z11079085", value: "VARIOUS X-RAY FILM IMAGING SUPPORT INSTRUMENTS - CONSUMABLES" },
        { key: "Z11079092", value: "VARIOUS X-RAY FILM IMAGING SUPPORT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z11079099", value: "VARIOUS X–RAY FILM IMAGING SUPPORT INSTRUMENTS - OTHER" },
        { key: "Z1190", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS" },
        { key: "Z119001", value: "BONE DENSITOMETRY SYSTEMS" },
        { key: "Z11900101", value: "GAMMA–RAY BONE DENSITOMETERS" },
        { key: "Z11900102", value: "ULTRASOUND BONE DENSITOMETERS" },
        { key: "Z11900103", value: "X–RAY BONE DENSITOMETERS" },
        { key: "Z11900180", value: "BONE DENSITOMETRY SYSTEMS - HARDWARE" },
        { key: "Z11900182", value: "BONE DENSITOMETRY SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z11900185", value: "BONE DENSITOMETRY SYSTEMS - CONSUMABLES" },
        { key: "Z11900192", value: "BONE DENSITOMETRY SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z119002", value: "DOSIMETERS" },
        { key: "Z119003", value: "BIOIMAGING PHOTOGRAPHY INSTRUMENTS" },
        { key: "Z119004", value: "MICROFILM IMAGE READERS" },
        { key: "Z119005", value: "PERSONAL DOSIMETER READERS" },
        { key: "Z119007", value: "IMAGE ACQUISITION MODULES" },
        { key: "Z119008", value: "BIOIMAGING VISUALIZATION AND/OR DIAGNOSTIC REPORT VIEWING MONITORS" },
        { key: "Z11900801", value: "BIOIMAGING DIAGNOSTIC REPORT VIEWING MONITORS" },
        { key: "Z11900802", value: "BIOIMAGING VIEWING MONITORS" },
        { key: "Z11900880", value: "BIOIMAGING VISUALIZATION AND/OR DIAGNOSTIC REPORT VIEWING MONITORS - HARDWARE ACCESSORIES" },
        { key: "Z11900885", value: "BIOIMAGING VISUALIZATION AND/OR DIAGNOSTIC REPORT VIEWING MONITORS- CONSUMABLES ACCESSORIES" },
        { key: "Z119010", value: "LASER SYSTEMS FOR PATIENT POSITIONING" },
        { key: "Z119011", value: "MAMMOGRAPHY ECOGRAPHY OR RADIOGRAPHY STEREOTACTIC SYSTEMS" },
        { key: "Z119012", value: "CLOSED CIRCUIT TELEVISION SYSTEMS" },
        { key: "Z119013", value: "THERMOGRAPHS" },
        { key: "Z119014", value: "VIDEO RECORDERS FOR BIOIMAGES" },
        { key: "Z119080", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z119082", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z119085", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z119092", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z119099", value: "VARIOUS BIOIMAGING AND RADIOTHERAPY INSTRUMENTS - OTHER" },
        { key: "Z12", value: "INSTRUMENTS FOR FUNCTIONAL EXPLORATIONS AND THERAPEUTIC INTERVENTIONS" },
        { key: "Z1201", value: "GENERAL AND MULTIDISCIPLINARY SURGERY INSTRUMENTS" },
        { key: "Z120101", value: "ARTERIOTOMY ABLATORS" },
        { key: "Z120102", value: "CRYOSURGERY EQUIPMENT" },
        { key: "Z120103", value: "DERMOTOMY EQUIPMENT" },
        { key: "Z120104", value: "SELF–TRANSFUSION EQUIPMENT" },
        { key: "Z120105", value: "SURGICAL MEDICAL ASPIRATORS" },
        { key: "Z120106", value: "HYDRODISSECTORS" },
        { key: "Z120107", value: "SCIALYTIC LAMP LIGHTING SYSTEMS" },
        { key: "Z12010701", value: "FIXED SCIALYTIC LAMPS" },
        { key: "Z12010702", value: "MOBILE SCIALYTIC LAMPS" },
        { key: "Z12010780", value: "SCIALYTIC LAMP LIGHTING SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z12010785", value: "SCIALYTIC LAMP LIGHTING SYSTEMS - CONSUMABLES" },
        { key: "Z12010799", value: "SCIALYTIC LAMP LIGHTING SYSTEMS - OTHER" },
        { key: "Z120108", value: "INSTRUMENTS FOR ULTRASONIC SURGERY" },
        { key: "Z12010801", value: "ULTRASONIC SCALPEL" },
        { key: "Z12010880", value: "INSTRUMENTS FOR ULTRASONIC SURGERY - HARDWARE ACCESSORIES" },
        { key: "Z12010882", value: "INSTRUMENTS FOR ULTRASONIC SURGERY - SOFTWARE ACCESSORIES" },
        { key: "Z12010885", value: "INSTRUMENTS FOR ULTRASONIC SURGERY - CONSUMABLES" },
        { key: "Z12010892", value: "INSTRUMENTS FOR ULTRASONIC SURGERY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120109", value: "ELECTROSURGICAL INSTRUMENTS" },
        { key: "Z12010901", value: "DIATHERMOCOAGULATORS" },
        { key: "Z12010902", value: "ELECTROSURGICAL UNITS (ESU) FOR GENERAL USE" },
        { key: "Z12010903", value: "ARGON ELECTROSURGICAL UNITS (ESU)" },
        { key: "Z12010904", value: "ENDOSCOPIC ELECTROSURGICAL UNITS (ESU)" },
        { key: "Z12010905", value: "RADIOSURGICAL UNITS" },
        { key: "Z12010980", value: "ELECTROSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12010982", value: "ELECTROSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12010985", value: "ELECTROSURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12010992", value: "ELECTROSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12010999", value: "ELECTROSURGERY INSTRUMENTS - OTHER" },
        { key: "Z120110", value: "LASER SURGERY INSTRUMENTS" },
        { key: "Z12011001", value: "EXCIMER SURGICAL LASER" },
        { key: "Z12011002", value: "CARBON MONOXIDE SURGICAL LASER" },
        { key: "Z12011003", value: "HOLMIUM SURGICAL LASER" },
        { key: "Z12011004", value: "KRYPTON SURGICAL LASER" },
        { key: "Z12011005", value: "CARBON DIOXIDE SURGICAL LASER" },
        { key: "Z12011006", value: "DIODE–PUMPED SOLID–STATE (DPSS) SURGICAL LASER" },
        { key: "Z12011007", value: "DYE SURGICAL LASER" },
        { key: "Z12011008", value: "HELIUM/NEON SURGICAL LASER" },
        { key: "Z12011009", value: "COPPER VAPOUR SURGICAL LASER" },
        { key: "Z12011010", value: "ARGON/KRYPTON SURGICAL LASER" },
        { key: "Z12011011", value: "KTP SURGICAL LASER" },
        { key: "Z12011012", value: "DYE/ALEXANDRITE SURGICAL LASER" },
        { key: "Z12011013", value: "ARGON SURGICAL LASER" },
        { key: "Z12011014", value: "ERBIUM SURGICAL LASER" },
        { key: "Z12011015", value: "RUBIDIUM SURGICAL LASER" },
        { key: "Z12011016", value: "DIODE SURGICAL LASER" },
        { key: "Z12011017", value: "NEODYMIUM SURGICAL LASER" },
        { key: "Z12011018", value: "HELIUM/CADMIUM SURGICAL LASER" },
        { key: "Z12011019", value: "MULTI–PLATFORM LASER" },
        { key: "Z12011080", value: "LASER SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12011082", value: "LASER SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12011085", value: "LASER SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12011092", value: "LASER SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12011099", value: "LASER SURGERY INSTRUMENTS - OTHER" },
        { key: "Z120111", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY" },
        { key: "Z12011101", value: "OPERATIVE MICROSCOPES" },
        { key: "Z12011180", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY - HARDWARE ACCESSORIES" },
        { key: "Z1201118001", value: "STANDS FOR OPERATIVE MICROSCOPY" },
        { key: "Z1201118099", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY - HARDWARE ACCESSORIES - OTHER" },
        { key: "Z12011182", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY - SOFTWARE ACCESSORIES" },
        { key: "Z12011185", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY - CONSUMABLES" },
        { key: "Z12011192", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12011199", value: "INSTRUMENTS FOR OPERATIVE MICROSCOPY – OTHER" },
        { key: "Z120112", value: "PATIENT POSITIONING INSTRUMENTS" },
        { key: "Z12011201", value: "OPERATING CHAIRS" },
        { key: "Z12011202", value: "OPERATING TABLES" },
        { key: "Z12011280", value: "PATIENT POSITIONING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12011285", value: "PATIENT POSITIONING INSTRUMENTS - CONSUMABLES" },
        { key: "Z12011299", value: "PATIENT POSITIONING INSTRUMENTS – OTHER" },
        { key: "Z120113", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS" },
        { key: "Z12011301", value: "CLEANING AND DISINFECTION EQUIPMENT" },
        { key: "Z12011302", value: "ULTRASONIC CLEANING EQUIPMENT" },
        { key: "Z12011303", value: "CHEMICAL STERILISATION EQUIPMENT" },
        { key: "Z12011304", value: "AUTOCLAVES WITH A CHAMBER LARGER THAN OR EQUAL TO 1 STANDARD STERILISATION UNIT" },
        { key: "Z12011305", value: "SMALL LOAD AUTOCLAVES WITH A CHAMBER SMALLER THAN 1 STANDARD STERILISATION UNIT" },
        { key: "Z12011306", value: "CLEANING AND DECONTAMINATION SYSTEMS FOR GENERAL AND MULTIDISCIPLINARY SURGERY INSTRUMENTS" },
        { key: "Z12011307", value: "DRY AIR STERILISERS" },
        { key: "Z12011309", value: "PLASMA STERILISERS" },
        { key: "Z12011310", value: "RADIATION STERILISERS" },
        { key: "Z1201131001", value: "RADIATION STERILISERS, X–RAY" },
        { key: "Z1201131002", value: "RADIATION STERILISERS, GAMMA–RAY" },
        { key: "Z1201131003", value: "RADIATION STERILISERS, MICROWAVE" },
        { key: "Z1201131099", value: "RADIATION STERILISERS - OTHER" },
        { key: "Z12011311", value: "ENDOSCOPE WASHERS" },
        { key: "Z12011312", value: "ENDOSCOPE DRYERS" },
        { key: "Z12011313", value: "ENDOSCOPE STERILISERS" },
        { key: "Z12011314", value: "ENDOSCOPE DRYING CABINETS AND STORAGE" },
        { key: "Z12011380", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12011382", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12011385", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12011392", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12011399", value: "CLEANING, DISINFECTION AND STERILISATION INSTRUMENTS - OTHER" },
        { key: "Z120114", value: "SURGICAL NAVIGATION INSTRUMENTS" },
        { key: "Z12011401", value: "SURGICAL NAVIGATION SYSTEM" },
        { key: "Z12011480", value: "SURGICAL NAVIGATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12011482", value: "SURGICAL NAVIGATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12011485", value: "SURGICAL NAVIGATION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12011492", value: "SURGICAL NAVIGATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120190", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY" },
        { key: "Z12019001", value: "SURGICAL WIRE APPLICATION EQUIPMENT" },
        { key: "Z12019002", value: "EQUIPMENT FOR THE TRANSPORT OF ORGANIC MATERIAL" },
        { key: "Z12019003", value: "WOUND TREATMENT EQUIPMENT" },
        { key: "Z12019004", value: "SURGICAL SMOKE EVACUATION SYSTEMS" },
        { key: "Z12019005", value: "DERMOGRAPHS" },
        { key: "Z12019006", value: "PHOTOCOAGULATORS" },
        { key: "Z12019007", value: "IRRIGATORS" },
        { key: "Z12019008", value: "BLOOD HEATERS" },
        { key: "Z12019009", value: "THAWING UNITS" },
        { key: "Z12019010", value: "PATIENT TRANSFER SYSTEMS" },
        { key: "Z12019080", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY - HARDWARE ACCESSORIES" },
        { key: "Z12019082", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY - SOFTWARE ACCESSORIES" },
        { key: "Z12019085", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY - CONSUMABLES" },
        { key: "Z12019092", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12019099", value: "VARIOUS INSTRUMENTS FOR GENERAL AND MULTIDISCIPLINARY SURGERY - OTHER" },
        { key: "Z1202", value: "ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY INSTRUMENTS" },
        { key: "Z120201", value: "REMOTE CONTROL ROBOTIC ENDOSCOPIC SURGERY INSTRUMENTS" },
        { key: "Z12020101", value: "ROBOT-ASSISTED ENDOSCOPIC SURGERY SYSTEMS" },
        { key: "Z12020180", value: "REMOTE CONTROL ROBOT-ASSISTED ENDOSCOPIC SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1202018001", value: "ROBOTIC ARMS FOR VIDEOENDOSCOPY" },
        { key: "Z1202018002", value: "COMMAND CONSOLES FOR ENDOSCOPIC SURGERY" },
        { key: "Z1202018099", value: "REMOTE CONTROL ROBOT-ASSISTED ENDOSCOPIC SURGERY INSTRUMENTS - HARDWARE ACCESSORIES - OTHER" },
        { key: "Z12020182", value: "REMOTE CONTROL ROBOTIC ENDOSCOPIC SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020185", value: "REMOTE CONTROL ROBOT-ASSISTED ENDOSCOPIC SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020192", value: "REMOTE CONTROL ROBOT-ASSISTED ENDOSCOPIC SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020199", value: "REMOTE CONTROL ROBOT-ASSISTED ENDOSCOPIC SURGERY INSTRUMENTS - OTHER" },
        { key: "Z120202", value: "MOTORISED INSTRUMENTS FOR ENDOSCOPIC SURGERY" },
        { key: "Z12020201", value: "MOTORISED SYSTEMS FOR ENDOSCOPIC SURGERY" },
        { key: "Z12020280", value: "MOTORISED INSTRUMENTS FOR ENDOSCOPIC SURGERY - HARDWARE ACCESSORIES" },
        { key: "Z12020282", value: "MOTORISED INSTRUMENTS FOR ENDOSCOPIC SURGERY - SOFTWARE ACCESSORIES" },
        { key: "Z12020285", value: "MOTORISED INSTRUMENTS FOR ENDOSCOPIC SURGERY - CONSUMABLES" },
        { key: "Z12020292", value: "MOTORISED INSTRUMENTS FOR ENDOSCOPIC SURGERY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120203", value: "ENDOSCOPIC LITHOTRIPSY INSTRUMENTS" },
        { key: "Z12020301", value: "ELECTROMECHANICAL ENDOSCOPIC LITHOTRIPTERS" },
        { key: "Z12020302", value: "ULTRASONIC ENDOSCOPIC LITHOTRIPTERS" },
        { key: "Z12020303", value: "ELECTROHYDRAULIC ENDOSCOPIC LITHOTRIPTERS" },
        { key: "Z12020304", value: "LASER ENDOSCOPIC LITHOTRIPTERS" },
        { key: "Z12020380", value: "ENDOSCOPIC LITHOTRIPSY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020382", value: "ENDOSCOPIC LITHOTRIPSY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020385", value: "ENDOSCOPIC LITHOTRIPSY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020392", value: "ENDOSCOPIC LITHOTRIPSY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120204", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES" },
        { key: "Z12020401", value: "INTEGRATED SYSTEMS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES" },
        { key: "Z12020402", value: "LIGHT SOURCES FOR ENDOSCOPY AND MINIMALLY INVASIVE SURGERY" },
        { key: "Z12020403", value: "MODULES FOR ENDOSCOPIC IMAGING AND MINIMALLY INVASIVE SURGERY" },
        { key: "Z12020404", value: "REMOTE CONTROL UNITS FOR ENDOSCOPY AND MINIMALLY INVASIVE SURGERY" },
        { key: "Z12020405", value: "SURGICAL CAMERAS" },
        { key: "Z12020406", value: "VIDEO PROCESSORS" },
        { key: "Z12020480", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES - HARDWARE ACCESSORIES" },
        { key: "Z12020482", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES - SOFTWARE ACCESSORIES" },
        { key: "Z12020485", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES - CONSUMABLES" },
        { key: "Z12020492", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020499", value: "INSTRUMENTS FOR THE ACQUISITION AND MANAGEMENT OF ENDOSCOPIC AND MINIMALLY INVASIVE SURGERY IMAGES – OTHER" },
        { key: "Z120205", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS" },
        { key: "Z12020501", value: "CHOLEDOCOSCOPES" },
        { key: "Z12020502", value: "DUODENOSCOPES" },
        { key: "Z12020503", value: "ECHO–GASTROSCOPES" },
        { key: "Z12020504", value: "OESOPHAGOSCOPES" },
        { key: "Z12020505", value: "GASTRODUODENOSCOPES" },
        { key: "Z12020506", value: "GASTROSCOPES" },
        { key: "Z12020507", value: "VIDEO CHOLEDOCOSCOPES" },
        { key: "Z12020508", value: "VIDEO DUODENOSCOPES" },
        { key: "Z12020509", value: "VIDEO OESOPHAGOSCOPES" },
        { key: "Z12020510", value: "VIDEO GASTRODUODENOSCOPES" },
        { key: "Z12020511", value: "VIDEO GASTROSCOPES" },
        { key: "Z12020580", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020582", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020585", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020592", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020599", value: "UPPER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - OTHER" },
        { key: "Z120206", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS" },
        { key: "Z12020601", value: "COLONOSCOPES" },
        { key: "Z12020602", value: "SIGMOIDOSCOPES" },
        { key: "Z12020603", value: "PROCTOSCOPES" },
        { key: "Z12020604", value: "ULTRASONIC PROCTOSCOPES" },
        { key: "Z12020605", value: "RECTOSCOPES" },
        { key: "Z12020606", value: "VIDEO COLONOSCOPES" },
        { key: "Z12020607", value: "VIDEO ENTEROSCOPES" },
        { key: "Z12020608", value: "VIDEO SIGMOIDOSCOPES" },
        { key: "Z12020680", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020682", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020685", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020692", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020699", value: "LOWER GASTROINTESTINAL TRACT ENDOSCOPY INSTRUMENTS - OTHER" },
        { key: "Z120207", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS" },
        { key: "Z12020701", value: "CYSTOSCOPES" },
        { key: "Z12020702", value: "CYSTOURETHROSCOPES" },
        { key: "Z12020703", value: "COLPOSCOPES" },
        { key: "Z12020704", value: "HYSTEROSCOPES" },
        { key: "Z12020705", value: "NEPHROSCOPES" },
        { key: "Z12020706", value: "PELVISCOPES" },
        { key: "Z12020707", value: "RESECTOSCOPES" },
        { key: "Z12020708", value: "VIDEO COLPOSCOPY INSTRUMENTS" },
        { key: "Z1202070801", value: "VIDEO COLPOSCOPY SYSTEMS" },
        { key: "Z1202070880", value: "VIDEO COLPOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1202070882", value: "VIDEO COLPOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1202070885", value: "VIDEO COLPOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1202070892", value: "VIDEO COLPOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020709", value: "UTEROSCOPES" },
        { key: "Z12020710", value: "VAGINOSCOPES" },
        { key: "Z12020711", value: "VIDEO CYSTOURETHROSCOPES" },
        { key: "Z12020712", value: "VIDEO HYSTEROSCOPES" },
        { key: "Z12020713", value: "URETERORENOSCOPES" },
        { key: "Z12020780", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020782", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020785", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020792", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020799", value: "GENITOURINARY ENDOSCOPY INSTRUMENTS – OTHER" },
        { key: "Z120208", value: "PULMONARY ENDOSCOPIC INSTRUMENTS" },
        { key: "Z12020801", value: "BRONCHOSCOPES" },
        { key: "Z12020802", value: "VIDEO BRONCHOSCOPES" },
        { key: "Z12020880", value: "PULMONARY ENDOSCOPIC INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020882", value: "PULMONARY ENDOSCOPIC INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020885", value: "PULMONARY ENDOSCOPIC INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020892", value: "PULMONARY ENDOSCOPIC INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020899", value: "PULMONARY ENDOSCOPIC INSTRUMENTS - OTHER" },
        { key: "Z120209", value: "NEUROENDOSCOPY INSTRUMENTS" },
        { key: "Z12020901", value: "ENCEPHALOSCOPES" },
        { key: "Z12020902", value: "NEUROSCOPES" },
        { key: "Z12020903", value: "SPINOSCOPES" },
        { key: "Z12020980", value: "NEUROENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12020982", value: "NEUROENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12020985", value: "NEUROENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12020992", value: "NEUROENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12020999", value: "NEUROENDOSCOPY INSTRUMENTS - OTHER" },
        { key: "Z120210", value: "ENT ENDOSCOPY INSTRUMENTS" },
        { key: "Z12021001", value: "PHARYNGOSCOPES" },
        { key: "Z12021002", value: "VIDEO PHARYNGOSCOPES" },
        { key: "Z12021003", value: "LARYNGOSCOPES" },
        { key: "Z12021004", value: "VIDEO LARYNGOSCOPES" },
        { key: "Z12021005", value: "NASAL PHARYNGO/LARYNGOSCOPES" },
        { key: "Z12021006", value: "VIDEO NASOPHARYNGO/LARYNGOSCOPES" },
        { key: "Z12021007", value: "MIDDLE EAR OTOSCOPES" },
        { key: "Z12021008", value: "RHINOSCOPES" },
        { key: "Z12021009", value: "DIRECT OUTPATIENT VIDEO-OTOSCOPES" },
        { key: "Z12021010", value: "LARYNGOSTROBOSCOPES" },
        { key: "Z12021011", value: "MOTORISED RHINOSCOPY SURGERY INSTRUMENTS" },
        { key: "Z1202101101", value: "MOTORISED RHINOSCOPY SURGERY SYSTEMS" },
        { key: "Z1202101180", value: "MOTORISED RHINOSCOPY SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1202101182", value: "MOTORISED RHINOSCOPY SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1202101185", value: "MOTORISED RHINOSCOPY SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1202101192", value: "MOTORISED RHINOSCOPY SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12021080", value: "ENT ENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12021082", value: "ENT ENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12021085", value: "ENT ENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12021092", value: "ENT ENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12021099", value: "ENT ENDOSCOPY INSTRUMENTS - OTHER" },
        { key: "Z120211", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS" },
        { key: "Z12021101", value: "ARTHROSCOPES" },
        { key: "Z12021102", value: "MOTORISED ARTHROSCOPIC SURGERY INSTRUMENTS" },
        { key: "Z1202110201", value: "MOTORISED ARTHROSCOPIC SURGERY SYSTEMS" },
        { key: "Z1202110280", value: "MOTORISED ARTHROSCOPIC SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1202110282", value: "MOTORISED ARTHROSCOPIC SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1202110285", value: "MOTORISED ARTHROSCOPIC SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1202110292", value: "MOTORISED ARTHROSCOPIC SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12021180", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12021182", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12021185", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12021192", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12021199", value: "ORTHOPAEDIC ENDOSCOPY INSTRUMENTS - OTHER" },
        { key: "Z120212", value: "ENDOSCOPIC CAPSULES INSTRUMENTS" },
        { key: "Z12021201", value: "ENDOSCOPIC CAPSULES" },
        { key: "Z12021202", value: "ENDOSCOPIC CAPSULE SIGNAL RECEIVERS" },
        { key: "Z12021280", value: "ENDOSCOPIC CAPSULE SIGNAL RECEIVERS - HARDWARE ACCESSORIES" },
        { key: "Z12021282", value: "ENDOSCOPIC CAPSULE SIGNAL RECEIVERS - SOFTWARE ACCESSORIES" },
        { key: "Z12021285", value: "ENDOSCOPIC CAPSULE SIGNAL RECEIVERS - CONSUMABLES" },
        { key: "Z12021292", value: "ENDOSCOPIC CAPSULE SIGNAL RECEIVERS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120290", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI-INVASIVE SURGERY" },
        { key: "Z12029001", value: "AMNIOSCOPES" },
        { key: "Z12029002", value: "ANGIOSCOPES" },
        { key: "Z12029003", value: "ENDOSCOPE TRANSPORT CARTS" },
        { key: "Z12029004", value: "LACRIMAL DUCT ENDOSCOPES" },
        { key: "Z12029005", value: "MAMMARY DUCT ENDOSCOPES" },
        { key: "Z12029006", value: "FIBROSCOPES FOR INTUBATION" },
        { key: "Z12029007", value: "INFRA–RED SURGICAL ILLUMINATORS" },
        { key: "Z12029008", value: "GAS INFLATORS" },
        { key: "Z12029009", value: "LAPAROSCOPES" },
        { key: "Z12029011", value: "OPTICAL HEATERS" },
        { key: "Z12029012", value: "ENDOSCOPIC PHLEBOTOMY SYSTEMS WITH TRANSILLUMINATION" },
        { key: "Z12029014", value: "GAS PRE–HEATING UNITS" },
        { key: "Z12029015", value: "LENS CLEANING UNITS" },
        { key: "Z12029016", value: "VIDEO LAPAROSCOPES" },
        { key: "Z12029017", value: "THORACOSCOPES" },
        { key: "Z12029080", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI-INVASIVE SURGERY - HARDWARE ACCESSORIES" },
        { key: "Z12029082", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI-INVASIVE SURGERY - SOFTWARE ACCESSORIES" },
        { key: "Z12029085", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI-INVASIVE SURGERY - CONSUMABLES" },
        { key: "Z12029092", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI-INVASIVE SURGERY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12029099", value: "VARIOUS INSTRUMENTS FOR ENDOSCOPY AND MINI–INVASIVE SURGERY – OTHER" },
        { key: "Z1203", value: "INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS" },
        { key: "Z120301", value: "ANAESTHESIA AND PULMONARY VENTILATION SUPPORT INSTRUMENTS" },
        { key: "Z12030101", value: "ANAESTHESIA SYSTEMS" },
        { key: "Z1203010101", value: "ANAESTHESIA DEVICES" },
        { key: "Z1203010180", value: "ANAESTHESIA SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z1203010182", value: "ANAESTHESIA SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z1203010185", value: "ANAESTHESIA SYSTEMS - CONSUMABLES" },
        { key: "Z1203010192", value: "ANAESTHESIA SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1203010199", value: "ANAESTHESIA SYSTEMS - OTHER" },
        { key: "Z12030102", value: "CONTINUOUS POSITIVE PRESSURE EQUIPMENT" },
        { key: "Z12030103", value: "PULMONARY VENTILATORS FOR NON–HOSPITAL USE" },
        { key: "Z12030104", value: "PORTABLE PULMONARY VENTILATORS" },
        { key: "Z12030105", value: "PULMONARY VENTILATORS FOR HOSPITAL USE" },
        { key: "Z1203010501", value: "HIGH–FREQUENCY PULMONARY VENTILATORS" },
        { key: "Z1203010502", value: "ADULT PULMONARY VENTILATORS" },
        { key: "Z1203010503", value: "NEONATAL/PAEDIATRIC PULMONARY VENTILATORS" },
        { key: "Z1203010504", value: "ADULT AND PAEDIATRIC/NEONATAL PULMONARY VENTILATORS" },
        { key: "Z1203010580", value: "PULMONARY VENTILATORS FOR HOSPITAL USE - HARDWARE ACCESSORIES" },
        { key: "Z1203010582", value: "PULMONARY VENTILATORS FOR HOSPITAL USE - SOFTWARE ACCESSORIES" },
        { key: "Z1203010585", value: "PULMONARY VENTILATORS FOR HOSPITAL USE - CONSUMABLES" },
        { key: "Z1203010592", value: "PULMONARY VENTILATORS FOR HOSPITAL USE - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1203010599", value: "PULMONARY VENTILATORS FOR HOSPITAL USE - OTHER" },
        { key: "Z12030190", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT" },
        { key: "Z1203019001", value: "NEUROMUSCULAR RELAXATION MONITORING EQUIPMENT" },
        { key: "Z1203019002", value: "NITRIC OXIDE DISPENSERS" },
        { key: "Z1203019003", value: "VENTILATION MONITORS" },
        { key: "Z1203019004", value: "IRON LUNGS" },
        { key: "Z1203019005", value: "OXYGEN THERAPY TENTS" },
        { key: "Z1203019080", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT - HARDWARE ACCESSORIES" },
        { key: "Z1203019082", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT - SOFTWARE ACCESSORIES" },
        { key: "Z1203019085", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT - CONSUMABLES" },
        { key: "Z1203019092", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1203019099", value: "VARIOUS INSTRUMENTS FOR ANAESTHESIA AND PULMONARY VENTILATION SUPPORT – OTHER" },
        { key: "Z120302", value: "VITAL SIGNS MONITORING INSTRUMENTS" },
        { key: "Z12030201", value: "CENTRAL INFORMATION COMPUTING SYSTEMS" },
        { key: "Z12030202", value: "MULTI–PARAMETER PATIENT MONITORS" },
        { key: "Z1203020201", value: "MULTI–PARAMETER PATIENT BEDSIDE MONITORS" },
        { key: "Z1203020202", value: "TRANSPORTABLE/PORTABLE MULTI–PARAMETER PATIENT MONITORS" },
        { key: "Z1203020280", value: "MULTI-PARAMETER MONITORS - HARDWARE ACCESSORIES" },
        { key: "Z1203020282", value: "MULTI-PARAMETER MONITORS - SOFTWARE ACCESSORIES" },
        { key: "Z1203020285", value: "MULTI-PARAMETER MONITORS - CONSUMABLES" },
        { key: "Z1203020292", value: "MULTI-PARAMETER MONITORS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1203020299", value: "MULTI–PARAMETER MONITORS - OTHER" },
        { key: "Z12030203", value: "BLOOD PRESSURE MONITORING INSTRUMENTS" },
        { key: "Z1203020301", value: "INVASIVE BLOOD PRESSURE MONITORING INSTRUMENTS" },
        { key: "Z1203020302", value: "NON–INVASIVE BLOOD PRESSURE MONITORING INSTRUMENTS" },
        { key: "Z12030204", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS" },
        { key: "Z1203020401", value: "CARBON DIOXIDE ANALYSERS" },
        { key: "Z1203020402", value: "CARBON MONOXIDE ANALYSERS" },
        { key: "Z1203020403", value: "OXYGEN ANALYSERS" },
        { key: "Z1203020404", value: "METABOLISM EQUIPMENT" },
        { key: "Z1203020405", value: "TRANSCUTANEOUS PO2/PCO2 MONITORS" },
        { key: "Z1203020406", value: "CEREBRAL OXIMETERS" },
        { key: "Z1203020407", value: "SUBCUTANEOUS OXIMETERS" },
        { key: "Z1203020408", value: "PULSE OXIMETERS" },
        { key: "Z1203020480", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1203020482", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1203020485", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS - CONSUMABLES" },
        { key: "Z1203020492", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1203020499", value: "GASEOUS EXCHANGE MONITORING INSTRUMENTS – OTHER" },
        { key: "Z12030205", value: "NON–INVASIVE BLOOD PRESSURE GAUGES" },
        { key: "Z1203020501", value: "NON–INVASIVE OSCILLOMETRIC BLOOD PRESSURE GAUGES" },
        { key: "Z1203020599", value: "NON-INVASIVE BLOOD PRESSURE GAUGES - OTHER" },
        { key: "Z12030280", value: "VITAL SIGNS MONITORING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12030282", value: "VITAL SIGNS MONITORING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12030285", value: "VITAL SIGNS MONITORING INSTRUMENTS - CONSUMABLES" },
        { key: "Z12030292", value: "VITAL SIGNS MONITORING INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12030299", value: "VITAL SIGNS MONITORING INSTRUMENTS - OTHER" },
        { key: "Z120303", value: "INFUSION INSTRUMENTS" },
        { key: "Z12030301", value: "INFUSION PUMPS" },
        { key: "Z12030302", value: "SYRINGE PUMPS" },
        { key: "Z12030303", value: "ENTERAL FEEDING PUMPS" },
        { key: "Z12030304", value: "INFUSION REGULATORS" },
        { key: "Z12030305", value: "INFUSION HEATERS" },
        { key: "Z12030306", value: "INFUSION AND SYRINGE PUMP CONTROL SYSTEMS" },
        { key: "Z12030380", value: "INFUSION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12030382", value: "INFUSION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12030385", value: "INFUSION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12030392", value: "INFUSION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12030399", value: "INFUSION INSTRUMENTS - OTHER" },
        { key: "Z120304", value: "CARDIAC COMPRESSORS" },
        { key: "Z120305", value: "DEFIBRILLATORS" },
        { key: "Z12030501", value: "SEMI-AUTOMATIC DEFIBRILLATORS" },
        { key: "Z12030502", value: "MANUAL DEFIBRILLATORS" },
        { key: "Z12030503", value: "AUTOMATIC DEFIBRILLATORS" },
        { key: "Z12030580", value: "DEFIBRILLATORS - HARDWARE ACCESSORIES" },
        { key: "Z12030582", value: "DEFIBRILLATORS - SOFTWARE ACCESSORIES" },
        { key: "Z12030585", value: "DEFIBRILLATORS - CONSUMABLES" },
        { key: "Z12030592", value: "DEFIBRILLATORS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12030599", value: "DEFIBRILLATORS - OTHER" },
        { key: "Z120306", value: "VITAL SIGNS TELEMETRY INSTRUMENTS (ECG, NIPB, EtCO2, SpO2, RESPIRATION,...)" },
        { key: "Z12030601", value: "COMPLETE VITAL SIGNS TELEMETRY SYSTEMS" },
        { key: "Z12030602", value: "VITAL SIGNS TELEMETRY RECEIVERS" },
        { key: "Z12030603", value: "VITAL SIGNS TELEMETRY TRANSMITTER" },
        { key: "Z12030680", value: "VITAL SIGNS TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12030682", value: "VITAL SIGNS TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12030685", value: "VITAL SIGNS TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12030692", value: "VITAL SIGNS TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120308", value: "HYPERBARIC CHAMBERS" },
        { key: "Z120309", value: "MEDICAL/MEDICINAL GAS PIPELINE SYSTEMS AND RELATED ACCESSORIES" },
        { key: "Z120390", value: "VARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS" },
        { key: "Z12039001", value: "INTRACRANIAL PRESSURE MEASURING SYSTEMS" },
        { key: "Z12039002", value: "INTRA COMPARTMENTAL PRESSURE MONITOR SYSTEMS" },
        { key: "Z12039080", value: "VVARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS - HARDWARE ACCESSORIES" },
        { key: "Z12039082", value: "VARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS - SOFTWARE ACCESSORIES" },
        { key: "Z12039085", value: "VARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS - CONSUMABLES" },
        { key: "Z12039092", value: "VARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12039099", value: "VARIOUS INSTRUMENTS TO SUPPORT AND MONITOR VITAL SIGNS – OTHER" },
        { key: "Z1204", value: "GENERAL MEDICINE INSTRUMENTS" },
        { key: "Z120401", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS" },
        { key: "Z12040101", value: "ALGESIMETERS" },
        { key: "Z12040102", value: "EQUIPMENT FOR ANALYSIS OF THE PHYSIOLOGICAL PARAMETERS OF THE SKIN" },
        { key: "Z12040103", value: "HEPATIC FUNCTIONALITY EQUIPMENT" },
        { key: "Z12040104", value: "EQUIPMENT FOR DIAGNOSIS OF THE BIOELECTRIC FUNCTIONAL STATE" },
        { key: "Z12040105", value: "PERCEPTION THRESHOLD EQUIPMENT" },
        { key: "Z12040106", value: "ELECTROCELLULAR TOMOGRAPHY EQUIPMENT" },
        { key: "Z12040107", value: "CAPILLARISCOPES" },
        { key: "Z12040108", value: "DERMATOSCOPES" },
        { key: "Z12040109", value: "DERMOHYGROMETERS" },
        { key: "Z12040110", value: "ELECTROGUSTOMETERS" },
        { key: "Z12040111", value: "BLOOD FLOW METERS" },
        { key: "Z12040112", value: "ONCOLOGY TISSUE INTERFEROMETERS" },
        { key: "Z12040113", value: "REGIONAL PLETHYSMOGRAPHS" },
        { key: "Z12040114", value: "SYSTEMS FOR THE STUDY OF AUTONOMIC NEUROPATHIES" },
        { key: "Z12040115", value: "BLOOD SUGAR MONITORING SYSTEMS" },
        { key: "Z1204011501", value: "NON INVASIVE BLOOD SUGAR MONITORING SYSTEMS" },
        { key: "Z1204011502", value: "INVASIVE BLOOD SUGAR MONITORING SYSTEMS" },
        { key: "Z1204011585", value: "INVASIVE BLOOD SUGAR MONITORING SYSTEMS, SINGLE–USE SENSORS" },
        { key: "Z1204011599", value: "BLOOD SUGAR MONITORING SYSTEMS - OTHER" },
        { key: "Z12040116", value: "SPECTROPHOTOMETERS FOR EARLY DETECTION OF MELANOMA" },
        { key: "Z12040117", value: "METABOLIC AND PHYSICAL ACTIVITY HOLTER SYSTEMS" },
        { key: "Z12040118", value: "VIDEO DERMATOSCOPES" },
        { key: "Z12040180", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12040182", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12040185", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS - CONSUMABLES" },
        { key: "Z12040192", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12040199", value: "GENERAL MEDICINE DIAGNOSIS AND MONITORING INSTRUMENTS - OTHER" },
        { key: "Z120402", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS" },
        { key: "Z12040201", value: "PHOTOEPILATION EQUIPMENT" },
        { key: "Z12040202", value: "PHOTOTHERAPY EQUIPMENT" },
        { key: "Z12040203", value: "DERMAL REGENERATION EQUIPMENT" },
        { key: "Z12040205", value: "VACUUM MEDICATION EQUIPMENT" },
        { key: "Z12040206", value: "MESOTHERAPY EQUIPMENT" },
        { key: "Z12040207", value: "OZONE THERAPY EQUIPMENT" },
        { key: "Z12040208", value: "BODY THERMOREGULATION EQUIPMENT" },
        { key: "Z12040210", value: "ULTRASONIC NEBULISERS" },
        { key: "Z12040211", value: "ARTIFICIAL PANCREAS" },
        { key: "Z12040213", value: "PATIENT WASHING SYSTEMS" },
        { key: "Z12040214", value: "LIPOSUCTION SYSTEMS" },
        { key: "Z12040215", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA INSTRUMENTS" },
        { key: "Z1204021501", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA EQUIPMENT" },
        { key: "Z1204021580", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1204021582", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1204021585", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA INSTRUMENTS - CONSUMABLES" },
        { key: "Z1204021592", value: "MULTI-DISTRICT ONCOLOGICAL HYPERTHERMIA INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12040216", value: "PORTABLE MICROINFUSION INSTRUMENTS" },
        { key: "Z1204021601", value: "PORTABLE INSULIN INFUSION INSTRUMENTS" },
        { key: "Z120402160101", value: "PORTABLE INSULIN MICROINFUSORS" },
        { key: "Z120402160102", value: "PORTABLE INSULIN MICROINFUSORS WITH HANDHELD GLUCOSE METER" },
        { key: "Z120402160103", value: "PORTABLE INSULIN MICROINFUSORS CONNECTABLE TO CONTINUOUS GLUCOSE MONITORING SYSTEMS" },
        { key: "Z1204021602", value: "PORTABLE PAIN THERAPY INSTRUMENTS" },
        { key: "Z1204021603", value: "PORTABLE DOBUTAMINE INFUSION INSTRUMENTS" },
        { key: "Z1204021680", value: "PORTABLE MICROINFUSION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1204021685", value: "PORTABLE MICROINFUSION INSTRUMENTS - CONSUMABLES" },
        { key: "Z1204021699", value: "PORTABLE MICROINFUSION INSTRUMENTS - OTHER" },
        { key: "Z12040218", value: "ENDERMOLOGY TREATMENTS" },
        { key: "Z12040219", value: "REGIONAL PERFUSION UNITS" },
        { key: "Z12040280", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12040282", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12040285", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z12040292", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12040299", value: "GENERAL MEDICINE THERAPEUTIC TREATMENT INSTRUMENTS - OTHER" },
        { key: "Z120499", value: "GENERAL MEDICINE INSTRUMENTS - OTHER" },
        { key: "Z1205", value: "CARDIOLOGY AND CARDIOSURGERY INSTRUMENTS" },
        { key: "Z120501", value: "STRESS ANALYSIS INSTRUMENTS" },
        { key: "Z12050101", value: "STRESS ANALYSIS SYSTEMS" },
        { key: "Z12050180", value: "STRESS ANALYSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12050182", value: "STRESS ANALYSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12050185", value: "STRESS ANALYSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12050192", value: "STRESS ANALYSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120502", value: "EXTRA-CORPOREAL CIRCULATION INSTRUMENTS" },
        { key: "Z12050201", value: "EXTRA-CORPOREAL CIRCULATION SYSTEMS" },
        { key: "Z12050280", value: "EXTRA-CORPOREAL CIRCULATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12050282", value: "EXTRA-CORPOREAL CIRCULATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12050285", value: "EXTRA-CORPOREAL CIRCULATION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12050292", value: "EXTRA-CORPOREAL CIRCULATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120503", value: "ELECTROCARDIOGRAPHS" },
        { key: "Z12050301", value: "GENERAL PURPOSE ELECTROCARDIOGRAPHS" },
        { key: "Z12050302", value: "ADVANCED DIAGNOSIS ELECTROCARDIOGRAPHS" },
        { key: "Z12050303", value: "CARDIOPHONES" },
        { key: "Z12050380", value: "ELECTROCARDIOGRAPHS - HARDWARE ACCESSORIES" },
        { key: "Z12050382", value: "ELECTROCARDIOGRAPHS - SOFTWARE ACCESSORIES" },
        { key: "Z12050385", value: "ELECTROCARDIOGRAPHS - CONSUMABLES" },
        { key: "Z12050392", value: "ELECTROCARDIOGRAPHS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120504", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS" },
        { key: "Z12050401", value: "CARDIOVASCULAR HOLTER ANALYSERS" },
        { key: "Z12050402", value: "MULTI–PARAMETER CARDIOVASCULAR HOLTER RECORDERS (ECG, NIPB, ETC.)" },
        { key: "Z12050403", value: "ECG HOLTER RECORDERS" },
        { key: "Z12050404", value: "BLOOD PRESSURE HOLTER RECORDERS" },
        { key: "Z12050480", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS - HARDWARE ACCESSORIES" },
        { key: "Z12050482", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS - SOFTWARE ACCESSORIES" },
        { key: "Z12050485", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS - CONSUMABLES" },
        { key: "Z12050492", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12050499", value: "HOLTER SYSTEM INSTRUMENTS FOR CARDIOVASCULAR PARAMETERS – OTHER" },
        { key: "Z120505", value: "CARDIAC OUTPUT MEASUREMENT INSTRUMENTS" },
        { key: "Z12050501", value: "CARDIAC OUTPUT MEASUREMENT METERS" },
        { key: "Z12050580", value: "CARDIAC OUTPUT MEASUREMENT INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12050582", value: "CARDIAC OUTPUT MEASUREMENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12050585", value: "CARDIAC OUTPUT MEASUREMENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z12050592", value: "CARDIAC OUTPUT MEASUREMENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120506", value: "NON–IMPLANTABLE CARDIAC STIMULATORS" },
        { key: "Z12050601", value: "TRANSOESOPHAGEAL CARDIAC STIMULATORS" },
        { key: "Z12050602", value: "INVASIVE CARDIAC STIMULATORS" },
        { key: "Z12050603", value: "TRANSTHORACIC CARDIAC STIMULATORS" },
        { key: "Z12050680", value: "NON-IMPLANTABLE CARDIAC STIMULATORS - HARDWARE ACCESSORIES" },
        { key: "Z12050682", value: "NON-IMPLANTABLE CARDIAC STIMULATORS - SOFTWARE ACCESSORIES" },
        { key: "Z12050685", value: "NON-IMPLANTABLE CARDIAC STIMULATORS - CONSUMABLES" },
        { key: "Z12050692", value: "NON-IMPLANTABLE CARDIAC STIMULATORS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12050699", value: "NON–IMPLANTABLE CARDIAC STIMULATORS – OTHER" },
        { key: "Z120507", value: "CARDIOGRAPHY INSTRUMENTS" },
        { key: "Z12050701", value: "COMPLETE CARDIOGRAPHY SYSTEMS" },
        { key: "Z12050702", value: "POLYGRAPHY SYSTEMS FOR HAEMODYNAMIC STUDIES" },
        { key: "Z12050703", value: "POLYGRAPHY SYSTEMS FOR ELECTROPHYSIOLOGICAL STUDIES" },
        { key: "Z12050780", value: "CARDIOGRAPHY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1205078001", value: "CARDIAC ELECTROPHYSIOLOGY STIMULATORS" },
        { key: "Z1205078099", value: "INSTRUMENTS FOR CARDIOLOGICAL POLYGRAPHY - HARDWARE ACCESSORIES - OTHER" },
        { key: "Z12050782", value: "INSTRUMENTS FOR CARDIOLOGICAL POLYGRAPHY - SOFTWARE ACCESSORIES" },
        { key: "Z12050785", value: "INSTRUMENTS FOR CARDIOLOGICAL POLYGRAPHY - CONSUMABLES" },
        { key: "Z12050792", value: "INSTRUMENTS FOR CARDIOLOGICAL POLYGRAPHY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120508", value: "CARDIAC TELEMETRY INSTRUMENTS" },
        { key: "Z12050801", value: "COMPLETE CARDIAC TELEMETRY SYSTEMS" },
        { key: "Z12050802", value: "ELECTROCARDIOGRAPH TELEMETRY SYSTEM RECEIVERS" },
        { key: "Z12050803", value: "ELECTROCARDIOGRAPH TELEMETRY SYSTEM TRANSMITTERS" },
        { key: "Z12050804", value: "ERGOSPIROMETRIC TELEMETRY TRANSMITTERS" },
        { key: "Z12050880", value: "CARDIAC TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12050882", value: "CARDIAC TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12050885", value: "CARDIAC TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12050892", value: "CARDIAC TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12050899", value: "CARDIAC TELEMETRY INSTRUMENTS - OTHER" },
        { key: "Z120590", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY" },
        { key: "Z12059001", value: "PACING SENSING ANALYSERS" },
        { key: "Z12059002", value: "CARDIAC MAPPING EQUIPMENT" },
        { key: "Z12059003", value: "CLOT ASPIRATORS" },
        { key: "Z12059004", value: "AORTIC PUMPS" },
        { key: "Z12059005", value: "BLOOD FLOW VELOCIMETERS" },
        { key: "Z12059006", value: "FIBRILLATORS" },
        { key: "Z12059007", value: "INTRA-CARDIAC OXIMETERS" },
        { key: "Z12059008", value: "LASER FLUXIMETRY SYSTEMS" },
        { key: "Z12059009", value: "ECG DATA MANAGEMENT SYSTEMS" },
        { key: "Z12059010", value: "STERNOTOMES" },
        { key: "Z12059011", value: "CARDIAC ABLATION EQUIPMENT" },
        { key: "Z12059012", value: "PHONOCARDIOGRAPHS" },
        { key: "Z12059013", value: "MAGNETOCARDIOGRAPHS" },
        { key: "Z12059080", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY - HARDWARE ACCESSORIES" },
        { key: "Z12059082", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY - SOFTWARE ACCESSORIES" },
        { key: "Z12059085", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY - CONSUMABLES" },
        { key: "Z12059092", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12059099", value: "VARIOUS INSTRUMENTS FOR CARDIOLOGY AND CARDIAC SURGERY -OTHER" },
        { key: "Z1206", value: "PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS" },
        { key: "Z120601", value: "ELECTROTHERAPY EQUIPMENT (INCLUDED TENS)" },
        { key: "Z120602", value: "PHYSIOTHERAPY EQUIPMENT" },
        { key: "Z120603", value: "PASSIVE REHABILITATIVE GYMNASTICS EQUIPMENT" },
        { key: "Z120604", value: "IONTOPHORESIS EQUIPMENT" },
        { key: "Z120605", value: "EQUIPMENT FOR ELECTROMYOGRAPHIC ANALYSIS" },
        { key: "Z120606", value: "MAGNETOTHERAPY EQUIPMENT" },
        { key: "Z120607", value: "PNEUMATIC COMPRESSION EQUIPMENT" },
        { key: "Z120608", value: "MICROWAVE THERAPY EQUIPMENT" },
        { key: "Z120609", value: "SHORTWAVE THERAPY EQUIPMENT" },
        { key: "Z120610", value: "ULTRASOUND THERAPY EQUIPMENT" },
        { key: "Z120611", value: "VACUUM THERAPY EQUIPMENT" },
        { key: "Z120612", value: "ENDORAL ELECTRIC MASSAGE EQUIPMENT" },
        { key: "Z120613", value: "REHABILITATIVE THERAPY FURNACES" },
        { key: "Z120614", value: "INFRARED ULTRAVIOLET RAY LAMPS" },
        { key: "Z120615", value: "THERAPEUTIC LASERS" },
        { key: "Z120616", value: "ELECTROMECHANICAL SYSTEMS FOR PHYSICAL THERAPY" },
        { key: "Z120617", value: "MOVEMENT ANALYSIS INTEGRATED SYSTEMS" },
        { key: "Z120618", value: "HYDROGYMNASTICS AND HYDROTHERAPY SYSTEMS" },
        { key: "Z120619", value: "PARAFFIN THERAPY SYSTEMS" },
        { key: "Z120620", value: "VERTEBRAL COLUMN ELECTROANALGESIC STIMULATORS" },
        { key: "Z120621", value: "FACIAL STIMULATORS" },
        { key: "Z120622", value: "MUSCLE STIMULATORS" },
        { key: "Z120623", value: "ACUPUNCTURE STIMULATORS" },
        { key: "Z120624", value: "BIOFEEDBACK INSTRUMENTS" },
        { key: "Z12062401", value: "ELECTROMYOGRAPHIC BIOFEEDBACK SYSTEMS" },
        { key: "Z12062402", value: "POSITIONAL BIOFEEDBACK SYSTEMS" },
        { key: "Z12062403", value: "TEMPERATURE BIOFEEDBACK SYSTEMS" },
        { key: "Z12062404", value: "ELECTRODERMAL SIGNAL BIOFEEDBACK SYSTEMS" },
        { key: "Z12062480", value: "BIOFEEDBACK INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12062482", value: "BIOFEEDBACK INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12062485", value: "BIOFEEDBACK INSTRUMENTS - CONSUMABLES" },
        { key: "Z12062492", value: "BIOFEEDBACK INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12062499", value: "BIOFEEDBACK INSTRUMENTS - OTHER" },
        { key: "Z120625", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS" },
        { key: "Z12062501", value: "KINEMATIC GONIOMETRIC MOTION CAPTURE ANALYSIS SYSTEMS" },
        { key: "Z12062502", value: "KINEMATIC INERTIAL MOTION CAPTURE ANALYSIS SYSTEMS" },
        { key: "Z12062503", value: "KINEMATIC OPTOELECTRONIC MOTION CAPTURE ANALYSIS SYSTEMS USING PASSIVE MARKERS" },
        { key: "Z12062504", value: "KINEMATIC OPTOELECTRONIC MOTION CAPTURE ANALYSIS SYSTEMS USING ACTIVE MARKERS" },
        { key: "Z12062505", value: "KINEMATIC ULTRASOUND MOTION CAPTURE ANALYSIS SYSTEMS" },
        { key: "Z12062506", value: "KINEMATIC ELECTROMAGNETIC FIELD MOTION CAPTURE ANALYSIS SYSTEMS" },
        { key: "Z12062580", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS - HARDWARE" },
        { key: "Z12062582", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z12062585", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS - CONSUMABLES" },
        { key: "Z12062592", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12062599", value: "KINEMATIC MOTION CAPTURE ANALYSIS SYSTEMS - OTHER" },
        { key: "Z120626", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS" },
        { key: "Z12062601", value: "DYNAMOMETRIC PLATFORMS" },
        { key: "Z12062602", value: "SENSOR-BASED INSOLES" },
        { key: "Z12062603", value: "SENSOR-BASED PLATFORMS" },
        { key: "Z12062680", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS - HARDWARE" },
        { key: "Z12062682", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS - SOFTWARE ACCESSORIES" },
        { key: "Z12062685", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS - CONSUMABLES" },
        { key: "Z12062692", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12062699", value: "DYNAMOMETRIC SYSTEMS FOR MOVEMENT ANALYSIS – OTHER" },
        { key: "Z120627", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS" },
        { key: "Z12062701", value: "PERINEAL STIMULATORS" },
        { key: "Z12062702", value: "HOISTING AND WALKING STIMULATORS" },
        { key: "Z12062703", value: "CYCLING STIMULATORS" },
        { key: "Z12062704", value: "PREHENSION STIMULATORS" },
        { key: "Z12062705", value: "MYOELECTRIC CONTROL STIMULATORS" },
        { key: "Z12062780", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z12062782", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z12062785", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS - CONSUMABLES" },
        { key: "Z12062792", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12062799", value: "FUNCTIONAL ELECTRICAL STIMULATION SYSTEMS - OTHER" },
        { key: "Z120628", value: "NEUROMUSCULAR STIMULATION EQUIPMENT" },
        { key: "Z12062801", value: "MUSCLE REINFORCEMENT STIMULATORS FOR INNERVATED MUSCLES" },
        { key: "Z12062802", value: "STIMULATORS FOR SCOLIOSIS TREATMENT" },
        { key: "Z12062880", value: "NEUROMUSCULAR STIMULATION EQUIPMENT - HARDWARE ACCESSORIES" },
        { key: "Z12062882", value: "NEUROMUSCULAR STIMULATION EQUIPMENT - SOFTWARE ACCESSORIES" },
        { key: "Z12062885", value: "NEUROMUSCULAR STIMULATION EQUIPMENT - CONSUMABLES" },
        { key: "Z12062892", value: "NEUROMUSCULAR STIMULATION EQUIPMENT - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12062899", value: "NEUROMUSCULAR STIMULATION EQUIPMENT - OTHER" },
        { key: "Z120690", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS" },
        { key: "Z12069001", value: "ELECTRIC HOISTS AND WALKERS" },
        { key: "Z12069002", value: "ASSISTED LOCOMOTION SYSTEMS" },
        { key: "Z12069003", value: "CRYOTHERAPY CHAMBERS" },
        { key: "Z12069080", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12069082", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12069085", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS - SPECIFIC MATERIALS" },
        { key: "Z12069092", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12069099", value: "VARIOUS PHYSIOTHERAPY AND REHABILITATION INSTRUMENTS - OTHER" },
        { key: "Z1207", value: "GASTROENTEROLOGICAL INSTRUMENTS" },
        { key: "Z120701", value: "GASTROENTEROLOGICAL MANOMETRY EQUIPMENT" },
        { key: "Z120702", value: "GASTROESOPHAGEAL PH HOLTER RECORDERS" },
        { key: "Z120703", value: "OESOPHAGEAL FUNCTIONALITY ANALYSIS EQUIPMENT" },
        { key: "Z120704", value: "GASTRIC PH MONITOR" },
        { key: "Z120706", value: "EQUIPMENT FOR RADIOFREQUENCY TREATMENT OF THE CARDIAS" },
        { key: "Z120707", value: "LACTOSE INTOLERANCE EQUIPMENT" },
        { key: "Z120780", value: "GASTROENTEROLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z120782", value: "GASTROENTEROLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z120785", value: "GASTROENTEROLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z120792", value: "GASTROENTEROLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120799", value: "GASTROENTEROLOGY INSTRUMENTS -OTHER" },
        { key: "Z1208", value: "OBSTETRICS AND GYNAECOLOGY INSTRUMENTS" },
        { key: "Z120801", value: "PRENATAL DIAGNOSTIC INSTRUMENTS" },
        { key: "Z12080101", value: "FOETAL MONITORS" },
        { key: "Z12080102", value: "FOETAL PH MONITORS" },
        { key: "Z12080103", value: "FOETAL HEARTBEAT DETECTORS" },
        { key: "Z12080104", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS" },
        { key: "Z1208010401", value: "COMPLETE CARDIOTOCOGRAPHIC TELEMETRY SYSTEMS" },
        { key: "Z1208010402", value: "RECEIVING UNITS FOR CARDIOTOCOGRAPHIC TELEMETRY" },
        { key: "Z1208010403", value: "TRANSMITTING UNITS FOR CARDIOTOCOGRAPHIC TELEMETRY" },
        { key: "Z1208010480", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1208010482", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1208010485", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1208010492", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1208010499", value: "CARDIOTOCOGRAPHIC TELEMETRY INSTRUMENTS - OTHER" },
        { key: "Z12080105", value: "FOETAL ACOUSTIC STIMULATORS" },
        { key: "Z12080180", value: "PRENATAL DIAGNOSTIC INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12080182", value: "PRENATAL DIAGNOSTIC INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12080185", value: "PRENATAL DIAGNOSTIC INSTRUMENTS - CONSUMABLES" },
        { key: "Z12080192", value: "PRENATAL DIAGNOSTIC INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12080199", value: "PRENATAL DIAGNOSTIC INSTRUMENTS - OTHER" },
        { key: "Z120802", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS" },
        { key: "Z12080201", value: "ENDOMETRIAL ABLATION EQUIPMENT" },
        { key: "Z12080202", value: "OOCYTE ASPIRATION EQUIPMENT" },
        { key: "Z12080203", value: "HYSTEROSUCTION SURGICAL ASPIRATORS" },
        { key: "Z12080204", value: "MORCELLATORS" },
        { key: "Z12080205", value: "OOCYTE LASER DRILLS" },
        { key: "Z12080280", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12080282", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12080285", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z12080292", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12080299", value: "GYNAECOLOGY AND FERTILITY TREATMENT INSTRUMENTS - OTHER" },
        { key: "Z120803", value: "CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS" },
        { key: "Z12080301", value: "OBSTETRIC VACUUM EXTRACTORS" },
        { key: "Z12080303", value: "BREAST PUMPS" },
        { key: "Z12080304", value: "ULTRASONIC BLADDER VOLUME SCANNERS" },
        { key: "Z12080305", value: "BIRTHING BATHS" },
        { key: "Z12080380", value: "VARIOUS CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12080382", value: "VARIOUS CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS -SOFTWARE ACCESSORIES" },
        { key: "Z12080385", value: "VARIOUS CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS - CONSUMABLES" },
        { key: "Z12080392", value: "VARIOUS CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12080399", value: "VARIOUS CHILDBIRTH SUPPORT AND MATERNAL ASSISTANCE INSTRUMENTS - OTHER" },
        { key: "Z120804", value: "NEONATOLOGY INSTRUMENTS" },
        { key: "Z12080401", value: "PAEDIATRIC PHOTOTHERAPY EQUIPMENT" },
        { key: "Z12080402", value: "NEONATAL SCALES" },
        { key: "Z12080403", value: "NEONATAL INCUBATORS" },
        { key: "Z1208040301", value: "FIXED NEONATAL INCUBATORS" },
        { key: "Z1208040302", value: "MOBILE NEONATAL INCUBATORS" },
        { key: "Z1208040380", value: "NEONATAL INCUBATORS - HARDWARE ACCESSORIES" },
        { key: "Z1208040382", value: "NEONATAL INCUBATORS - SOFTWARE ACCESSORIES" },
        { key: "Z1208040385", value: "NEONATAL INCUBATORS - CONSUMABLES" },
        { key: "Z1208040392", value: "NEONATAL INCUBATORS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12080404", value: "PAEDIATRIC INFRARED LAMPS" },
        { key: "Z12080405", value: "NEONATAL RESUSCITATION BEDS" },
        { key: "Z12080406", value: "APNOEA MONITORS" },
        { key: "Z12080407", value: "NEONATAL RADIANT WARMERS" },
        { key: "Z12080408", value: "SWEAT TEST STIMULATORS" },
        { key: "Z12080409", value: "INFRARED CEREBRAL TOPOGRAPHS" },
        { key: "Z12080410", value: "TRANSCUTANEOUS BILIRUBINOMETERS" },
        { key: "Z12080480", value: "NEONATOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12080482", value: "NEONATOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12080485", value: "NEONATOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12080492", value: "NEONATOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12080499", value: "NEONATOLOGY INSTRUMENTS - OTHER" },
        { key: "Z120899", value: "GYNAECOLOGY AND MATERNAL-INFANTS INSTRUMENTS - OTHER" },
        { key: "Z1209", value: "NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS" },
        { key: "Z120901", value: "PERITONEAL DIALYSIS INSTRUMENTS" },
        { key: "Z12090101", value: "PERITONEAL DIALYSIS EQUIPMENT" },
        { key: "Z12090180", value: "PERITONEAL DIALYSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12090182", value: "PERITONEAL DIALYSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12090185", value: "PERITONEAL DIALYSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12090192", value: "PERITONEAL DIALYSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120902", value: "HAEMODIALYSIS INSTRUMENTS" },
        { key: "Z12090201", value: "HAEMODIALYSIS EQUIPMENT" },
        { key: "Z12090280", value: "HAEMODIALYSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12090282", value: "HAEMODIALYSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12090285", value: "HAEMODIALYSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12090292", value: "HAEMODIALYSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120903", value: "HAEMOFILTRATION INSTRUMENTS" },
        { key: "Z12090301", value: "HAEMOFILTRATION EQUIPMENT" },
        { key: "Z12090380", value: "HAEMOFILTRATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12090382", value: "HAEMOFILTRATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12090385", value: "HAEMOFILTRATION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12090392", value: "HAEMOFILTRATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z120990", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS" },
        { key: "Z12099001", value: "BODY IMPEDANCE ANALYSERS" },
        { key: "Z12099002", value: "MONITORING CENTRES FOR DIALYSIS TREATMENT" },
        { key: "Z12099003", value: "HOSPITAL BEDS OR ARMCHAIR SCALES FOR DIALYSIS" },
        { key: "Z12099004", value: "HEPARIN PUMPS" },
        { key: "Z12099005", value: "BLOOD PUMPS" },
        { key: "Z12099006", value: "LIQUID DIALYSIS PREPARATIONS" },
        { key: "Z12099007", value: "DIALYSIS WATER TREATMENT SYSTEMS" },
        { key: "Z12099080", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12099082", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12099085", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12099092", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12099099", value: "VARIOUS NEPHROLOGY AND HAEMODIALYSIS INSTRUMENTS - OTHER" },
        { key: "Z1210", value: "NEUROLOGY AND NEUROSURGERY INSTRUMENTS" },
        { key: "Z121001", value: "RADIOFREQUENCY NERVOUS TISSUE ABLATION INSTRUMENTS" },
        { key: "Z121002", value: "NERVOUS SYSTEM MONITORING SYSTEMS" },
        { key: "Z121003", value: "ELECTROENCEPHALOGRAPHY INSTRUMENTS" },
        { key: "Z12100301", value: "EEG SPECTRAL ANALYSERS" },
        { key: "Z12100302", value: "ELECTROENCEPHALOGRAPHS" },
        { key: "Z12100303", value: "SYSTEMS FOR ANALYSING AND MANAGING EEG TRACES" },
        { key: "Z12100380", value: "ELECTROENCEPHALOGRAPHY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100382", value: "ELECTROENCEPHALOGRAPHY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100385", value: "ELECTROENCEPHALOGRAPHY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100392", value: "ELECTROENCEPHALOGRAPHY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121004", value: "ELECTROMYOGRAPHY INSTRUMENTS" },
        { key: "Z12100401", value: "ELECTROMYOGRAPHS" },
        { key: "Z12100480", value: "ELECTROMYOGRAPHY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100482", value: "ELECTROMYOGRAPHY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100485", value: "ELECTROMYOGRAPHY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100492", value: "ELECTROMYOGRAPHY INSTRUMENTS -MEDICAL DEVICE SOFTWARE" },
        { key: "Z121005", value: "POLYSOMNOGRAPHY INSTRUMENTS" },
        { key: "Z12100501", value: "POLYSOMNOGRAPHS" },
        { key: "Z12100580", value: "POLYSOMNOGRAPHY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100582", value: "POLYSOMNOGRAPHY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100585", value: "POLYSOMNOGRAPHY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100592", value: "POLYSOMNOGRAPHY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121006", value: "STEREOTACTIC NEUROSURGERY INSTRUMENTS" },
        { key: "Z12100601", value: "STEREOTACTIC NEUROSURGERY SYSTEMS" },
        { key: "Z12100680", value: "STEREOTACTIC NEUROSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100682", value: "STEREOTACTIC NEUROSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100685", value: "STEREOTACTIC NEUROSURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100692", value: "STEREOTACTIC NEUROSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121007", value: "ELECTROMYOGRAPHIC (EMG) TELEMETRY INSTRUMENTS" },
        { key: "Z12100701", value: "EMG TELEMETRY SYSTEMS" },
        { key: "Z12100702", value: "EMG TELEMETRIC TRANSMITTERS" },
        { key: "Z12100703", value: "EMG TELEMETRY RECEIVERS" },
        { key: "Z12100780", value: "EMG TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100782", value: "EMG TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100785", value: "EMG TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100792", value: "EMG TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121008", value: "ELECTROENCEPHALOGRAPHIC (EEG) TELEMETRY INSTRUMENTS" },
        { key: "Z12100801", value: "EEG TELEMETRY SYSTEMS" },
        { key: "Z12100802", value: "EEG TELEMETRY TRANSMITTERS" },
        { key: "Z12100803", value: "EEG TELEMETRY RECEIVERS" },
        { key: "Z12100880", value: "EEG TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12100882", value: "EEG TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12100885", value: "EEG TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12100892", value: "EEG TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121009", value: "INSTRUMENTS FOR MOTORISED NEUROSURGERY SYSTEMS" },
        { key: "Z12100901", value: "MOTORISED NEUROSURGERY SYSTEMS" },
        { key: "Z12100902", value: "DRILLS FOR NEUROSURGERY" },
        { key: "Z12100980", value: "INSTRUMENTS FOR MOTORISED NEUROSURGERY SYSTEMS - HARDWARE ACCESSORIES" },
        { key: "Z12100982", value: "INSTRUMENTS FOR MOTORISED NEUROSURGERY SYSTEMS - SOFTWARE ACCESSORIES" },
        { key: "Z12100985", value: "INSTRUMENTS FOR MOTORISED NEUROSURGERY SYSTEMS - CONSUMABLES" },
        { key: "Z12100992", value: "INSTRUMENTS FOR MOTORISED NEUROSURGERY SYSTEMS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121010", value: "ELECTROENCEPHALOGRAPHIC (EEG) HOLTER SYSTEMS INSTRUMENTS" },
        { key: "Z12101001", value: "EEG HOLTER SYSTEMS" },
        { key: "Z12101002", value: "EEG HOLTER READERS" },
        { key: "Z12101003", value: "EEG HOLTER RECORDERS" },
        { key: "Z12101080", value: "EEG HOLTER SYSTEMS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12101082", value: "EEG HOLTER SYSTEMS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12101085", value: "EEG HOLTER SYSTEMS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12101092", value: "EEG HOLTER SYSTEMS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121011", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS" },
        { key: "Z12101101", value: "SOMATOSENSORY EVOKED POTENTIAL ANALYSERS" },
        { key: "Z12101102", value: "ELECTRODE POSITIONING SYSTEMS FOR BRAIN STIMULATION" },
        { key: "Z12101103", value: "SOMATOSENSORY EVOKED POTENTIAL INTEGRATED SYSTEMS" },
        { key: "Z12101104", value: "CEREBRAL MAPPING SYSTEMS" },
        { key: "Z12101105", value: "MAGNETIC STIMULATORS" },
        { key: "Z12101106", value: "NEUROLOGICAL STIMULATORS" },
        { key: "Z12101180", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12101182", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12101185", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z12101192", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12101199", value: "PERIPHERAL OR CENTRAL NEURO STIMULATION AND ASSESSMENT INSTRUMENTS - OTHER" },
        { key: "Z121012", value: "MAGNETOENCEPHALOGRAPHY INSTRUMENTS" },
        { key: "Z12101201", value: "MAGNETOENCEPHALOGRAPHY SYSTEMS" },
        { key: "Z12101280", value: "MAGNETOENCEPHALOGRAPHY INSTRUMENTS – HARDWARE ACCESSORIES" },
        { key: "Z12101282", value: "MAGNETOENCEPHALOGRAPHY INSTRUMENTS – SOFTWARE ACCESSORIES" },
        { key: "Z12101285", value: "MAGNETOENCEPHALOGRAPHY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12101292", value: "MAGNETOENCEPHALOGRAPHY INSTRUMENTS – MEDICAL DEVICE SOFTWARE" },
        { key: "Z121090", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS" },
        { key: "Z12109001", value: "DETACHABLE COIL EQUIPMENT FOR BRAIN ANEURYSMS" },
        { key: "Z12109002", value: "ELECTROCONVULSIVE THERAPY (ECT) EQUIPMENT" },
        { key: "Z12109003", value: "CEREBROSPINAL FLUID PRESSURE MONITORING SYSTEMS" },
        { key: "Z12109004", value: "VIBRATION THRESHOLD METERS (VIBROMETER)" },
        { key: "Z12109005", value: "REACTION TIME/REFLEX METERS" },
        { key: "Z12109006", value: "BRAIN TISSUE MONITORING SYSTEMS" },
        { key: "Z12109007", value: "PSYCHOMETRIC TESTING SYSTEMS" },
        { key: "Z12109080", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12109082", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12109085", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS - SPECIFIC MATERIALS" },
        { key: "Z12109092", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12109099", value: "VARIOUS NEUROLOGY AND NEUROSURGERY INSTRUMENTS - OTHER" },
        { key: "Z1211", value: "DENTAL STOMATOLOGY INSTRUMENTS" },
        { key: "Z121101", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS" },
        { key: "Z12110101", value: "DENTAL TREATMENT UNITS" },
        { key: "Z12110102", value: "DENTAL DRILLS" },
        { key: "Z12110180", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS - HARDWARE ACCESSORIES" },
        { key: "Z12110182", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS - SOFTWARE ACCESSORIES" },
        { key: "Z12110185", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS - CONSUMABLES" },
        { key: "Z12110192", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12110199", value: "INSTRUMENTS FOR DENTAL TREATMENT UNITS - OTHER" },
        { key: "Z121190", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS" },
        { key: "Z12119001", value: "TARTAR ABLATORS" },
        { key: "Z12119002", value: "AMALGAMATORS" },
        { key: "Z12119003", value: "COLD LIGHT DENTAL EQUIPMENT" },
        { key: "Z12119004", value: "EQUIPMENT FOR DIAGNOSIS OF PERIODONTAL DISEASES" },
        { key: "Z12119005", value: "PULP VITALITY ANALYSERS" },
        { key: "Z12119006", value: "DENTAL CLEANING/WASHING HANDPIECE EQUIPMENTS" },
        { key: "Z12119007", value: "DENTAL PROPHYLAXIS EQUIPMENT" },
        { key: "Z12119008", value: "ENDODONTIC COMPACTORS" },
        { key: "Z12119009", value: "APEX LOCATORS" },
        { key: "Z12119080", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12119082", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12119085", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12119092", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12119099", value: "VARIOUS DENTAL STOMATOLOGY INSTRUMENTS - OTHER" },
        { key: "Z1212", value: "OPHTHALMOLOGY INSTRUMENTS" },
        { key: "Z121201", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS" },
        { key: "Z12120101", value: "LASER POLARIMETRY EQUIPMENT" },
        { key: "Z12120102", value: "COMPUTERISED OPTICAL BIOMETERS" },
        { key: "Z12120103", value: "ELECTRORETINOGRAPHS" },
        { key: "Z12120104", value: "EXOPHTHALMOMETERS" },
        { key: "Z12120105", value: "FLUOROANGIOGRAPHS" },
        { key: "Z12120106", value: "FLUOROPHOTOMETERS" },
        { key: "Z12120107", value: "PHOTOCHERATOSCOPES" },
        { key: "Z12120108", value: "SLIT LAMPS" },
        { key: "Z12120109", value: "RETINOSCOPY LAMPS" },
        { key: "Z12120110", value: "CORNEAL CONFOCAL MICROSCOPES" },
        { key: "Z12120111", value: "EYE MOVEMENT MONITORS" },
        { key: "Z12120112", value: "GLASSES FOR NYSTAGMUS" },
        { key: "Z12120113", value: "OPHTHALMOMETERS" },
        { key: "Z12120114", value: "OPHTHALMOSCOPES" },
        { key: "Z12120115", value: "OPTOMETERS" },
        { key: "Z12120116", value: "PACHYMETERS" },
        { key: "Z12120117", value: "INTRA-OCULAR PRESSURE REGULATORS" },
        { key: "Z12120118", value: "RETINOSCOPES" },
        { key: "Z12120119", value: "OPHTHALMOLOGICAL TREATMENT UNITS" },
        { key: "Z12120120", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY" },
        { key: "Z1212012001", value: "VISUAL FUNCTIONAL ASSESSMENT EQUIPMENT" },
        { key: "Z1212012002", value: "ADAPTOMETERS" },
        { key: "Z1212012003", value: "PERIPHERAL VISION ANALYSERS" },
        { key: "Z1212012004", value: "HESS SCREENS" },
        { key: "Z1212012005", value: "ANOMALOSCOPES" },
        { key: "Z1212012080", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY - HARDWARE ACCESSORIES" },
        { key: "Z1212012082", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY - SOFTWARE ACCESSORIES" },
        { key: "Z1212012085", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY - CONSUMABLES" },
        { key: "Z1212012092", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1212012099", value: "INSTRUMENTS FOR THE ASSESSMENT OF VISUAL FUNCTIONALITY - OTHER" },
        { key: "Z12120121", value: "OPTICAL CONSISTENCY TOMOGRAPHS" },
        { key: "Z12120122", value: "TONOMETERS" },
        { key: "Z12120123", value: "COMPUTERISED CORNEAL TOPOGRAPHS" },
        { key: "Z12120124", value: "VIDEO/ELECTRONYSTAGMOGRAPHS" },
        { key: "Z12120125", value: "PUPILLOMETERS" },
        { key: "Z12120180", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12120182", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12120185", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12120192", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12120199", value: "OPHTALMOLOGY ASSESSMENTS AND DIAGNOSIS INSTRUMENTS – OTHER" },
        { key: "Z121202", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS" },
        { key: "Z12120201", value: "CROSS–EYE CONVERGENCE TRAINERS" },
        { key: "Z12120202", value: "LASER PHOTOCOAGULATORS" },
        { key: "Z12120203", value: "CORNEAL MILLER" },
        { key: "Z12120204", value: "SYNOPTISCOPES" },
        { key: "Z12120205", value: "INSTRUMENTS FOR MICROKERATOME SURGERY" },
        { key: "Z1212020501", value: "MICROKERATOME LASERS" },
        { key: "Z1212020502", value: "MICROBLADE MICROKERATOMES" },
        { key: "Z1212020580", value: "MICROKERATOMY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1212020582", value: "MICROKERATOMY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1212020585", value: "MICROKERATOMY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1212020592", value: "MICROKERATOMY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1212020599", value: "MICROKERATOMY INSTRUMENTS - OTHER" },
        { key: "Z12120206", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS" },
        { key: "Z1212020601", value: "OPHTHALMIC ELECTROSURGERY EQUIPMENT" },
        { key: "Z1212020602", value: "OPHTHALMIC MICRODIATHERMY COAGULATORS" },
        { key: "Z1212020680", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1212020682", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1212020685", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1212020692", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1212020699", value: "OPHTHALMIC ELECTROSURGERY INSTRUMENTS – OTHER" },
        { key: "Z12120207", value: "PHACO-VITRECTOMY INSTRUMENTS" },
        { key: "Z1212020701", value: "PHACO-EMULSIFIERS" },
        { key: "Z1212020702", value: "PHACO-VITRECTOMY SYSTEMS" },
        { key: "Z1212020703", value: "VITRECTOMES" },
        { key: "Z1212020780", value: "PHACO-VITRECTOMY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z1212020782", value: "PHACO-VITRECTOMY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z1212020785", value: "PHACO-VITRECTOMY INSTRUMENTS - CONSUMABLES" },
        { key: "Z1212020792", value: "PHACO-VITRECTOMY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z1212020799", value: "PHACO-VITRECTOMY INSTRUMENTS - OTHER" },
        { key: "Z12120208", value: "CORNEAL DRILLS" },
        { key: "Z12120280", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12120282", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12120285", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12120292", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12120299", value: "THERAPEUTIC AND SURGICAL OPHTHOLMOLOGICAL TREATMENTS INSTRUMENTS - OTHER" },
        { key: "Z121290", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS" },
        { key: "Z12129001", value: "OPHTHALMOLOGICAL INSTRUMENT STANDS" },
        { key: "Z12129080", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12129082", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12129085", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12129092", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12129099", value: "VARIOUS OPHTALMOLOGY INSTRUMENTS - OTHER" },
        { key: "Z1213", value: "ORTHOPAEDIC INSTRUMENTS" },
        { key: "Z121301", value: "PERCUTANEOUS DISCECTOMY EQUIPMENT" },
        { key: "Z121302", value: "ORTHOPAEDIC TRACTION INSTRUMENTS" },
        { key: "Z12130201", value: "TRACTION BEDS" },
        { key: "Z12130202", value: "TRACTION SYSTEMS" },
        { key: "Z12130280", value: "ORTHOPAEDIC TRACTION INSTRUMENTS – HARDWARE ACCESSORIES" },
        { key: "Z12130282", value: "ORTHOPAEDIC TRACTION INSTRUMENTS – SOFTWARE ACCESSORIES" },
        { key: "Z12130285", value: "ORTHOPAEDIC TRACTION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12130292", value: "ORTHOPAEDIC TRACTION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121303", value: "BONE GROWTH STIMULATION INSTRUMENTS" },
        { key: "Z12130301", value: "BONE GROWTH STIMULATORS" },
        { key: "Z12130380", value: "BONE GROWTH STIMULATION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12130382", value: "BONE GROWTH STIMULATION INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12130385", value: "BONE GROWTH STIMULATION INSTRUMENTS - CONSUMABLES" },
        { key: "Z12130392", value: "BONE GROWTH STIMULATION INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121304", value: "STEREOTACTIC ORTHOPAEDIC SURGERY INSTRUMENTS" },
        { key: "Z12130401", value: "STEREOTACTIC ORTHOPAEDIC SURGERY SYSTEMS" },
        { key: "Z12130480", value: "STEREOTACTIC ORTHOPAEDIC SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12130482", value: "STEREOTACTIC ORTHOPAEDIC SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12130485", value: "STEREOTACTIC ORTHOPAEDIC SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12130492", value: "STEREOTACTIC ORTHOPAEDIC SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121305", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS" },
        { key: "Z12130501", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEMS" },
        { key: "Z12130502", value: "ORTHOPAEDIC SURGICAL SAWS" },
        { key: "Z12130503", value: "ORTHOPAEDIC SURGICAL DRILLS" },
        { key: "Z12130580", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12130582", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12130585", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS - CONSUMABLES" },
        { key: "Z12130592", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12130599", value: "MOTORISED ORTHOPAEDIC SURGERY SYSTEM INSTRUMENTS - OTHER" },
        { key: "Z121390", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS" },
        { key: "Z12139001", value: "SHOCK WAVE THERAPY EQUIPMENT" },
        { key: "Z12139002", value: "PROSTHETIC CEMENT REMOVAL EQUIPMENT" },
        { key: "Z12139003", value: "PODOSCOPE SYSTEMS" },
        { key: "Z12139004", value: "PODOLOGICAL TREATMENT UNITS" },
        { key: "Z12139005", value: "PLASTER CAST SAWS" },
        { key: "Z12139006", value: "PNEUMATIC TOURNIQUETS" },
        { key: "Z12139080", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12139082", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12139085", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12139092", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12139099", value: "VARIOUS ORTHOPAEDIC AND TRAUMATOLOGY INSTRUMENTS - OTHER" },
        { key: "Z1214", value: "ENT INSTRUMENTS" },
        { key: "Z121401", value: "AUDIOMETERS" },
        { key: "Z121402", value: "ENT TREATMENT UNITS" },
        { key: "Z121403", value: "EVOKED POTENTIAL AUDIOMETRY INSTRUMENTS" },
        { key: "Z12140301", value: "EVOKED POTENTIAL AUDIOMETRY INTEGRATED SYSTEMS" },
        { key: "Z12140302", value: "EVOKED POTENTIAL AUDIOMETRY EQUIPMENTS" },
        { key: "Z12140380", value: "EVOKED POTENTIAL AUDIOMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12140382", value: "EVOKED POTENTIAL AUDIOMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12140385", value: "EVOKED POTENTIAL AUDIOMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12140392", value: "EVOKED POTENTIAL AUDIOMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121404", value: "VESTIBULAR SYSTEM ANALYSIS INSTRUMENTS" },
        { key: "Z12140401", value: "VESTIBULAR ASSESSMENT SYSTEMS" },
        { key: "Z12140402", value: "VESTIBULAR ASSESSMENTSTABILOMETRIC PLATFORMS" },
        { key: "Z12140403", value: "ROTATING PENDULAR CHAIRS" },
        { key: "Z12140404", value: "POSTUROGRAPHY SYSTEMS" },
        { key: "Z12140480", value: "VESTIBULAR SYSTEM ANALYSIS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12140482", value: "VESTIBULAR SYSTEM ANALYSIS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12140485", value: "VESTIBULAR SYSTEM ANALYSIS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12140492", value: "VESTIBULAR SYSTEM ANALYSIS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121405", value: "STEREOTACTIC ENT SURGERY INSTRUMENTS" },
        { key: "Z12140501", value: "STEREOTACTIC ENT SURGERY SYSTEMS" },
        { key: "Z12140580", value: "STEREOTACTIC ENT SURGERY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12140582", value: "STEREOTACTIC ENT SURGERY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12140585", value: "STEREOTACTIC ENT SURGERY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12140592", value: "STEREOTACTIC ENT SURGERY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121490", value: "VARIOUS ENT INSTRUMENTS" },
        { key: "Z12149001", value: "OTOACOUSTIC EMISSIONS EQUIPMENT" },
        { key: "Z12149002", value: "AUDIOMETRIC CHAMBERS" },
        { key: "Z12149003", value: "OLFACTOMETERS" },
        { key: "Z12149004", value: "OTO-CALORIC STIMULATORS" },
        { key: "Z12149005", value: "IMPEDANCE METERS FOR THE AUDITORY SYSTEM" },
        { key: "Z12149006", value: "DIRECT OUTPATIENT OTOSCOPES" },
        { key: "Z12149007", value: "OTOLOGICAL DRILLS" },
        { key: "Z12149008", value: "RHINOANEMOMETERS" },
        { key: "Z12149009", value: "RHINOMETERS" },
        { key: "Z12149010", value: "VOICE DISPLAYS" },
        { key: "Z12149011", value: "ELECTRIC PHARYNGEAL STIMULATORS" },
        { key: "Z12149080", value: "VARIOUS ENT INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12149082", value: "VARIOUS ENT INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12149085", value: "VARIOUS ENT INSTRUMENTS - CONSUMABLES" },
        { key: "Z12149092", value: "VARIOUS ENT INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12149099", value: "VARIOUS ENT INSTRUMENTS - OTHER" },
        { key: "Z1215", value: "PNEUMONOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS" },
        { key: "Z121501", value: "SPIROMETRY INSTRUMENTS" },
        { key: "Z12150101", value: "CLINICAL/DIAGNOSTIC SPIROMETERS" },
        { key: "Z12150102", value: "PEAK FLOW SPIROMETERS" },
        { key: "Z12150180", value: "SPIROMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12150182", value: "SPIROMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12150185", value: "SPIROMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12150192", value: "SPIROMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12150199", value: "SPIROMETRY INSTRUMENTS - OTHER" },
        { key: "Z121502", value: "SPIROMETRIC TELEMETRY INSTRUMENTS" },
        { key: "Z12150201", value: "COMPLETE SPIROMETRIC TELEMETRY SYSTEMS" },
        { key: "Z12150202", value: "SPIROMETRIC TELEMETRY RECEIVERS" },
        { key: "Z12150203", value: "SPIROMETRIC TELEMETRY TRANSMITTERS" },
        { key: "Z12150280", value: "SPIROMETRIC TELEMETRY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12150282", value: "SPIROMETRIC TELEMETRY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12150285", value: "SPIROMETRIC TELEMETRY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12150292", value: "SPIROMETRIC TELEMETRY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121590", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS" },
        { key: "Z12159001", value: "NITROGEN ANALYSERS" },
        { key: "Z12159002", value: "AEROSOL EQUIPMENT" },
        { key: "Z12159003", value: "DIFFUSION ANALYSIS EQUIPMENT" },
        { key: "Z12159004", value: "OXYGEN CONCENTRATORS" },
        { key: "Z12159005", value: "BRONCHOSTIMULATION DOSIMETERS" },
        { key: "Z12159006", value: "EXPIRATED GAS ANALYSERS" },
        { key: "Z12159007", value: "BODY PLETHYSMOGRAPHS" },
        { key: "Z12159008", value: "PNEUMOTACHOGRAPHS" },
        { key: "Z12159009", value: "EQUIPMENT FOR REMOVAL OF SECRETIONS" },
        { key: "Z12159010", value: "RHINOMANOMETERS" },
        { key: "Z12159011", value: "PNEUMOLOGICAL NAVIGATION SYSTEM" },
        { key: "Z12159080", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12159082", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12159085", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12159092", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12159099", value: "VAROUS PNEUMOLOGY AND RESPIRATORY PHYSIOPATHOLOGY INSTRUMENTS - OTHER" },
        { key: "Z1216", value: "UROLOGY INSTRUMENTS" },
        { key: "Z121601", value: "EXTRACORPOREAL LITHOTRIPSY INSTRUMENTS" },
        { key: "Z12160101", value: "EXTRACORPOREAL LITHOTRIPTERS" },
        { key: "Z12160180", value: "EXTRACORPOREAL LITHOTRIPSY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12160182", value: "EXTRACORPOREAL LITHOTRIPSY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12160185", value: "EXTRACORPOREAL LITHOTRIPSY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12160192", value: "EXTRACORPOREAL LITHOTRIPSY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121602", value: "HOLTER SYSTEM INSTRUMENTS FOR URODYNAMIC PARAMETERS" },
        { key: "Z12160201", value: "URODYNAMIC HOLTER ANALYSERS" },
        { key: "Z12160202", value: "URODYNAMIC HOLTER RECORDERS" },
        { key: "Z12160280", value: "HOLTER SYSTEM INSTRUMENTS FOR URODYNAMIC PARAMETERS - HARDWARE ACCESSORIES" },
        { key: "Z12160282", value: "HOLTER SYSTEM INSTRUMENTS FOR URODYNAMIC PARAMETERS - SOFTWARE ACCESSORIES" },
        { key: "Z12160285", value: "HOLTER SYSTEM INSTRUMENTS FOR URODYNAMIC PARAMETERS - CONSUMABLES" },
        { key: "Z12160292", value: "HOLTER SYSTEM INSTRUMENTS FOR URODYNAMIC PARAMETERS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121603", value: "PROSTATE THERMOTHERAPY INSTRUMENTS" },
        { key: "Z12160301", value: "EQUIPMENT FOR MICROWAVE PROSTATE THERMOTHERAPY" },
        { key: "Z12160302", value: "EQUIPMENT FOR LIQUID PROSTATE THERMOTHERAPY" },
        { key: "Z12160303", value: "EQUIPMENT FOR ULTRASONIC ONCOLOGY THERAPY" },
        { key: "Z12160380", value: "PROSTATE THERMOTHERAPY INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12160382", value: "PROSTATE THERMOTHERAPY INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12160385", value: "PROSTATE THERMOTHERAPY INSTRUMENTS - CONSUMABLES" },
        { key: "Z12160392", value: "PROSTATE THERMOTHERAPY INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12160399", value: "PROSTATE THERMOTHERAPY INSTRUMENTS - OTHER" },
        { key: "Z121604", value: "URODYNAMICS INSTRUMENTS" },
        { key: "Z12160401", value: "URODYNAMICS SYSTEMS " },
        { key: "Z12160480", value: "URODYNAMICS INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z12160482", value: "URODYNAMICS INSTRUMENTS - SOFTWARE ACCESSORIES" },
        { key: "Z12160485", value: "URODYNAMICS INSTRUMENTS - CONSUMABLES" },
        { key: "Z12160492", value: "URODYNAMICS INSTRUMENTS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z121605", value: "UROFLOWMETERS" },
        { key: "Z121690", value: "VARIOUS INSTRUMENTS FOR UROLOGY" },
        { key: "Z12169001", value: "PENILE TUMESCENCE MEASURING EQUIPMENT" },
        { key: "Z12169002", value: "UROLOGICAL STIMULATORS" },
        { key: "Z12169003", value: "EJACULATION STIMULATORS" },
        { key: "Z12169004", value: "ERECTILE DYSFUNCTION STIMULATORS" },
        { key: "Z12169080", value: "VARIOUS INSTRUMENTS FOR UROLOGY - HARDWARE ACCESSORIES" },
        { key: "Z12169082", value: "VARIOUS INSTRUMENTS FOR UROLOGY - SOFTWARE ACCESSORIES" },
        { key: "Z12169085", value: "VARIOUS INSTRUMENTS FOR UROLOGY - CONSUMABLES" },
        { key: "Z12169092", value: "VARIOUS INSTRUMENTS FOR UROLOGY - MEDICAL DEVICE SOFTWARE" },
        { key: "Z12169099", value: "VARIOUS INSTRUMENTS FOR UROLOGY - OTHER" },
        { key: "Z1217", value: "BLOOD TRANSFUSION INSTRUMENTS" },
        { key: "Z121701", value: "BLOOD BANKS REFRIGERATORS" },
        { key: "Z121702", value: "PLASMA FREEZERS" },
        { key: "Z121703", value: "PLASMA THAWERS" },
        { key: "Z121704", value: "APHERESIS EQUIPMENT" },
        { key: "Z12170401", value: "BLOOD DONATION APHERESIS EQUIPMENT" },
        { key: "Z12170402", value: "THERAPEUTIC APHERESIS EQUIPMENT" },
        { key: "Z121780", value: "BLOOD TRANSFUSION INSTRUMENTS - HARDWARE ACCESSORIES" },
        { key: "Z121799", value: "BLOOD TRANSFUSION INSTRUMENTS - OTHER" },
        { key: "Z1290", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS" },
        { key: "Z129003", value: "CYCLES FOR PHYSIOTHERAPY AND/OR DIAGNOSTIC USES" },
        { key: "Z129004", value: "LIGHT SOURCES" },
        { key: "Z129005", value: "GENERIC PHOTOSTIMULATORS" },
        { key: "Z129006", value: "TREADMILLS FOR PHYSIOTHERAPY AND/OR DIAGNOSTIC USES" },
        { key: "Z129007", value: "HANGING UNITS FOR THE OPERATING ROOM AND INTENSIVE CARE" },
        { key: "Z129009", value: "EQUIPMENT FOR ANALYSING POTENTIAL" },
        { key: "Z129010", value: "MULTI-DISCIPLINARY HOLTER SYSTEMS" },
        { key: "Z129011", value: "MULTI-DISCIPLINARY TELEMETRY SYSTEMS" },
        { key: "Z129012", value: "MULTI-FUNCTIONAL POLYGRAPHIC SYSTEMS" },
        { key: "Z129013", value: "GENERAL AUDITORY AND/OR VISUAL STIMULATORS" },
        { key: "Z129017", value: "BED HEAD UNITS" },
        { key: "Z129080", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS - HARDWARE ACCESSORIES" },
        { key: "Z129082", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS - SOFTWARE ACCESSORIES" },
        { key: "Z129085", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS - SPECIFIC MATERIALS" },
        { key: "Z129092", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS - MEDICAL DEVICE SOFTWARE" },
        { key: "Z129099", value: "VARIOUS INSTRUMENTS FOR FUNCTIONAL EXPLORATION AND THERAPEUTIC INTERVENTIONS - OTHER" },
        { key: "Z13", value: "NON-SPECIFIC CONSUMABLES FOR DIAGNOSTIC INSTRUMENTS" },
        { key: "Z1301", value: "X-RAY FILMS" },
        { key: "Z130101", value: "GENERAL PURPOSE X-RAY FILMS" },
        { key: "Z130102", value: "THORACIC X-RAY FILMS" },
        { key: "Z130103", value: "MAMMOGRAPHIC X-RAY FILMS" },
        { key: "Z130104", value: "ENDORAL DENTAL X-RAY FILMS" },
        { key: "Z130105", value: "EXTRA–ORAL DENTAL X-RAY FILMS" },
        { key: "Z130106", value: "DRY THERMAL PRINTER X-RAY FILMS" },
        { key: "Z130107", value: "FILMS FOR REPRODUCTION FROM LASER TECHNOLOGIES" },
        { key: "Z130190", value: "FILMS FOR VARIOUS USES" },
        { key: "Z13019001", value: "FILMS FOR THE REPRODUCTION OF RADIOGRAMS (DUPLICATING)" },
        { key: "Z13019002", value: "RADIOTHERAPY VERIFICATION AND LOCALIZATION FILMS" },
        { key: "Z13019099", value: "X-RAY FILMS - OTHER" },
        { key: "Z1302", value: "DIAGNOSTIC REGISTRATION PAPERS" },
        { key: "Z1399", value: "NON-SPECIFIC CONSUMABLES FOR DIAGNOSTIC INSTRUMENTS - OTHER" },
    ];

    // State
    const [items, setItems] = useState(() => {
        try {
            return (typeof initialData === 'string' ? JSON.parse(initialData) : initialData) || [];
        } catch {
            return [];
        }
    });

    const [isEditing, setIsEditing] = useState(forceIsEditing != null ? forceIsEditing : false);
    const [searchTerm, setSearchTerm] = useState("");

    // Derived Search Results (Filter as user types, min 3 chars)
    const searchResults = searchTerm.length >= 3
        ? nomenclatureLookup.filter(x =>
            x.key.toLowerCase().includes(searchTerm.toLowerCase()) ||
            x.value.toLowerCase().includes(searchTerm.toLowerCase())
        )
        : [];

    const handleAdd = (nomenclature) => {
        const newItem = {
            EMDNNomenclature: nomenclature.key,
            EMDNNomenclatureText: nomenclature.value
        };

        const updatedItems = [...items, newItem];
        setItems(updatedItems);

        // Update Global Context (EUProductUDI)
        setUDI(prevItem => ({
            ...prevItem,
            NomenclatureCode: updatedItems
        }));

        setSearchTerm(""); // Clear search after adding
    };

    const handleRemove = (index) => {
        const updatedItems = items.filter((_, i) => i !== index);
        setItems(updatedItems);

        setUDI(prevItem => ({
            ...prevItem,
            NomenclatureCode: updatedItems
        }));

    };

    const [errorVar, setErrorVar] = useState(false);

    const validate = (list) => {
        setErrorVar(false);
        if (!list || list.length === 0) {
            setErrorVar(fieldTitle + " is mandatory");
        }
    };

    useEffect(() => {
        validate(items);
    }, [items]);

    const changeIsEditingField = (state) => {

        if (forceIsEditing != null)
            return;

        setIsEditing(state);

    }


    useEffect(() => {

        if (forceIsEditing != null)
            setIsEditing(forceIsEditing);

    }, [forceIsEditing]);



    // --- Render Mode: Edit ---
    return (


        <div className="view-task-field">
            <div className="view-task-field-line">
                <div className="view-task-field-title">{fieldTitle}</div>
                <div className="view-task-field-value">

                    <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>

                        {isEditing ?


                            <div style={{ backgroundColor: '#f8f8f8', padding: '10px' }}>
                                <table className={`table table-bordered ${errorVar ? "form-field-error" : ""}`}>
                                    <thead>
                                        <tr>
                                            <th>Nomenclature</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.EMDNNomenclature} - {item.EMDNNomenclatureText}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="udiRemoveButton"
                                                        onClick={() => handleRemove(index)}
                                                    >
                                                        <i className="fas fa-times-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div style={{ marginTop: '20px' }}>
                                    EMDN Nomenclature:
                                    <br />
                                    <input
                                        type="text"
                                        placeholder="Search Nomenclatures"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        style={{ width: '300px', marginBottom: '5px' }}
                                    />
                                    <small style={{ marginLeft: '10px' }}>(min: 3 chars)</small>

                                    <div style={{ marginTop: '15px', maxHeight: '200px', overflowY: 'auto', border: searchTerm.length >= 3 ? '1px solid #ddd' : 'none' }}>
                                        {searchResults.map((result) => (
                                            <div key={result.key} style={{ padding: '8px', borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                <input
                                                    className="udiActionButton"
                                                    type="button"
                                                    onClick={() => handleAdd(result)}
                                                    value="Add"
                                                    style={{ padding: '2px 10px' }}
                                                />
                                                <span><strong>{result.key}</strong> - {result.value}</span>
                                            </div>
                                        ))}
                                        {searchTerm.length >= 3 && searchResults.length === 0 && (
                                            <div style={{ padding: '10px', color: '#666' }}>No results found</div>
                                        )}
                                    </div>
                                </div>

                                                                {errorVar && (
                                    <div style={{ marginTop: '8px' }}>
                                        <span className="form-field-error-message">
                                            {errorVar}
                                        </span>
                                    </div>
                                )}
                                <input type="hidden" name={hiddenFieldName} value={JSON.stringify(items)} />
                            </div>

                            :


                            <>

                                <table className={`dataTable ${errorVar ? "form-field-error" : ""}`} style={{ borderWidth: '1px', width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th>EMDN Nomenclature</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.EMDNNomenclature} - {item.EMDNNomenclatureText}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                {errorVar && (
                                    <div style={{ marginTop: '8px' }}>
                                        <span className="form-field-error-message">
                                            {errorVar}
                                        </span>
                                    </div>
                                )}

                                {/*
						        <input
							        type="button"
							        className="udiActionButton"
							        value="Edit"
							        onClick={() => changeIsEditingField(true)}
						        />
                                */}


                            </>

                        }

                    </div>

                </div>
            </div>
        </div>



    );
};

export default EMDNNomenclature;